/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * document_storage_service
 * OpenAPI spec version: 0.1.0
 */
import * as zod from 'zod';

/**
 * @summary Deletes a single unthreaded anchor for a document
If you need to delete a threaded anchor, see the delete comment handler
 */
export const deleteAnchorBody = zod
  .object({
    anchorType: zod.enum(['highlight']),
    uuid: zod.uuid(),
  })
  .and(
    zod.object({
      fileType: zod.enum(['pdf']),
    })
  );

export const deleteAnchorResponse = zod
  .union([
    zod.object({
      anchorType: zod.enum(['free-comment']),
      uuid: zod.uuid(),
    }),
    zod.object({
      anchorType: zod.enum(['highlight']),
      uuid: zod.uuid(),
    }),
  ])
  .and(
    zod.object({
      fileType: zod.enum(['pdf']),
    })
  )
  .and(
    zod.object({
      documentId: zod.string(),
      threadId: zod.number().nullish(),
    })
  );

/**
 * @summary Edits a single anchor for a document
 */
export const editAnchorBody = zod
  .object({
    allowableEdits: zod.unknown().optional(),
    heightPct: zod.number().nullish(),
    originalIndex: zod.number().nullish(),
    originalPage: zod.number().nullish(),
    page: zod.number().nullish(),
    rotation: zod.number().nullish(),
    shouldLockOnSave: zod.boolean().nullish(),
    uuid: zod.uuid(),
    wasDeleted: zod.boolean().nullish(),
    wasEdited: zod.boolean().nullish(),
    widthPct: zod.number().nullish(),
    xPct: zod.number().nullish(),
    yPct: zod.number().nullish(),
  })
  .and(
    zod.object({
      anchorType: zod.enum(['free-comment']),
    })
  )
  .and(
    zod.object({
      fileType: zod.enum(['pdf']),
    })
  );

export const editAnchorResponse = zod
  .union([
    zod
      .object({
        allowableEdits: zod.unknown().optional(),
        documentId: zod.string(),
        heightPct: zod.number(),
        originalIndex: zod.number(),
        originalPage: zod.number(),
        owner: zod.string(),
        page: zod.number(),
        rotation: zod.number(),
        shouldLockOnSave: zod.boolean(),
        threadId: zod.number(),
        uuid: zod.uuid(),
        wasDeleted: zod.boolean(),
        wasEdited: zod.boolean(),
        widthPct: zod.number(),
        xPct: zod.number(),
        yPct: zod.number(),
      })
      .and(
        zod.object({
          anchorType: zod.enum(['placeable']),
        })
      ),
    zod
      .object({
        alpha: zod.number(),
        blue: zod.number(),
        createdAt: zod.iso.datetime({}).nullish(),
        deletedAt: zod.iso.datetime({}).nullish(),
        documentId: zod.string(),
        green: zod.number(),
        highlightRects: zod.array(
          zod.object({
            height: zod.number(),
            id: zod.number(),
            left: zod.number(),
            top: zod.number(),
            width: zod.number(),
          })
        ),
        highlightType: zod.union([
          zod.literal(1),
          zod.literal(2),
          zod.literal(3),
        ]),
        owner: zod.string(),
        page: zod.number(),
        pageViewportHeight: zod.number(),
        pageViewportWidth: zod.number(),
        red: zod.number(),
        text: zod.string(),
        threadId: zod.number().nullish(),
        updatedAt: zod.iso.datetime({}).nullish(),
        uuid: zod.uuid(),
      })
      .and(
        zod.object({
          anchorType: zod.enum(['highlight']),
        })
      ),
  ])
  .and(
    zod.object({
      documentId: zod.string(),
    })
  );

/**
 * @summary Gets a set of comment anchors for a document
 */
export const getDocumentAnchorsParams = zod.object({
  document_id: zod.string().describe('Document ID'),
});

export const getDocumentAnchorsResponse = zod.object({
  data: zod.array(
    zod.union([
      zod
        .object({
          allowableEdits: zod.unknown().optional(),
          documentId: zod.string(),
          heightPct: zod.number(),
          originalIndex: zod.number(),
          originalPage: zod.number(),
          owner: zod.string(),
          page: zod.number(),
          rotation: zod.number(),
          shouldLockOnSave: zod.boolean(),
          threadId: zod.number(),
          uuid: zod.uuid(),
          wasDeleted: zod.boolean(),
          wasEdited: zod.boolean(),
          widthPct: zod.number(),
          xPct: zod.number(),
          yPct: zod.number(),
        })
        .and(
          zod.object({
            anchorType: zod.enum(['placeable']),
          })
        ),
      zod
        .object({
          alpha: zod.number(),
          blue: zod.number(),
          createdAt: zod.iso.datetime({}).nullish(),
          deletedAt: zod.iso.datetime({}).nullish(),
          documentId: zod.string(),
          green: zod.number(),
          highlightRects: zod.array(
            zod.object({
              height: zod.number(),
              id: zod.number(),
              left: zod.number(),
              top: zod.number(),
              width: zod.number(),
            })
          ),
          highlightType: zod.union([
            zod.literal(1),
            zod.literal(2),
            zod.literal(3),
          ]),
          owner: zod.string(),
          page: zod.number(),
          pageViewportHeight: zod.number(),
          pageViewportWidth: zod.number(),
          red: zod.number(),
          text: zod.string(),
          threadId: zod.number().nullish(),
          updatedAt: zod.iso.datetime({}).nullish(),
          uuid: zod.uuid(),
        })
        .and(
          zod.object({
            anchorType: zod.enum(['highlight']),
          })
        ),
    ])
  ),
});

/**
 * @summary Creates an unthreaded anchor for a document
If you need to create a threaded anchor, see the create comment handler
 */
export const createAnchorParams = zod.object({
  document_id: zod.string().describe('The document id'),
});

export const createAnchorBody = zod
  .object({
    alpha: zod.number(),
    blue: zod.number(),
    green: zod.number(),
    highlightRects: zod.array(
      zod.object({
        height: zod.number(),
        left: zod.number(),
        top: zod.number(),
        width: zod.number(),
      })
    ),
    highlightType: zod.union([zod.literal(1), zod.literal(2), zod.literal(3)]),
    page: zod.number(),
    pageViewportHeight: zod.number(),
    pageViewportWidth: zod.number(),
    red: zod.number(),
    text: zod.string(),
    uuid: zod.uuid().nullish(),
  })
  .and(
    zod.object({
      anchorType: zod.enum(['highlight']),
    })
  )
  .and(
    zod.object({
      fileType: zod.enum(['pdf']),
    })
  );

export const createAnchorResponse = zod
  .union([
    zod
      .object({
        allowableEdits: zod.unknown().optional(),
        documentId: zod.string(),
        heightPct: zod.number(),
        originalIndex: zod.number(),
        originalPage: zod.number(),
        owner: zod.string(),
        page: zod.number(),
        rotation: zod.number(),
        shouldLockOnSave: zod.boolean(),
        threadId: zod.number(),
        uuid: zod.uuid(),
        wasDeleted: zod.boolean(),
        wasEdited: zod.boolean(),
        widthPct: zod.number(),
        xPct: zod.number(),
        yPct: zod.number(),
      })
      .and(
        zod.object({
          anchorType: zod.enum(['placeable']),
        })
      ),
    zod
      .object({
        alpha: zod.number(),
        blue: zod.number(),
        createdAt: zod.iso.datetime({}).nullish(),
        deletedAt: zod.iso.datetime({}).nullish(),
        documentId: zod.string(),
        green: zod.number(),
        highlightRects: zod.array(
          zod.object({
            height: zod.number(),
            id: zod.number(),
            left: zod.number(),
            top: zod.number(),
            width: zod.number(),
          })
        ),
        highlightType: zod.union([
          zod.literal(1),
          zod.literal(2),
          zod.literal(3),
        ]),
        owner: zod.string(),
        page: zod.number(),
        pageViewportHeight: zod.number(),
        pageViewportWidth: zod.number(),
        red: zod.number(),
        text: zod.string(),
        threadId: zod.number().nullish(),
        updatedAt: zod.iso.datetime({}).nullish(),
        uuid: zod.uuid(),
      })
      .and(
        zod.object({
          anchorType: zod.enum(['highlight']),
        })
      ),
  ])
  .and(
    zod.object({
      documentId: zod.string(),
    })
  );

/**
 * @summary Deletes a single comment for a document
 */
export const deleteCommentParams = zod.object({
  comment_id: zod.number().describe('The comment id'),
});

export const deleteCommentBodyRemoveAnchorThreadOnlyDefault = null;

export const deleteCommentBody = zod.object({
  removeAnchorThreadOnly: zod.boolean().nullish(),
});

export const deleteCommentResponse = zod.object({
  anchor: zod
    .union([
      zod.null(),
      zod
        .union([
          zod.object({
            anchorType: zod.enum(['free-comment']),
            uuid: zod.uuid(),
          }),
          zod.object({
            anchorType: zod.enum(['highlight']),
            uuid: zod.uuid(),
          }),
        ])
        .and(
          zod.object({
            fileType: zod.enum(['pdf']),
          })
        )
        .and(
          zod.object({
            deleted: zod.boolean(),
          })
        ),
    ])
    .optional(),
  commentId: zod.number(),
  documentId: zod.string(),
  thread: zod.object({
    deleted: zod.boolean(),
    threadId: zod.number(),
  }),
});

/**
 * @summary Edits a single comment for a document
 */
export const editCommentParams = zod.object({
  comment_id: zod.number().describe('The comment id'),
});

export const editCommentBody = zod.object({
  mentions: zod
    .union([
      zod.null(),
      zod.object({
        mentionId: zod.string(),
        users: zod.array(zod.string()),
      }),
    ])
    .optional(),
  metadata: zod.unknown().optional(),
  text: zod.string().nullish(),
  threadId: zod.number(),
});

export const editCommentResponse = zod
  .object({
    commentId: zod.number(),
    createdAt: zod.iso.datetime({}).nullish(),
    deletedAt: zod.iso.datetime({}).nullish(),
    metadata: zod.unknown().optional(),
    order: zod.number().nullish(),
    owner: zod.string(),
    sender: zod.string().nullish(),
    text: zod.string(),
    threadId: zod.number(),
    updatedAt: zod.iso.datetime({}).nullish(),
  })
  .and(
    zod.object({
      documentId: zod.string(),
      documentName: zod.string(),
      documentOwner: zod.string(),
      fileType: zod.string().nullish(),
      subType: zod
        .union([
          zod.null(),
          zod
            .enum(['task', 'snippet', 'skill'])
            .describe(
              'The document sub type enum represents all values of document sub types.\nThese values should match the `document_sub_type_value` table in macrodb.'
            ),
        ])
        .optional(),
    })
  );

/**
 * @summary Gets a set of comment threads for a document
 */
export const getDocumentCommentsParams = zod.object({
  document_id: zod.string().describe('Document ID'),
});

export const getDocumentCommentsResponse = zod.object({
  data: zod.array(
    zod.object({
      comments: zod.array(
        zod.object({
          commentId: zod.number(),
          createdAt: zod.iso.datetime({}).nullish(),
          deletedAt: zod.iso.datetime({}).nullish(),
          metadata: zod.unknown().optional(),
          order: zod.number().nullish(),
          owner: zod.string(),
          sender: zod.string().nullish(),
          text: zod.string(),
          threadId: zod.number(),
          updatedAt: zod.iso.datetime({}).nullish(),
        })
      ),
      thread: zod.object({
        createdAt: zod.iso.datetime({}).nullish(),
        deletedAt: zod.iso.datetime({}).nullish(),
        documentId: zod.string(),
        metadata: zod.unknown().optional(),
        owner: zod.string(),
        resolved: zod.boolean(),
        threadId: zod.number(),
        updatedAt: zod.iso.datetime({}).nullish(),
      }),
    })
  ),
});

/**
 * @summary Creates a single comment for a document
Optionally creates a new thread/anchor if one does not exist
 */
export const createCommentParams = zod.object({
  document_id: zod.string().describe('The document id'),
});

export const createCommentBody = zod.object({
  anchor: zod
    .union([
      zod.null(),
      zod
        .union([
          zod
            .object({
              allowableEdits: zod.unknown().optional(),
              heightPct: zod.number(),
              originalIndex: zod.number(),
              originalPage: zod.number(),
              page: zod.number(),
              rotation: zod.number(),
              shouldLockOnSave: zod.boolean(),
              uuid: zod.uuid().nullish(),
              wasDeleted: zod.boolean(),
              wasEdited: zod.boolean(),
              widthPct: zod.number(),
              xPct: zod.number(),
              yPct: zod.number(),
            })
            .and(
              zod.object({
                anchorType: zod.enum(['free-comment']),
              })
            ),
          zod
            .object({
              alpha: zod.number(),
              blue: zod.number(),
              green: zod.number(),
              highlightRects: zod.array(
                zod.object({
                  height: zod.number(),
                  left: zod.number(),
                  top: zod.number(),
                  width: zod.number(),
                })
              ),
              highlightType: zod.union([
                zod.literal(1),
                zod.literal(2),
                zod.literal(3),
              ]),
              page: zod.number(),
              pageViewportHeight: zod.number(),
              pageViewportWidth: zod.number(),
              red: zod.number(),
              text: zod.string(),
              uuid: zod.uuid().nullish(),
            })
            .and(
              zod.object({
                anchorType: zod.enum(['highlight']),
              })
            ),
          zod
            .object({
              attachmentType: zod.enum(['highlight']),
              uuid: zod.uuid(),
            })
            .and(
              zod.object({
                anchorType: zod.enum(['attachment']),
              })
            ),
        ])
        .and(
          zod.object({
            fileType: zod.enum(['pdf']),
          })
        ),
    ])
    .optional(),
  mentions: zod
    .union([
      zod.null(),
      zod.object({
        mentionId: zod.string(),
        users: zod.array(zod.string()),
      }),
    ])
    .optional(),
  metadata: zod.unknown().optional(),
  text: zod.string(),
  threadId: zod.number().nullish(),
  threadMetadata: zod.unknown().optional(),
});

export const createCommentResponse = zod
  .object({
    comments: zod.array(
      zod.object({
        commentId: zod.number(),
        createdAt: zod.iso.datetime({}).nullish(),
        deletedAt: zod.iso.datetime({}).nullish(),
        metadata: zod.unknown().optional(),
        order: zod.number().nullish(),
        owner: zod.string(),
        sender: zod.string().nullish(),
        text: zod.string(),
        threadId: zod.number(),
        updatedAt: zod.iso.datetime({}).nullish(),
      })
    ),
    thread: zod.object({
      createdAt: zod.iso.datetime({}).nullish(),
      deletedAt: zod.iso.datetime({}).nullish(),
      documentId: zod.string(),
      metadata: zod.unknown().optional(),
      owner: zod.string(),
      resolved: zod.boolean(),
      threadId: zod.number(),
      updatedAt: zod.iso.datetime({}).nullish(),
    }),
  })
  .and(
    zod.object({
      anchor: zod
        .union([
          zod.null(),
          zod.union([
            zod
              .object({
                allowableEdits: zod.unknown().optional(),
                documentId: zod.string(),
                heightPct: zod.number(),
                originalIndex: zod.number(),
                originalPage: zod.number(),
                owner: zod.string(),
                page: zod.number(),
                rotation: zod.number(),
                shouldLockOnSave: zod.boolean(),
                threadId: zod.number(),
                uuid: zod.uuid(),
                wasDeleted: zod.boolean(),
                wasEdited: zod.boolean(),
                widthPct: zod.number(),
                xPct: zod.number(),
                yPct: zod.number(),
              })
              .and(
                zod.object({
                  anchorType: zod.enum(['placeable']),
                })
              ),
            zod
              .object({
                alpha: zod.number(),
                blue: zod.number(),
                createdAt: zod.iso.datetime({}).nullish(),
                deletedAt: zod.iso.datetime({}).nullish(),
                documentId: zod.string(),
                green: zod.number(),
                highlightRects: zod.array(
                  zod.object({
                    height: zod.number(),
                    id: zod.number(),
                    left: zod.number(),
                    top: zod.number(),
                    width: zod.number(),
                  })
                ),
                highlightType: zod.union([
                  zod.literal(1),
                  zod.literal(2),
                  zod.literal(3),
                ]),
                owner: zod.string(),
                page: zod.number(),
                pageViewportHeight: zod.number(),
                pageViewportWidth: zod.number(),
                red: zod.number(),
                text: zod.string(),
                threadId: zod.number().nullish(),
                updatedAt: zod.iso.datetime({}).nullish(),
                uuid: zod.uuid(),
              })
              .and(
                zod.object({
                  anchorType: zod.enum(['highlight']),
                })
              ),
          ]),
        ])
        .optional(),
      documentId: zod.string(),
    })
  );

/**
 * @summary Handler for `GET /bots/me`.
 */
export const getSelfBotResponse = zod
  .object({
    avatar_url: zod.string().nullish().describe('Optional avatar URL.'),
    created_at: zod.iso.datetime({}).describe('Creation timestamp.'),
    created_by: zod.string().nullish().describe('User that created this bot.'),
    deleted_at: zod.iso
      .datetime({})
      .nullish()
      .describe('Soft-delete timestamp.'),
    description: zod.string().nullish().describe('Optional description.'),
    handle: zod.string().describe('Stable handle.'),
    id: zod.string(),
    kind: zod.enum(['owned', 'system']).describe('Bot kind.'),
    name: zod.string().describe('Display name.'),
    owner: zod
      .union([
        zod.null(),
        zod
          .union([
            zod
              .object({
                type: zod.enum(['user']),
                user_id: zod.string().describe('Owner user id.'),
              })
              .describe('User-owned bot.'),
            zod
              .object({
                team_id: zod.uuid().describe('Owner team id.'),
                type: zod.enum(['team']),
              })
              .describe('Team-owned bot.'),
          ])
          .describe('Bot owner.'),
      ])
      .optional(),
    updated_at: zod.iso.datetime({}).describe('Update timestamp.'),
  })
  .describe('Bot row.');

/**
 * @summary Handler for `GET /bots/{bot_id}/channels`.
 */
export const listBotChannelsParams = zod.object({
  bot_id: zod.string().describe('Bot ID'),
});

export const listBotChannelsResponseItem = zod
  .object({
    channel_id: zod.uuid().describe('Channel id.'),
    channel_type: zod
      .enum(['public', 'private', 'direct_message', 'team'])
      .describe('Channel type for a channel containing a bot.'),
    joined_at: zod.iso
      .datetime({})
      .describe('Timestamp when the bot joined the channel.'),
    name: zod.string().nullish().describe('Channel display name.'),
  })
  .describe('Channel containing a bot.');
export const listBotChannelsResponse = zod.array(listBotChannelsResponseItem);

/**
 * @summary Handler for `DELETE /bots/{bot_id}/channels/{channel_id}`.
 */
export const removeBotFromChannelByBotParams = zod.object({
  bot_id: zod.string().describe('Bot ID'),
  channel_id: zod.uuid().describe('Channel ID'),
});

/**
 * @summary Return calendar occurrences visible to the authenticated requester.
 */
export const listOccurrencesQueryLimitMax = 2000;

export const listOccurrencesQueryParams = zod.object({
  start: zod.iso.datetime({}).describe('Inclusive UTC viewport start.'),
  end: zod.iso.datetime({}).describe('Exclusive UTC viewport end.'),
  startDate: zod.iso
    .date()
    .optional()
    .describe('Inclusive local date boundary for all-day events.'),
  endDate: zod.iso
    .date()
    .optional()
    .describe('Exclusive local date boundary for all-day events.'),
  limit: zod
    .number()
    .min(1)
    .max(listOccurrencesQueryLimitMax)
    .optional()
    .describe('Maximum number of occurrences, from 1 through 2,000.'),
  cursor: zod
    .string()
    .optional()
    .describe('Opaque continuation cursor returned by the previous page.'),
});

export const listOccurrencesResponseItemsItemEventRemindersOverridesItemMinutesMin = 0;

export const listOccurrencesResponseItemsItemEventSequenceMin = 0;

export const listOccurrencesResponse = zod
  .object({
    hasMore: zod.boolean(),
    items: zod.array(
      zod
        .object({
          event: zod
            .object({
              attendees: zod
                .array(
                  zod
                    .object({
                      comment: zod
                        .string()
                        .nullish()
                        .describe('Optional attendee comment.'),
                      displayName: zod
                        .string()
                        .nullish()
                        .describe('Provider display name.'),
                      email: zod.string().describe('Normalized email address.'),
                      isOptional: zod
                        .boolean()
                        .describe('Whether attendance is optional.'),
                      isOrganizer: zod
                        .boolean()
                        .describe('Whether this attendee is the organizer.'),
                      isSelf: zod
                        .boolean()
                        .describe(
                          'Whether this attendee represents the connected account.'
                        ),
                      responseStatus: zod
                        .enum([
                          'needs_action',
                          'accepted',
                          'declined',
                          'tentative',
                        ])
                        .describe('RSVP state for an attendee.'),
                    })
                    .describe('An attendee on a calendar event.')
                )
                .describe('Attendees, keyed by email during persistence.'),
              calendarId: zod
                .uuid()
                .nullish()
                .describe(
                  'Calendar the canonical source belongs to, when known. Absent only in\nprojections stored before calendars were attributed.'
                ),
              conferenceProvider: zod
                .union([
                  zod.null(),
                  zod
                    .enum(['google_meet', 'other'])
                    .describe(
                      "The conferencing system backing an event's join URL.\n\nMacro generates only Google Meet conferences, so this distinguishes one it\ncreated from a third party's — Zoom and friends arriving as `addOn`\nconference data, or a legacy classic Hangout. Clients use it to label the\nconference and to tell whether the Meet toggle reflects a Macro-managed\nconference.\n\nIt does not gate mutation. An explicit request replaces or detaches any\nconference, third-party included, exactly as deleting the event would;\nwhat protects a conference is that omitting the field leaves it untouched,\nso an unrelated edit never disturbs it."
                    ),
                ])
                .optional(),
              conferenceUrl: zod
                .string()
                .nullish()
                .describe('Direct join URL when known.'),
              createdAt: zod.iso.datetime({}).describe('Entity creation time.'),
              description: zod
                .string()
                .nullish()
                .describe('Optional event body.'),
              icalUid: zod
                .string()
                .describe(
                  'RFC 5545 UID used to reconcile provider and email sources.'
                ),
              id: zod.uuid().describe('Macro entity identifier.'),
              isReadOnly: zod
                .boolean()
                .describe(
                  'Whether the current user can edit the canonical source.'
                ),
              location: zod
                .string()
                .nullish()
                .describe('Optional physical or virtual location label.'),
              organizerEmail: zod
                .string()
                .nullish()
                .describe('Organizer email.'),
              organizerName: zod
                .string()
                .nullish()
                .describe('Organizer display name.'),
              ownerId: zod
                .string()
                .describe('Macro user who owns this event entity.'),
              recurrenceLines: zod
                .array(zod.string())
                .describe(
                  'Raw RFC 5545 recurrence properties (`RRULE`, `RDATE`, `EXDATE`).'
                ),
              reminders: zod
                .object({
                  overrides: zod
                    .array(
                      zod
                        .object({
                          method: zod
                            .string()
                            .describe(
                              'Provider method, stored verbatim; only `popup` fires Macro\nnotifications.'
                            ),
                          minutes: zod
                            .number()
                            .min(
                              listOccurrencesResponseItemsItemEventRemindersOverridesItemMinutesMin
                            )
                            .describe('Minutes before the event start.'),
                        })
                        .describe(
                          "One reminder: how it alerts and how many minutes before the event start\n(before midnight in the calendar's zone for all-day events) it fires."
                        )
                    )
                    .optional()
                    .describe(
                      'Explicit reminders replacing the defaults when `use_default` is off.'
                    ),
                  useDefault: zod
                    .boolean()
                    .describe(
                      "Whether the calendar's default reminders apply."
                    ),
                })
                .optional()
                .describe(
                  "Per-user reminder configuration for an event, mirroring Google's model:\neither the calendar's default reminders apply, or the explicit overrides\nreplace them entirely."
                ),
              sequence: zod
                .number()
                .min(listOccurrencesResponseItemsItemEventSequenceMin)
                .describe('Provider\/iCalendar sequence number.'),
              status: zod
                .enum(['confirmed', 'tentative', 'cancelled'])
                .describe('Canonical event status.'),
              time: zod
                .union([
                  zod
                    .object({
                      endsAt: zod.iso
                        .datetime({})
                        .describe('Exclusive end instant.'),
                      kind: zod.enum(['timed']),
                      startsAt: zod.iso
                        .datetime({})
                        .describe('Inclusive start instant.'),
                      timeZone: zod
                        .string()
                        .nullish()
                        .describe(
                          'Original IANA time-zone identifier, when supplied.'
                        ),
                    })
                    .describe('An event with absolute instants.'),
                  zod
                    .object({
                      endDate: zod.iso
                        .date()
                        .describe('Exclusive local end date.'),
                      kind: zod.enum(['allDay']),
                      startDate: zod.iso
                        .date()
                        .describe('Inclusive local start date.'),
                    })
                    .describe(
                      "An all-day event using RFC 5545's exclusive end date."
                    ),
                ])
                .describe(
                  'The mutually exclusive time shape of a calendar event.\n\nFields are renamed per variant rather than with `rename_all_fields`\nbecause utoipa only honors variant-level serde renames when it\nderives the OpenAPI schema.'
                ),
              title: zod.string().describe('Display title.'),
              transparency: zod
                .enum(['opaque', 'transparent'])
                .describe('Whether an event blocks availability.'),
              updatedAt: zod.iso.datetime({}).describe('Entity update time.'),
              visibility: zod
                .enum(['default', 'public', 'private', 'confidential'])
                .describe('Visibility of event details.'),
            })
            .describe('A stable, first-class Macro calendar event entity.'),
          occurrence: zod
            .object({
              eventId: zod.uuid().describe('Owning event entity.'),
              isCancelled: zod
                .boolean()
                .describe('Whether the instance was cancelled.'),
              occurrenceKey: zod
                .string()
                .describe('Stable key within the event.'),
              recurrenceId: zod
                .string()
                .nullish()
                .describe('Provider recurrence identifier, when applicable.'),
              time: zod
                .union([
                  zod
                    .object({
                      endsAt: zod.iso
                        .datetime({})
                        .describe('Exclusive end instant.'),
                      kind: zod.enum(['timed']),
                      startsAt: zod.iso
                        .datetime({})
                        .describe('Inclusive start instant.'),
                      timeZone: zod
                        .string()
                        .nullish()
                        .describe(
                          'Original IANA time-zone identifier, when supplied.'
                        ),
                    })
                    .describe('An event with absolute instants.'),
                  zod
                    .object({
                      endDate: zod.iso
                        .date()
                        .describe('Exclusive local end date.'),
                      kind: zod.enum(['allDay']),
                      startDate: zod.iso
                        .date()
                        .describe('Inclusive local start date.'),
                    })
                    .describe(
                      "An all-day event using RFC 5545's exclusive end date."
                    ),
                ])
                .describe(
                  'The mutually exclusive time shape of a calendar event.\n\nFields are renamed per variant rather than with `rename_all_fields`\nbecause utoipa only honors variant-level serde renames when it\nderives the OpenAPI schema.'
                ),
            })
            .describe(
              'A materialized recurrence instance optimized for range queries.'
            ),
        })
        .describe(
          'One materialized occurrence paired with its stable calendar event entity.'
        )
    ),
    nextCursor: zod.string().nullish(),
    syncStatus: zod
      .enum(['syncing', 'ready'])
      .describe(
        'Aggregate ingestion state across every calendar account visible to a\nrequester, letting clients render progressively while sources build.'
      ),
  })
  .describe('Paginated calendar occurrence viewport response.');

/**
 * @summary Resolve mentioned calendar events to the requester's own projections.
 */
export const mentionPreviewsBody = zod
  .object({
    items: zod
      .array(
        zod
          .object({
            eventId: zod.uuid().describe('Mentioned calendar event id.'),
            occurrenceKey: zod
              .string()
              .nullish()
              .describe(
                'Occurrence the mention points at, when it targets one instance.'
              ),
          })
          .describe('One mentioned event to resolve for the requester.')
      )
      .describe('Mentioned events to resolve, at most 100.'),
  })
  .describe('Batch calendar mention preview request.');

export const mentionPreviewsResponseItemsItemEventAttendeeCountMin = 0;

export const mentionPreviewsResponse = zod
  .object({
    items: zod.array(
      zod
        .object({
          event: zod
            .union([
              zod.null(),
              zod
                .object({
                  attendeeCount: zod
                    .number()
                    .min(mentionPreviewsResponseItemsItemEventAttendeeCountMin)
                    .describe("Number of attendees on the requester's copy."),
                  isRecurring: zod
                    .boolean()
                    .describe('Whether the event repeats.'),
                  location: zod
                    .string()
                    .nullish()
                    .describe('Location label, when set.'),
                  occurrenceKey: zod
                    .string()
                    .nullish()
                    .describe(
                      'Key of the previewed instance, absent when no occurrence is\nmaterialized.'
                    ),
                  organizerEmail: zod
                    .string()
                    .nullish()
                    .describe('Organizer email.'),
                  organizerName: zod
                    .string()
                    .nullish()
                    .describe('Organizer display name.'),
                  time: zod
                    .union([
                      zod
                        .object({
                          endsAt: zod.iso
                            .datetime({})
                            .describe('Exclusive end instant.'),
                          kind: zod.enum(['timed']),
                          startsAt: zod.iso
                            .datetime({})
                            .describe('Inclusive start instant.'),
                          timeZone: zod
                            .string()
                            .nullish()
                            .describe(
                              'Original IANA time-zone identifier, when supplied.'
                            ),
                        })
                        .describe('An event with absolute instants.'),
                      zod
                        .object({
                          endDate: zod.iso
                            .date()
                            .describe('Exclusive local end date.'),
                          kind: zod.enum(['allDay']),
                          startDate: zod.iso
                            .date()
                            .describe('Inclusive local start date.'),
                        })
                        .describe(
                          "An all-day event using RFC 5545's exclusive end date."
                        ),
                    ])
                    .describe(
                      'The mutually exclusive time shape of a calendar event.\n\nFields are renamed per variant rather than with `rename_all_fields`\nbecause utoipa only honors variant-level serde renames when it\nderives the OpenAPI schema.'
                    ),
                  title: zod.string().describe('Display title.'),
                  updatedAt: zod.iso
                    .datetime({})
                    .describe("Entity update time of the requester's copy."),
                  viewerEventId: zod
                    .uuid()
                    .describe(
                      "The requester's own event entity for the mentioned meeting. Differs\nfrom the mentioned id when the mention came from another attendee."
                    ),
                })
                .describe(
                  "Meeting-level fields shown in a calendar event mention preview, taken from\nthe requester's own projection of the meeting."
                ),
            ])
            .optional(),
          eventId: zod
            .uuid()
            .describe('The mentioned event id, echoed from the request.'),
          type: zod
            .enum(['access', 'no_access', 'does_not_exist'])
            .describe('Requester-relative visibility of one mentioned event.'),
        })
        .describe('Resolution of one mentioned event, in request order.')
    ),
  })
  .describe('Batch calendar mention preview response.');

/**
 * Batch-fetches lightweight previews for a list of call ids. Mirrors the
`POST /documents/preview` endpoint: no per-id access checks, duplicate
ids are deduplicated server-side, and missing ids come back as
`CallRecordPreview::DoesNotExist` rather than producing an error.
 * @summary Handler for `POST /call/record/preview`.
 */
export const getBatchCallRecordPreviewBody = zod
  .object({
    callIds: zod
      .array(zod.uuid())
      .describe(
        'The call ids to preview. Duplicate ids are deduplicated server-side.\nCapped at [`MAX_BATCH_CALL_IDS`] entries.'
      ),
  })
  .describe(
    'Request body for `POST \/call\/record\/preview`.\n\nThe `call_ids` list is bounded at [`MAX_BATCH_CALL_IDS`]; the handler\nrejects anything larger with a 400 before touching the database.'
  );

export const getBatchCallRecordPreviewResponse = zod
  .object({
    previews: zod
      .array(
        zod
          .union([
            zod
              .object({
                callId: zod.uuid().describe('The call identifier.'),
                channelId: zod
                  .uuid()
                  .describe('The channel this call belongs to.'),
                channelName: zod
                  .string()
                  .nullish()
                  .describe('Resolved display name for the channel.'),
                customName: zod
                  .string()
                  .nullish()
                  .describe(
                    'User-supplied or AI-generated display name for the call. Only set on\narchived `call_records`; active calls always return `None`.'
                  ),
                endedAt: zod.iso
                  .datetime({})
                  .nullish()
                  .describe('When the call ended (None if still active).'),
                startedAt: zod.iso
                  .datetime({})
                  .describe(
                    'When the call started (created_at for active, started_at for archived).'
                  ),
              })
              .describe('Preview payload returned for each found call id.')
              .and(
                zod.object({
                  type: zod.enum(['exists']),
                })
              )
              .describe(
                'The call exists (in either the active or archived table).'
              ),
            zod
              .object({
                callId: zod.uuid().describe('The call identifier.'),
              })
              .describe(
                'Wrapper carrying just a call id. Used by the [`CallRecordPreview::DoesNotExist`]\nvariant.'
              )
              .and(
                zod.object({
                  type: zod.enum(['does_not_exist']),
                })
              )
              .describe(
                'No call with this id exists in either the active or archived tables.'
              ),
          ])
          .describe(
            'Lightweight preview of a call record, returned by the batch preview endpoint.\n\nEach requested id resolves to one of two outcomes: the call exists\n(`Exists`) or it does not (`DoesNotExist`). The endpoint does not perform\naccess checks, so there is no separate \"not authorized\" variant.'
          )
      )
      .describe('One entry per deduplicated input id.'),
  })
  .describe('Response body for `POST \/call\/record\/preview`.');

/**
 * Returns the full [`CallRecord`] (metadata + participants + transcript)
for a call identified by its own id. Covers both active and archived calls.
Access is validated via channel membership (MemberParticipantRole).
 * @summary Handler for `GET /call/record/{call_id}`.
 */
export const getCallRecordParams = zod.object({
  call_id: zod.uuid().describe('Call ID'),
});

export const getCallRecordResponse = zod
  .object({
    callId: zod.uuid().describe('The call identifier.'),
    channelId: zod.uuid().describe('The channel this call belongs to.'),
    channelName: zod
      .string()
      .nullish()
      .describe('Resolved display name for the channel.'),
    createdBy: zod.string().describe('User who created the call.'),
    customName: zod
      .string()
      .nullish()
      .describe(
        'User-supplied or AI-generated display name for the call. Only set on\narchived `call_records`; active calls always return `None`.'
      ),
    durationMs: zod
      .number()
      .nullish()
      .describe('Call duration in milliseconds (None if still active).'),
    egressId: zod.string().nullish().describe('Recording egress ID, if any.'),
    endedAt: zod.iso
      .datetime({})
      .nullish()
      .describe('When the call ended (None if still active).'),
    isActive: zod
      .boolean()
      .describe('Whether the call is currently active (from `calls` table).'),
    participants: zod
      .array(
        zod
          .object({
            joinedAt: zod.iso
              .datetime({})
              .describe('When the user joined the call.'),
            leftAt: zod.iso
              .datetime({})
              .nullish()
              .describe(
                'When the user left (None if still in an active call).'
              ),
            userId: zod.string().describe('The user id.'),
          })
          .describe(
            'A participant as returned in a [`CallRecord`] (historic — includes `left_at`).'
          )
      )
      .describe('Participants (both active and historic).'),
    recordingPreviewUrl: zod
      .string()
      .nullish()
      .describe(
        'Presigned URL for the call recording preview image, if available.'
      ),
    recordingStartedAt: zod.iso
      .datetime({})
      .nullish()
      .describe(
        'When the egress recording actually began. `None` until the\n`egress_started` webhook arrives (typically a few seconds after\n`started_at`). Frontend should anchor transcript-to-audio sync to\nthis value when present, falling back to `started_at` otherwise.'
      ),
    recordingUrl: zod
      .string()
      .nullish()
      .describe('Presigned URL for the call recording, if available.'),
    roomName: zod.string().describe('The RTC room name.'),
    shareWithTeam: zod
      .boolean()
      .describe("Whether the call is shared with the creator's team."),
    startedAt: zod.iso
      .datetime({})
      .describe(
        'When the call started (created_at for active, started_at for archived).'
      ),
    status: zod
      .union([
        zod.null(),
        zod
          .enum(['ATTENDED', 'MISSED', 'UNATTENDED'])
          .describe(
            'Viewer-relative attendance status for a call record.\nSerializes as `ATTENDED`, `MISSED`, or `UNATTENDED`.'
          ),
      ])
      .optional(),
    summary: zod
      .string()
      .nullish()
      .describe(
        'AI-generated summary of the call. Only set on archived `call_records`\nonce summarization has run; active calls always return `None`.'
      ),
    transcript: zod
      .array(
        zod
          .object({
            content: zod.string().describe('The transcribed text content.'),
            diarizedSpeakerId: zod
              .string()
              .nullish()
              .describe(
                "Stable per-speaker identifier produced by the STT provider's diarization\npass. Unique across tracks in the call. `None` when the provider didn't\nreturn a speaker label."
              ),
            endedAt: zod.iso
              .datetime({})
              .nullish()
              .describe('When the speaker stopped (if known).'),
            segmentId: zod
              .string()
              .nullish()
              .describe('LiveKit segment ID (nullable for archived records).'),
            sequenceNum: zod.number().describe('Ordering within the call.'),
            speakerId: zod.string().describe("The speaker's user ID."),
            startedAt: zod.iso
              .datetime({})
              .describe('When the speaker started this segment.'),
            transcriptId: zod
              .uuid()
              .describe('Stable DB-row id for the segment.'),
          })
          .describe('A transcript segment as returned in a [`CallRecord`].')
      )
      .describe('Transcript segments ordered by `sequence_num`.'),
    userAccessLevel: zod
      .union([
        zod.null(),
        zod
          .enum(['view', 'comment', 'edit', 'owner'])
          .describe('Ordered from least to most access top -> bottom'),
      ])
      .optional(),
  })
  .describe(
    'Full record of a call, unifying rows from `calls` (active) and\n`call_records` (archived) into a single response shape.'
  );

/**
 * Deletes a call record (and its participants/transcripts via cascade).
Access is validated via channel membership (MemberParticipantRole).
 * @summary Handler for `DELETE /call/record/{call_id}`.
 */
export const deleteCallRecordParams = zod.object({
  call_id: zod.uuid().describe('Call ID'),
});

/**
 * Edits a call record — currently supports updating the record's share
permissions. Access is validated via channel membership
 * @summary Handler for `PATCH /call/record/{call_id}`.
 */
export const editCallRecordParams = zod.object({
  call_id: zod.uuid().describe('Call ID'),
});

export const editCallRecordBody = zod
  .object({
    customName: zod
      .string()
      .nullish()
      .describe(
        'Updated user-supplied display name for the call. `None` is a no-op;\n`Some(\"\")` clears `call_records.custom_name`; any other `Some(s)`\noverwrites it with `s`. Only the archived `call_records` row carries\nthis column — patching while the call is still active is a no-op for\nthis field.'
      ),
    sharePermission: zod
      .union([
        zod.null(),
        zod.object({
          channelSharePermissions: zod
            .array(
              zod.object({
                accessLevel: zod
                  .union([
                    zod.null(),
                    zod
                      .enum(['view', 'comment', 'edit', 'owner'])
                      .describe(
                        'Ordered from least to most access top -> bottom'
                      ),
                  ])
                  .optional(),
                channelId: zod.string().describe('The channel id'),
                operation: zod.enum(['add', 'remove', 'replace']),
              })
            )
            .nullish()
            .describe(
              'Any channel share permissions to be created\/updated\/removed'
            ),
          linkShare: zod
            .union([
              zod.null(),
              zod
                .enum(['PUBLIC', 'TEAM'])
                .describe(
                  'Defines who can access an item through its share link.'
                ),
            ])
            .optional(),
          linkShareAccessLevel: zod
            .union([
              zod.null(),
              zod
                .enum(['view', 'comment', 'edit', 'owner'])
                .describe('Ordered from least to most access top -> bottom'),
            ])
            .optional(),
        }),
      ])
      .optional(),
    shareWithTeam: zod
      .boolean()
      .nullish()
      .describe(
        "If `Some(true)`, grant the creator's team View access on the call.\nIf `Some(false)`, revoke the creator's team's access. `None` is a no-op.\nThe team is resolved from the call's `created_by`, not the acting user."
      ),
  })
  .describe('Edit call request');

/**
 * Toggles the `share_with_team` flag on the active call. Returns the new
value as the JSON body.
 * @summary Handler for `POST /call/record/{call_id}/share-with-team/toggle`.
 */
export const toggleShareWithTeamParams = zod.object({
  call_id: zod.uuid().describe('Call ID'),
});

export const toggleShareWithTeamResponse = zod.boolean();

/**
 * Applies per-diarized-speaker `custom_speaker` overrides to the call's
archived transcript rows. Auth uses the same `EditAccessLevel` extractor
as `edit_call_record_handler`.
 * @summary Handler for `PATCH /call/record/{call_id}/transcript`.
 */
export const editCallTranscriptParams = zod.object({
  call_id: zod.uuid().describe('Call ID'),
});

export const editCallTranscriptBody = zod
  .object({
    assignments: zod
      .array(
        zod
          .object({
            customSpeaker: zod
              .string()
              .describe(
                'Macro user id to attribute matching rows to, or `None` to clear.'
              ),
            diarizedSpeakerId: zod
              .string()
              .describe(
                'The diarization label whose rows this assignment targets.'
              ),
          })
          .describe(
            'One per-diarized-speaker override, used in [`EditCallTranscriptRequest`].\n\n`custom_speaker = None` clears any existing override for this\n`diarized_speaker_id`; `Some(macro_user_id)` sets it. The string is\nexpected to parse as a `MacroUserId` (e.g. `macro|alice@example.com`);\nthe service layer rejects malformed values with `400 Bad Request`.'
          )
      )
      .describe('The set of per-diarized-speaker overrides to apply.'),
  })
  .describe(
    'Body of `PATCH \/call\/record\/{call_id}\/transcript`.\n\nEach entry in `assignments` sets (or clears, when `custom_speaker` is\n`None`) the `custom_speaker` override for every transcript row in the\ncall whose `diarized_speaker_id` matches. Diarized speakers not listed\nare left untouched. Empty `assignments` is a 204 no-op.'
  );

/**
 * Reports whether the authenticated user should keep ringing for the call.
Polled by native clients while the CallKit incoming-call UI is showing, so
a ring can be cancelled when the user answers on another device
(`answered`) or the call ends before anyone answers (`ended`).

Outside the user-auth layer: the bearer credential is the recipient's
LiveKit JWT from the VoIP push payload, verified with the LiveKit secret.
 * @summary Handler for `GET /call/ring-status/{call_id}`.
 */
export const getRingStatusParams = zod.object({
  call_id: zod.uuid().describe('Call ID'),
});

export const getRingStatusResponse = zod
  .object({
    status: zod
      .enum(['ringing', 'answered', 'ended'])
      .describe(
        'Per-user status of an incoming-call ring, as reported by the\nring-status endpoint while a native client is ringing.'
      ),
  })
  .describe('Response body for `GET \/call\/ring-status\/{call_id}`.');

/**
 * Gets or creates a call for the channel. If a call already exists, joins it;
otherwise creates a new one. Always returns a join token.
 * @summary Handler for `GET /call/{channel_id}`.
 */
export const getOrCreateCallParams = zod.object({
  channel_id: zod.uuid().describe('Channel ID'),
});

export const getOrCreateCallResponse = zod
  .object({
    callId: zod.uuid().describe('The call identifier.'),
    channelId: zod.uuid().describe('The channel this call is associated with.'),
    roomName: zod.string().describe('The RTC room name.'),
    serverUrl: zod
      .string()
      .describe('The RTC server URL for the frontend SDK to connect to.'),
    token: zod.string().describe('The RTC token for connecting to the room.'),
  })
  .describe('Response returned when creating or joining a call.');

/**
 * @summary Handler for `DELETE /call/{channel_id}`.
 */
export const leaveOrEndCallParams = zod.object({
  channel_id: zod.uuid().describe('Channel ID'),
});

export const leaveOrEndCallResponse = zod
  .object({
    callEnded: zod
      .boolean()
      .describe('Whether the entire call was ended (room deleted).'),
  })
  .describe('Response for the leave\/end call operation.');

/**
 * Returns 200 with call info if an active call exists, or 204 No Content if not.
 * @summary Handler for `GET /call/{channel_id}/active`.
 */
export const checkActiveCallParams = zod.object({
  channel_id: zod.uuid().describe('Channel ID'),
});

export const checkActiveCallResponse = zod
  .object({
    callId: zod.uuid().describe('The call identifier.'),
    channelId: zod.uuid().describe('The channel this call belongs to.'),
    createdAt: zod.iso.datetime({}).describe('When the call was created.'),
    createdBy: zod.string().describe('User who created the call.'),
  })
  .describe('Response indicating whether an active call exists for a channel.');

/**
 * Receives transcript segments from the transcription agent.
Authenticated via the `x-macro-internal-call` shared secret.
Duplicate segments (same `segment_id`) are ignored.
 * @summary Handler for `POST /call/{channel_id}/transcript`.
 */
export const ingestTranscriptParams = zod.object({
  channel_id: zod.uuid().describe('Channel ID'),
});

export const ingestTranscriptBody = zod
  .object({
    content: zod.string().describe('The transcribed text content.'),
    diarizedSpeakerId: zod
      .string()
      .nullish()
      .describe(
        "Stable per-speaker identifier produced by the STT provider's diarization\npass. Namespaced upstream by audio track so values are unique across all\ntracks in a call. `None` when the provider didn't return a speaker label."
      ),
    embedding: zod
      .array(zod.number())
      .nullish()
      .describe(
        'Speaker voice embedding computed by the transcription agent\n(e.g. a Resemblyzer 256-dim vector). When present, the server\nupserts a `voice` row and stores the resulting id on the transcript\nsegment so the call-finished pipeline can match it to enrolled users.'
      ),
    endedAt: zod.iso
      .datetime({})
      .nullish()
      .describe('When the speaker stopped talking for this segment.'),
    isFinal: zod
      .boolean()
      .describe('Whether this is a final transcription (not interim).'),
    segmentId: zod
      .string()
      .describe(
        'LiveKit segment ID (used for deduplication across multiple submitters).'
      ),
    speakerId: zod
      .string()
      .describe("The speaker's user ID (from `lk.transcribed_track_id`)."),
    startedAt: zod.iso
      .datetime({})
      .describe('When the speaker started talking for this segment.'),
    streamStartedAt: zod.iso
      .datetime({})
      .nullish()
      .describe(
        "Wall-clock when the transcriber's STT stream first received audio\nfor this participant. The server takes the earliest non-null value\nacross all participants and uses it to overwrite the\n`egress_started`-derived `recording_started_at`, which is too early\n(it stamps egress bootstrap, not first audio frame)."
      ),
  })
  .describe('A transcript segment from LiveKit Inference STT.');

/**
 * @summary Handler for `POST /channels`.
 */
export const createChannelBodyAutoJoinTeamDefault = false;

export const createChannelBody = zod
  .object({
    auto_join_team: zod
      .boolean()
      .optional()
      .describe(
        'Whether team members automatically join this channel. Defaults to false.'
      ),
    channel_type: zod
      .enum(['public', 'private', 'direct_message', 'team'])
      .describe('Type of channel.'),
    name: zod.string().nullish().describe('Optional channel name.'),
    participants: zod
      .array(zod.string())
      .describe('Participants to add, excluding the owner.'),
    team_id: zod.uuid().nullish().describe('Team id for team channels.'),
  })
  .describe('Request to create a channel.');

export const createChannelResponse = zod
  .object({
    id: zod.string().describe('Created channel id.'),
  })
  .describe('Response returned after creating a channel.');

/**
 * @summary Handler for `GET /channels/activity`.
 */
export const getActivityResponseItem = zod
  .object({
    channel_id: zod.uuid().describe('Channel id.'),
    created_at: zod.iso
      .datetime({})
      .describe('When the activity row was created.'),
    id: zod.uuid().describe('Activity id.'),
    interacted_at: zod.iso
      .datetime({})
      .nullish()
      .describe('The last time the user interacted with the channel.'),
    updated_at: zod.iso
      .datetime({})
      .describe('When the activity row was last updated.'),
    user_id: zod.string().describe('User id.'),
    viewed_at: zod.iso
      .datetime({})
      .nullish()
      .describe('The last time the user viewed the channel.'),
  })
  .describe("A user's activity (view\/interaction) within a channel.");
export const getActivityResponse = zod.array(getActivityResponseItem);

/**
 * @summary Handler for `POST /channels/activity`.
 */
export const postActivityBody = zod
  .object({
    activity_type: zod
      .enum(['view', 'interact'])
      .describe('The kind of activity a user performs in a channel.'),
    channel_id: zod.string().describe('Channel id to record activity for.'),
  })
  .describe('Request body for `POST \/channels\/activity`.');

export const postActivityResponse = zod
  .object({
    channel_id: zod.uuid().describe('Channel id.'),
    created_at: zod.iso
      .datetime({})
      .describe('When the activity row was created.'),
    id: zod.uuid().describe('Activity id.'),
    interacted_at: zod.iso
      .datetime({})
      .nullish()
      .describe('The last time the user interacted with the channel.'),
    updated_at: zod.iso
      .datetime({})
      .describe('When the activity row was last updated.'),
    user_id: zod.string().describe('User id.'),
    viewed_at: zod.iso
      .datetime({})
      .nullish()
      .describe('The last time the user viewed the channel.'),
  })
  .describe("A user's activity (view\/interaction) within a channel.");

/**
 * @summary Handler for `GET /channels/attachments/{entity_type}/{entity_id}/references`.
 */
export const getAttachmentReferencesParams = zod.object({
  entity_type: zod.string().describe('Type of the attachment entity'),
  entity_id: zod.string().describe('Id of the attachment entity'),
});

export const getAttachmentReferencesResponse = zod
  .object({
    references: zod
      .array(
        zod
          .union([
            zod
              .object({
                attachment_created_at: zod.iso
                  .datetime({})
                  .describe('When the attachment row was created.'),
                channel_id: zod
                  .uuid()
                  .describe('Channel that contains the message.'),
                channel_name: zod
                  .string()
                  .nullish()
                  .describe('Optional channel name (DMs do not have a name).'),
                message_content: zod
                  .string()
                  .describe(
                    'Full message content (might be used for preview\/snippet).'
                  ),
                message_created_at: zod.iso
                  .datetime({})
                  .describe('When the message itself was created.'),
                message_id: zod
                  .uuid()
                  .describe('Message that contains the attachment reference.'),
                sender_id: zod.string().describe('Sender of the message.'),
                thread_id: zod
                  .uuid()
                  .nullish()
                  .describe(
                    'If the message belongs to a thread this is the parent id.'
                  ),
              })
              .describe(
                'A reference to an attachment entity from a channel message.'
              )
              .and(
                zod.object({
                  reference_type: zod.enum(['channel']),
                })
              )
              .describe('Referenced from a channel message.'),
            zod
              .object({
                created_at: zod.iso
                  .datetime({})
                  .describe('When this reference was created.'),
                entity_id: zod
                  .string()
                  .describe('ID of the referenced entity.'),
                entity_type: zod
                  .string()
                  .describe('Type of the referenced entity.'),
                source_entity_id: zod
                  .string()
                  .describe('ID of the source entity.'),
                source_entity_type: zod
                  .string()
                  .describe(
                    'Type of the source entity (e.g., \"document\", \"chat\", etc.).'
                  ),
                user_id: zod
                  .string()
                  .nullish()
                  .describe(
                    'User who created this reference (optional for non-user sources).'
                  ),
              })
              .describe(
                'A reference to an attachment entity from a non-message source.'
              )
              .and(
                zod.object({
                  reference_type: zod.enum(['generic']),
                })
              )
              .describe('Referenced from any non-message source entity.'),
          ])
          .describe('An attachment reference, tagged by source kind.')
      )
      .describe('References to the requested entity, newest-first.'),
  })
  .describe('Response from the attachment-references endpoint.');

/**
 * @summary Handler for `POST /channels/get_or_create_dm`.
 */
export const getOrCreateDmBody = zod
  .object({
    recipient_id: zod.string().describe('Recipient user id.'),
  })
  .describe('Request to get or create a direct message channel.');

export const getOrCreateDmResponse = zod
  .object({
    action: zod
      .enum(['get', 'create'])
      .describe('Result of a get-or-create channel operation.'),
    channel_id: zod.string().describe('Channel id.'),
  })
  .describe('Response for get-or-create channel operations.');

/**
 * @summary Handler for `POST /channels/get_or_create_private`.
 */
export const getOrCreatePrivateBody = zod
  .object({
    recipients: zod.array(zod.string()).describe('Recipient user ids.'),
  })
  .describe('Request to get or create a private channel.');

export const getOrCreatePrivateResponse = zod
  .object({
    action: zod
      .enum(['get', 'create'])
      .describe('Result of a get-or-create channel operation.'),
    channel_id: zod.string().describe('Channel id.'),
  })
  .describe('Response for get-or-create channel operations.');

/**
 * @summary Handler for `POST /channels/join/{join_code}`.
 */
export const joinChannelByCodeParams = zod.object({
  join_code: zod.uuid().describe('Channel join code'),
});

/**
 * @summary Handler for `POST /channels/mentions`.
 */
export const createEntityMentionBody = zod
  .object({
    entity_id: zod.string().describe('Id of the mentioned entity.'),
    entity_type: zod.string().describe('Type of the mentioned entity.'),
    source_entity_id: zod
      .string()
      .describe('Id of the entity that owns the mention.'),
    source_entity_type: zod
      .string()
      .describe('Type of the entity that owns the mention.'),
  })
  .describe('Request body for `POST \/channels\/mentions`.');

/**
 * @summary Handler for `DELETE /channels/mentions/{mention_id}`.
 */
export const deleteEntityMentionParams = zod.object({
  mention_id: zod.uuid().describe('Entity mention id'),
});

export const deleteEntityMentionResponse = zod
  .object({
    deleted: zod.boolean().describe('Whether the mention was deleted.'),
  })
  .describe('Response body for `DELETE \/channels\/mentions\/{mention_id}`.');

/**
 * @summary Handler for `POST /channels/preview`.
 */
export const getBatchChannelPreviewBody = zod
  .object({
    channel_ids: zod.array(zod.string()).describe('Channel ids to look up.'),
  })
  .describe('Request for a batched channel preview lookup.');

export const getBatchChannelPreviewResponse = zod
  .object({
    previews: zod
      .array(
        zod
          .union([
            zod
              .object({
                channel_id: zod.string().describe('Channel id.'),
                channel_name: zod
                  .string()
                  .describe('Resolved channel display name.'),
                channel_type: zod
                  .enum(['public', 'private', 'direct_message', 'team'])
                  .describe('Type of channel.'),
              })
              .describe('Preview payload returned for accessible channels.')
              .and(
                zod.object({
                  type: zod.enum(['access']),
                })
              )
              .describe('Viewer can access the channel.'),
            zod
              .object({
                channel_id: zod.string().describe('Channel id.'),
              })
              .describe(
                'Preview payload returned for channels with only id information.'
              )
              .and(
                zod.object({
                  type: zod.enum(['no_access']),
                })
              )
              .describe('Viewer cannot access the channel.'),
            zod
              .object({
                channel_id: zod.string().describe('Channel id.'),
              })
              .describe(
                'Preview payload returned for channels with only id information.'
              )
              .and(
                zod.object({
                  type: zod.enum(['does_not_exist']),
                })
              )
              .describe('Channel does not exist.'),
          ])
          .describe('Preview entry for a single channel id.')
      )
      .describe('Resolved channel previews, one per requested channel id.'),
  })
  .describe('Response for a batched channel preview lookup.');

/**
 * @summary Handler for `GET /channels/{channel_id}`.
 */
export const getChannelParams = zod.object({
  channel_id: zod.uuid().describe('Channel ID'),
});

export const getChannelQueryLimitMin = 0;

export const getChannelQueryParams = zod.object({
  limit: zod
    .number()
    .min(getChannelQueryLimitMin)
    .optional()
    .describe('Recent message page size (1-100, default 50)'),
});

export const getChannelResponse = zod
  .object({
    channel_id: zod.uuid().describe('Channel id.'),
    channel_name: zod
      .string()
      .describe("Resolved display name from the viewer's perspective."),
    channel_type: zod
      .enum(['public', 'private', 'direct_message', 'team'])
      .describe('Type of channel.'),
    messages: zod
      .array(
        zod
          .object({
            attachments: zod
              .array(
                zod
                  .object({
                    created_at: zod.iso
                      .datetime({})
                      .describe('When the attachment was created.'),
                    entity_id: zod.string().describe('Entity id.'),
                    entity_type: zod.string().describe('Type of entity.'),
                    height: zod
                      .number()
                      .nullish()
                      .describe('Height (for images).'),
                    id: zod.uuid().describe('Attachment id.'),
                    width: zod
                      .number()
                      .nullish()
                      .describe('Width (for images).'),
                  })
                  .describe('An attachment on a message.')
              )
              .describe('Attachments on this message.'),
            channel_id: zod.uuid().describe('Channel id.'),
            content: zod.string().describe('Message content.'),
            created_at: zod.iso
              .datetime({})
              .describe('When the message was created.'),
            deleted_at: zod.iso
              .datetime({})
              .nullish()
              .describe('When the message was soft-deleted.'),
            edited_at: zod.iso
              .datetime({})
              .nullish()
              .describe('When the message was edited.'),
            id: zod.uuid().describe('Message id.'),
            reactions: zod
              .array(
                zod
                  .object({
                    emoji: zod.string().describe('The emoji string.'),
                    users: zod
                      .array(zod.string())
                      .describe('User ids who added this reaction.'),
                  })
                  .describe('A reaction with emoji and user list.')
              )
              .describe('Reactions on this message.'),
            sender: zod
              .object({
                avatar_url: zod
                  .string()
                  .nullish()
                  .describe('Avatar URL for bot senders.'),
                id: zod
                  .string()
                  .describe('Sender id without the storage namespace prefix.'),
                name: zod
                  .string()
                  .nullish()
                  .describe('Display name for bot senders.'),
                triggered_by: zod
                  .string()
                  .nullish()
                  .describe(
                    'For an agent (bot) message, the id of the user who triggered it.'
                  ),
                type: zod.enum(['user', 'bot']).describe('Public sender type.'),
              })
              .describe('Public sender identity for channel messages.'),
            sender_id: zod.string().describe('Sender user id.'),
            thread: zod
              .object({
                latest_reply_at: zod.iso
                  .datetime({})
                  .nullish()
                  .describe('Timestamp of the latest reply.'),
                preview: zod
                  .array(
                    zod
                      .object({
                        attachments: zod
                          .array(
                            zod
                              .object({
                                created_at: zod.iso
                                  .datetime({})
                                  .describe('When the attachment was created.'),
                                entity_id: zod.string().describe('Entity id.'),
                                entity_type: zod
                                  .string()
                                  .describe('Type of entity.'),
                                height: zod
                                  .number()
                                  .nullish()
                                  .describe('Height (for images).'),
                                id: zod.uuid().describe('Attachment id.'),
                                width: zod
                                  .number()
                                  .nullish()
                                  .describe('Width (for images).'),
                              })
                              .describe('An attachment on a message.')
                          )
                          .describe('Attachments on this reply.'),
                        content: zod.string().describe('Reply content.'),
                        created_at: zod.iso
                          .datetime({})
                          .describe('When the reply was created.'),
                        edited_at: zod.iso
                          .datetime({})
                          .nullish()
                          .describe('When the reply was edited.'),
                        id: zod.uuid().describe('Reply id.'),
                        reactions: zod
                          .array(
                            zod
                              .object({
                                emoji: zod
                                  .string()
                                  .describe('The emoji string.'),
                                users: zod
                                  .array(zod.string())
                                  .describe(
                                    'User ids who added this reaction.'
                                  ),
                              })
                              .describe('A reaction with emoji and user list.')
                          )
                          .describe('Reactions on this reply.'),
                        sender: zod
                          .object({
                            avatar_url: zod
                              .string()
                              .nullish()
                              .describe('Avatar URL for bot senders.'),
                            id: zod
                              .string()
                              .describe(
                                'Sender id without the storage namespace prefix.'
                              ),
                            name: zod
                              .string()
                              .nullish()
                              .describe('Display name for bot senders.'),
                            triggered_by: zod
                              .string()
                              .nullish()
                              .describe(
                                'For an agent (bot) message, the id of the user who triggered it.'
                              ),
                            type: zod
                              .enum(['user', 'bot'])
                              .describe('Public sender type.'),
                          })
                          .describe(
                            'Public sender identity for channel messages.'
                          ),
                        sender_id: zod.string().describe('Sender user id.'),
                        updated_at: zod.iso
                          .datetime({})
                          .describe('When the reply was last updated.'),
                      })
                      .describe('A thread reply shown in preview.')
                  )
                  .describe('Last N replies for thread preview.'),
                reply_count: zod.number().describe('Total reply count.'),
              })
              .describe('Thread metadata and preview replies.'),
            updated_at: zod.iso
              .datetime({})
              .describe('When the message was last updated.'),
          })
          .describe('A top-level channel message with thread info.')
      )
      .describe('Recent messages (newest-first first page).'),
    participants: zod
      .array(
        zod
          .object({
            channel_id: zod.uuid().describe('Channel id.'),
            joined_at: zod.iso.datetime({}).describe('When the user joined.'),
            role: zod
              .enum(['owner', 'admin', 'member'])
              .describe('Participant role in a channel.'),
            user_id: zod.string().describe('User id.'),
          })
          .describe('A channel participant.')
      )
      .describe('Active participants.'),
  })
  .describe(
    'Channel detail: metadata, active participants, and a recent page of messages.\n\n`messages` is the newest-first first page (size controlled by `limit`); use the\ndedicated `\/{channel_id}\/messages` endpoint for cursor pagination.'
  );

/**
 * @summary Handler for `DELETE /channels/{channel_id}`.
 */
export const deleteChannelParams = zod.object({
  channel_id: zod.uuid().describe('Channel ID'),
});

/**
 * @summary Handler for `PATCH /channels/{channel_id}`.
 */
export const patchChannelParams = zod.object({
  channel_id: zod.uuid().describe('Channel ID'),
});

export const patchChannelBody = zod
  .object({
    auto_join_team: zod
      .boolean()
      .nullish()
      .describe('Whether team members should automatically join the channel.'),
    channel_name: zod.string().nullish().describe('New channel name.'),
    convert_to_team_channel: zod
      .boolean()
      .nullish()
      .describe(
        'Sets whether the channel is a team channel.\n\n`true` converts a non-team channel to a team channel, while `false`\nconverts a team channel to a private channel.'
      ),
  })
  .describe('Request to patch a channel.');

/**
 * @summary Handler for `GET /channels/{channel_id}/attachments`.
 */
export const getChannelAttachmentsParams = zod.object({
  channel_id: zod.uuid().describe('Channel ID'),
});

export const getChannelAttachmentsQueryLimitMin = 0;

export const getChannelAttachmentsQueryParams = zod.object({
  limit: zod
    .number()
    .min(getChannelAttachmentsQueryLimitMin)
    .optional()
    .describe('Page size (1-500, default 50)'),
  cursor: zod.string().optional().describe('Base64 encoded cursor value'),
  attachment_type: zod
    .string()
    .optional()
    .describe(
      "Filter by type: 'static' for images\/videos, 'dss' for documents"
    ),
});

export const getChannelAttachmentsResponse = zod
  .object({
    items: zod
      .array(
        zod
          .object({
            channel_id: zod.uuid().describe('Channel id.'),
            created_at: zod.iso
              .datetime({})
              .describe('When the attachment was created.'),
            entity_id: zod.string().describe('Entity id.'),
            entity_type: zod.string().describe('Type of entity.'),
            height: zod.number().nullish().describe('Height (for images).'),
            id: zod.uuid().describe('Attachment id.'),
            message_id: zod
              .uuid()
              .describe('Message id this attachment belongs to.'),
            sender_id: zod
              .string()
              .describe(
                'The user who sent the message containing this attachment.'
              ),
            width: zod.number().nullish().describe('Width (for images).'),
          })
          .describe('A channel-level attachment.')
      )
      .describe('Attachments on this page.'),
    next_cursor: zod
      .string()
      .nullish()
      .describe('Cursor for the next page, null if no more pages.'),
  })
  .describe('Paginated response of channel attachments.');

/**
 * @summary Handler for `POST /channels/{channel_id}/bots/scoped`.
 */
export const createChannelScopedBotParams = zod.object({
  channel_id: zod.uuid().describe('Channel ID'),
});

export const createChannelScopedBotBody = zod
  .object({
    avatar_url: zod.string().nullish().describe('Optional avatar URL.'),
    description: zod.string().nullish().describe('Optional description.'),
    handle: zod.string().describe('Stable handle.'),
    name: zod.string().describe('Display name.'),
    team_id: zod
      .uuid()
      .nullish()
      .describe(
        'Team owner. The caller must be a team administrator or owner. Omit for a user-owned bot.'
      ),
    token_expires_at: zod.iso
      .datetime({})
      .nullish()
      .describe('Optional token expiration timestamp.'),
    token_label: zod.string().nullish().describe('Optional token label.'),
  })
  .describe('Request to create a bot scoped to a channel.');

/**
 * @summary Handler for `POST /channels/{channel_id}/join`.
 */
export const joinChannelParams = zod.object({
  channel_id: zod.uuid().describe('Channel ID'),
});

/**
 * @summary Handler for `GET /channels/{channel_id}/join-link`.
 */
export const getChannelJoinLinkParams = zod.object({
  channel_id: zod.uuid().describe('Channel ID'),
});

export const getChannelJoinLinkResponse = zod
  .object({
    join_code: zod.uuid().describe('Reusable code for joining the channel.'),
  })
  .describe("Response containing a channel's reusable join code.");

/**
 * @summary Handler for `POST /channels/{channel_id}/leave`.
 */
export const leaveChannelParams = zod.object({
  channel_id: zod.uuid().describe('Channel ID'),
});

/**
 * @summary Handler for `POST /channels/{channel_id}/message`.
 */
export const postMessageParams = zod.object({
  channel_id: zod.uuid().describe('Channel ID'),
});

export const postMessageBody = zod
  .object({
    attachments: zod
      .array(
        zod
          .object({
            entity_id: zod.string().describe('Attachment entity id.'),
            entity_type: zod.string().describe('Attachment entity type.'),
            height: zod
              .number()
              .nullish()
              .describe('Optional rendered height.'),
            width: zod.number().nullish().describe('Optional rendered width.'),
          })
          .describe('New attachment to add to a channel message.')
      )
      .describe('Attachments to add after message creation.'),
    content: zod.string().describe('Message body.'),
    mentions: zod
      .array(
        zod
          .object({
            entity_id: zod.string().describe('Mentioned entity id.'),
            entity_type: zod.string().describe('Mentioned entity type.'),
          })
          .describe('Simple entity mention attached to a message.')
      )
      .describe('Message mentions.'),
    nonce: zod.string().nullish().describe('Optional optimistic-update nonce.'),
    thread_id: zod.uuid().nullish().describe('Optional thread parent id.'),
  })
  .describe('Request to send a channel message.');

export const postMessageResponse = zod
  .object({
    id: zod.string().describe('Created message id.'),
    nonce: zod.string().nullish().describe('Optional optimistic-update nonce.'),
  })
  .describe('Response returned after sending a message.');

/**
 * @summary Handler for `DELETE /channels/{channel_id}/message/{message_id}`.
 */
export const deleteMessageParams = zod.object({
  channel_id: zod.uuid().describe('Channel ID'),
  message_id: zod.uuid().describe('Message ID'),
});

export const deleteMessageQueryParams = zod.object({
  nonce: zod.string().optional().describe('Optional optimistic-update nonce'),
});

/**
 * @summary Handler for `PATCH /channels/{channel_id}/message/{message_id}`.
 */
export const patchMessageParams = zod.object({
  channel_id: zod.uuid().describe('Channel ID'),
  message_id: zod.uuid().describe('Message ID'),
});

export const patchMessageBody = zod
  .object({
    attachment_ids_to_delete: zod
      .array(zod.string())
      .nullish()
      .describe('Attachment ids to remove.'),
    attachments_to_add: zod
      .array(
        zod
          .object({
            entity_id: zod.string().describe('Attachment entity id.'),
            entity_type: zod.string().describe('Attachment entity type.'),
            height: zod
              .number()
              .nullish()
              .describe('Optional rendered height.'),
            width: zod.number().nullish().describe('Optional rendered width.'),
          })
          .describe('New attachment to add to a channel message.')
      )
      .nullish()
      .describe('Attachments to add.'),
    content: zod
      .string()
      .nullish()
      .describe('Optional replacement message body.'),
    mentions: zod
      .array(
        zod
          .object({
            entity_id: zod.string().describe('Mentioned entity id.'),
            entity_type: zod.string().describe('Mentioned entity type.'),
          })
          .describe('Simple entity mention attached to a message.')
      )
      .nullish()
      .describe('Optional replacement mentions.'),
    nonce: zod.string().nullish().describe('Optional optimistic-update nonce.'),
  })
  .describe('Request to patch a channel message.');

/**
 * @summary Handler for `GET /channels/{channel_id}/messages`.
 */
export const getChannelMessagesParams = zod.object({
  channel_id: zod.uuid().describe('Channel ID'),
});

export const getChannelMessagesQueryLimitMin = 0;

export const getChannelMessagesQueryParams = zod.object({
  limit: zod
    .number()
    .min(getChannelMessagesQueryLimitMin)
    .optional()
    .describe('Page size (1-100, default 50)'),
  cursor: zod
    .string()
    .optional()
    .describe('Base64 encoded cursor value for older messages'),
  previous_cursor: zod
    .string()
    .optional()
    .describe('Base64 encoded cursor value for newer messages'),
  load_around_message_id: zod
    .uuid()
    .optional()
    .describe('Return a centered window around this message ID'),
});

export const getChannelMessagesResponse = zod
  .object({
    items: zod
      .array(
        zod
          .object({
            attachments: zod
              .array(
                zod
                  .object({
                    created_at: zod.iso
                      .datetime({})
                      .describe('When the attachment was created.'),
                    entity_id: zod.string().describe('Entity id.'),
                    entity_type: zod.string().describe('Type of entity.'),
                    height: zod
                      .number()
                      .nullish()
                      .describe('Height (for images).'),
                    id: zod.uuid().describe('Attachment id.'),
                    width: zod
                      .number()
                      .nullish()
                      .describe('Width (for images).'),
                  })
                  .describe('An attachment on a message.')
              )
              .describe('Attachments on this message.'),
            channel_id: zod.uuid().describe('Channel id.'),
            content: zod.string().describe('Message content.'),
            created_at: zod.iso
              .datetime({})
              .describe('When the message was created.'),
            deleted_at: zod.iso
              .datetime({})
              .nullish()
              .describe('When the message was soft-deleted.'),
            edited_at: zod.iso
              .datetime({})
              .nullish()
              .describe('When the message was edited.'),
            id: zod.uuid().describe('Message id.'),
            reactions: zod
              .array(
                zod
                  .object({
                    emoji: zod.string().describe('The emoji string.'),
                    users: zod
                      .array(zod.string())
                      .describe('User ids who added this reaction.'),
                  })
                  .describe('A reaction with emoji and user list.')
              )
              .describe('Reactions on this message.'),
            sender: zod
              .object({
                avatar_url: zod
                  .string()
                  .nullish()
                  .describe('Avatar URL for bot senders.'),
                id: zod
                  .string()
                  .describe('Sender id without the storage namespace prefix.'),
                name: zod
                  .string()
                  .nullish()
                  .describe('Display name for bot senders.'),
                triggered_by: zod
                  .string()
                  .nullish()
                  .describe(
                    'For an agent (bot) message, the id of the user who triggered it.'
                  ),
                type: zod.enum(['user', 'bot']).describe('Public sender type.'),
              })
              .describe('Public sender identity for channel messages.'),
            sender_id: zod.string().describe('Sender user id.'),
            thread: zod
              .object({
                latest_reply_at: zod.iso
                  .datetime({})
                  .nullish()
                  .describe('Timestamp of the latest reply.'),
                preview: zod
                  .array(
                    zod
                      .object({
                        attachments: zod
                          .array(
                            zod
                              .object({
                                created_at: zod.iso
                                  .datetime({})
                                  .describe('When the attachment was created.'),
                                entity_id: zod.string().describe('Entity id.'),
                                entity_type: zod
                                  .string()
                                  .describe('Type of entity.'),
                                height: zod
                                  .number()
                                  .nullish()
                                  .describe('Height (for images).'),
                                id: zod.uuid().describe('Attachment id.'),
                                width: zod
                                  .number()
                                  .nullish()
                                  .describe('Width (for images).'),
                              })
                              .describe('An attachment on a message.')
                          )
                          .describe('Attachments on this reply.'),
                        content: zod.string().describe('Reply content.'),
                        created_at: zod.iso
                          .datetime({})
                          .describe('When the reply was created.'),
                        edited_at: zod.iso
                          .datetime({})
                          .nullish()
                          .describe('When the reply was edited.'),
                        id: zod.uuid().describe('Reply id.'),
                        reactions: zod
                          .array(
                            zod
                              .object({
                                emoji: zod
                                  .string()
                                  .describe('The emoji string.'),
                                users: zod
                                  .array(zod.string())
                                  .describe(
                                    'User ids who added this reaction.'
                                  ),
                              })
                              .describe('A reaction with emoji and user list.')
                          )
                          .describe('Reactions on this reply.'),
                        sender: zod
                          .object({
                            avatar_url: zod
                              .string()
                              .nullish()
                              .describe('Avatar URL for bot senders.'),
                            id: zod
                              .string()
                              .describe(
                                'Sender id without the storage namespace prefix.'
                              ),
                            name: zod
                              .string()
                              .nullish()
                              .describe('Display name for bot senders.'),
                            triggered_by: zod
                              .string()
                              .nullish()
                              .describe(
                                'For an agent (bot) message, the id of the user who triggered it.'
                              ),
                            type: zod
                              .enum(['user', 'bot'])
                              .describe('Public sender type.'),
                          })
                          .describe(
                            'Public sender identity for channel messages.'
                          ),
                        sender_id: zod.string().describe('Sender user id.'),
                        updated_at: zod.iso
                          .datetime({})
                          .describe('When the reply was last updated.'),
                      })
                      .describe('A thread reply shown in preview.')
                  )
                  .describe('Last N replies for thread preview.'),
                reply_count: zod.number().describe('Total reply count.'),
              })
              .describe('Thread metadata and preview replies.'),
            updated_at: zod.iso
              .datetime({})
              .describe('When the message was last updated.'),
          })
          .describe('A top-level channel message with thread info.')
      )
      .describe('Messages on this page.'),
    next_cursor: zod
      .string()
      .nullish()
      .describe('Cursor for the next page, null if no more pages.'),
    previous_cursor: zod
      .string()
      .nullish()
      .describe('Cursor for the previous page, null if no newer page exists.'),
  })
  .describe('Paginated response of channel messages.');

/**
 * @summary Handler for `POST /channels/{channel_id}/messages`.
 */
export const postChannelMessagesParams = zod.object({
  channel_id: zod.uuid().describe('Channel ID'),
});

export const postChannelMessagesQueryLimitMin = 0;

export const postChannelMessagesQueryParams = zod.object({
  limit: zod
    .number()
    .min(postChannelMessagesQueryLimitMin)
    .optional()
    .describe('Page size (1-100, default 50)'),
  cursor: zod
    .string()
    .optional()
    .describe('Base64 encoded cursor value for older messages'),
  previous_cursor: zod
    .string()
    .optional()
    .describe('Base64 encoded cursor value for newer messages'),
  load_around_message_id: zod
    .uuid()
    .optional()
    .describe('Return a centered window around this message ID'),
});

export const postChannelMessagesBody = zod
  .object({
    activity_after: zod.iso
      .datetime({})
      .nullish()
      .describe(
        'When set, only return top-level messages with channel activity at or after\nthis timestamp. Activity means either the message itself was created after\nthis time, or a thread reply was created after this time.\n\nAccepts the legacy JSON field `last_activity` for backwards compatibility.'
      ),
    activity_before: zod.iso
      .datetime({})
      .nullish()
      .describe(
        'When set, only return top-level messages with channel activity before this\ntimestamp. Activity means either the parent message or at least one thread\nreply falls in the requested activity window.'
      ),
    created_after: zod.iso
      .datetime({})
      .nullish()
      .describe(
        'When set, only return top-level messages created at or after this timestamp.'
      ),
    created_before: zod.iso
      .datetime({})
      .nullish()
      .describe(
        'When set, only return top-level messages created before this timestamp.'
      ),
    message_ids: zod
      .array(zod.uuid())
      .optional()
      .describe('When non-empty, only return messages with these IDs.'),
    notification_filters: zod
      .object({
        done: zod
          .boolean()
          .nullish()
          .describe(
            'Filter by notification done state. `Some(true)` selects done\nnotifications; `Some(false)` selects not-done notifications.'
          ),
        seen: zod
          .boolean()
          .nullish()
          .describe(
            'Filter by notification seen state. `Some(true)` selects seen\nnotifications; `Some(false)` selects not-seen notifications.'
          ),
      })
      .optional()
      .describe('Notification state filters for channel message queries.'),
  })
  .describe('Filters for channel message queries.');

export const postChannelMessagesResponse = zod
  .object({
    items: zod
      .array(
        zod
          .object({
            attachments: zod
              .array(
                zod
                  .object({
                    created_at: zod.iso
                      .datetime({})
                      .describe('When the attachment was created.'),
                    entity_id: zod.string().describe('Entity id.'),
                    entity_type: zod.string().describe('Type of entity.'),
                    height: zod
                      .number()
                      .nullish()
                      .describe('Height (for images).'),
                    id: zod.uuid().describe('Attachment id.'),
                    width: zod
                      .number()
                      .nullish()
                      .describe('Width (for images).'),
                  })
                  .describe('An attachment on a message.')
              )
              .describe('Attachments on this message.'),
            channel_id: zod.uuid().describe('Channel id.'),
            content: zod.string().describe('Message content.'),
            created_at: zod.iso
              .datetime({})
              .describe('When the message was created.'),
            deleted_at: zod.iso
              .datetime({})
              .nullish()
              .describe('When the message was soft-deleted.'),
            edited_at: zod.iso
              .datetime({})
              .nullish()
              .describe('When the message was edited.'),
            id: zod.uuid().describe('Message id.'),
            reactions: zod
              .array(
                zod
                  .object({
                    emoji: zod.string().describe('The emoji string.'),
                    users: zod
                      .array(zod.string())
                      .describe('User ids who added this reaction.'),
                  })
                  .describe('A reaction with emoji and user list.')
              )
              .describe('Reactions on this message.'),
            sender: zod
              .object({
                avatar_url: zod
                  .string()
                  .nullish()
                  .describe('Avatar URL for bot senders.'),
                id: zod
                  .string()
                  .describe('Sender id without the storage namespace prefix.'),
                name: zod
                  .string()
                  .nullish()
                  .describe('Display name for bot senders.'),
                triggered_by: zod
                  .string()
                  .nullish()
                  .describe(
                    'For an agent (bot) message, the id of the user who triggered it.'
                  ),
                type: zod.enum(['user', 'bot']).describe('Public sender type.'),
              })
              .describe('Public sender identity for channel messages.'),
            sender_id: zod.string().describe('Sender user id.'),
            thread: zod
              .object({
                latest_reply_at: zod.iso
                  .datetime({})
                  .nullish()
                  .describe('Timestamp of the latest reply.'),
                preview: zod
                  .array(
                    zod
                      .object({
                        attachments: zod
                          .array(
                            zod
                              .object({
                                created_at: zod.iso
                                  .datetime({})
                                  .describe('When the attachment was created.'),
                                entity_id: zod.string().describe('Entity id.'),
                                entity_type: zod
                                  .string()
                                  .describe('Type of entity.'),
                                height: zod
                                  .number()
                                  .nullish()
                                  .describe('Height (for images).'),
                                id: zod.uuid().describe('Attachment id.'),
                                width: zod
                                  .number()
                                  .nullish()
                                  .describe('Width (for images).'),
                              })
                              .describe('An attachment on a message.')
                          )
                          .describe('Attachments on this reply.'),
                        content: zod.string().describe('Reply content.'),
                        created_at: zod.iso
                          .datetime({})
                          .describe('When the reply was created.'),
                        edited_at: zod.iso
                          .datetime({})
                          .nullish()
                          .describe('When the reply was edited.'),
                        id: zod.uuid().describe('Reply id.'),
                        reactions: zod
                          .array(
                            zod
                              .object({
                                emoji: zod
                                  .string()
                                  .describe('The emoji string.'),
                                users: zod
                                  .array(zod.string())
                                  .describe(
                                    'User ids who added this reaction.'
                                  ),
                              })
                              .describe('A reaction with emoji and user list.')
                          )
                          .describe('Reactions on this reply.'),
                        sender: zod
                          .object({
                            avatar_url: zod
                              .string()
                              .nullish()
                              .describe('Avatar URL for bot senders.'),
                            id: zod
                              .string()
                              .describe(
                                'Sender id without the storage namespace prefix.'
                              ),
                            name: zod
                              .string()
                              .nullish()
                              .describe('Display name for bot senders.'),
                            triggered_by: zod
                              .string()
                              .nullish()
                              .describe(
                                'For an agent (bot) message, the id of the user who triggered it.'
                              ),
                            type: zod
                              .enum(['user', 'bot'])
                              .describe('Public sender type.'),
                          })
                          .describe(
                            'Public sender identity for channel messages.'
                          ),
                        sender_id: zod.string().describe('Sender user id.'),
                        updated_at: zod.iso
                          .datetime({})
                          .describe('When the reply was last updated.'),
                      })
                      .describe('A thread reply shown in preview.')
                  )
                  .describe('Last N replies for thread preview.'),
                reply_count: zod.number().describe('Total reply count.'),
              })
              .describe('Thread metadata and preview replies.'),
            updated_at: zod.iso
              .datetime({})
              .describe('When the message was last updated.'),
          })
          .describe('A top-level channel message with thread info.')
      )
      .describe('Messages on this page.'),
    next_cursor: zod
      .string()
      .nullish()
      .describe('Cursor for the next page, null if no more pages.'),
    previous_cursor: zod
      .string()
      .nullish()
      .describe('Cursor for the previous page, null if no newer page exists.'),
  })
  .describe('Paginated response of channel messages.');

/**
 * @summary Handler for `GET /channels/{channel_id}/messages/{message_id}/context`.
 */
export const getMessageWithContextParams = zod.object({
  channel_id: zod.uuid().describe('Channel ID'),
  message_id: zod.uuid().describe('Message ID to get context around'),
});

export const getMessageWithContextQueryParams = zod.object({
  before: zod
    .number()
    .optional()
    .describe('Number of older messages to include'),
  after: zod
    .number()
    .optional()
    .describe('Number of newer messages to include'),
});

export const getMessageWithContextResponse = zod
  .object({
    messages: zod
      .array(
        zod
          .object({
            channel_id: zod.uuid().describe('Channel id.'),
            content: zod.string().describe('Message content.'),
            created_at: zod.iso
              .datetime({})
              .describe('When the message was created.'),
            deleted_at: zod.iso
              .datetime({})
              .nullish()
              .describe('When the message was soft-deleted.'),
            edited_at: zod.iso
              .datetime({})
              .nullish()
              .describe('When the message was edited.'),
            id: zod.uuid().describe('Message id.'),
            sender: zod
              .object({
                avatar_url: zod
                  .string()
                  .nullish()
                  .describe('Avatar URL for bot senders.'),
                id: zod
                  .string()
                  .describe('Sender id without the storage namespace prefix.'),
                name: zod
                  .string()
                  .nullish()
                  .describe('Display name for bot senders.'),
                triggered_by: zod
                  .string()
                  .nullish()
                  .describe(
                    'For an agent (bot) message, the id of the user who triggered it.'
                  ),
                type: zod.enum(['user', 'bot']).describe('Public sender type.'),
              })
              .describe('Public sender identity for channel messages.'),
            sender_id: zod.string().describe('Sender user id.'),
            thread_id: zod
              .uuid()
              .nullish()
              .describe('Parent thread id for replies.'),
            updated_at: zod.iso
              .datetime({})
              .describe('When the message was last updated.'),
          })
          .describe(
            'A channel message returned by the message-context endpoint.'
          )
      )
      .describe(
        'Messages around the requested message in chronological order.'
      ),
  })
  .describe('Response from the message-context endpoint.');

/**
 * @summary Handler for `GET /channels/{channel_id}/messages/{message_id}/replies`.
 */
export const getThreadRepliesParams = zod.object({
  channel_id: zod.uuid().describe('Channel ID'),
  message_id: zod.uuid().describe('Message ID (thread parent or reply id)'),
});

export const getThreadRepliesResponseItem = zod
  .object({
    attachments: zod
      .array(
        zod
          .object({
            created_at: zod.iso
              .datetime({})
              .describe('When the attachment was created.'),
            entity_id: zod.string().describe('Entity id.'),
            entity_type: zod.string().describe('Type of entity.'),
            height: zod.number().nullish().describe('Height (for images).'),
            id: zod.uuid().describe('Attachment id.'),
            width: zod.number().nullish().describe('Width (for images).'),
          })
          .describe('An attachment on a message.')
      )
      .describe('Attachments on this reply.'),
    content: zod.string().describe('Reply content.'),
    created_at: zod.iso.datetime({}).describe('When the reply was created.'),
    edited_at: zod.iso
      .datetime({})
      .nullish()
      .describe('When the reply was edited.'),
    id: zod.uuid().describe('Reply id.'),
    reactions: zod
      .array(
        zod
          .object({
            emoji: zod.string().describe('The emoji string.'),
            users: zod
              .array(zod.string())
              .describe('User ids who added this reaction.'),
          })
          .describe('A reaction with emoji and user list.')
      )
      .describe('Reactions on this reply.'),
    sender: zod
      .object({
        avatar_url: zod
          .string()
          .nullish()
          .describe('Avatar URL for bot senders.'),
        id: zod
          .string()
          .describe('Sender id without the storage namespace prefix.'),
        name: zod.string().nullish().describe('Display name for bot senders.'),
        triggered_by: zod
          .string()
          .nullish()
          .describe(
            'For an agent (bot) message, the id of the user who triggered it.'
          ),
        type: zod.enum(['user', 'bot']).describe('Public sender type.'),
      })
      .describe('Public sender identity for channel messages.'),
    sender_id: zod.string().describe('Sender user id.'),
    updated_at: zod.iso
      .datetime({})
      .describe('When the reply was last updated.'),
  })
  .describe('A thread reply shown in preview.');
export const getThreadRepliesResponse = zod.array(getThreadRepliesResponseItem);

/**
 * @summary Handler for `GET /channels/{channel_id}/messages/{message_id}/resolve`.
 */
export const resolveChannelMessageParams = zod.object({
  channel_id: zod.uuid().describe('Channel ID'),
  message_id: zod.uuid().describe('Message ID to resolve'),
});

export const resolveChannelMessageResponse = zod
  .object({
    channel_id: zod.uuid().describe('Channel this message belongs to.'),
    created_at: zod.iso
      .datetime({})
      .describe('When the requested message was created.'),
    kind: zod
      .enum(['topLevelMessage', 'threadReply'])
      .describe('Position of a message in the channel\/thread model.'),
    message_id: zod.uuid().describe('The requested message id.'),
    thread_id: zod
      .uuid()
      .describe(
        'The top-level parent\/thread id. Equals message_id for top-level messages.'
      ),
  })
  .describe('Resolution metadata for any channel message id.');

/**
 * @summary Handler for `GET /channels/{channel_id}/participants`.
 */
export const getChannelParticipantsParams = zod.object({
  channel_id: zod.uuid().describe('Channel ID'),
});

export const getChannelParticipantsResponseItem = zod
  .object({
    channel_id: zod.uuid().describe('Channel id.'),
    joined_at: zod.iso.datetime({}).describe('When the user joined.'),
    role: zod
      .enum(['owner', 'admin', 'member'])
      .describe('Participant role in a channel.'),
    user_id: zod.string().describe('User id.'),
  })
  .describe('A channel participant.');
export const getChannelParticipantsResponse = zod.array(
  getChannelParticipantsResponseItem
);

/**
 * @summary Handler for `POST /channels/{channel_id}/participants`.
 */
export const addParticipantsParams = zod.object({
  channel_id: zod.uuid().describe('Channel ID'),
});

export const addParticipantsBody = zod
  .object({
    participants: zod.array(zod.string()).describe('User ids to add.'),
  })
  .describe('Request to add participants.');

/**
 * @summary Handler for `DELETE /channels/{channel_id}/participants`.
 */
export const removeParticipantsParams = zod.object({
  channel_id: zod.uuid().describe('Channel ID'),
});

export const removeParticipantsBody = zod
  .object({
    participants: zod.array(zod.string()).describe('User ids to remove.'),
  })
  .describe('Request to remove participants.');

/**
 * @summary Handler for `POST /channels/{channel_id}/reaction`.
 */
export const postReactionParams = zod.object({
  channel_id: zod.uuid().describe('Channel ID'),
});

export const postReactionBody = zod
  .object({
    action: zod.enum(['Add', 'Remove']).describe('Reaction mutation action.'),
    emoji: zod.string().describe('Reaction emoji.'),
    message_id: zod.string().describe('Message id to react to.'),
    nonce: zod.string().nullish().describe('Optional optimistic-update nonce.'),
  })
  .describe('Request to mutate a reaction.');

/**
 * @summary Handler for `POST /channels/{channel_id}/typing`.
 */
export const postTypingParams = zod.object({
  channel_id: zod.uuid().describe('Channel ID'),
});

export const postTypingBody = zod
  .object({
    action: zod.enum(['start', 'stop']).describe('Typing indicator action.'),
    nonce: zod.string().nullish().describe('Optional optimistic-update nonce.'),
    thread_id: zod.string().nullish().describe('Optional thread id.'),
  })
  .describe('Request to emit a typing event.');

/**
 * @summary Handler for `POST /channels/{channel_id}/webhook`.
 */
export const postChannelBotWebhookParams = zod.object({
  channel_id: zod.uuid().describe('Channel ID'),
});

export const postChannelBotWebhookHeader = zod.object({
  'x-macro-bot-token': zod
    .string()
    .nullish()
    .describe('Preferred bot authentication token'),
  'x-macro-channel-bot-token': zod
    .string()
    .nullish()
    .describe('Legacy channel-scoped bot authentication token'),
});

export const postChannelBotWebhookBody = zod
  .object({
    content: zod.string().describe('Message body.'),
  })
  .describe('Request to post a channel webhook message.');

export const postChannelBotWebhookResponse = zod
  .object({
    message_id: zod.string().describe('Created message id.'),
  })
  .describe('Response returned after posting a channel webhook message.');

/**
 * @summary Handle channel list requests for `GET /comms/channels`.
 */
export const getChannelsQueryLimitMin = 0;

export const getChannelsQueryParams = zod.object({
  limit: zod
    .number()
    .min(getChannelsQueryLimitMin)
    .optional()
    .describe('Page size (1-100, default 100)'),
  cursor: zod.string().optional().describe('Opaque cursor for the next page'),
});

export const getChannelsResponseItemsItemOrgIdMin = 0;

export const getChannelsResponse = zod
  .object({
    items: zod
      .array(
        zod
          .object({
            auto_join_team: zod
              .boolean()
              .describe('Whether team members automatically join the channel.'),
            channel_type: zod
              .enum(['public', 'private', 'direct_message', 'team'])
              .describe('Channel type in API responses.'),
            created_at: zod.iso
              .datetime({})
              .describe('Channel creation timestamp.'),
            frecency_score: zod
              .number()
              .nullish()
              .describe('Aggregate frecency score.'),
            id: zod.uuid().describe('Channel id.'),
            interacted_at: zod.iso
              .datetime({})
              .nullish()
              .describe('Last interaction timestamp for requesting user.'),
            is_participant: zod
              .boolean()
              .describe(
                'Whether the requesting user is an active participant of the channel.'
              ),
            latest_message: zod
              .union([
                zod.null(),
                zod
                  .object({
                    content: zod.string().describe('Message content.'),
                    created_at: zod.iso
                      .datetime({})
                      .describe('Creation timestamp.'),
                    deleted_at: zod.iso
                      .datetime({})
                      .nullish()
                      .describe('Deletion timestamp, if deleted.'),
                    mentions: zod
                      .array(zod.string())
                      .describe(
                        'message mentions formatted as `{ENTITY_TYPE}:{ENTITY_ID}`'
                      ),
                    message_id: zod.uuid().describe('Message id.'),
                    sender_id: zod.string().describe('Sender user id.'),
                    thread_id: zod
                      .uuid()
                      .nullish()
                      .describe('Thread id, if the message is a reply.'),
                    updated_at: zod.iso
                      .datetime({})
                      .describe('Update timestamp.'),
                  })
                  .describe('Channel message in API responses.'),
              ])
              .optional(),
            latest_non_thread_message: zod
              .union([
                zod.null(),
                zod
                  .object({
                    content: zod.string().describe('Message content.'),
                    created_at: zod.iso
                      .datetime({})
                      .describe('Creation timestamp.'),
                    deleted_at: zod.iso
                      .datetime({})
                      .nullish()
                      .describe('Deletion timestamp, if deleted.'),
                    mentions: zod
                      .array(zod.string())
                      .describe(
                        'message mentions formatted as `{ENTITY_TYPE}:{ENTITY_ID}`'
                      ),
                    message_id: zod.uuid().describe('Message id.'),
                    sender_id: zod.string().describe('Sender user id.'),
                    thread_id: zod
                      .uuid()
                      .nullish()
                      .describe('Thread id, if the message is a reply.'),
                    updated_at: zod.iso
                      .datetime({})
                      .describe('Update timestamp.'),
                  })
                  .describe('Channel message in API responses.'),
              ])
              .optional(),
            name: zod.string().nullish().describe('Channel name.'),
            org_id: zod
              .number()
              .min(getChannelsResponseItemsItemOrgIdMin)
              .nullish()
              .describe('Organization id.'),
            owner_id: zod.string().describe('Channel owner user id.'),
            participants: zod
              .array(
                zod
                  .object({
                    channel_id: zod.uuid().describe('id of the channel'),
                    joined_at: zod.iso
                      .datetime({})
                      .describe(
                        'timestamp of when the user joined the channel'
                      ),
                    left_at: zod.iso
                      .datetime({})
                      .nullish()
                      .describe('timestamp of when the user left the channel'),
                    role: zod
                      .enum(['owner', 'admin', 'member'])
                      .describe('Participant role in API responses.'),
                    user_id: zod.string().describe('id of the user'),
                  })
                  .describe('Channel participant in API responses.')
              )
              .describe('Active participants.'),
            team_id: zod.uuid().nullish().describe('Team id.'),
            updated_at: zod.iso
              .datetime({})
              .describe('Channel last-updated timestamp.'),
            viewed_at: zod.iso
              .datetime({})
              .nullish()
              .describe('Last viewed timestamp for requesting user.'),
          })
          .describe('Channel list response item.')
      )
      .describe('Channels in this page.'),
    next_cursor: zod
      .string()
      .nullish()
      .describe('Opaque cursor for the next page, if one exists.'),
  })
  .describe('A cursor-paginated channel list response.');

/**
 * @summary Soft-delete a CRM comment, scoped to the requesting user's team. When it
was the thread's last live comment, the thread is soft-deleted too
(reported via `threadDeleted`).
 */
export const deleteCrmCommentParams = zod.object({
  comment_id: zod.uuid().describe('The CRM comment to delete'),
});

export const deleteCrmCommentResponse = zod
  .object({
    commentId: zod.uuid().describe("The deleted comment's id."),
    threadDeleted: zod
      .boolean()
      .describe(
        'Whether the thread itself was soft-deleted because no live comments\nremained.'
      ),
    threadId: zod.uuid().describe('The thread the comment belonged to.'),
  })
  .describe(
    'Outcome of soft-deleting a CRM comment: reports whether the parent thread\nwas soft-deleted too (it is when the deleted comment was its last live one).'
  );

/**
 * @summary Edit a CRM comment's text, scoped to the requesting user's team via the
comment's thread → entity → company. Returns the updated comment.
 */
export const editCrmCommentParams = zod.object({
  comment_id: zod.uuid().describe('The CRM comment to edit'),
});

export const editCrmCommentBody = zod
  .object({
    text: zod.string().describe('The new comment body (markdown).'),
  })
  .describe('Request body for `PATCH \/crm\/comments\/comment\/{comment_id}`.');

export const editCrmCommentResponse = zod
  .object({
    commentId: zod.uuid().describe('The comment id.'),
    createdAt: zod.iso.datetime({}).describe('When the comment was created.'),
    deletedAt: zod.iso
      .datetime({})
      .nullish()
      .describe('When the comment was soft-deleted, if ever.'),
    metadata: zod.unknown().optional().describe('Arbitrary client metadata.'),
    order: zod
      .number()
      .nullish()
      .describe(
        'Optional explicit ordering within the thread; the frontend falls\nback to `createdAt` when absent.'
      ),
    owner: zod.string().describe('Macro user id of the comment author.'),
    sender: zod
      .string()
      .nullish()
      .describe(
        'Macro user id of the actual sender, when distinct from `owner`.'
      ),
    text: zod.string().describe('The comment body (markdown).'),
    threadId: zod
      .uuid()
      .describe('The id of the thread this comment belongs to.'),
    updatedAt: zod.iso
      .datetime({})
      .describe('When the comment was last updated.'),
  })
  .describe('A single comment within a [`CrmThread`].');

/**
 * @summary List the comment threads on a CRM company or contact. Access is
enforced by [`EntityPermissionExtractor`] against the path's
`crm_company`/`crm_contact` entity type — hidden parents are
invisible to plain members. An accessible entity with no threads
returns `200 []`.
 */
export const listCrmCommentsParams = zod.object({
  entity_type: zod
    .enum(['crm_company', 'crm_contact'])
    .describe('Which CRM entity kind the threads hang off'),
  entity_id: zod.uuid().describe('The CRM company or contact id'),
});

export const listCrmCommentsResponseItem = zod
  .object({
    comments: zod
      .array(
        zod
          .object({
            commentId: zod.uuid().describe('The comment id.'),
            createdAt: zod.iso
              .datetime({})
              .describe('When the comment was created.'),
            deletedAt: zod.iso
              .datetime({})
              .nullish()
              .describe('When the comment was soft-deleted, if ever.'),
            metadata: zod
              .unknown()
              .optional()
              .describe('Arbitrary client metadata.'),
            order: zod
              .number()
              .nullish()
              .describe(
                'Optional explicit ordering within the thread; the frontend falls\nback to `createdAt` when absent.'
              ),
            owner: zod
              .string()
              .describe('Macro user id of the comment author.'),
            sender: zod
              .string()
              .nullish()
              .describe(
                'Macro user id of the actual sender, when distinct from `owner`.'
              ),
            text: zod.string().describe('The comment body (markdown).'),
            threadId: zod
              .uuid()
              .describe('The id of the thread this comment belongs to.'),
            updatedAt: zod.iso
              .datetime({})
              .describe('When the comment was last updated.'),
          })
          .describe('A single comment within a [`CrmThread`].')
      )
      .describe("The thread's comments, oldest first."),
    thread: zod
      .object({
        createdAt: zod.iso
          .datetime({})
          .describe('When the thread was created.'),
        deletedAt: zod.iso
          .datetime({})
          .nullish()
          .describe('When the thread was soft-deleted, if ever.'),
        entityId: zod
          .uuid()
          .describe(
            'The id of the CRM company or contact this thread belongs to.'
          ),
        entityType: zod
          .enum(['crm_company', 'crm_contact'])
          .describe(
            'Which CRM entity a comment thread is attached to. Serializes to\n`crm_company` \/ `crm_contact` — matching the `entityType` the frontend\nuses elsewhere when building entity URLs — and is parsed from the\n`{entity_type}` path segment on the comment routes.'
          ),
        metadata: zod
          .unknown()
          .optional()
          .describe('Arbitrary client metadata.'),
        owner: zod.string().describe('Macro user id of the thread creator.'),
        resolved: zod.boolean().describe('Whether the thread is resolved.'),
        threadId: zod.uuid().describe('The thread id.'),
        updatedAt: zod.iso
          .datetime({})
          .describe('When the thread was last updated.'),
      })
      .describe(
        'A CRM comment thread: the parent record one or more comments hang off.'
      ),
  })
  .describe(
    'A [`CrmThread`] with its comments nested under it — the unit the\nfrontend renders.'
  );
export const listCrmCommentsResponse = zod.array(listCrmCommentsResponseItem);

/**
 * @summary Create a comment on a CRM company or contact — a new thread, or a reply
when `threadId` is supplied. Returns the full thread (with all comments)
after the insert. Team-scoped; 404 when the entity isn't owned by the
team or `threadId` doesn't belong to it.
 */
export const createCrmCommentParams = zod.object({
  entity_type: zod
    .enum(['crm_company', 'crm_contact'])
    .describe('Which CRM entity kind the thread hangs off'),
  entity_id: zod.uuid().describe('The CRM company or contact id'),
});

export const createCrmCommentBody = zod
  .object({
    metadata: zod
      .unknown()
      .optional()
      .describe('Arbitrary client metadata for the comment.'),
    text: zod.string().describe('The comment body (markdown).'),
    threadId: zod
      .uuid()
      .nullish()
      .describe(
        'Existing thread to append to. Omit to start a new thread on the\naddressed entity.'
      ),
    threadMetadata: zod
      .unknown()
      .optional()
      .describe(
        'Metadata to set on a newly created thread (ignored when replying\nwithout a value).'
      ),
  })
  .describe(
    'Request body for `POST \/crm\/comments\/{entity_type}\/{entity_id}`.'
  );

export const createCrmCommentResponse = zod
  .object({
    comments: zod
      .array(
        zod
          .object({
            commentId: zod.uuid().describe('The comment id.'),
            createdAt: zod.iso
              .datetime({})
              .describe('When the comment was created.'),
            deletedAt: zod.iso
              .datetime({})
              .nullish()
              .describe('When the comment was soft-deleted, if ever.'),
            metadata: zod
              .unknown()
              .optional()
              .describe('Arbitrary client metadata.'),
            order: zod
              .number()
              .nullish()
              .describe(
                'Optional explicit ordering within the thread; the frontend falls\nback to `createdAt` when absent.'
              ),
            owner: zod
              .string()
              .describe('Macro user id of the comment author.'),
            sender: zod
              .string()
              .nullish()
              .describe(
                'Macro user id of the actual sender, when distinct from `owner`.'
              ),
            text: zod.string().describe('The comment body (markdown).'),
            threadId: zod
              .uuid()
              .describe('The id of the thread this comment belongs to.'),
            updatedAt: zod.iso
              .datetime({})
              .describe('When the comment was last updated.'),
          })
          .describe('A single comment within a [`CrmThread`].')
      )
      .describe("The thread's comments, oldest first."),
    thread: zod
      .object({
        createdAt: zod.iso
          .datetime({})
          .describe('When the thread was created.'),
        deletedAt: zod.iso
          .datetime({})
          .nullish()
          .describe('When the thread was soft-deleted, if ever.'),
        entityId: zod
          .uuid()
          .describe(
            'The id of the CRM company or contact this thread belongs to.'
          ),
        entityType: zod
          .enum(['crm_company', 'crm_contact'])
          .describe(
            'Which CRM entity a comment thread is attached to. Serializes to\n`crm_company` \/ `crm_contact` — matching the `entityType` the frontend\nuses elsewhere when building entity URLs — and is parsed from the\n`{entity_type}` path segment on the comment routes.'
          ),
        metadata: zod
          .unknown()
          .optional()
          .describe('Arbitrary client metadata.'),
        owner: zod.string().describe('Macro user id of the thread creator.'),
        resolved: zod.boolean().describe('Whether the thread is resolved.'),
        threadId: zod.uuid().describe('The thread id.'),
        updatedAt: zod.iso
          .datetime({})
          .describe('When the thread was last updated.'),
      })
      .describe(
        'A CRM comment thread: the parent record one or more comments hang off.'
      ),
  })
  .describe(
    'A [`CrmThread`] with its comments nested under it — the unit the\nfrontend renders.'
  );

/**
 * @summary Manually create a CRM company for the caller's team. Any team member
may create one. The domain must not already be tracked by the team
(409), and the team's CRM killswitch must be on (403). Returns the
created company in the same shape as `GET /crm/companies/{id}` (its
contact list is empty until emails populate it).
 */
export const createCrmCompanyBody = zod
  .object({
    domain: zod
      .string()
      .describe(
        'The company\'s email domain, e.g. \"acme.com\". Must be a bare\ndomain (no scheme, path, or email) and not a generic email\nprovider domain.'
      ),
    name: zod
      .string()
      .describe(
        'Display name for the company. Team-scoped: overrides the\ndomain-directory name on every read path.'
      ),
  })
  .describe('Request body for `POST \/crm\/companies`.');

export const createCrmCompanyResponse = zod
  .object({
    contacts: zod
      .array(
        zod
          .object({
            companyId: zod
              .uuid()
              .describe('The id of the company the contact belongs to.'),
            createdAt: zod.iso
              .datetime({})
              .describe('When the contact record was created.'),
            email: zod.string().describe("The contact's email address."),
            firstInteraction: zod.iso
              .datetime({})
              .describe('Earliest known interaction with this contact.'),
            hidden: zod
              .boolean()
              .describe(
                'Whether the contact is hidden from CRM listings for the\nrequesting team. Non-admin viewers never see `hidden = true`\nrows (the endpoint filters them out); admin\/owner callers see\nhidden contacts so they can render the right toggle state.'
              ),
            id: zod.uuid().describe('The id of the contact record.'),
            lastInteraction: zod.iso
              .datetime({})
              .describe('Most recent known interaction with this contact.'),
            name: zod
              .string()
              .nullish()
              .describe('Display name observed for the contact, if any.'),
            updatedAt: zod.iso
              .datetime({})
              .describe('When the contact record was last updated.'),
          })
          .describe(
            'A CRM contact as returned by `GET \/crm\/companies\/{company_id}\/contacts`.'
          )
      )
      .describe(
        'Contacts attached to this company. Hidden contacts are filtered\nout for non-admin viewers.'
      ),
    createdAt: zod.iso
      .datetime({})
      .describe('Earliest known interaction with this company.'),
    description: zod
      .string()
      .nullish()
      .describe(
        "Display description from the primary domain's directory entry."
      ),
    domains: zod
      .array(
        zod
          .object({
            companyId: zod
              .uuid()
              .describe('The id of the company the domain belongs to.'),
            createdAt: zod.iso
              .datetime({})
              .describe('When the domain record was created.'),
            domain: zod.string().describe('The domain (e.g. \"acme.com\").'),
            id: zod.uuid().describe('The id of the domain record.'),
          })
          .describe('A CRM domain associated with a company.')
      )
      .describe(
        'All domains associated with this company, ordered by creation\ntime ascending (primary first).'
      ),
    emailSync: zod
      .boolean()
      .describe('Whether email sync is enabled for this company.'),
    hidden: zod
      .boolean()
      .describe(
        'Whether the company is hidden from CRM listings for the\nrequesting team. Non-admin viewers never see `hidden = true`\nrows (the endpoint 404s for them); admin\/owner callers see\nhidden companies so they can render the right toggle state.'
      ),
    id: zod.uuid().describe('The id of the company.'),
    name: zod
      .string()
      .nullish()
      .describe(
        "Display name from the primary domain's directory entry, or\n`None` when unresolved."
      ),
    teamId: zod
      .uuid()
      .describe('The id of the team that owns this company record.'),
    updatedAt: zod.iso
      .datetime({})
      .describe('Most recent known interaction with this company.'),
  })
  .describe(
    "A CRM company as returned by `GET \/crm\/companies\/{company_id}`.\nMirrors the soup-listed `crmCompany` shape (`name` \/ `description`\nresolved from the primary domain's `crm_domain_directory` entry) and\nembeds the company's contacts so the panel can render in a single\nrequest."
  );

/**
 * @summary Fetch a single CRM company by id, hydrated with its domains, the
primary domain's directory display metadata (name + description),
and the company's contacts. Access is enforced by
[`CrmCompanyAccessLevelExtractor`]: the user must be on the team
that owns the company, and hidden companies are invisible to plain
members. Admin/owner callers see hidden companies and contacts so
they can render the right unhide UI.
 */
export const getCompanyParams = zod.object({
  company_id: zod.uuid().describe('The CRM company to fetch'),
});

export const getCompanyResponse = zod
  .object({
    contacts: zod
      .array(
        zod
          .object({
            companyId: zod
              .uuid()
              .describe('The id of the company the contact belongs to.'),
            createdAt: zod.iso
              .datetime({})
              .describe('When the contact record was created.'),
            email: zod.string().describe("The contact's email address."),
            firstInteraction: zod.iso
              .datetime({})
              .describe('Earliest known interaction with this contact.'),
            hidden: zod
              .boolean()
              .describe(
                'Whether the contact is hidden from CRM listings for the\nrequesting team. Non-admin viewers never see `hidden = true`\nrows (the endpoint filters them out); admin\/owner callers see\nhidden contacts so they can render the right toggle state.'
              ),
            id: zod.uuid().describe('The id of the contact record.'),
            lastInteraction: zod.iso
              .datetime({})
              .describe('Most recent known interaction with this contact.'),
            name: zod
              .string()
              .nullish()
              .describe('Display name observed for the contact, if any.'),
            updatedAt: zod.iso
              .datetime({})
              .describe('When the contact record was last updated.'),
          })
          .describe(
            'A CRM contact as returned by `GET \/crm\/companies\/{company_id}\/contacts`.'
          )
      )
      .describe(
        'Contacts attached to this company. Hidden contacts are filtered\nout for non-admin viewers.'
      ),
    createdAt: zod.iso
      .datetime({})
      .describe('Earliest known interaction with this company.'),
    description: zod
      .string()
      .nullish()
      .describe(
        "Display description from the primary domain's directory entry."
      ),
    domains: zod
      .array(
        zod
          .object({
            companyId: zod
              .uuid()
              .describe('The id of the company the domain belongs to.'),
            createdAt: zod.iso
              .datetime({})
              .describe('When the domain record was created.'),
            domain: zod.string().describe('The domain (e.g. \"acme.com\").'),
            id: zod.uuid().describe('The id of the domain record.'),
          })
          .describe('A CRM domain associated with a company.')
      )
      .describe(
        'All domains associated with this company, ordered by creation\ntime ascending (primary first).'
      ),
    emailSync: zod
      .boolean()
      .describe('Whether email sync is enabled for this company.'),
    hidden: zod
      .boolean()
      .describe(
        'Whether the company is hidden from CRM listings for the\nrequesting team. Non-admin viewers never see `hidden = true`\nrows (the endpoint 404s for them); admin\/owner callers see\nhidden companies so they can render the right toggle state.'
      ),
    id: zod.uuid().describe('The id of the company.'),
    name: zod
      .string()
      .nullish()
      .describe(
        "Display name from the primary domain's directory entry, or\n`None` when unresolved."
      ),
    teamId: zod
      .uuid()
      .describe('The id of the team that owns this company record.'),
    updatedAt: zod.iso
      .datetime({})
      .describe('Most recent known interaction with this company.'),
  })
  .describe(
    "A CRM company as returned by `GET \/crm\/companies\/{company_id}`.\nMirrors the soup-listed `crmCompany` shape (`name` \/ `description`\nresolved from the primary domain's `crm_domain_directory` entry) and\nembeds the company's contacts so the panel can render in a single\nrequest."
  );

/**
 * @summary List the contacts of a CRM company. Access is enforced by
[`CrmCompanyAccessLevelExtractor`]: the user must be on the team that
owns the company. Hidden companies and hidden contacts are invisible
to plain members; admin/owner callers see hidden rows so they can
render the right unhide UI.
 */
export const listCompanyContactsParams = zod.object({
  company_id: zod.uuid().describe('The CRM company whose contacts to list'),
});

export const listCompanyContactsResponseItem = zod
  .object({
    companyId: zod
      .uuid()
      .describe('The id of the company the contact belongs to.'),
    createdAt: zod.iso
      .datetime({})
      .describe('When the contact record was created.'),
    email: zod.string().describe("The contact's email address."),
    firstInteraction: zod.iso
      .datetime({})
      .describe('Earliest known interaction with this contact.'),
    hidden: zod
      .boolean()
      .describe(
        'Whether the contact is hidden from CRM listings for the\nrequesting team. Non-admin viewers never see `hidden = true`\nrows (the endpoint filters them out); admin\/owner callers see\nhidden contacts so they can render the right toggle state.'
      ),
    id: zod.uuid().describe('The id of the contact record.'),
    lastInteraction: zod.iso
      .datetime({})
      .describe('Most recent known interaction with this contact.'),
    name: zod
      .string()
      .nullish()
      .describe('Display name observed for the contact, if any.'),
    updatedAt: zod.iso
      .datetime({})
      .describe('When the contact record was last updated.'),
  })
  .describe(
    'A CRM contact as returned by `GET \/crm\/companies\/{company_id}\/contacts`.'
  );
export const listCompanyContactsResponse = zod.array(
  listCompanyContactsResponseItem
);

/**
 * @summary Manually create a contact under a CRM company. Access is enforced by
[`CrmCompanyAccessLevelExtractor`]: the caller must be on the team
that owns the company (hidden companies are reachable for
admin/owner only, and the new contact then inherits `hidden`). The
email's domain must be one of the company's domains (400), the
company must not already track the email (409), and the team's CRM
killswitch must be on (403).
 */
export const createCrmContactParams = zod.object({
  company_id: zod.uuid().describe('The CRM company to add the contact to'),
});

export const createCrmContactBody = zod
  .object({
    email: zod
      .string()
      .describe(
        'The contact\'s email address, e.g. \"jane@acme.com\". Its domain\nmust be one of the company\'s domains (400 otherwise).'
      ),
    name: zod.string().describe('Display name for the contact.'),
  })
  .describe(
    'Request body for `POST \/crm\/companies\/{company_id}\/contacts`.'
  );

export const createCrmContactResponse = zod
  .object({
    companyId: zod
      .uuid()
      .describe('The id of the company the contact belongs to.'),
    createdAt: zod.iso
      .datetime({})
      .describe('When the contact record was created.'),
    email: zod.string().describe("The contact's email address."),
    firstInteraction: zod.iso
      .datetime({})
      .describe('Earliest known interaction with this contact.'),
    hidden: zod
      .boolean()
      .describe(
        'Whether the contact is hidden from CRM listings for the\nrequesting team. Non-admin viewers never see `hidden = true`\nrows (the endpoint filters them out); admin\/owner callers see\nhidden contacts so they can render the right toggle state.'
      ),
    id: zod.uuid().describe('The id of the contact record.'),
    lastInteraction: zod.iso
      .datetime({})
      .describe('Most recent known interaction with this contact.'),
    name: zod
      .string()
      .nullish()
      .describe('Display name observed for the contact, if any.'),
    updatedAt: zod.iso
      .datetime({})
      .describe('When the contact record was last updated.'),
  })
  .describe(
    'A CRM contact as returned by `GET \/crm\/companies\/{company_id}\/contacts`.'
  );

/**
 * @summary Toggle `email_sync` on a CRM company. Purely a visibility flag —
it gates whether team members can see each other's emails with
this company. Existing CRM data is unaffected.
 */
export const setEmailSyncParams = zod.object({
  company_id: zod.uuid().describe('The CRM company to update'),
});

export const setEmailSyncBody = zod
  .object({
    email_sync: zod
      .boolean()
      .describe(
        "New value for `crm_companies.email_sync`. Purely a read-side\nvisibility\/permission gate — `soup` queries and email-permission\nchecks require `email_sync = true` before exposing the\ncompany's emails team-wide. Populate continues to write CRM\nhistory regardless, so toggling never destroys data and\nre-enabling never requires a backfill."
      ),
  })
  .describe(
    'Request body for `PUT \/crm\/companies\/{company_id}\/email-sync`.'
  );

/**
 * @summary Toggle `hidden` on a CRM company. Hiding also disables
`email_sync` and soft-hides every contact under the company.
Un-hide restores contact visibility only; `email_sync` is left
untouched (the team must re-enable it explicitly). Contact rows
and contact sources survive the cycle.
 */
export const setCompanyHiddenParams = zod.object({
  company_id: zod.uuid().describe('The CRM company to update'),
});

export const setCompanyHiddenBody = zod
  .object({
    hidden: zod
      .boolean()
      .describe(
        'New value for `crm_companies.hidden`. Setting to `true` hides\nthe company from CRM listings, disables `email_sync`, and\nsoft-hides every contact under it (`crm_contacts.hidden = true`).\nContact rows and `crm_contact_sources` are preserved across the\ncycle, so un-hide is a true reverse. Setting to `false`\nun-hides the company and soft-restores its contacts;\n`email_sync` is left untouched and the team must re-enable it\nexplicitly.'
      ),
  })
  .describe('Request body for `PUT \/companies\/{company_id}\/hidden`.');

/**
 * @summary Rename a CRM company. Access is enforced by
[`CrmCompanyAccessLevelExtractor`]: the caller must be on the team
that owns the company (hidden companies are reachable for
admin/owner only). The name is a team-scoped override
(`custom_name`) and never touches the global domain directory.
 */
export const setCrmCompanyNameParams = zod.object({
  company_id: zod.uuid().describe('The CRM company to rename'),
});

export const setCrmCompanyNameBody = zod
  .object({
    name: zod
      .string()
      .describe(
        'New display name for the company. Stored on the team-scoped\n`crm_companies.custom_name` override, which read paths COALESCE\nover the global directory name — the shared directory is never\nmodified. Must be non-blank (400 otherwise).'
      ),
  })
  .describe('Request body for `PUT \/companies\/{company_id}\/name`.');

/**
 * @summary Fetch a single CRM contact by id. Access is enforced by
[`CrmContactAccessLevelExtractor`]: the user must be on the team that
owns the contact's parent company, and hidden contacts are invisible
to plain members. Admin/owner callers see hidden contacts so they can
render the right unhide UI.
 */
export const getContactParams = zod.object({
  contact_id: zod.uuid().describe('The CRM contact to fetch'),
});

export const getContactResponse = zod
  .object({
    companyId: zod
      .uuid()
      .describe('The id of the company the contact belongs to.'),
    createdAt: zod.iso
      .datetime({})
      .describe('When the contact record was created.'),
    email: zod.string().describe("The contact's email address."),
    firstInteraction: zod.iso
      .datetime({})
      .describe('Earliest known interaction with this contact.'),
    hidden: zod
      .boolean()
      .describe(
        'Whether the contact is hidden from CRM listings for the\nrequesting team. Non-admin viewers never see `hidden = true`\nrows (the endpoint filters them out); admin\/owner callers see\nhidden contacts so they can render the right toggle state.'
      ),
    id: zod.uuid().describe('The id of the contact record.'),
    lastInteraction: zod.iso
      .datetime({})
      .describe('Most recent known interaction with this contact.'),
    name: zod
      .string()
      .nullish()
      .describe('Display name observed for the contact, if any.'),
    updatedAt: zod.iso
      .datetime({})
      .describe('When the contact record was last updated.'),
  })
  .describe(
    'A CRM contact as returned by `GET \/crm\/companies\/{company_id}\/contacts`.'
  );

/**
 * @summary Toggle `hidden` on a CRM contact. Hiding is a display-only opt-out
scoped to the team that owns the contact's company.
 */
export const setContactHiddenParams = zod.object({
  contact_id: zod.uuid().describe('The CRM contact to update'),
});

export const setContactHiddenBody = zod
  .object({
    hidden: zod
      .boolean()
      .describe(
        'New value for `crm_contacts.hidden`. `true` hides the contact\nfrom CRM listings for the team; `false` un-hides it. Display-only\n— does not affect populate\/depopulate.'
      ),
  })
  .describe('Request body for `PUT \/contacts\/{contact_id}\/hidden`.');

/**
 * @summary Rename a CRM contact. Access is enforced by
[`CrmContactAccessLevelExtractor`]: the caller must be on the team
that owns the contact's company (hidden contacts are reachable for
admin/owner only). The name overwrites the team-scoped
`crm_contacts.name` column.
 */
export const setCrmContactNameParams = zod.object({
  contact_id: zod.uuid().describe('The CRM contact to rename'),
});

export const setCrmContactNameBody = zod
  .object({
    name: zod
      .string()
      .describe(
        'New display name for the contact. Stored on `crm_contacts.name`,\nwhich is already team-scoped — unlike company renames no global\ndirectory is involved. Must be non-blank (400 otherwise).'
      ),
  })
  .describe('Request body for `PUT \/contacts\/{contact_id}\/name`.');

/**
 * @summary Read the caller's team CRM configuration. Any team member may read;
teams without a settings row get the defaults.
 */
export const getCrmTeamSettingsResponse = zod
  .object({
    closed_stage_ids: zod
      .array(zod.uuid())
      .nullish()
      .describe(
        'Stage option ids counting as closed deals; absent = the client\nfalls back to its label heuristic.'
      ),
    default_team_view_id: zod
      .string()
      .nullish()
      .describe(
        'Team view applied by default when a member opens the CRM view.'
      ),
    delete_records_role: zod
      .enum(['admin', 'owner'])
      .describe(
        'Minimum team role required for a CRM governance capability. Members\ncan edit visible CRM records (e.g. company properties), but the\ngovernance capabilities these settings gate stay restricted to\nadmin (default) vs owner. Maps to the `team_role` Postgres enum;\n`member` is deliberately not representable.'
      ),
    edit_stages_role: zod
      .enum(['admin', 'owner'])
      .describe(
        'Minimum team role required for a CRM governance capability. Members\ncan edit visible CRM records (e.g. company properties), but the\ngovernance capabilities these settings gate stay restricted to\nadmin (default) vs owner. Maps to the `team_role` Postgres enum;\n`member` is deliberately not representable.'
      ),
    move_closed_deals_role: zod
      .enum(['admin', 'owner'])
      .describe(
        'Minimum team role required for a CRM governance capability. Members\ncan edit visible CRM records (e.g. company properties), but the\ngovernance capabilities these settings gate stay restricted to\nadmin (default) vs owner. Maps to the `team_role` Postgres enum;\n`member` is deliberately not representable.'
      ),
    team_views: zod
      .unknown()
      .describe(
        'Team saved views — an opaque JSON array owned by the frontend.'
      ),
  })
  .describe(
    "The team's CRM configuration (everything on `team_crm_settings`\nexcept the `crm_enabled` killswitch, which is managed via\n`PATCH \/team\/crm` on the auth service)."
  );

/**
 * @summary Partially update the caller's team CRM configuration. Any team
member may update the views fields (`team_views`,
`default_team_view_id`); the governance fields (permission
thresholds, `closed_stage_ids`) require an admin/owner team role
(403 otherwise). Omitted fields keep their current values;
`team_views` is replaced whole. Returns the resulting settings.
 */
export const putCrmTeamSettingsBody = zod
  .object({
    closed_stage_ids: zod
      .array(zod.uuid())
      .nullish()
      .describe(
        'New closed-stage set. Omit to keep the current value; pass\n`null` to clear it (falling back to the client label heuristic).'
      ),
    default_team_view_id: zod
      .string()
      .nullish()
      .describe(
        'New default team view id. Omit to keep the current value; pass\n`null` to clear it.'
      ),
    delete_records_role: zod
      .union([
        zod.null(),
        zod
          .enum(['admin', 'owner'])
          .describe(
            'Minimum team role required for a CRM governance capability. Members\ncan edit visible CRM records (e.g. company properties), but the\ngovernance capabilities these settings gate stay restricted to\nadmin (default) vs owner. Maps to the `team_role` Postgres enum;\n`member` is deliberately not representable.'
          ),
      ])
      .optional(),
    edit_stages_role: zod
      .union([
        zod.null(),
        zod
          .enum(['admin', 'owner'])
          .describe(
            'Minimum team role required for a CRM governance capability. Members\ncan edit visible CRM records (e.g. company properties), but the\ngovernance capabilities these settings gate stay restricted to\nadmin (default) vs owner. Maps to the `team_role` Postgres enum;\n`member` is deliberately not representable.'
          ),
      ])
      .optional(),
    move_closed_deals_role: zod
      .union([
        zod.null(),
        zod
          .enum(['admin', 'owner'])
          .describe(
            'Minimum team role required for a CRM governance capability. Members\ncan edit visible CRM records (e.g. company properties), but the\ngovernance capabilities these settings gate stay restricted to\nadmin (default) vs owner. Maps to the `team_role` Postgres enum;\n`member` is deliberately not representable.'
          ),
      ])
      .optional(),
    team_views: zod
      .unknown()
      .optional()
      .describe('Replacement team-views array (whole-blob, last write wins).'),
  })
  .describe(
    'Request body for `PUT \/crm\/settings`. Every field is optional:\nomitted fields keep their current values.'
  );

export const putCrmTeamSettingsResponse = zod
  .object({
    closed_stage_ids: zod
      .array(zod.uuid())
      .nullish()
      .describe(
        'Stage option ids counting as closed deals; absent = the client\nfalls back to its label heuristic.'
      ),
    default_team_view_id: zod
      .string()
      .nullish()
      .describe(
        'Team view applied by default when a member opens the CRM view.'
      ),
    delete_records_role: zod
      .enum(['admin', 'owner'])
      .describe(
        'Minimum team role required for a CRM governance capability. Members\ncan edit visible CRM records (e.g. company properties), but the\ngovernance capabilities these settings gate stay restricted to\nadmin (default) vs owner. Maps to the `team_role` Postgres enum;\n`member` is deliberately not representable.'
      ),
    edit_stages_role: zod
      .enum(['admin', 'owner'])
      .describe(
        'Minimum team role required for a CRM governance capability. Members\ncan edit visible CRM records (e.g. company properties), but the\ngovernance capabilities these settings gate stay restricted to\nadmin (default) vs owner. Maps to the `team_role` Postgres enum;\n`member` is deliberately not representable.'
      ),
    move_closed_deals_role: zod
      .enum(['admin', 'owner'])
      .describe(
        'Minimum team role required for a CRM governance capability. Members\ncan edit visible CRM records (e.g. company properties), but the\ngovernance capabilities these settings gate stay restricted to\nadmin (default) vs owner. Maps to the `team_role` Postgres enum;\n`member` is deliberately not representable.'
      ),
    team_views: zod
      .unknown()
      .describe(
        'Team saved views — an opaque JSON array owned by the frontend.'
      ),
  })
  .describe(
    "The team's CRM configuration (everything on `team_crm_settings`\nexcept the `crm_enabled` killswitch, which is managed via\n`PATCH \/team\/crm` on the auth service)."
  );

/**
 * @summary Gets the users documents to populate their recent document list
 */
export const getUserDocumentsHandlerQueryParams = zod.object({
  limit: zod
    .number()
    .describe(
      'The maximum number of documents to retreive. Default 10, max 100.'
    ),
  offset: zod.number().describe('The offset to start from. Default 0.'),
  file_type: zod.string().describe('The file type to filter by. Default all.'),
});

export const getUserDocumentsHandlerResponse = zod.object({
  data: zod
    .union([
      zod.null(),
      zod.object({
        documents: zod.array(
          zod.object({
            branchedFromId: zod
              .string()
              .nullish()
              .describe('The id of the document this document branched from'),
            branchedFromVersionId: zod
              .number()
              .nullish()
              .describe(
                'The id of the version this document branched from\nThis could be either DocumentInstance or DocumentBom id depending on\nthe file type'
              ),
            createdAt: zod.iso
              .datetime({})
              .nullish()
              .describe('The time the document was created'),
            deletedAt: zod.iso
              .datetime({})
              .nullish()
              .describe('The time the document was deleted'),
            documentBom: zod
              .array(
                zod.object({
                  id: zod.string().describe('The uuid of the bom part'),
                  path: zod
                    .string()
                    .describe('The file path of the bom part content'),
                  sha: zod
                    .string()
                    .describe(
                      'The sha of the bom part content\nThere is an index on sha for more performant queries based on it.'
                    ),
                })
              )
              .nullish()
              .describe(
                'If the document is a DOCX document and unzipped, the document_bom will be present'
              ),
            documentFamilyId: zod
              .number()
              .nullish()
              .describe(
                'The id of the document family this document belongs to'
              ),
            documentId: zod.string().describe('The document id'),
            documentName: zod.string().describe('The name of the document'),
            documentVersionId: zod
              .number()
              .describe(
                'The version of the document\nThis could be the document_instance_id or document_bom_id depending on\nthe file type'
              ),
            fileType: zod
              .string()
              .nullish()
              .describe('The file type of the document (file extension)'),
            modificationData: zod
              .unknown()
              .optional()
              .describe(
                'The modification data for the document instance.\nThis is only used for PDF documents.'
              ),
            owner: zod.string().describe('The owner of the document'),
            projectId: zod
              .string()
              .nullish()
              .describe('The id of the project that this document belongs to'),
            projectName: zod
              .string()
              .nullish()
              .describe(
                'The name of the project that this document belongs to'
              ),
            sha: zod
              .string()
              .nullish()
              .describe(
                'If the document is a PDF, this is the SHA of the pdf\nIf the document is a DOCX, this will not be present'
              ),
            subType: zod
              .union([
                zod.null(),
                zod
                  .enum(['task', 'snippet', 'skill'])
                  .describe(
                    'The document sub type enum represents all values of document sub types.\nThese values should match the `document_sub_type_value` table in macrodb.'
                  ),
              ])
              .optional(),
            updatedAt: zod.iso
              .datetime({})
              .nullish()
              .describe(
                'The time the document instance \/ document BOM was updated'
              ),
          })
        ),
        next_offset: zod
          .number()
          .nullish()
          .describe('The next offset to be used if there is one'),
        total: zod
          .number()
          .describe('The total number of documents the user has'),
      }),
    ])
    .optional(),
  error: zod.boolean().describe('Indicates if an error occurred'),
  message: zod.string().nullish().describe('Message to explain failure'),
});

/**
 * Creates a new document, generates an S3 presigned upload URL, and returns
the document metadata with the URL for the client to upload to.
 * @summary Handler for `POST /documents`.
 */
export const createDocumentBody = zod.object({
  branchedFromId: zod
    .string()
    .nullish()
    .describe('The document id if the document is being branched.'),
  branchedFromVersionId: zod
    .number()
    .nullish()
    .describe('The version id if the document is being branched.'),
  createdAt: zod.iso
    .datetime({})
    .nullish()
    .describe(
      "Optional time to set the document's created_at to. Set when backfilling email attachments."
    ),
  documentFamilyId: zod
    .number()
    .nullish()
    .describe('The document family id if the document is being branched.'),
  documentName: zod
    .string()
    .describe('The name of the document without extension.'),
  emailAttachmentId: zod
    .uuid()
    .nullish()
    .describe(
      'Internal only field that links the document created to the specified email attachment by\ncreating a row in the document_email table.'
    ),
  fileType: zod
    .string()
    .nullish()
    .describe('Optional file type of the document.'),
  id: zod.uuid().nullish().describe('The id of the document in the database'),
  isTask: zod
    .boolean()
    .optional()
    .describe(
      'Whether the document is a task.\nThis is only applicable for md documents and the request will fail if the file type is not\nmd.'
    ),
  jobId: zod
    .string()
    .nullish()
    .describe(
      'Optional job id to be used to track an upload job for the newly created document.\nWill need to have a corresponding job initiated for the file beforehand.'
    ),
  mimeType: zod
    .string()
    .nullish()
    .describe(
      'The content type of the document (currently only used for logging matches against file type).'
    ),
  projectId: zod.uuid().nullish(),
  sha: zod.string().describe('The sha of the document.'),
  skipHistory: zod
    .boolean()
    .optional()
    .describe(
      'Whether to add a viewed_at record for this document upon creation.'
    ),
  teamId: zod
    .uuid()
    .nullish()
    .describe(
      'Team to assign the task number within when creating a task document. If omitted,\nthe service may infer it only when the creator belongs to exactly one team.'
    ),
});

export const createDocumentResponse = zod.object({
  data: zod
    .object({
      documentMetadata: zod
        .object({
          branchedFromId: zod
            .string()
            .nullish()
            .describe('The id of the document this document branched from'),
          branchedFromVersionId: zod
            .number()
            .nullish()
            .describe(
              'The id of the version this document branched from\nThis could be either DocumentInstance or DocumentBom id depending on\nthe file type'
            ),
          createdAt: zod.iso
            .datetime({})
            .nullish()
            .describe('The time the document was created'),
          documentBom: zod
            .array(
              zod.object({
                id: zod.string().describe('The uuid of the bom part'),
                path: zod
                  .string()
                  .describe('The file path of the bom part content'),
                sha: zod
                  .string()
                  .describe(
                    'The sha of the bom part content\nThere is an index on sha for more performant queries based on it.'
                  ),
              })
            )
            .nullish()
            .describe(
              'If the document is a DOCX document, the document_bom will be present'
            ),
          documentFamilyId: zod
            .number()
            .nullish()
            .describe('The id of the document family this document belongs to'),
          documentId: zod.string().describe('The document id'),
          documentName: zod.string().describe('The name of the document'),
          documentVersionId: zod
            .number()
            .describe(
              'The version of the document\nThis could be the document_instance_id or document_bom_id depending on\nthe file type'
            ),
          fileType: zod
            .string()
            .nullish()
            .describe('The file type of the document'),
          modificationData: zod
            .unknown()
            .optional()
            .describe(
              'The modification data for the document instance.\nThis is only used for PDF documents.'
            ),
          owner: zod.string().describe('The owner of the document'),
          sha: zod
            .string()
            .nullish()
            .describe(
              'If the document is a PDF, this is the SHA of the pdf\nIf the document is a DOCX, this will not be present'
            ),
          subType: zod
            .union([
              zod.null(),
              zod
                .enum(['task', 'snippet', 'skill'])
                .describe(
                  'The document sub type enum represents all values of document sub types.\nThese values should match the `document_sub_type_value` table in macrodb.'
                ),
            ])
            .optional(),
          updatedAt: zod.iso
            .datetime({})
            .nullish()
            .describe(
              'The time the document instance \/ document BOM was updated'
            ),
        })
        .and(
          zod.object({
            content: zod
              .object({
                location: zod
                  .union([
                    zod.null(),
                    zod
                      .enum([
                        'object_storage',
                        'sync_service',
                        'docx_bom_parts',
                        'converted_pdf',
                        'unknown',
                      ])
                      .describe(
                        'Where document content is, or is expected to be, read from.'
                      ),
                  ])
                  .optional(),
                state: zod
                  .enum(['unknown', 'pending', 'ready'])
                  .describe(
                    'API-visible content lifecycle state derived from current document metadata.'
                  ),
              })
              .describe('API-visible content lifecycle and location metadata.'),
            teamId: zod
              .uuid()
              .nullish()
              .describe(
                'The team this task number is scoped to, for task documents.'
              ),
            teamTaskId: zod
              .number()
              .nullish()
              .describe(
                'The task number assigned within the team, for task documents.'
              ),
          })
        )
        .describe(
          'Create\/copy response metadata plus content lifecycle metadata.'
        ),
      presignedUrl: zod
        .string()
        .nullish()
        .describe(
          'Presigned upload URL, when the caller still needs to upload bytes.'
        ),
    })
    .describe('Document response with content lifecycle metadata.')
    .and(
      zod.object({
        contentType: zod
          .string()
          .describe('Content type of the document converted from file type.'),
        fileType: zod
          .string()
          .nullish()
          .describe('The file type of the document.'),
      })
    )
    .describe('Create document response data with content lifecycle metadata.')
    .describe('Data to be returned'),
  error: zod.boolean().describe('Indicates if an error occurred'),
});

/**
 * @summary Creates and initializes a markdown document in one backend-owned lifecycle.
 */
export const createMarkdownHandlerBody = zod
  .object({
    documentName: zod.string().describe('The document name.'),
    markdown: zod
      .string()
      .nullish()
      .describe('Markdown source text. Defaults to an empty document.'),
    projectId: zod
      .uuid()
      .nullish()
      .describe('Optional project ID to associate the document with.'),
    skipHistory: zod
      .boolean()
      .optional()
      .describe(
        'Whether to add a viewed_at record for this document upon creation.'
      ),
  })
  .describe(
    'Request body for creating a markdown document whose content is initialized\nby the backend.'
  );

export const createMarkdownHandlerResponse = zod
  .object({
    documentId: zod
      .string()
      .describe('The document ID of the created markdown document'),
    documentMetadata: zod.object({
      branchedFromId: zod
        .string()
        .nullish()
        .describe('The id of the document this document branched from'),
      branchedFromVersionId: zod
        .number()
        .nullish()
        .describe(
          'The id of the version this document branched from\nThis could be either DocumentInstance or DocumentBom id depending on\nthe file type'
        ),
      createdAt: zod.iso
        .datetime({})
        .nullish()
        .describe('The time the document was created'),
      documentBom: zod
        .array(
          zod.object({
            id: zod.string().describe('The uuid of the bom part'),
            path: zod
              .string()
              .describe('The file path of the bom part content'),
            sha: zod
              .string()
              .describe(
                'The sha of the bom part content\nThere is an index on sha for more performant queries based on it.'
              ),
          })
        )
        .nullish()
        .describe(
          'If the document is a DOCX document, the document_bom will be present'
        ),
      documentFamilyId: zod
        .number()
        .nullish()
        .describe('The id of the document family this document belongs to'),
      documentId: zod.string().describe('The document id'),
      documentName: zod.string().describe('The name of the document'),
      documentVersionId: zod
        .number()
        .describe(
          'The version of the document\nThis could be the document_instance_id or document_bom_id depending on\nthe file type'
        ),
      fileType: zod
        .string()
        .nullish()
        .describe('The file type of the document'),
      modificationData: zod
        .unknown()
        .optional()
        .describe(
          'The modification data for the document instance.\nThis is only used for PDF documents.'
        ),
      owner: zod.string().describe('The owner of the document'),
      sha: zod
        .string()
        .nullish()
        .describe(
          'If the document is a PDF, this is the SHA of the pdf\nIf the document is a DOCX, this will not be present'
        ),
      subType: zod
        .union([
          zod.null(),
          zod
            .enum(['task', 'snippet', 'skill'])
            .describe(
              'The document sub type enum represents all values of document sub types.\nThese values should match the `document_sub_type_value` table in macrodb.'
            ),
        ])
        .optional(),
      updatedAt: zod.iso
        .datetime({})
        .nullish()
        .describe('The time the document instance \/ document BOM was updated'),
    }),
    token: zod
      .string()
      .describe('A pre-generated permission token that you can use for SS'),
  })
  .describe('Response for creating a markdown document.');

/**
 * @summary Creates a skill document with initialized markdown content in one
backend-owned lifecycle. Skills are markdown documents containing
instructions that AI reads and follows when the skill is referenced in an
AI input.
 */
export const createSkillHandlerBody = zod
  .object({
    markdown: zod
      .string()
      .nullish()
      .describe('Markdown source text. Defaults to an empty skill document.'),
    projectId: zod
      .uuid()
      .nullish()
      .describe('Optional project ID to associate the skill with.'),
    skillName: zod.string().describe('The name of the skill.'),
  })
  .describe(
    'Request body for creating a skill — a markdown document containing\ninstructions that AI reads and follows when the skill is referenced in an\nAI input.'
  );

export const createSkillHandlerResponse = zod
  .object({
    documentId: zod.string().describe('The document ID of the created skill.'),
  })
  .describe('Response for creating a skill.');

/**
 * @summary Creates a snippet document with initialized markdown content in one
backend-owned lifecycle. Snippets are created personal; team sharing is
toggled separately via `PUT /documents/{document_id}/team_share`.
 */
export const createSnippetHandlerBody = zod
  .object({
    markdown: zod
      .string()
      .nullish()
      .describe('Markdown source text. Defaults to an empty snippet document.'),
    projectId: zod
      .uuid()
      .nullish()
      .describe('Optional project ID to associate the snippet with.'),
    snippetName: zod.string().describe('The name of the snippet.'),
  })
  .describe(
    'Request body for creating a snippet — a reusable markdown document that can\nbe inserted into any markdown area.'
  );

export const createSnippetHandlerResponse = zod
  .object({
    documentId: zod
      .string()
      .describe('The document ID of the created snippet.'),
  })
  .describe('Response for creating a snippet.');

/**
 * @summary Creates a task document with properties and initialized markdown content in
one backend-owned lifecycle.
 */
export const createTaskHandlerBody = zod
  .object({
    markdown: zod
      .string()
      .nullish()
      .describe('Markdown source text. Defaults to an empty task document.'),
    projectId: zod
      .uuid()
      .nullish()
      .describe('Optional project ID to associate the task with.'),
    propertyValues: zod
      .array(
        zod
          .object({
            propertyId: zod.string().describe('The property definition ID.'),
            value: zod
              .union([
                zod
                  .object({
                    type: zod.enum(['boolean']),
                    value: zod.boolean(),
                  })
                  .describe('Boolean true\/false value'),
                zod
                  .object({
                    type: zod.enum(['date']),
                    value: zod.iso.datetime({}),
                  })
                  .describe('Date and time value'),
                zod
                  .object({
                    type: zod.enum(['number']),
                    value: zod.number(),
                  })
                  .describe('Numeric value'),
                zod
                  .object({
                    type: zod.enum(['string']),
                    value: zod.string(),
                  })
                  .describe('String\/text value'),
                zod
                  .object({
                    option_id: zod.uuid(),
                    type: zod.enum(['select_option']),
                  })
                  .describe('Select option by ID (for select-type properties)'),
                zod
                  .object({
                    option_ids: zod.array(zod.uuid()),
                    type: zod.enum(['multi_select_option']),
                  })
                  .describe(
                    'Multiple select options by ID (for multi-select properties)'
                  ),
                zod
                  .object({
                    reference: zod
                      .object({
                        entity_id: zod.string(),
                        entity_type: zod
                          .enum([
                            'CALENDAR_EVENT',
                            'CALL_RECORD',
                            'CHANNEL',
                            'CHAT',
                            'COMPANY',
                            'DOCUMENT',
                            'PROJECT',
                            'TASK',
                            'THREAD',
                            'USER',
                          ])
                          .describe(
                            'Type of entity that can be referenced by entity properties.'
                          ),
                        specific_message_id: zod
                          .uuid()
                          .nullish()
                          .describe(
                            'For CHANNEL, CHAT, THREAD entity types - optional specific message ID.\nThis allows referencing a specific message within a thread\/channel\/chat.'
                          ),
                      })
                      .describe(
                        'Entity reference for entity-type property values.'
                      ),
                    type: zod.enum(['entity_reference']),
                  })
                  .describe('Entity reference'),
                zod
                  .object({
                    references: zod.array(
                      zod
                        .object({
                          entity_id: zod.string(),
                          entity_type: zod
                            .enum([
                              'CALENDAR_EVENT',
                              'CALL_RECORD',
                              'CHANNEL',
                              'CHAT',
                              'COMPANY',
                              'DOCUMENT',
                              'PROJECT',
                              'TASK',
                              'THREAD',
                              'USER',
                            ])
                            .describe(
                              'Type of entity that can be referenced by entity properties.'
                            ),
                          specific_message_id: zod
                            .uuid()
                            .nullish()
                            .describe(
                              'For CHANNEL, CHAT, THREAD entity types - optional specific message ID.\nThis allows referencing a specific message within a thread\/channel\/chat.'
                            ),
                        })
                        .describe(
                          'Entity reference for entity-type property values.'
                        )
                    ),
                    type: zod.enum(['multi_entity_reference']),
                  })
                  .describe(
                    'Multiple entity references (for multi-select entity properties)'
                  ),
                zod
                  .object({
                    type: zod.enum(['link']),
                    url: zod.string(),
                  })
                  .describe('Link value'),
                zod
                  .object({
                    type: zod.enum(['multi_link']),
                    urls: zod.array(zod.string()),
                  })
                  .describe(
                    'Multiple link values (for multi-select link properties)'
                  ),
              ])
              .describe(
                'Type-safe enum for setting entity property values - provides compile-time validation.'
              ),
          })
          .describe('Property input for setting a property value on a task.')
      )
      .nullish()
      .describe('Optional property values to set on the task.'),
    shareWithTeam: zod
      .boolean()
      .optional()
      .describe(
        'Whether to share the task with your team or not\nDefaults to true'
      ),
    taskName: zod.string().describe('The name of the task.'),
    teamId: zod
      .uuid()
      .nullish()
      .describe(
        'Team to assign the task number within. If omitted, it is inferred only\nwhen the creator belongs to exactly one team.'
      ),
  })
  .describe('Request body for creating a task.');

export const createTaskHandlerResponse = zod
  .object({
    documentId: zod.string().describe('The document ID of the created task.'),
    documentMetadata: zod.object({
      branchedFromId: zod
        .string()
        .nullish()
        .describe('The id of the document this document branched from'),
      branchedFromVersionId: zod
        .number()
        .nullish()
        .describe(
          'The id of the version this document branched from\nThis could be either DocumentInstance or DocumentBom id depending on\nthe file type'
        ),
      createdAt: zod.iso
        .datetime({})
        .nullish()
        .describe('The time the document was created'),
      documentBom: zod
        .array(
          zod.object({
            id: zod.string().describe('The uuid of the bom part'),
            path: zod
              .string()
              .describe('The file path of the bom part content'),
            sha: zod
              .string()
              .describe(
                'The sha of the bom part content\nThere is an index on sha for more performant queries based on it.'
              ),
          })
        )
        .nullish()
        .describe(
          'If the document is a DOCX document, the document_bom will be present'
        ),
      documentFamilyId: zod
        .number()
        .nullish()
        .describe('The id of the document family this document belongs to'),
      documentId: zod.string().describe('The document id'),
      documentName: zod.string().describe('The name of the document'),
      documentVersionId: zod
        .number()
        .describe(
          'The version of the document\nThis could be the document_instance_id or document_bom_id depending on\nthe file type'
        ),
      fileType: zod
        .string()
        .nullish()
        .describe('The file type of the document'),
      modificationData: zod
        .unknown()
        .optional()
        .describe(
          'The modification data for the document instance.\nThis is only used for PDF documents.'
        ),
      owner: zod.string().describe('The owner of the document'),
      sha: zod
        .string()
        .nullish()
        .describe(
          'If the document is a PDF, this is the SHA of the pdf\nIf the document is a DOCX, this will not be present'
        ),
      subType: zod
        .union([
          zod.null(),
          zod
            .enum(['task', 'snippet', 'skill'])
            .describe(
              'The document sub type enum represents all values of document sub types.\nThese values should match the `document_sub_type_value` table in macrodb.'
            ),
        ])
        .optional(),
      updatedAt: zod.iso
        .datetime({})
        .nullish()
        .describe('The time the document instance \/ document BOM was updated'),
    }),
    initialSnapshot: zod
      .string()
      .describe(
        'Base64-encoded canonical Loro snapshot used to initialize the task.'
      ),
    teamId: zod
      .uuid()
      .nullish()
      .describe('The team this task number is scoped to.'),
    teamTaskId: zod
      .number()
      .nullish()
      .describe('The task number assigned within the team.'),
    token: zod
      .string()
      .describe('A pre-generated permission token that you can use for SS'),
  })
  .describe('Response for creating a task.');

export const initializeUserDocumentsResponse = zod.object({
  success: zod.boolean().describe('Indicates if the request was successful'),
});

/**
 * @summary Gets a list of all the user's documents so they are able to be searched on
 */
export const getDocumentListHandlerResponse = zod.object({
  data: zod
    .array(
      zod.object({
        branchedFromId: zod
          .string()
          .nullish()
          .describe('The id of the document this document branched from'),
        branchedFromVersionId: zod
          .number()
          .nullish()
          .describe(
            'The id of the version this document branched from\nThis could be either DocumentInstance or DocumentBom id depending on\nthe file type'
          ),
        createdAt: zod.iso
          .datetime({})
          .nullish()
          .describe('The time the document was created'),
        documentFamilyId: zod
          .number()
          .nullish()
          .describe('The id of the document family this document belongs to'),
        documentId: zod.string().describe('The id of the document'),
        documentName: zod.string().describe('The name of the document'),
        documentVersionId: zod
          .number()
          .describe('The id of the document version'),
        fileType: zod
          .string()
          .nullish()
          .describe('The file type of the document'),
        updatedAt: zod.iso
          .datetime({})
          .nullish()
          .describe(
            'The time the document instance \/ document BOM was updated'
          ),
      })
    )
    .describe('Data to be returned'),
  error: zod.boolean().describe('Indicates if an error occurred'),
});

/**
 * @summary Validates the provided document permissions token
 */
export const validateDocumentPermissionsTokenBody = zod.object({
  token: zod.string().describe('The encoded document permissions token'),
});

export const validateDocumentPermissionsTokenResponseExpMin = 0;

export const validateDocumentPermissionsTokenResponse = zod.object({
  access_level: zod
    .enum(['view', 'comment', 'edit', 'owner'])
    .describe('Ordered from least to most access top -> bottom'),
  document_id: zod.string().describe('The document id'),
  exp: zod
    .number()
    .min(validateDocumentPermissionsTokenResponseExpMin)
    .describe('The expiration time of the token'),
  iss: zod.string().describe('The issuer of the token'),
  user_id: zod.union([zod.null(), zod.string()]).optional(),
});

/**
 * @summary Generates a document permissions token for a provided document id
 */
export const getDocumentPermissionsTokenParams = zod.object({
  document_id: zod.string().describe('Document ID'),
});

export const getDocumentPermissionsTokenResponse = zod.object({
  token: zod.string().describe('The encoded document permissions token'),
});

/**
 * @deprecated
 * @summary Takes the docx document bom parts and generates presigned urls to upload
any new content
 */
export const presaveDocumentHandlerParams = zod.object({
  document_id: zod.string().describe('Document ID'),
});

export const presaveDocumentHandlerBody = zod.object({
  newBom: zod
    .array(
      zod.object({
        path: zod.string().describe('The file path of the bom part content'),
        sha: zod
          .string()
          .describe(
            'The sha of the bom part content\nThere is an index on sha for more performant queries based on it.'
          ),
      })
    )
    .describe(
      'The updated BOM for the document\nContaining the file path and the sha'
    ),
});

export const presaveDocumentHandlerResponse = zod.object({
  data: zod.object({
    presignedUrls: zod
      .array(
        zod.object({
          presignedUrl: zod
            .string()
            .describe('The presigned url used to upload the sha'),
          sha: zod.string().describe('The sha of the item'),
        })
      )
      .describe(
        'Contains any presigned urls you need to upload specific bom parts with.'
      ),
  }),
  error: zod.boolean().describe('Indicates if an error occurred'),
});

export const getBatchPreviewHandlerBody = zod.object({
  document_ids: zod.array(zod.string()),
});

export const getBatchPreviewHandlerResponse = zod.object({
  previews: zod.array(
    zod.union([
      zod
        .object({
          document_id: zod.string().describe('The document id'),
          document_name: zod.string().describe('The name of the document'),
          file_type: zod
            .string()
            .nullish()
            .describe('The file type of the document (e.g. pdf, docx)'),
          owner: zod.string().describe('The id of the owner of the document'),
          sub_type: zod
            .union([
              zod.null(),
              zod
                .union([
                  zod
                    .object({
                      is_completed: zod
                        .boolean()
                        .describe(
                          'Whether the task is completed.\nTrue if the Status property is set to \"Completed\".'
                        ),
                      type: zod.enum(['task']),
                    })
                    .describe('A task document with completion status'),
                  zod
                    .object({
                      type: zod.enum(['snippet']),
                    })
                    .describe('A snippet document — reusable markdown'),
                  zod
                    .object({
                      type: zod.enum(['skill']),
                    })
                    .describe(
                      'A skill document — markdown instructions for AI'
                    ),
                ])
                .describe(
                  'The sub type of a document preview with associated properties.\nTask-related properties are encoded within the variant to ensure valid states.'
                ),
            ])
            .optional(),
          updated_at: zod.iso
            .datetime({})
            .nullish()
            .describe('The time the document was last updated'),
        })
        .and(
          zod.object({
            type: zod.enum(['access']),
          })
        ),
      zod
        .object({
          document_id: zod.string(),
        })
        .and(
          zod.object({
            type: zod.enum(['no_access']),
          })
        ),
      zod
        .object({
          document_id: zod.string(),
        })
        .and(
          zod.object({
            type: zod.enum(['does_not_exist']),
          })
        ),
    ])
  ),
});

/**
 * Returns document metadata, user access level, and view location.
 * @summary Handler for `GET /documents/slug/{slug}`.
 */
export const getDocumentByTeamSlugParams = zod.object({
  slug: zod.string().describe('Team-task reference, such as ENG-42'),
});

export const getDocumentByTeamSlugResponse = zod.object({
  data: zod
    .object({
      items: zod
        .array(
          zod.union([
            zod.object({
              branchedFromId: zod
                .string()
                .nullish()
                .describe('The id of the document this document branched from'),
              branchedFromVersionId: zod
                .number()
                .nullish()
                .describe(
                  'The id of the version this document branched from\nThis could be either DocumentInstance or DocumentBom id depending on\nthe file type'
                ),
              createdAt: zod.iso
                .datetime({})
                .nullish()
                .describe('The time the document was created'),
              deletedAt: zod.iso
                .datetime({})
                .nullish()
                .describe('The time the document was deleted'),
              documentFamilyId: zod
                .number()
                .nullish()
                .describe(
                  'The id of the document family this document belongs to'
                ),
              documentVersionId: zod
                .number()
                .describe(
                  'The version of the document\nThis could be the document_instance_id or document_bom_id depending on\nthe file type'
                ),
              fileType: zod
                .string()
                .nullish()
                .describe('The file type of the document (e.g. pdf, docx)'),
              id: zod.string().describe('The document id'),
              name: zod.string().describe('The name of the document'),
              owner: zod.string().describe('The owner of the document'),
              projectId: zod
                .string()
                .nullish()
                .describe(
                  'The id of the project that this document belongs to'
                ),
              sha: zod
                .string()
                .nullish()
                .describe(
                  'If the document is a PDF, this is the SHA of the pdf\nIf the document is a DOCX, this will not be present'
                ),
              subType: zod
                .union([
                  zod.null(),
                  zod
                    .union([
                      zod
                        .object({
                          is_completed: zod
                            .boolean()
                            .describe(
                              'Whether the task is completed.\nTrue if the Status property is set to \"Completed\".'
                            ),
                          type: zod.enum(['task']),
                        })
                        .describe(
                          'A task document with its associated properties'
                        ),
                      zod
                        .object({
                          type: zod.enum(['snippet']),
                        })
                        .describe('A snippet document — reusable markdown'),
                      zod
                        .object({
                          type: zod.enum(['skill']),
                        })
                        .describe(
                          'A skill document — markdown instructions for AI'
                        ),
                    ])
                    .describe(
                      'Sub type of a document with associated properties encoded in each variant.\nThis ensures type-safety: task properties only exist when the document is a task.'
                    ),
                ])
                .optional(),
              updatedAt: zod.iso
                .datetime({})
                .nullish()
                .describe(
                  'The time the document instance \/ document BOM was updated'
                ),
              type: zod.enum(['document']),
            }),
            zod.object({
              createdAt: zod.iso
                .datetime({})
                .nullish()
                .describe('The time the chat was created'),
              deletedAt: zod.iso
                .datetime({})
                .nullish()
                .describe('The time the chat was deleted'),
              id: zod.string().describe('The chat uuid'),
              isPersistent: zod.boolean(),
              model: zod
                .string()
                .nullish()
                .describe('The model used to generate the chat'),
              name: zod.string().describe('The name of the chat'),
              projectId: zod
                .string()
                .nullish()
                .describe('The project id of the chat'),
              tokenCount: zod.number().nullish(),
              updatedAt: zod.iso
                .datetime({})
                .nullish()
                .describe('The time the chat was last updated'),
              userId: zod.string().describe('Who the chat belongs to'),
              type: zod.enum(['chat']),
            }),
            zod.object({
              createdAt: zod.iso
                .datetime({})
                .nullish()
                .describe('The time the project was created'),
              deletedAt: zod.iso.datetime({}).nullish(),
              id: zod.string().describe('The id of the project'),
              name: zod.string().describe('The name of the project'),
              parentId: zod
                .string()
                .nullish()
                .describe('The parent project id'),
              updatedAt: zod.iso
                .datetime({})
                .nullish()
                .describe('The time the project was updated'),
              userId: zod
                .string()
                .describe('The user id of who created the project'),
              type: zod.enum(['project']),
            }),
          ])
        )
        .describe('The items returned from the call'),
    })
    .describe('Data to be returned'),
  error: zod.boolean().describe('Indicates if an error occurred'),
});

/**
 * @summary Resolves the current user's starter documents.
 */
export const handlerResponse = zod
  .object({
    how_to_guide_id: zod
      .string()
      .describe('Id of the user\'s \"Macro how to guide\".'),
  })
  .describe('The deterministic starter document ids for the current user.');

/**
 * @summary Lists the built-in system skills. System skills are static, code-defined
AI instructions (see the `system_skills` crate); they surface in the
skills menu and AI skill tools like user skills, but have no document
behind them, so clients must not offer to open them.
 */
export const getSystemSkillsHandlerResponse = zod
  .object({
    skills: zod
      .array(
        zod
          .object({
            id: zod
              .uuid()
              .describe(
                'The well-known id the skill is referenced by in mentions and AI tools.'
              ),
            name: zod.string().describe('The name of the skill.'),
          })
          .describe(
            'A built-in system skill: static, code-defined AI instructions surfaced\nthrough the same tools as user-authored skill documents, but with no\ndocument behind them.'
          )
      )
      .describe('Every system skill, in display order.'),
  })
  .describe('Response listing the built-in system skills.');

/**
 * Returns document metadata, user access level, and view location.
 * @summary Handler for `GET /documents/{document_id}`.
 */
export const getDocumentParams = zod.object({
  document_id: zod.string().describe('Document ID'),
});

export const getDocumentResponse = zod.object({
  data: zod
    .object({
      documentMetadata: zod
        .object({
          branchedFromId: zod
            .string()
            .nullish()
            .describe('The id of the document this document branched from'),
          branchedFromVersionId: zod
            .number()
            .nullish()
            .describe(
              'The id of the version this document branched from\nThis could be either DocumentInstance or DocumentBom id depending on\nthe file type'
            ),
          createdAt: zod.iso
            .datetime({})
            .nullish()
            .describe('The time the document was created'),
          deletedAt: zod.iso
            .datetime({})
            .nullish()
            .describe('The time the document was deleted'),
          documentBom: zod
            .array(
              zod.object({
                id: zod.string().describe('The uuid of the bom part'),
                path: zod
                  .string()
                  .describe('The file path of the bom part content'),
                sha: zod
                  .string()
                  .describe(
                    'The sha of the bom part content\nThere is an index on sha for more performant queries based on it.'
                  ),
              })
            )
            .nullish()
            .describe(
              'If the document is a DOCX document and unzipped, the document_bom will be present'
            ),
          documentFamilyId: zod
            .number()
            .nullish()
            .describe('The id of the document family this document belongs to'),
          documentId: zod.string().describe('The document id'),
          documentName: zod.string().describe('The name of the document'),
          documentVersionId: zod
            .number()
            .describe(
              'The version of the document\nThis could be the document_instance_id or document_bom_id depending on\nthe file type'
            ),
          fileType: zod
            .string()
            .nullish()
            .describe('The file type of the document (file extension)'),
          modificationData: zod
            .unknown()
            .optional()
            .describe(
              'The modification data for the document instance.\nThis is only used for PDF documents.'
            ),
          owner: zod.string().describe('The owner of the document'),
          projectId: zod
            .string()
            .nullish()
            .describe('The id of the project that this document belongs to'),
          projectName: zod
            .string()
            .nullish()
            .describe('The name of the project that this document belongs to'),
          sha: zod
            .string()
            .nullish()
            .describe(
              'If the document is a PDF, this is the SHA of the pdf\nIf the document is a DOCX, this will not be present'
            ),
          subType: zod
            .union([
              zod.null(),
              zod
                .enum(['task', 'snippet', 'skill'])
                .describe(
                  'The document sub type enum represents all values of document sub types.\nThese values should match the `document_sub_type_value` table in macrodb.'
                ),
            ])
            .optional(),
          updatedAt: zod.iso
            .datetime({})
            .nullish()
            .describe(
              'The time the document instance \/ document BOM was updated'
            ),
        })
        .and(
          zod.object({
            content: zod
              .object({
                location: zod
                  .union([
                    zod.null(),
                    zod
                      .enum([
                        'object_storage',
                        'sync_service',
                        'docx_bom_parts',
                        'converted_pdf',
                        'unknown',
                      ])
                      .describe(
                        'Where document content is, or is expected to be, read from.'
                      ),
                  ])
                  .optional(),
                state: zod
                  .enum(['unknown', 'pending', 'ready'])
                  .describe(
                    'API-visible content lifecycle state derived from current document metadata.'
                  ),
              })
              .describe('API-visible content lifecycle and location metadata.'),
            teamId: zod
              .uuid()
              .nullish()
              .describe(
                'The team this task number is scoped to, for task documents.'
              ),
            teamTaskId: zod
              .number()
              .nullish()
              .describe(
                'The task number assigned within the team, for task documents.'
              ),
          })
        )
        .describe('Full document metadata plus content lifecycle metadata.'),
      userAccessLevel: zod
        .enum(['view', 'comment', 'edit', 'owner'])
        .describe('Ordered from least to most access top -> bottom'),
      viewLocation: zod
        .string()
        .nullish()
        .describe("The user's view location if there is one."),
    })
    .describe('Get document response data with content lifecycle metadata.')
    .describe('Data to be returned'),
  error: zod.boolean().describe('Indicates if an error occurred'),
});

/**
 * @summary Creates a new version of a document
 */
export const saveDocumentHandlerParams = zod.object({
  document_id: zod.string().describe('Document ID'),
});

export const saveDocumentHandlerBody = zod.object({
  modificationData: zod
    .unknown()
    .optional()
    .describe(
      'The modification data for the document instance.\nUsed to store highlights and other overlays onto a static file'
    ),
  newBom: zod
    .array(
      zod.object({
        path: zod.string().describe('The file path of the bom part content'),
        sha: zod
          .string()
          .describe(
            'The sha of the bom part content\nThere is an index on sha for more performant queries based on it.'
          ),
      })
    )
    .nullish()
    .describe(
      '\*\*DOCX ONLY\*\*\nThe updated BOM for the document.\nContaining the file path and the sha.'
    ),
  sha: zod
    .string()
    .nullish()
    .describe(
      'The sha of the new document.\nThis is used to generate a presigned url to upload the new document content to s3.'
    ),
});

export const saveDocumentHandlerResponse = zod.object({
  data: zod.object({
    documentMetadata: zod.object({
      branchedFromId: zod
        .string()
        .nullish()
        .describe('The id of the document this document branched from'),
      branchedFromVersionId: zod
        .number()
        .nullish()
        .describe(
          'The id of the version this document branched from\nThis could be either DocumentInstance or DocumentBom id depending on\nthe file type'
        ),
      createdAt: zod.iso
        .datetime({})
        .nullish()
        .describe('The time the document was created'),
      documentBom: zod
        .array(
          zod.object({
            id: zod.string().describe('The uuid of the bom part'),
            path: zod
              .string()
              .describe('The file path of the bom part content'),
            sha: zod
              .string()
              .describe(
                'The sha of the bom part content\nThere is an index on sha for more performant queries based on it.'
              ),
          })
        )
        .nullish()
        .describe(
          'If the document is a DOCX document, the document_bom will be present'
        ),
      documentFamilyId: zod
        .number()
        .nullish()
        .describe('The id of the document family this document belongs to'),
      documentId: zod.string().describe('The document id'),
      documentName: zod.string().describe('The name of the document'),
      documentVersionId: zod
        .number()
        .describe(
          'The version of the document\nThis could be the document_instance_id or document_bom_id depending on\nthe file type'
        ),
      fileType: zod
        .string()
        .nullish()
        .describe('The file type of the document'),
      modificationData: zod
        .unknown()
        .optional()
        .describe(
          'The modification data for the document instance.\nThis is only used for PDF documents.'
        ),
      owner: zod.string().describe('The owner of the document'),
      sha: zod
        .string()
        .nullish()
        .describe(
          'If the document is a PDF, this is the SHA of the pdf\nIf the document is a DOCX, this will not be present'
        ),
      subType: zod
        .union([
          zod.null(),
          zod
            .enum(['task', 'snippet', 'skill'])
            .describe(
              'The document sub type enum represents all values of document sub types.\nThese values should match the `document_sub_type_value` table in macrodb.'
            ),
        ])
        .optional(),
      updatedAt: zod.iso
        .datetime({})
        .nullish()
        .describe('The time the document instance \/ document BOM was updated'),
    }),
    presignedUrl: zod
      .string()
      .nullish()
      .describe(
        'If the document is an editable file, we provide a presigned url to save the updated file to.'
      ),
  }),
  error: zod.boolean().describe('Indicates if an error occurred'),
});

/**
 * Soft-deletes a document (only owners can delete).
 * @summary Handler for `DELETE /documents/{document_id}`.
 */
export const deleteDocumentParams = zod.object({
  document_id: zod.string().describe('Document ID'),
});

export const deleteDocumentResponse = zod.object({
  success: zod.boolean().describe('Indicates if the request was successful'),
});

/**
 * Edits document metadata such as name or project, and modifies
the document's share permissions. Requires edit access to the document,
and edit access to the target project if moving the document.
 * @summary Handler for `PATCH /documents/{document_id}`.
 */
export const editDocumentParams = zod.object({
  document_id: zod.string().describe('Document ID'),
});

export const editDocumentBody = zod
  .object({
    documentName: zod.string().nullish().describe('The name of the document.'),
    fileType: zod
      .union([
        zod.null(),
        zod
          .union([
            zod
              .object({
                set: zod
                  .enum([
                    'docx',
                    'pdf',
                    'md',
                    'canvas',
                    'coffee',
                    'cson',
                    'iced',
                    'c',
                    'i',
                    'cpp',
                    'cppm',
                    'cc',
                    'ccm',
                    'cxx',
                    'cxxm',
                    'cplusplus',
                    'cplusplusm',
                    'hpp',
                    'hh',
                    'hxx',
                    'hplusplus',
                    'h',
                    'ii',
                    'ino',
                    'inl',
                    'ipp',
                    'ixx',
                    'tpp',
                    'txx',
                    'hppin',
                    'hin',
                    'cu',
                    'cuh',
                    'cs',
                    'csx',
                    'cake',
                    'css',
                    'dart',
                    'diff',
                    'patch',
                    'rej',
                    'dockerfile',
                    'containerfile',
                    'go',
                    'handlebars',
                    'hbs',
                    'hjs',
                    'hlsl',
                    'hlsli',
                    'fx',
                    'fxh',
                    'vsh',
                    'psh',
                    'cginc',
                    'compute',
                    'html',
                    'htm',
                    'shtml',
                    'xhtml',
                    'xht',
                    'mdoc',
                    'jsp',
                    'asp',
                    'aspx',
                    'jshtm',
                    'volt',
                    'ejs',
                    'rhtml',
                    'ini',
                    'conf',
                    'properties',
                    'cfg',
                    'directory',
                    'gitattributes',
                    'gitconfig',
                    'gitmodules',
                    'editorconfig',
                    'repo',
                    'java',
                    'jav',
                    'jsx',
                    'js',
                    'es6',
                    'mjs',
                    'cjs',
                    'pac',
                    'json',
                    'bowerrc',
                    'jscsrc',
                    'webmanifest',
                    'jsmap',
                    'cssmap',
                    'tsmap',
                    'har',
                    'jslintrc',
                    'jsonld',
                    'geojson',
                    'ipynb',
                    'vuerc',
                    'jsonc',
                    'eslintrc',
                    'eslintrcjson',
                    'jsfmtrc',
                    'jshintrc',
                    'swcrc',
                    'hintrc',
                    'babelrc',
                    'jsonl',
                    'ndjson',
                    'codesnippets',
                    'jl',
                    'jmd',
                    'sty',
                    'cls',
                    'bbx',
                    'cbx',
                    'tex',
                    'ltx',
                    'ctx',
                    'bib',
                    'less',
                    'log',
                    'lua',
                    'mak',
                    'mk',
                    'mkd',
                    'mdwn',
                    'mdown',
                    'markdown',
                    'markdn',
                    'mdtxt',
                    'mdtext',
                    'workbook',
                    'm',
                    'mm',
                    'pl',
                    'pm',
                    'pod',
                    't',
                    'psgi',
                    'raku',
                    'rakumod',
                    'rakutest',
                    'rakudoc',
                    'nqp',
                    'p6',
                    'pl6',
                    'pm6',
                    'php',
                    'php4',
                    'php5',
                    'phtml',
                    'ctp',
                    'ps1',
                    'psm1',
                    'psd1',
                    'pssc',
                    'psrc',
                    'py',
                    'rpy',
                    'pyw',
                    'cpy',
                    'gyp',
                    'gypi',
                    'pyi',
                    'ipy',
                    'pyt',
                    'r',
                    'rhistory',
                    'rprofile',
                    'rt',
                    'cshtml',
                    'razor',
                    'rb',
                    'rbx',
                    'rjs',
                    'gemspec',
                    'rake',
                    'ru',
                    'erb',
                    'podspec',
                    'rbi',
                    'rs',
                    'scss',
                    'sass',
                    'shader',
                    'sh',
                    'bash',
                    'bashrc',
                    'bashaliases',
                    'bashprofile',
                    'bashlogin',
                    'ebuild',
                    'eclass',
                    'profile',
                    'bashlogout',
                    'xprofile',
                    'xsession',
                    'xsessionrc',
                    'zsh',
                    'zshrc',
                    'zprofile',
                    'zlogin',
                    'zlogout',
                    'zshenv',
                    'zshtheme',
                    'fish',
                    'ksh',
                    'csh',
                    'cshrc',
                    'tcshrc',
                    'yashrc',
                    'yashprofile',
                    'sql',
                    'dsql',
                    'swift',
                    'ts',
                    'cts',
                    'mts',
                    'tsx',
                    'tsbuildinfo',
                    'xml',
                    'xsd',
                    'ascx',
                    'atom',
                    'axml',
                    'axaml',
                    'bpmn',
                    'cpt',
                    'csl',
                    'csproj',
                    'csprojuser',
                    'dita',
                    'ditamap',
                    'dtd',
                    'ent',
                    'mod',
                    'dtml',
                    'fsproj',
                    'fxml',
                    'iml',
                    'isml',
                    'jmx',
                    'launch',
                    'menu',
                    'mxml',
                    'nuspec',
                    'opml',
                    'owl',
                    'proj',
                    'props',
                    'pt',
                    'publishsettings',
                    'pubxml',
                    'pubxmluser',
                    'rbxlx',
                    'rbxmx',
                    'rdf',
                    'rng',
                    'rss',
                    'shproj',
                    'storyboard',
                    'targets',
                    'tld',
                    'tmx',
                    'vbproj',
                    'vbprojuser',
                    'vcxproj',
                    'vcxprojfilters',
                    'wsdl',
                    'wxi',
                    'wxl',
                    'wxs',
                    'xaml',
                    'xbl',
                    'xib',
                    'xlf',
                    'xliff',
                    'xpdl',
                    'xul',
                    'xoml',
                    'xsl',
                    'xslt',
                    'yaml',
                    'yml',
                    'eyaml',
                    'eyml',
                    'cff',
                    'yamltmlanguage',
                    'yamltmpreferences',
                    'yamltmtheme',
                    'winget',
                    'txt',
                    'csv',
                    'tsv',
                    'jpeg',
                    'jpg',
                    'png',
                    'gif',
                    'svg',
                    'webp',
                    'avif',
                    'bmp',
                    'ico',
                    'tiff',
                    'tif',
                    'heic',
                    'heif',
                    'tar',
                    'targz',
                    'tgz',
                    'gz',
                    'bz2',
                    'tarbz2',
                    'tbz2',
                    'z',
                    'tarz',
                    'lz',
                    'tarlz',
                    'xz',
                    'tarxz',
                    'txz',
                    'lzma',
                    'tarlzma',
                    'rar',
                    'sevenz',
                    'zst',
                    'tarzst',
                    'tzst',
                    'zip',
                    'exe',
                    'msi',
                    'dll',
                    'bat',
                    'cmd',
                    'com',
                    'appimage',
                    'app',
                    'bin',
                    'deb',
                    'rpm',
                    'apk',
                    'dmg',
                    'pkg',
                    'crx',
                    'xpi',
                    'mp3',
                    'wav',
                    'ogg',
                    'flac',
                    'aac',
                    'm4a',
                    'wma',
                    'mid',
                    'midi',
                    'mp4',
                    'mkv',
                    'webm',
                    'avi',
                    'mov',
                    'wmv',
                    'mpg',
                    'mpeg',
                    'm4v',
                    'flv',
                    'f4v',
                    'threegp',
                    'ttf',
                    'otf',
                    'woff',
                    'woff2',
                    'eot',
                    'rtf',
                    'odt',
                    'ods',
                    'odp',
                    'odg',
                    'odf',
                    'epub',
                    'mobi',
                    'azw',
                    'azw3',
                    'djvu',
                    'xls',
                    'ppt',
                    'pptx',
                    'xlsx',
                    'db',
                    'sqlite',
                    'sqlite3',
                    'mdb',
                    'accdb',
                    'dbf',
                    'plist',
                    'toml',
                    'env',
                    'dot',
                    'gv',
                    'torrent',
                    'ics',
                    'vcf',
                    'ai',
                    'eps',
                    'ps',
                    'dxf',
                    'dwg',
                    'stl',
                    'obj',
                    'fbx',
                    'blend',
                    'dae',
                    'threeds',
                    'gltf',
                    'glb',
                    'vhd',
                    'vhdx',
                    'vmdk',
                    'ova',
                    'ovf',
                    'iso',
                    'img',
                    'swf',
                  ])
                  .describe(
                    'Generates a FileType enum and associated ContentType enum with their implementations.\n\nThis macro takes a list of tuples in the format:\n(Variant, \"extension\", \"mime_type\", CONTENT_TYPE_VARIANT)\n\nFor each tuple it generates:\n- A variant in the FileType enum\n- A variant in the ContentType enum\n- Implementations for:\n  - FileType::to_str() - Converts FileType to extension string\n  - FileType::from_str() - Converts extension string to FileType\n  - From<FileType> for ContentType - Maps FileType to ContentType\n  - ContentType::mime_type() - Gets MIME type for ContentType\n'
                  ),
              })
              .describe('Set the file type to a specific value.'),
            zod.enum(['clear']).describe('Clear the file type (set to null).'),
          ])
          .describe(
            'Represents a file type update: either set to a specific type or clear to null.'
          ),
      ])
      .optional(),
    projectId: zod
      .string()
      .nullish()
      .describe('The new project id of the document.'),
    sharePermission: zod
      .union([
        zod.null(),
        zod.object({
          channelSharePermissions: zod
            .array(
              zod.object({
                accessLevel: zod
                  .union([
                    zod.null(),
                    zod
                      .enum(['view', 'comment', 'edit', 'owner'])
                      .describe(
                        'Ordered from least to most access top -> bottom'
                      ),
                  ])
                  .optional(),
                channelId: zod.string().describe('The channel id'),
                operation: zod.enum(['add', 'remove', 'replace']),
              })
            )
            .nullish()
            .describe(
              'Any channel share permissions to be created\/updated\/removed'
            ),
          linkShare: zod
            .union([
              zod.null(),
              zod
                .enum(['PUBLIC', 'TEAM'])
                .describe(
                  'Defines who can access an item through its share link.'
                ),
            ])
            .optional(),
          linkShareAccessLevel: zod
            .union([
              zod.null(),
              zod
                .enum(['view', 'comment', 'edit', 'owner'])
                .describe('Ordered from least to most access top -> bottom'),
            ])
            .optional(),
        }),
      ])
      .optional(),
  })
  .describe('Arguments for the edit_document service call.');

export const editDocumentResponse = zod
  .object({
    data: zod.object({
      success: zod
        .boolean()
        .describe('Indicates if the request was successful'),
    }),
    error: zod.boolean().describe('Whether an error occurred.'),
  })
  .describe('Edit document response.');

/**
 * Returns the short UUID and git branch name for a task document.
Returns 400 if the document is not a task.
 * @summary Handler for `GET /documents/{document_id}/branch_name`.
 */
export const getDocumentBranchNameParams = zod.object({
  document_id: zod.string().describe('Document ID'),
});

export const getDocumentBranchNameResponse = zod
  .object({
    branchName: zod
      .string()
      .describe('The git branch name for the task document.'),
    shortId: zod.string().describe('The short id of the document.'),
  })
  .describe('Branch name response.');

/**
 * Copies an existing document, creating a new document with the same content.
Does not require re-uploading the document file.
 * @summary Handler for `POST /documents/{document_id}/copy`.
 */
export const copyDocumentParams = zod.object({
  document_id: zod.string().describe('Document ID'),
});

export const copyDocumentQueryParams = zod.object({
  version_id: zod
    .number()
    .optional()
    .describe(
      'The version id of the document to copy. Defaults to copying the latest version of the document.'
    ),
});

export const copyDocumentBody = zod
  .object({
    documentName: zod
      .string()
      .describe('The name of the new document (without extension).'),
    versionId: zod
      .union([
        zod.null(),
        zod.object({
          counter: zod.number(),
          peer: zod.string(),
        }),
      ])
      .optional(),
  })
  .describe('Request body for copying a document.');

export const copyDocumentResponse = zod
  .object({
    data: zod
      .object({
        documentMetadata: zod
          .object({
            branchedFromId: zod
              .string()
              .nullish()
              .describe('The id of the document this document branched from'),
            branchedFromVersionId: zod
              .number()
              .nullish()
              .describe(
                'The id of the version this document branched from\nThis could be either DocumentInstance or DocumentBom id depending on\nthe file type'
              ),
            createdAt: zod.iso
              .datetime({})
              .nullish()
              .describe('The time the document was created'),
            documentBom: zod
              .array(
                zod.object({
                  id: zod.string().describe('The uuid of the bom part'),
                  path: zod
                    .string()
                    .describe('The file path of the bom part content'),
                  sha: zod
                    .string()
                    .describe(
                      'The sha of the bom part content\nThere is an index on sha for more performant queries based on it.'
                    ),
                })
              )
              .nullish()
              .describe(
                'If the document is a DOCX document, the document_bom will be present'
              ),
            documentFamilyId: zod
              .number()
              .nullish()
              .describe(
                'The id of the document family this document belongs to'
              ),
            documentId: zod.string().describe('The document id'),
            documentName: zod.string().describe('The name of the document'),
            documentVersionId: zod
              .number()
              .describe(
                'The version of the document\nThis could be the document_instance_id or document_bom_id depending on\nthe file type'
              ),
            fileType: zod
              .string()
              .nullish()
              .describe('The file type of the document'),
            modificationData: zod
              .unknown()
              .optional()
              .describe(
                'The modification data for the document instance.\nThis is only used for PDF documents.'
              ),
            owner: zod.string().describe('The owner of the document'),
            sha: zod
              .string()
              .nullish()
              .describe(
                'If the document is a PDF, this is the SHA of the pdf\nIf the document is a DOCX, this will not be present'
              ),
            subType: zod
              .union([
                zod.null(),
                zod
                  .enum(['task', 'snippet', 'skill'])
                  .describe(
                    'The document sub type enum represents all values of document sub types.\nThese values should match the `document_sub_type_value` table in macrodb.'
                  ),
              ])
              .optional(),
            updatedAt: zod.iso
              .datetime({})
              .nullish()
              .describe(
                'The time the document instance \/ document BOM was updated'
              ),
          })
          .and(
            zod.object({
              content: zod
                .object({
                  location: zod
                    .union([
                      zod.null(),
                      zod
                        .enum([
                          'object_storage',
                          'sync_service',
                          'docx_bom_parts',
                          'converted_pdf',
                          'unknown',
                        ])
                        .describe(
                          'Where document content is, or is expected to be, read from.'
                        ),
                    ])
                    .optional(),
                  state: zod
                    .enum(['unknown', 'pending', 'ready'])
                    .describe(
                      'API-visible content lifecycle state derived from current document metadata.'
                    ),
                })
                .describe(
                  'API-visible content lifecycle and location metadata.'
                ),
              teamId: zod
                .uuid()
                .nullish()
                .describe(
                  'The team this task number is scoped to, for task documents.'
                ),
              teamTaskId: zod
                .number()
                .nullish()
                .describe(
                  'The task number assigned within the team, for task documents.'
                ),
            })
          )
          .describe(
            'Create\/copy response metadata plus content lifecycle metadata.'
          ),
        presignedUrl: zod
          .string()
          .nullish()
          .describe(
            'Presigned upload URL, when the caller still needs to upload bytes.'
          ),
      })
      .describe('Document response with content lifecycle metadata.'),
    error: zod.boolean().describe('Indicates if an error occurred.'),
  })
  .describe('Response wrapper for the copy document endpoint.');

/**
 * @summary Generates a presigned url to download the raw content of the document
For files with modification layers, they will not be applied in the downloaded file.
 */
export const exportDocumentParams = zod.object({
  document_id: zod.string().describe('Document ID'),
});

export const exportDocumentResponse = zod.object({
  presigned_url: zod
    .string()
    .describe('The presigned url to download the raw content of the document'),
});

/**
 * Returns GitHub pull requests associated with a task document.
Returns 400 if the document is not a task.
 * @summary Handler for `GET /documents/{document_id}/github_prs`.
 */
export const getDocumentGithubPullRequestsParams = zod.object({
  document_id: zod.string().describe('Document ID'),
});

export const getDocumentGithubPullRequestsResponsePullRequestsItemAdditionsMin = 0;

export const getDocumentGithubPullRequestsResponsePullRequestsItemChecksItemIdMin = 0;

export const getDocumentGithubPullRequestsResponsePullRequestsItemCommentsItemIdMin = 0;

export const getDocumentGithubPullRequestsResponsePullRequestsItemCommentsItemInReplyToIdMin = 0;

export const getDocumentGithubPullRequestsResponsePullRequestsItemCommentsItemLineMin = 0;

export const getDocumentGithubPullRequestsResponsePullRequestsItemCommentsItemOriginalLineMin = 0;

export const getDocumentGithubPullRequestsResponsePullRequestsItemCommentsItemPullRequestReviewIdMin = 0;

export const getDocumentGithubPullRequestsResponsePullRequestsItemDeletionsMin = 0;

export const getDocumentGithubPullRequestsResponsePullRequestsItemNumberMin = 0;

export const getDocumentGithubPullRequestsResponse = zod
  .object({
    pullRequests: zod
      .array(
        zod
          .object({
            additions: zod
              .number()
              .min(
                getDocumentGithubPullRequestsResponsePullRequestsItemAdditionsMin
              )
              .nullish()
              .describe(
                'The number of added lines in the pull request, when enrichment data is available.'
              ),
            checks: zod
              .array(
                zod
                  .object({
                    completedAt: zod.iso
                      .datetime({})
                      .nullish()
                      .describe(
                        'When the check run completed, when available.'
                      ),
                    conclusion: zod
                      .string()
                      .nullish()
                      .describe(
                        'The raw GitHub check run conclusion, when the run has completed.'
                      ),
                    id: zod
                      .number()
                      .min(
                        getDocumentGithubPullRequestsResponsePullRequestsItemChecksItemIdMin
                      )
                      .describe(
                        'The unique GitHub identifier for the check run.'
                      ),
                    name: zod.string().describe('The check run name.'),
                    startedAt: zod.iso
                      .datetime({})
                      .nullish()
                      .describe('When the check run started, when available.'),
                    status: zod
                      .string()
                      .describe('The raw GitHub check run status.'),
                    url: zod
                      .string()
                      .nullish()
                      .describe(
                        'The public GitHub URL for the check run, when available.'
                      ),
                  })
                  .describe(
                    'A check run associated with a GitHub pull request.'
                  )
              )
              .nullish()
              .describe(
                'Check runs collected from the pull request head commit, when enrichment data is available.'
              ),
            comments: zod
              .array(
                zod
                  .object({
                    authorAssociation: zod
                      .string()
                      .nullish()
                      .describe(
                        "GitHub's relationship label for the author, when available."
                      ),
                    authorLogin: zod
                      .string()
                      .nullish()
                      .describe(
                        'The GitHub login for the comment author, when available.'
                      ),
                    body: zod
                      .string()
                      .describe('The comment or review body text.'),
                    createdAt: zod.iso
                      .datetime({})
                      .nullish()
                      .describe(
                        'When the comment was created or the review was submitted.'
                      ),
                    id: zod
                      .number()
                      .min(
                        getDocumentGithubPullRequestsResponsePullRequestsItemCommentsItemIdMin
                      )
                      .describe(
                        'The unique GitHub identifier for the comment or review.'
                      ),
                    inReplyToId: zod
                      .number()
                      .min(
                        getDocumentGithubPullRequestsResponsePullRequestsItemCommentsItemInReplyToIdMin
                      )
                      .nullish()
                      .describe(
                        'The id of the comment this one replies to, when it is part of a review\nthread. Only ever present on `review_comment` sources.'
                      ),
                    line: zod
                      .number()
                      .min(
                        getDocumentGithubPullRequestsResponsePullRequestsItemCommentsItemLineMin
                      )
                      .nullish()
                      .describe(
                        "The line in the current diff the comment is anchored to. Cleared by\nGitHub when later commits outdate the comment's diff."
                      ),
                    originalLine: zod
                      .number()
                      .min(
                        getDocumentGithubPullRequestsResponsePullRequestsItemCommentsItemOriginalLineMin
                      )
                      .nullish()
                      .describe(
                        'The line the comment was originally anchored to, kept even when the\ndiff has since changed.'
                      ),
                    path: zod
                      .string()
                      .nullish()
                      .describe(
                        'The repository-relative file path the review comment is anchored to.\nOnly ever present on `review_comment` sources.'
                      ),
                    pullRequestReviewId: zod
                      .number()
                      .min(
                        getDocumentGithubPullRequestsResponsePullRequestsItemCommentsItemPullRequestReviewIdMin
                      )
                      .nullish()
                      .describe(
                        'The id of the pull request review this comment was submitted with.\nOnly ever present on `review_comment` sources.'
                      ),
                    source: zod
                      .string()
                      .describe(
                        'The GitHub source for the comment, such as `issue_comment` or `review_comment`.'
                      ),
                    updatedAt: zod.iso
                      .datetime({})
                      .nullish()
                      .describe('When the comment or review was last updated.'),
                    url: zod
                      .string()
                      .nullish()
                      .describe(
                        'The public GitHub URL for the comment or review, when available.'
                      ),
                  })
                  .describe('A comment associated with a GitHub pull request.')
              )
              .nullish()
              .describe(
                'Comments collected from the pull request, when enrichment data is available.'
              ),
            deletions: zod
              .number()
              .min(
                getDocumentGithubPullRequestsResponsePullRequestsItemDeletionsMin
              )
              .nullish()
              .describe(
                'The number of deleted lines in the pull request, when enrichment data is available.'
              ),
            displayName: zod
              .string()
              .describe('A compact label suitable for display in the UI.'),
            foreignEntityId: zod
              .uuid()
              .nullish()
              .describe(
                'The internal `foreign_entity.id` UUID for the GitHub pull request row.'
              ),
            githubKey: zod
              .string()
              .describe(
                'The stored GitHub association key, in `owner\/repo\/pull\/number` format.'
              ),
            name: zod
              .string()
              .nullish()
              .describe(
                'The GitHub pull request title, when enrichment data is available.'
              ),
            number: zod
              .number()
              .min(
                getDocumentGithubPullRequestsResponsePullRequestsItemNumberMin
              )
              .describe('The GitHub pull request number.'),
            owner: zod
              .string()
              .describe('The GitHub repository owner or organization.'),
            repo: zod.string().describe('The GitHub repository name.'),
            status: zod
              .string()
              .nullish()
              .describe(
                'The GitHub pull request status, when enrichment data is available.'
              ),
            url: zod
              .string()
              .describe('The public GitHub URL for the pull request.'),
          })
          .describe(
            'Display-ready data for a GitHub pull request associated with a task.'
          )
      )
      .describe('Parsed pull requests, in repository query order.'),
  })
  .describe(
    'Response containing all GitHub pull requests associated with a task.'
  );

/**
 * @summary Gets the presigned url(s) for the document. aka location
 */
export const getLocationHandlerParams = zod.object({
  document_id: zod.string().describe('Document ID'),
});

export const getLocationHandlerQueryParams = zod.object({
  document_version_id: zod
    .number()
    .describe('A specific document version id to get the location for.'),
  get_converted_docx_url: zod
    .boolean()
    .describe('If true, this will return the converted docx url.'),
});

export const getLocationHandlerResponse = zod.union([
  zod
    .object({
      presignedUrl: zod
        .string()
        .describe('The presigned url of the document if it is not a docx'),
    })
    .describe('The presigned url of the document if it is not a docx'),
  zod
    .object({
      presignedUrls: zod
        .array(
          zod.object({
            presignedUrl: zod
              .string()
              .describe('The presigned url used to upload the sha'),
            sha: zod.string().describe('The sha of the item'),
          })
        )
        .describe('The presigned urls of the docx bom parts if it is a docx'),
    })
    .describe('The presigned urls of the docx bom parts if it is a docx'),
]);

/**
 * Returns a presigned URL or sync service content for accessing the document.
 * @summary Handler for `GET /documents/{document_id}/location_v3`.
 */
export const getDocumentLocationV3Params = zod.object({
  document_id: zod.string().describe('Document ID'),
});

export const getDocumentLocationV3QueryParams = zod.object({
  document_version_id: zod
    .number()
    .optional()
    .describe('A specific document version id to get the location for.'),
  get_converted_docx_url: zod
    .boolean()
    .optional()
    .describe('If true, this will return the converted docx url.'),
});

export const getDocumentLocationV3Response = zod
  .union([
    zod
      .object({
        content: zod
          .object({
            location: zod
              .union([
                zod.null(),
                zod
                  .enum([
                    'object_storage',
                    'sync_service',
                    'docx_bom_parts',
                    'converted_pdf',
                    'unknown',
                  ])
                  .describe(
                    'Where document content is, or is expected to be, read from.'
                  ),
              ])
              .optional(),
            state: zod
              .enum(['unknown', 'pending', 'ready'])
              .describe(
                'API-visible content lifecycle state derived from current document metadata.'
              ),
          })
          .describe('API-visible content lifecycle and location metadata.'),
        metadata: zod
          .object({
            branchedFromId: zod.string().nullish(),
            branchedFromVersionId: zod.number().nullish(),
            deletedAt: zod.iso.datetime({}).nullish(),
            documentFamilyId: zod.number().nullish(),
            documentId: zod.string(),
            documentName: zod.string(),
            fileType: zod.string().nullish(),
            owner: zod.string(),
            projectId: zod.string().nullish(),
            subType: zod
              .union([
                zod.null(),
                zod
                  .enum(['task', 'snippet', 'skill'])
                  .describe(
                    'The document sub type enum represents all values of document sub types.\nThese values should match the `document_sub_type_value` table in macrodb.'
                  ),
              ])
              .optional(),
          })
          .describe(
            'Returns basic information of a document used for some db queries'
          ),
        presignedUrl: zod.string().describe('Presigned URL.'),
        type: zod.enum(['presignedUrl']),
      })
      .describe('A single document-storage URL.'),
    zod
      .object({
        content: zod
          .object({
            location: zod
              .union([
                zod.null(),
                zod
                  .enum([
                    'object_storage',
                    'sync_service',
                    'docx_bom_parts',
                    'converted_pdf',
                    'unknown',
                  ])
                  .describe(
                    'Where document content is, or is expected to be, read from.'
                  ),
              ])
              .optional(),
            state: zod
              .enum(['unknown', 'pending', 'ready'])
              .describe(
                'API-visible content lifecycle state derived from current document metadata.'
              ),
          })
          .describe('API-visible content lifecycle and location metadata.'),
        metadata: zod
          .object({
            branchedFromId: zod.string().nullish(),
            branchedFromVersionId: zod.number().nullish(),
            deletedAt: zod.iso.datetime({}).nullish(),
            documentFamilyId: zod.number().nullish(),
            documentId: zod.string(),
            documentName: zod.string(),
            fileType: zod.string().nullish(),
            owner: zod.string(),
            projectId: zod.string().nullish(),
            subType: zod
              .union([
                zod.null(),
                zod
                  .enum(['task', 'snippet', 'skill'])
                  .describe(
                    'The document sub type enum represents all values of document sub types.\nThese values should match the `document_sub_type_value` table in macrodb.'
                  ),
              ])
              .optional(),
          })
          .describe(
            'Returns basic information of a document used for some db queries'
          ),
        presignedUrls: zod
          .array(
            zod.object({
              presignedUrl: zod
                .string()
                .describe('The presigned url used to upload the sha'),
              sha: zod.string().describe('The sha of the item'),
            })
          )
          .describe('Presigned URLs.'),
        type: zod.enum(['presignedUrls']),
      })
      .describe(
        'Multiple document-storage URLs, currently for DOCX BOM parts.'
      ),
    zod
      .object({
        content: zod
          .object({
            location: zod
              .union([
                zod.null(),
                zod
                  .enum([
                    'object_storage',
                    'sync_service',
                    'docx_bom_parts',
                    'converted_pdf',
                    'unknown',
                  ])
                  .describe(
                    'Where document content is, or is expected to be, read from.'
                  ),
              ])
              .optional(),
            state: zod
              .enum(['unknown', 'pending', 'ready'])
              .describe(
                'API-visible content lifecycle state derived from current document metadata.'
              ),
          })
          .describe('API-visible content lifecycle and location metadata.'),
        metadata: zod
          .object({
            branchedFromId: zod.string().nullish(),
            branchedFromVersionId: zod.number().nullish(),
            deletedAt: zod.iso.datetime({}).nullish(),
            documentFamilyId: zod.number().nullish(),
            documentId: zod.string(),
            documentName: zod.string(),
            fileType: zod.string().nullish(),
            owner: zod.string(),
            projectId: zod.string().nullish(),
            subType: zod
              .union([
                zod.null(),
                zod
                  .enum(['task', 'snippet', 'skill'])
                  .describe(
                    'The document sub type enum represents all values of document sub types.\nThese values should match the `document_sub_type_value` table in macrodb.'
                  ),
              ])
              .optional(),
          })
          .describe(
            'Returns basic information of a document used for some db queries'
          ),
        type: zod.enum(['syncServiceContent']),
      })
      .describe('Sync-service backed content.'),
  ])
  .describe('Location response with content lifecycle metadata.');

/**
 * @summary Permanently deletes a document.
 */
export const permanentlyDeleteDocumentParams = zod.object({
  document_id: zod.string().describe('Document ID'),
});

export const permanentlyDeleteDocumentResponse = zod.object({
  data: zod.object({
    success: zod.boolean().describe('Indicates if the request was successful'),
  }),
  error: zod.boolean().describe('Indicates if an error occurred'),
});

/**
 * @summary Fetches the document pdf processing result for a given document id
 */
export const getDocumentProcessingResultParams = zod.object({
  document_id: zod.string().describe('Document ID'),
});

export const getDocumentProcessingResultResponse = zod.object({
  data: zod
    .union([
      zod.null(),
      zod.object({
        result: zod.string().describe('The stringified result'),
      }),
    ])
    .optional(),
  error: zod.boolean().describe('Indicates if an error occurred'),
  message: zod.string().nullish().describe('Message to explain failure'),
});

/**
 * @summary Fetches the document processing result for a given document id and job id
 */
export const jobProcessingResultHandlerParams = zod.object({
  document_id: zod.string().describe('Document ID'),
  job_id: zod.string().describe('Job ID'),
});

export const jobProcessingResultHandlerResponse = zod.object({
  data: zod
    .union([
      zod.null(),
      zod.object({
        result: zod.string().describe('The stringified result'),
      }),
    ])
    .optional(),
  error: zod.boolean().describe('Indicates if an error occurred'),
  message: zod.string().nullish().describe('Message to explain failure'),
});

/**
 * @summary Deletes a specific document
 */
export const revertDeleteDocumentParams = zod.object({
  document_id: zod.string().describe('Document ID'),
});

export const revertDeleteDocumentResponse = zod.object({
  data: zod.object({
    success: zod.boolean().describe('Indicates if the request was successful'),
  }),
  error: zod.boolean().describe('Indicates if an error occurred'),
});

/**
 * Returns the short UUID for a document.
 * @summary Handler for `GET /documents/{document_id}/short_id`.
 */
export const getDocumentShortIdParams = zod.object({
  document_id: zod.string().describe('Document ID'),
});

/**
 * @summary For any file that isn't PDF or DOCX, use this endpoint for saving.
This endpoint will allow you to save the document by providing the file content as part of a multipart request. Use key 'file' along with the file bytes.
simple_save is different than the save_document endpoint because it does not return a presigned URL, Instead, it simply saves the file to S3 directly (and returns the document metadata).
 */
export const simpleSaveParams = zod.object({
  document_id: zod.string().describe('Document ID'),
});

export const simpleSaveResponse = zod.object({
  data: zod.object({
    documentMetadata: zod.object({
      branchedFromId: zod
        .string()
        .nullish()
        .describe('The id of the document this document branched from'),
      branchedFromVersionId: zod
        .number()
        .nullish()
        .describe(
          'The id of the version this document branched from\nThis could be either DocumentInstance or DocumentBom id depending on\nthe file type'
        ),
      createdAt: zod.iso
        .datetime({})
        .nullish()
        .describe('The time the document was created'),
      documentBom: zod
        .array(
          zod.object({
            id: zod.string().describe('The uuid of the bom part'),
            path: zod
              .string()
              .describe('The file path of the bom part content'),
            sha: zod
              .string()
              .describe(
                'The sha of the bom part content\nThere is an index on sha for more performant queries based on it.'
              ),
          })
        )
        .nullish()
        .describe(
          'If the document is a DOCX document, the document_bom will be present'
        ),
      documentFamilyId: zod
        .number()
        .nullish()
        .describe('The id of the document family this document belongs to'),
      documentId: zod.string().describe('The document id'),
      documentName: zod.string().describe('The name of the document'),
      documentVersionId: zod
        .number()
        .describe(
          'The version of the document\nThis could be the document_instance_id or document_bom_id depending on\nthe file type'
        ),
      fileType: zod
        .string()
        .nullish()
        .describe('The file type of the document'),
      modificationData: zod
        .unknown()
        .optional()
        .describe(
          'The modification data for the document instance.\nThis is only used for PDF documents.'
        ),
      owner: zod.string().describe('The owner of the document'),
      sha: zod
        .string()
        .nullish()
        .describe(
          'If the document is a PDF, this is the SHA of the pdf\nIf the document is a DOCX, this will not be present'
        ),
      subType: zod
        .union([
          zod.null(),
          zod
            .enum(['task', 'snippet', 'skill'])
            .describe(
              'The document sub type enum represents all values of document sub types.\nThese values should match the `document_sub_type_value` table in macrodb.'
            ),
        ])
        .optional(),
      updatedAt: zod.iso
        .datetime({})
        .nullish()
        .describe('The time the document instance \/ document BOM was updated'),
    }),
    presignedUrl: zod
      .string()
      .nullish()
      .describe(
        'If the document is an editable file, we provide a presigned url to save the updated file to.'
      ),
  }),
  error: zod.boolean().describe('Indicates if an error occurred'),
});

/**
 * @summary Gets the team-share state of a document. The team is resolved from the
document owner's team membership; `teamId` is omitted when the owner does
not belong to a team.
 */
export const getDocumentTeamShareParams = zod.object({
  document_id: zod.string().describe('Document ID'),
});

export const getDocumentTeamShareResponse = zod
  .object({
    sharedWithTeam: zod
      .boolean()
      .describe(
        "Whether the document is currently shared with the owner's team."
      ),
    teamId: zod
      .uuid()
      .nullish()
      .describe(
        "The owner's team the document is (or would be) shared with. `None` when\nthe owner does not belong to a team."
      ),
  })
  .describe(
    "The team-share state of a document. The team is resolved from the document\nowner's team membership."
  );

/**
 * @summary Sets the team-share state of a document. Sharing grants the document
owner's team Edit access; unsharing removes the team's access. Requires
Edit access on the document.
 */
export const setDocumentTeamShareParams = zod.object({
  document_id: zod.string().describe('Document ID'),
});

export const setDocumentTeamShareBody = zod
  .object({
    shareWithTeam: zod
      .boolean()
      .describe("Whether the document should be shared with the owner's team."),
  })
  .describe("Request body for setting a document's team-share state.");

export const setDocumentTeamShareResponse = zod
  .object({
    sharedWithTeam: zod
      .boolean()
      .describe(
        "Whether the document is currently shared with the owner's team."
      ),
    teamId: zod
      .uuid()
      .nullish()
      .describe(
        "The owner's team the document is (or would be) shared with. `None` when\nthe owner does not belong to a team."
      ),
  })
  .describe(
    "The team-share state of a document. The team is resolved from the document\nowner's team membership."
  );

/**
 * @summary Gets the list of users who have viewed a given document
 */
export const getDocumentViewsHandlerParams = zod.object({
  document_id: zod.string().describe('Document ID'),
});

export const getDocumentViewsHandlerResponse = zod.object({
  count: zod.number().describe('Total number of views for the document'),
  users: zod
    .array(zod.string())
    .describe('List of user emails who have viewed the document'),
});

/**
 * @summary Gets a particular document by its id
 */
export const getDocumentVersionParams = zod.object({
  document_id: zod.string().describe('Document ID'),
  document_version_id: zod.number().describe('Document Version ID'),
});

export const getDocumentVersionResponse = zod.object({
  data: zod.object({
    documentMetadata: zod.object({
      branchedFromId: zod
        .string()
        .nullish()
        .describe('The id of the document this document branched from'),
      branchedFromVersionId: zod
        .number()
        .nullish()
        .describe(
          'The id of the version this document branched from\nThis could be either DocumentInstance or DocumentBom id depending on\nthe file type'
        ),
      createdAt: zod.iso
        .datetime({})
        .nullish()
        .describe('The time the document was created'),
      deletedAt: zod.iso
        .datetime({})
        .nullish()
        .describe('The time the document was deleted'),
      documentBom: zod
        .array(
          zod.object({
            id: zod.string().describe('The uuid of the bom part'),
            path: zod
              .string()
              .describe('The file path of the bom part content'),
            sha: zod
              .string()
              .describe(
                'The sha of the bom part content\nThere is an index on sha for more performant queries based on it.'
              ),
          })
        )
        .nullish()
        .describe(
          'If the document is a DOCX document and unzipped, the document_bom will be present'
        ),
      documentFamilyId: zod
        .number()
        .nullish()
        .describe('The id of the document family this document belongs to'),
      documentId: zod.string().describe('The document id'),
      documentName: zod.string().describe('The name of the document'),
      documentVersionId: zod
        .number()
        .describe(
          'The version of the document\nThis could be the document_instance_id or document_bom_id depending on\nthe file type'
        ),
      fileType: zod
        .string()
        .nullish()
        .describe('The file type of the document (file extension)'),
      modificationData: zod
        .unknown()
        .optional()
        .describe(
          'The modification data for the document instance.\nThis is only used for PDF documents.'
        ),
      owner: zod.string().describe('The owner of the document'),
      projectId: zod
        .string()
        .nullish()
        .describe('The id of the project that this document belongs to'),
      projectName: zod
        .string()
        .nullish()
        .describe('The name of the project that this document belongs to'),
      sha: zod
        .string()
        .nullish()
        .describe(
          'If the document is a PDF, this is the SHA of the pdf\nIf the document is a DOCX, this will not be present'
        ),
      subType: zod
        .union([
          zod.null(),
          zod
            .enum(['task', 'snippet', 'skill'])
            .describe(
              'The document sub type enum represents all values of document sub types.\nThese values should match the `document_sub_type_value` table in macrodb.'
            ),
        ])
        .optional(),
      updatedAt: zod.iso
        .datetime({})
        .nullish()
        .describe('The time the document instance \/ document BOM was updated'),
    }),
    userAccessLevel: zod
      .enum(['view', 'comment', 'edit', 'owner'])
      .describe('Ordered from least to most access top -> bottom'),
    viewLocation: zod
      .string()
      .nullish()
      .describe('The users view location if there is one'),
  }),
  error: zod.boolean().describe('Indicates if an error occurred'),
});

/**
 * @summary Get the current user's permission for a given entity.
 */
export const getEntityPermissionParams = zod.object({
  entity_type: zod
    .string()
    .describe(
      'Entity type (document, chat, project, thread, email_thread, channel)'
    ),
  entity_id: zod.string().describe('Entity ID'),
});

export const getEntityPermissionResponse = zod
  .union([
    zod.object({
      permission: zod
        .union([
          zod
            .object({
              access_level: zod
                .enum(['view', 'comment', 'edit', 'owner'])
                .describe('Ordered from least to most access top -> bottom'),
              type: zod.enum(['access_level']),
            })
            .describe(
              'Permission for item-based entities (document, chat, project, thread).'
            ),
          zod
            .object({
              type: zod.enum(['channel_view_only']),
            })
            .describe(
              'View-only permission for a channel without an active participant role.'
            ),
          zod
            .object({
              role: zod
                .enum(['owner', 'admin', 'member'])
                .describe('The role a user has within a channel.'),
              type: zod.enum(['channel_role']),
            })
            .describe(
              'Permission for channel-based entities with an active participant role.'
            ),
          zod
            .object({
              role: zod
                .enum(['member', 'admin', 'owner'])
                .describe(
                  'The role a user has within a team.\n\nOrdered least to most privileged so comparisons reflect access strength.'
                ),
              type: zod.enum(['team_role']),
            })
            .describe('Permission for team-based entities.'),
        ])
        .describe(
          "A user's permission for an entity, discriminated by entity kind.\n\nItems (documents, chats, projects, threads) use access levels.\nChannels use view-only permission or participant roles."
        ),
      status: zod.enum(['access']),
    }),
    zod.object({
      status: zod.enum(['no_access']),
    }),
  ])
  .describe('API response envelope for entity permissions.');

/**
 * @summary List the caller's favorites.
 */
export const listFavoritesResponse = zod
  .object({
    favorites: zod
      .array(
        zod
          .object({
            channelId: zod
              .string()
              .nullish()
              .describe(
                'Owning channel id of the favorited channel message, when applicable.'
              ),
            channelType: zod
              .string()
              .nullish()
              .describe(
                'Channel type (e.g. `public`, `direct_message`) of the favorited channel, when applicable.'
              ),
            createdAt: zod.iso
              .datetime({})
              .describe('When the favorite was created.'),
            documentSubType: zod
              .string()
              .nullish()
              .describe(
                'Document sub type (e.g. `task`) of the favorited document, when applicable.'
              ),
            entityId: zod.string().describe('The id of the favorited entity.'),
            entityType: zod
              .enum([
                'user',
                'chat',
                'channel',
                'channel_message',
                'document',
                'project',
                'email_thread',
                'calendar_event',
                'team',
                'call',
                'foreign_entity',
                'static_file',
                'crm_company',
                'crm_contact',
                'reminder',
                'skill',
              ])
              .describe('The type of an entity in Macro')
              .describe('The type of the favorited entity.'),
            fileType: zod
              .string()
              .nullish()
              .describe(
                'File type of the favorited document, when applicable.'
              ),
            sortOrder: zod
              .number()
              .describe('Manual ordering value; lower sorts first.'),
          })
          .describe(
            "A single favorited entity, including display metadata hydrated from the\nfavorited entity where available. Display names are deliberately not\nincluded: clients resolve them from the entity previews pipeline, which\nis viewer-relative for DM channels and updated by renames.\n\nA favorite is identified by `(entity_type, entity_id)` within the user's\ncollection; there is no surrogate id."
          )
      )
      .describe("The requesting user's favorites, in manual order."),
  })
  .describe("The user's favorites, in manual order.");

/**
 * @summary Favorite an entity in the caller's collection.
 */
export const addFavoriteBody = zod
  .object({
    entityId: zod.string().describe('The id of the entity to favorite.'),
    entityType: zod
      .enum([
        'user',
        'chat',
        'channel',
        'channel_message',
        'document',
        'project',
        'email_thread',
        'calendar_event',
        'team',
        'call',
        'foreign_entity',
        'static_file',
        'crm_company',
        'crm_contact',
        'reminder',
        'skill',
      ])
      .describe('The type of an entity in Macro')
      .describe('The type of the entity to favorite.'),
  })
  .describe('Request body for favoriting an entity.');

export const addFavoriteResponse = zod
  .object({
    channelId: zod
      .string()
      .nullish()
      .describe(
        'Owning channel id of the favorited channel message, when applicable.'
      ),
    channelType: zod
      .string()
      .nullish()
      .describe(
        'Channel type (e.g. `public`, `direct_message`) of the favorited channel, when applicable.'
      ),
    createdAt: zod.iso.datetime({}).describe('When the favorite was created.'),
    documentSubType: zod
      .string()
      .nullish()
      .describe(
        'Document sub type (e.g. `task`) of the favorited document, when applicable.'
      ),
    entityId: zod.string().describe('The id of the favorited entity.'),
    entityType: zod
      .enum([
        'user',
        'chat',
        'channel',
        'channel_message',
        'document',
        'project',
        'email_thread',
        'calendar_event',
        'team',
        'call',
        'foreign_entity',
        'static_file',
        'crm_company',
        'crm_contact',
        'reminder',
        'skill',
      ])
      .describe('The type of an entity in Macro')
      .describe('The type of the favorited entity.'),
    fileType: zod
      .string()
      .nullish()
      .describe('File type of the favorited document, when applicable.'),
    sortOrder: zod
      .number()
      .describe('Manual ordering value; lower sorts first.'),
  })
  .describe(
    "A single favorited entity, including display metadata hydrated from the\nfavorited entity where available. Display names are deliberately not\nincluded: clients resolve them from the entity previews pipeline, which\nis viewer-relative for DM channels and updated by renames.\n\nA favorite is identified by `(entity_type, entity_id)` within the user's\ncollection; there is no surrogate id."
  );

/**
 * @summary Persist a manual order for the caller's favorites.
 */
export const reorderFavoritesBody = zod
  .object({
    favorites: zod
      .array(
        zod
          .object({
            entityId: zod.string().describe('The id of the favorited entity.'),
            entityType: zod
              .enum([
                'user',
                'chat',
                'channel',
                'channel_message',
                'document',
                'project',
                'email_thread',
                'calendar_event',
                'team',
                'call',
                'foreign_entity',
                'static_file',
                'crm_company',
                'crm_contact',
                'reminder',
                'skill',
              ])
              .describe('The type of an entity in Macro')
              .describe('The type of the favorited entity.'),
          })
          .describe('A reference to a favorited entity.')
      )
      .describe("The user's favorited entities in the desired order."),
  })
  .describe('Request body for reordering favorites.');

export const reorderFavoritesResponseDefault = null;

export const reorderFavoritesResponse = zod.unknown();

/**
 * @summary Remove a favorite by entity.
 */
export const removeFavoriteByEntityParams = zod.object({
  entity_type: zod
    .enum([
      'user',
      'chat',
      'channel',
      'channel_message',
      'document',
      'project',
      'email_thread',
      'calendar_event',
      'team',
      'call',
      'foreign_entity',
      'static_file',
      'crm_company',
      'crm_contact',
      'reminder',
      'skill',
    ])
    .describe('The type of the favorited entity.'),
  entity_id: zod.string().describe('The id of the favorited entity.'),
});

export const removeFavoriteByEntityResponseDefault = null;

export const removeFavoriteByEntityResponse = zod.unknown();

/**
 * @summary Get a visible foreign entity by its internal ID.
 */
export const getForeignEntityParams = zod.object({
  id: zod.uuid().describe('Foreign entity ID'),
});

export const getForeignEntityResponse = zod
  .object({
    createdAt: zod.iso
      .datetime({})
      .describe('Timestamp when the record was created.'),
    foreignEntityId: zod
      .string()
      .describe('Identifier assigned by the external system.'),
    foreignEntitySource: zod
      .string()
      .describe('Source system that owns the external identifier.'),
    id: zod
      .uuid()
      .describe('Internal primary key for this foreign entity record.'),
    metadata: zod
      .unknown()
      .describe('Arbitrary metadata stored with the mapping.'),
    storedForAuthEntity: zod
      .string()
      .describe(
        'Internal auth entity namespace this foreign entity is stored for.'
      ),
    storedForId: zod
      .string()
      .describe(
        'Internal entity identifier this foreign entity is stored for.'
      ),
    updatedAt: zod.iso
      .datetime({})
      .describe('Timestamp when the record was last updated.'),
  })
  .describe('A persisted mapping to an entity owned by an external system.');

/**
 * @summary Gets the users history
 */
export const getHistoryHandlerResponse = zod.object({
  data: zod
    .array(
      zod.union([
        zod.object({
          branchedFromId: zod
            .string()
            .nullish()
            .describe('The id of the document this document branched from'),
          branchedFromVersionId: zod
            .number()
            .nullish()
            .describe(
              'The id of the version this document branched from\nThis could be either DocumentInstance or DocumentBom id depending on\nthe file type'
            ),
          createdAt: zod.iso
            .datetime({})
            .nullish()
            .describe('The time the document was created'),
          deletedAt: zod.iso
            .datetime({})
            .nullish()
            .describe('The time the document was deleted'),
          documentFamilyId: zod
            .number()
            .nullish()
            .describe('The id of the document family this document belongs to'),
          documentVersionId: zod
            .number()
            .describe(
              'The version of the document\nThis could be the document_instance_id or document_bom_id depending on\nthe file type'
            ),
          fileType: zod
            .string()
            .nullish()
            .describe('The file type of the document (e.g. pdf, docx)'),
          id: zod.string().describe('The document id'),
          name: zod.string().describe('The name of the document'),
          owner: zod.string().describe('The owner of the document'),
          projectId: zod
            .string()
            .nullish()
            .describe('The id of the project that this document belongs to'),
          sha: zod
            .string()
            .nullish()
            .describe(
              'If the document is a PDF, this is the SHA of the pdf\nIf the document is a DOCX, this will not be present'
            ),
          subType: zod
            .union([
              zod.null(),
              zod
                .union([
                  zod
                    .object({
                      is_completed: zod
                        .boolean()
                        .describe(
                          'Whether the task is completed.\nTrue if the Status property is set to \"Completed\".'
                        ),
                      type: zod.enum(['task']),
                    })
                    .describe('A task document with its associated properties'),
                  zod
                    .object({
                      type: zod.enum(['snippet']),
                    })
                    .describe('A snippet document — reusable markdown'),
                  zod
                    .object({
                      type: zod.enum(['skill']),
                    })
                    .describe(
                      'A skill document — markdown instructions for AI'
                    ),
                ])
                .describe(
                  'Sub type of a document with associated properties encoded in each variant.\nThis ensures type-safety: task properties only exist when the document is a task.'
                ),
            ])
            .optional(),
          updatedAt: zod.iso
            .datetime({})
            .nullish()
            .describe(
              'The time the document instance \/ document BOM was updated'
            ),
          type: zod.enum(['document']),
        }),
        zod.object({
          createdAt: zod.iso
            .datetime({})
            .nullish()
            .describe('The time the chat was created'),
          deletedAt: zod.iso
            .datetime({})
            .nullish()
            .describe('The time the chat was deleted'),
          id: zod.string().describe('The chat uuid'),
          isPersistent: zod.boolean(),
          model: zod
            .string()
            .nullish()
            .describe('The model used to generate the chat'),
          name: zod.string().describe('The name of the chat'),
          projectId: zod
            .string()
            .nullish()
            .describe('The project id of the chat'),
          tokenCount: zod.number().nullish(),
          updatedAt: zod.iso
            .datetime({})
            .nullish()
            .describe('The time the chat was last updated'),
          userId: zod.string().describe('Who the chat belongs to'),
          type: zod.enum(['chat']),
        }),
        zod.object({
          createdAt: zod.iso
            .datetime({})
            .nullish()
            .describe('The time the project was created'),
          deletedAt: zod.iso.datetime({}).nullish(),
          id: zod.string().describe('The id of the project'),
          name: zod.string().describe('The name of the project'),
          parentId: zod.string().nullish().describe('The parent project id'),
          updatedAt: zod.iso
            .datetime({})
            .nullish()
            .describe('The time the project was updated'),
          userId: zod
            .string()
            .describe('The user id of who created the project'),
          type: zod.enum(['project']),
        }),
      ])
    )
    .describe('Data to be returned'),
  error: zod.boolean().describe('Indicates if an error occurred'),
});

/**
 * @summary Upserts an item into the user's history and performs other necessary tracking actions
 */
export const upsertHistoryHandlerParams = zod.object({
  item_type: zod.string().describe('Type of the item'),
  item_id: zod.string().describe('ID of the item'),
});

export const upsertHistoryHandlerResponse = zod.object({
  data: zod.object({
    success: zod.boolean().describe('Indicates if the request was successful'),
  }),
  error: zod.boolean().describe('Indicates if an error occurred'),
});

/**
 * @summary Deletes an item from the user's history
 */
export const deleteHistoryHandlerParams = zod.object({
  item_type: zod.string().describe('Type of the item'),
  item_id: zod.string().describe('ID of the item'),
});

export const deleteHistoryHandlerResponse = zod.object({
  data: zod.object({
    success: zod.boolean().describe('Indicates if the request was successful'),
  }),
  error: zod.boolean().describe('Indicates if an error occurred'),
});

/**
 * @summary Gets the instructions document for the current user
 */
export const getInstructionsHandlerResponse = zod.object({
  documentId: zod.string(),
});

/**
 * @summary Creates an instructions document for the current user
 */
export const createInstructionsHandlerResponse = zod.object({
  documentId: zod.string(),
});

/**
 * @summary Gets the items the user has access to
 */
export const getItemsSoupQueryLimitMin = 0;

export const getItemsSoupQueryParams = zod.object({
  expand: zod
    .boolean()
    .optional()
    .describe('Whether to expand projects. Defaults to true.'),
  limit: zod
    .number()
    .min(getItemsSoupQueryLimitMin)
    .optional()
    .describe('Limit the number of items returned. Defaults to 20. Max 500.'),
  sort_method: zod
    .enum([
      'viewed_at',
      'created_at',
      'updated_at',
      'viewed_updated',
      'frecency',
      'touched_by_me',
    ])
    .optional()
    .describe(
      'Sort method. Options are viewed_at, created_at, updated_at,\nviewed_updated, frecency, touched_by_me. Defaults to viewed_at.'
    ),
  sort_direction: zod
    .enum(['asc', 'desc'])
    .optional()
    .describe(
      'Sort direction. Options are asc, desc. Defaults to desc.\n\nRe-send this with every page: it is not carried in the cursor.\n\nApplies to the timestamp sort methods only. `asc` combined with\n`frecency` is rejected rather than ignored: frecency pages are ordered\nby relevance score and the cursor comparison assumes descending, so\nthere is no ascending frecency order to give.'
    ),
  cursor: zod.string().optional().describe('Base64 encoded cursor value.'),
});

export const getItemsSoupResponseItemsItemDataChannelOrgIdMin = 0;

export const getItemsSoupResponse = zod
  .object({
    items: zod.array(
      zod
        .union([
          zod
            .object({
              data: zod
                .object({
                  properties: zod
                    .array(
                      zod
                        .object({
                          definition: zod
                            .object({
                              created_at: zod.iso.datetime({}),
                              data_type: zod
                                .enum([
                                  'BOOLEAN',
                                  'DATE',
                                  'NUMBER',
                                  'STRING',
                                  'SELECT_NUMBER',
                                  'SELECT_STRING',
                                  'TAG',
                                  'ENTITY',
                                  'LINK',
                                ])
                                .describe(
                                  'Data type for property values, determining storage and validation.'
                                ),
                              display_name: zod.string(),
                              id: zod.uuid(),
                              is_metadata: zod
                                .boolean()
                                .describe(
                                  'Flag to indicate if this is a system-generated metadata property.\nNot stored in database - computed at service layer.'
                                ),
                              is_multi_select: zod.boolean(),
                              is_system: zod
                                .boolean()
                                .describe(
                                  'Flag to indicate if this is a system property (stored in DB).'
                                ),
                              owner: zod
                                .union([
                                  zod
                                    .object({
                                      scope: zod.enum(['user']),
                                      user_id: zod.string(),
                                    })
                                    .describe('User-scoped property.'),
                                  zod
                                    .object({
                                      scope: zod.enum(['team']),
                                      team_id: zod.uuid(),
                                    })
                                    .describe('Team-scoped property.'),
                                  zod
                                    .object({
                                      scope: zod.enum(['system']),
                                    })
                                    .describe(
                                      'System-owned property (no user or team owner).'
                                    ),
                                ])
                                .describe(
                                  'Defines who owns a property - user-scoped, team-scoped, or system.'
                                ),
                              specific_entity_type: zod
                                .union([
                                  zod.null(),
                                  zod
                                    .enum([
                                      'CALENDAR_EVENT',
                                      'CALL_RECORD',
                                      'CHANNEL',
                                      'CHAT',
                                      'COMPANY',
                                      'DOCUMENT',
                                      'PROJECT',
                                      'TASK',
                                      'THREAD',
                                      'USER',
                                    ])
                                    .describe(
                                      'Type of entity that can be referenced by entity properties.'
                                    ),
                                ])
                                .optional(),
                              updated_at: zod.iso.datetime({}),
                            })
                            .describe(
                              'Property definition model (service representation).'
                            ),
                          id: zod
                            .uuid()
                            .describe(
                              'Globally unique id of the assignment attaching this property to an entity.'
                            ),
                          value: zod
                            .union([
                              zod.null(),
                              zod
                                .union([
                                  zod
                                    .object({
                                      type: zod.enum(['Boolean']),
                                      value: zod
                                        .boolean()
                                        .describe(
                                          'Boolean value\nSerializes as: {\"type\": \"Boolean\", \"value\": true}'
                                        ),
                                    })
                                    .describe(
                                      'Boolean value\nSerializes as: {\"type\": \"Boolean\", \"value\": true}'
                                    ),
                                  zod
                                    .object({
                                      type: zod.enum(['Number']),
                                      value: zod
                                        .number()
                                        .describe(
                                          'Numeric value\nSerializes as: {\"type\": \"Number\", \"value\": 42.5}'
                                        ),
                                    })
                                    .describe(
                                      'Numeric value\nSerializes as: {\"type\": \"Number\", \"value\": 42.5}'
                                    ),
                                  zod
                                    .object({
                                      type: zod.enum(['String']),
                                      value: zod
                                        .string()
                                        .describe(
                                          'String value\nSerializes as: {\"type\": \"String\", \"value\": \"text\"}'
                                        ),
                                    })
                                    .describe(
                                      'String value\nSerializes as: {\"type\": \"String\", \"value\": \"text\"}'
                                    ),
                                  zod
                                    .object({
                                      type: zod.enum(['Date']),
                                      value: zod.iso
                                        .datetime({})
                                        .describe(
                                          'Date\/timestamp value\nSerializes as: {\"type\": \"Date\", \"value\": \"2025-01-01T00:00:00Z\"}'
                                        ),
                                    })
                                    .describe(
                                      'Date\/timestamp value\nSerializes as: {\"type\": \"Date\", \"value\": \"2025-01-01T00:00:00Z\"}'
                                    ),
                                  zod
                                    .object({
                                      type: zod.enum(['SelectOption']),
                                      value: zod
                                        .array(zod.uuid())
                                        .describe(
                                          'Select option(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"SelectOption\", \"value\": [\"uuid\"]} (length 0 or 1)\nMulti-select: {\"type\": \"SelectOption\", \"value\": [\"uuid1\", \"uuid2\", ...]} (length 0+)'
                                        ),
                                    })
                                    .describe(
                                      'Select option(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"SelectOption\", \"value\": [\"uuid\"]} (length 0 or 1)\nMulti-select: {\"type\": \"SelectOption\", \"value\": [\"uuid1\", \"uuid2\", ...]} (length 0+)'
                                    ),
                                  zod
                                    .object({
                                      type: zod.enum(['EntityReference']),
                                      value: zod
                                        .array(
                                          zod
                                            .object({
                                              entity_id: zod.string(),
                                              entity_type: zod
                                                .enum([
                                                  'CALENDAR_EVENT',
                                                  'CALL_RECORD',
                                                  'CHANNEL',
                                                  'CHAT',
                                                  'COMPANY',
                                                  'DOCUMENT',
                                                  'PROJECT',
                                                  'TASK',
                                                  'THREAD',
                                                  'USER',
                                                ])
                                                .describe(
                                                  'Type of entity that can be referenced by entity properties.'
                                                ),
                                              specific_message_id: zod
                                                .uuid()
                                                .nullish()
                                                .describe(
                                                  'For CHANNEL, CHAT, THREAD entity types - optional specific message ID.\nThis allows referencing a specific message within a thread\/channel\/chat.'
                                                ),
                                            })
                                            .describe(
                                              'Entity reference for entity-type property values.'
                                            )
                                        )
                                        .describe(
                                          'Entity reference(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"EntityReference\", \"value\": [{...}]} (length 0 or 1)\nMulti-select: {\"type\": \"EntityReference\", \"value\": [{...}, {...}, ...]} (length 0+)'
                                        ),
                                    })
                                    .describe(
                                      'Entity reference(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"EntityReference\", \"value\": [{...}]} (length 0 or 1)\nMulti-select: {\"type\": \"EntityReference\", \"value\": [{...}, {...}, ...]} (length 0+)'
                                    ),
                                  zod
                                    .object({
                                      type: zod.enum(['Link']),
                                      value: zod
                                        .array(zod.string())
                                        .describe(
                                          'Link value(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"Link\", \"value\": [\"https:\/\/example.com\"]} (length 0 or 1)\nMulti-select: {\"type\": \"Link\", \"value\": [\"https:\/\/example.com\", \"https:\/\/other.com\"]} (length 0+)'
                                        ),
                                    })
                                    .describe(
                                      'Link value(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"Link\", \"value\": [\"https:\/\/example.com\"]} (length 0 or 1)\nMulti-select: {\"type\": \"Link\", \"value\": [\"https:\/\/example.com\", \"https:\/\/other.com\"]} (length 0+)'
                                    ),
                                ])
                                .describe(
                                  'Property value (service representation).\n\nRepresents the actual value stored for an entity property.\nThis is serialized to\/from JSONB in the database.'
                                ),
                            ])
                            .optional(),
                        })
                        .describe(
                          'A property attached to a Soup item.\n\nThis is a simplified representation that includes only the definition and value,\nomitting the entity property assignment metadata and options.'
                        )
                    )
                    .describe('Properties attached to the entity.'),
                })
                .describe(
                  'Property fields that can be flattened into property-bearing Soup items.'
                )
                .and(
                  zod.object({
                    branchedFromId: zod
                      .uuid()
                      .nullish()
                      .describe(
                        'The id of the document this document branched from'
                      ),
                    branchedFromVersionId: zod
                      .number()
                      .nullish()
                      .describe(
                        'The id of the version this document branched from\nThis could be either DocumentInstance or DocumentBom id depending on the file type'
                      ),
                    createdAt: zod.iso
                      .datetime({})
                      .describe('The time the document was created'),
                    deletedAt: zod.iso
                      .datetime({})
                      .nullish()
                      .describe('The time the document was deleted'),
                    documentFamilyId: zod
                      .number()
                      .nullish()
                      .describe(
                        'The id of the document family this document belongs to'
                      ),
                    documentVersionId: zod
                      .number()
                      .describe(
                        'The version of the document\nThis could be the document_instance_id or document_bom_id depending on the file type'
                      ),
                    fileType: zod
                      .string()
                      .nullish()
                      .describe(
                        'The file type of the document (e.g. pdf, docx)'
                      ),
                    id: zod.uuid().describe('The document id'),
                    name: zod.string().describe('The name of the document'),
                    ownerId: zod.string().describe('The owner of the document'),
                    projectId: zod
                      .uuid()
                      .nullish()
                      .describe(
                        'The id of the project that this document belongs to'
                      ),
                    sha: zod
                      .string()
                      .nullish()
                      .describe(
                        'If the document is a PDF, this is the SHA of the pdf\nIf the document is a DOCX, this will not be present'
                      ),
                    subType: zod
                      .union([
                        zod.null(),
                        zod
                          .union([
                            zod
                              .object({
                                is_completed: zod
                                  .boolean()
                                  .describe(
                                    'Whether the task is completed.\nTrue if the Status property is set to \"Completed\".'
                                  ),
                                type: zod.enum(['task']),
                              })
                              .describe(
                                'A task document with its associated properties'
                              ),
                            zod
                              .object({
                                type: zod.enum(['snippet']),
                              })
                              .describe(
                                'A snippet document — reusable markdown'
                              ),
                            zod
                              .object({
                                type: zod.enum(['skill']),
                              })
                              .describe(
                                'A skill document — markdown instructions for AI'
                              ),
                          ])
                          .describe(
                            'Sub type of a document with associated properties encoded in each variant.\nThis ensures type-safety: task properties only exist when the document is a task.'
                          ),
                      ])
                      .optional(),
                    updatedAt: zod.iso
                      .datetime({})
                      .describe(
                        'The time the document instance \/ document BOM was updated'
                      ),
                    viewedAt: zod.iso
                      .datetime({})
                      .nullish()
                      .describe('The time the document was last viewed'),
                  })
                )
                .describe('A document as displayed in Soup.'),
              tag: zod.enum(['document']),
            })
            .describe('Document item.'),
          zod
            .object({
              data: zod
                .object({
                  properties: zod
                    .array(
                      zod
                        .object({
                          definition: zod
                            .object({
                              created_at: zod.iso.datetime({}),
                              data_type: zod
                                .enum([
                                  'BOOLEAN',
                                  'DATE',
                                  'NUMBER',
                                  'STRING',
                                  'SELECT_NUMBER',
                                  'SELECT_STRING',
                                  'TAG',
                                  'ENTITY',
                                  'LINK',
                                ])
                                .describe(
                                  'Data type for property values, determining storage and validation.'
                                ),
                              display_name: zod.string(),
                              id: zod.uuid(),
                              is_metadata: zod
                                .boolean()
                                .describe(
                                  'Flag to indicate if this is a system-generated metadata property.\nNot stored in database - computed at service layer.'
                                ),
                              is_multi_select: zod.boolean(),
                              is_system: zod
                                .boolean()
                                .describe(
                                  'Flag to indicate if this is a system property (stored in DB).'
                                ),
                              owner: zod
                                .union([
                                  zod
                                    .object({
                                      scope: zod.enum(['user']),
                                      user_id: zod.string(),
                                    })
                                    .describe('User-scoped property.'),
                                  zod
                                    .object({
                                      scope: zod.enum(['team']),
                                      team_id: zod.uuid(),
                                    })
                                    .describe('Team-scoped property.'),
                                  zod
                                    .object({
                                      scope: zod.enum(['system']),
                                    })
                                    .describe(
                                      'System-owned property (no user or team owner).'
                                    ),
                                ])
                                .describe(
                                  'Defines who owns a property - user-scoped, team-scoped, or system.'
                                ),
                              specific_entity_type: zod
                                .union([
                                  zod.null(),
                                  zod
                                    .enum([
                                      'CALENDAR_EVENT',
                                      'CALL_RECORD',
                                      'CHANNEL',
                                      'CHAT',
                                      'COMPANY',
                                      'DOCUMENT',
                                      'PROJECT',
                                      'TASK',
                                      'THREAD',
                                      'USER',
                                    ])
                                    .describe(
                                      'Type of entity that can be referenced by entity properties.'
                                    ),
                                ])
                                .optional(),
                              updated_at: zod.iso.datetime({}),
                            })
                            .describe(
                              'Property definition model (service representation).'
                            ),
                          id: zod
                            .uuid()
                            .describe(
                              'Globally unique id of the assignment attaching this property to an entity.'
                            ),
                          value: zod
                            .union([
                              zod.null(),
                              zod
                                .union([
                                  zod
                                    .object({
                                      type: zod.enum(['Boolean']),
                                      value: zod
                                        .boolean()
                                        .describe(
                                          'Boolean value\nSerializes as: {\"type\": \"Boolean\", \"value\": true}'
                                        ),
                                    })
                                    .describe(
                                      'Boolean value\nSerializes as: {\"type\": \"Boolean\", \"value\": true}'
                                    ),
                                  zod
                                    .object({
                                      type: zod.enum(['Number']),
                                      value: zod
                                        .number()
                                        .describe(
                                          'Numeric value\nSerializes as: {\"type\": \"Number\", \"value\": 42.5}'
                                        ),
                                    })
                                    .describe(
                                      'Numeric value\nSerializes as: {\"type\": \"Number\", \"value\": 42.5}'
                                    ),
                                  zod
                                    .object({
                                      type: zod.enum(['String']),
                                      value: zod
                                        .string()
                                        .describe(
                                          'String value\nSerializes as: {\"type\": \"String\", \"value\": \"text\"}'
                                        ),
                                    })
                                    .describe(
                                      'String value\nSerializes as: {\"type\": \"String\", \"value\": \"text\"}'
                                    ),
                                  zod
                                    .object({
                                      type: zod.enum(['Date']),
                                      value: zod.iso
                                        .datetime({})
                                        .describe(
                                          'Date\/timestamp value\nSerializes as: {\"type\": \"Date\", \"value\": \"2025-01-01T00:00:00Z\"}'
                                        ),
                                    })
                                    .describe(
                                      'Date\/timestamp value\nSerializes as: {\"type\": \"Date\", \"value\": \"2025-01-01T00:00:00Z\"}'
                                    ),
                                  zod
                                    .object({
                                      type: zod.enum(['SelectOption']),
                                      value: zod
                                        .array(zod.uuid())
                                        .describe(
                                          'Select option(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"SelectOption\", \"value\": [\"uuid\"]} (length 0 or 1)\nMulti-select: {\"type\": \"SelectOption\", \"value\": [\"uuid1\", \"uuid2\", ...]} (length 0+)'
                                        ),
                                    })
                                    .describe(
                                      'Select option(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"SelectOption\", \"value\": [\"uuid\"]} (length 0 or 1)\nMulti-select: {\"type\": \"SelectOption\", \"value\": [\"uuid1\", \"uuid2\", ...]} (length 0+)'
                                    ),
                                  zod
                                    .object({
                                      type: zod.enum(['EntityReference']),
                                      value: zod
                                        .array(
                                          zod
                                            .object({
                                              entity_id: zod.string(),
                                              entity_type: zod
                                                .enum([
                                                  'CALENDAR_EVENT',
                                                  'CALL_RECORD',
                                                  'CHANNEL',
                                                  'CHAT',
                                                  'COMPANY',
                                                  'DOCUMENT',
                                                  'PROJECT',
                                                  'TASK',
                                                  'THREAD',
                                                  'USER',
                                                ])
                                                .describe(
                                                  'Type of entity that can be referenced by entity properties.'
                                                ),
                                              specific_message_id: zod
                                                .uuid()
                                                .nullish()
                                                .describe(
                                                  'For CHANNEL, CHAT, THREAD entity types - optional specific message ID.\nThis allows referencing a specific message within a thread\/channel\/chat.'
                                                ),
                                            })
                                            .describe(
                                              'Entity reference for entity-type property values.'
                                            )
                                        )
                                        .describe(
                                          'Entity reference(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"EntityReference\", \"value\": [{...}]} (length 0 or 1)\nMulti-select: {\"type\": \"EntityReference\", \"value\": [{...}, {...}, ...]} (length 0+)'
                                        ),
                                    })
                                    .describe(
                                      'Entity reference(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"EntityReference\", \"value\": [{...}]} (length 0 or 1)\nMulti-select: {\"type\": \"EntityReference\", \"value\": [{...}, {...}, ...]} (length 0+)'
                                    ),
                                  zod
                                    .object({
                                      type: zod.enum(['Link']),
                                      value: zod
                                        .array(zod.string())
                                        .describe(
                                          'Link value(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"Link\", \"value\": [\"https:\/\/example.com\"]} (length 0 or 1)\nMulti-select: {\"type\": \"Link\", \"value\": [\"https:\/\/example.com\", \"https:\/\/other.com\"]} (length 0+)'
                                        ),
                                    })
                                    .describe(
                                      'Link value(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"Link\", \"value\": [\"https:\/\/example.com\"]} (length 0 or 1)\nMulti-select: {\"type\": \"Link\", \"value\": [\"https:\/\/example.com\", \"https:\/\/other.com\"]} (length 0+)'
                                    ),
                                ])
                                .describe(
                                  'Property value (service representation).\n\nRepresents the actual value stored for an entity property.\nThis is serialized to\/from JSONB in the database.'
                                ),
                            ])
                            .optional(),
                        })
                        .describe(
                          'A property attached to a Soup item.\n\nThis is a simplified representation that includes only the definition and value,\nomitting the entity property assignment metadata and options.'
                        )
                    )
                    .describe('Properties attached to the entity.'),
                })
                .describe(
                  'Property fields that can be flattened into property-bearing Soup items.'
                )
                .and(
                  zod.object({
                    createdAt: zod.iso
                      .datetime({})
                      .describe('The time the chat was created'),
                    deletedAt: zod.iso
                      .datetime({})
                      .nullish()
                      .describe('The time the chat was deleted'),
                    id: zod.uuid().describe('The chat uuid'),
                    isPersistent: zod
                      .boolean()
                      .describe('Whether the chat is persistent or not'),
                    name: zod.string().describe('The name of the chat'),
                    ownerId: zod.string().describe('Who the chat belongs to'),
                    projectId: zod
                      .uuid()
                      .nullish()
                      .describe('The project id of the chat'),
                    updatedAt: zod.iso
                      .datetime({})
                      .describe('The time the chat was last updated'),
                    viewedAt: zod.iso
                      .datetime({})
                      .nullish()
                      .describe('The time the chat was last viewed'),
                  })
                )
                .describe('A chat as displayed in Soup.'),
              tag: zod.enum(['chat']),
            })
            .describe('Chat item.'),
          zod
            .object({
              data: zod
                .object({
                  properties: zod
                    .array(
                      zod
                        .object({
                          definition: zod
                            .object({
                              created_at: zod.iso.datetime({}),
                              data_type: zod
                                .enum([
                                  'BOOLEAN',
                                  'DATE',
                                  'NUMBER',
                                  'STRING',
                                  'SELECT_NUMBER',
                                  'SELECT_STRING',
                                  'TAG',
                                  'ENTITY',
                                  'LINK',
                                ])
                                .describe(
                                  'Data type for property values, determining storage and validation.'
                                ),
                              display_name: zod.string(),
                              id: zod.uuid(),
                              is_metadata: zod
                                .boolean()
                                .describe(
                                  'Flag to indicate if this is a system-generated metadata property.\nNot stored in database - computed at service layer.'
                                ),
                              is_multi_select: zod.boolean(),
                              is_system: zod
                                .boolean()
                                .describe(
                                  'Flag to indicate if this is a system property (stored in DB).'
                                ),
                              owner: zod
                                .union([
                                  zod
                                    .object({
                                      scope: zod.enum(['user']),
                                      user_id: zod.string(),
                                    })
                                    .describe('User-scoped property.'),
                                  zod
                                    .object({
                                      scope: zod.enum(['team']),
                                      team_id: zod.uuid(),
                                    })
                                    .describe('Team-scoped property.'),
                                  zod
                                    .object({
                                      scope: zod.enum(['system']),
                                    })
                                    .describe(
                                      'System-owned property (no user or team owner).'
                                    ),
                                ])
                                .describe(
                                  'Defines who owns a property - user-scoped, team-scoped, or system.'
                                ),
                              specific_entity_type: zod
                                .union([
                                  zod.null(),
                                  zod
                                    .enum([
                                      'CALENDAR_EVENT',
                                      'CALL_RECORD',
                                      'CHANNEL',
                                      'CHAT',
                                      'COMPANY',
                                      'DOCUMENT',
                                      'PROJECT',
                                      'TASK',
                                      'THREAD',
                                      'USER',
                                    ])
                                    .describe(
                                      'Type of entity that can be referenced by entity properties.'
                                    ),
                                ])
                                .optional(),
                              updated_at: zod.iso.datetime({}),
                            })
                            .describe(
                              'Property definition model (service representation).'
                            ),
                          id: zod
                            .uuid()
                            .describe(
                              'Globally unique id of the assignment attaching this property to an entity.'
                            ),
                          value: zod
                            .union([
                              zod.null(),
                              zod
                                .union([
                                  zod
                                    .object({
                                      type: zod.enum(['Boolean']),
                                      value: zod
                                        .boolean()
                                        .describe(
                                          'Boolean value\nSerializes as: {\"type\": \"Boolean\", \"value\": true}'
                                        ),
                                    })
                                    .describe(
                                      'Boolean value\nSerializes as: {\"type\": \"Boolean\", \"value\": true}'
                                    ),
                                  zod
                                    .object({
                                      type: zod.enum(['Number']),
                                      value: zod
                                        .number()
                                        .describe(
                                          'Numeric value\nSerializes as: {\"type\": \"Number\", \"value\": 42.5}'
                                        ),
                                    })
                                    .describe(
                                      'Numeric value\nSerializes as: {\"type\": \"Number\", \"value\": 42.5}'
                                    ),
                                  zod
                                    .object({
                                      type: zod.enum(['String']),
                                      value: zod
                                        .string()
                                        .describe(
                                          'String value\nSerializes as: {\"type\": \"String\", \"value\": \"text\"}'
                                        ),
                                    })
                                    .describe(
                                      'String value\nSerializes as: {\"type\": \"String\", \"value\": \"text\"}'
                                    ),
                                  zod
                                    .object({
                                      type: zod.enum(['Date']),
                                      value: zod.iso
                                        .datetime({})
                                        .describe(
                                          'Date\/timestamp value\nSerializes as: {\"type\": \"Date\", \"value\": \"2025-01-01T00:00:00Z\"}'
                                        ),
                                    })
                                    .describe(
                                      'Date\/timestamp value\nSerializes as: {\"type\": \"Date\", \"value\": \"2025-01-01T00:00:00Z\"}'
                                    ),
                                  zod
                                    .object({
                                      type: zod.enum(['SelectOption']),
                                      value: zod
                                        .array(zod.uuid())
                                        .describe(
                                          'Select option(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"SelectOption\", \"value\": [\"uuid\"]} (length 0 or 1)\nMulti-select: {\"type\": \"SelectOption\", \"value\": [\"uuid1\", \"uuid2\", ...]} (length 0+)'
                                        ),
                                    })
                                    .describe(
                                      'Select option(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"SelectOption\", \"value\": [\"uuid\"]} (length 0 or 1)\nMulti-select: {\"type\": \"SelectOption\", \"value\": [\"uuid1\", \"uuid2\", ...]} (length 0+)'
                                    ),
                                  zod
                                    .object({
                                      type: zod.enum(['EntityReference']),
                                      value: zod
                                        .array(
                                          zod
                                            .object({
                                              entity_id: zod.string(),
                                              entity_type: zod
                                                .enum([
                                                  'CALENDAR_EVENT',
                                                  'CALL_RECORD',
                                                  'CHANNEL',
                                                  'CHAT',
                                                  'COMPANY',
                                                  'DOCUMENT',
                                                  'PROJECT',
                                                  'TASK',
                                                  'THREAD',
                                                  'USER',
                                                ])
                                                .describe(
                                                  'Type of entity that can be referenced by entity properties.'
                                                ),
                                              specific_message_id: zod
                                                .uuid()
                                                .nullish()
                                                .describe(
                                                  'For CHANNEL, CHAT, THREAD entity types - optional specific message ID.\nThis allows referencing a specific message within a thread\/channel\/chat.'
                                                ),
                                            })
                                            .describe(
                                              'Entity reference for entity-type property values.'
                                            )
                                        )
                                        .describe(
                                          'Entity reference(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"EntityReference\", \"value\": [{...}]} (length 0 or 1)\nMulti-select: {\"type\": \"EntityReference\", \"value\": [{...}, {...}, ...]} (length 0+)'
                                        ),
                                    })
                                    .describe(
                                      'Entity reference(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"EntityReference\", \"value\": [{...}]} (length 0 or 1)\nMulti-select: {\"type\": \"EntityReference\", \"value\": [{...}, {...}, ...]} (length 0+)'
                                    ),
                                  zod
                                    .object({
                                      type: zod.enum(['Link']),
                                      value: zod
                                        .array(zod.string())
                                        .describe(
                                          'Link value(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"Link\", \"value\": [\"https:\/\/example.com\"]} (length 0 or 1)\nMulti-select: {\"type\": \"Link\", \"value\": [\"https:\/\/example.com\", \"https:\/\/other.com\"]} (length 0+)'
                                        ),
                                    })
                                    .describe(
                                      'Link value(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"Link\", \"value\": [\"https:\/\/example.com\"]} (length 0 or 1)\nMulti-select: {\"type\": \"Link\", \"value\": [\"https:\/\/example.com\", \"https:\/\/other.com\"]} (length 0+)'
                                    ),
                                ])
                                .describe(
                                  'Property value (service representation).\n\nRepresents the actual value stored for an entity property.\nThis is serialized to\/from JSONB in the database.'
                                ),
                            ])
                            .optional(),
                        })
                        .describe(
                          'A property attached to a Soup item.\n\nThis is a simplified representation that includes only the definition and value,\nomitting the entity property assignment metadata and options.'
                        )
                    )
                    .describe('Properties attached to the entity.'),
                })
                .describe(
                  'Property fields that can be flattened into property-bearing Soup items.'
                )
                .and(
                  zod.object({
                    createdAt: zod.iso
                      .datetime({})
                      .describe('The time the project was created'),
                    deletedAt: zod.iso
                      .datetime({})
                      .nullish()
                      .describe('The time the project was deleted'),
                    id: zod.uuid().describe('The id of the project'),
                    name: zod.string().describe('The name of the project'),
                    ownerId: zod
                      .string()
                      .describe('The user id of who created the project'),
                    parentId: zod
                      .uuid()
                      .nullish()
                      .describe('The parent project id'),
                    updatedAt: zod.iso
                      .datetime({})
                      .describe('The time the project was updated'),
                    viewedAt: zod.iso
                      .datetime({})
                      .nullish()
                      .describe('The time the document was last viewed'),
                  })
                )
                .describe('A project as displayed in Soup.'),
              tag: zod.enum(['project']),
            })
            .describe('Project item.'),
          zod
            .object({
              data: zod
                .object({
                  createdAt: zod.iso
                    .datetime({})
                    .describe('Timestamp when the thread was created.'),
                  id: zod.uuid().describe('Thread id.'),
                  inboxVisible: zod
                    .boolean()
                    .describe('Whether the thread should appear in the inbox.'),
                  isDraft: zod
                    .boolean()
                    .describe('Whether the thread contains a draft.'),
                  isImportant: zod
                    .boolean()
                    .describe('Whether the thread is marked important.'),
                  isRead: zod
                    .boolean()
                    .describe('Whether the thread has been read.'),
                  name: zod
                    .string()
                    .nullish()
                    .describe('Thread display name or subject.'),
                  ownerId: zod.string().describe('Owner user id.'),
                  projectId: zod
                    .string()
                    .nullish()
                    .describe('Project id associated with the thread.'),
                  providerId: zod
                    .string()
                    .nullish()
                    .describe('Provider-specific thread id.'),
                  senderEmail: zod
                    .string()
                    .nullish()
                    .describe('Sender email address for the preview.'),
                  senderName: zod
                    .string()
                    .nullish()
                    .describe('Sender display name for the preview.'),
                  senderPhotoUrl: zod
                    .string()
                    .nullish()
                    .describe('Sender photo URL for the preview.'),
                  snippet: zod.string().nullish().describe('Thread snippet.'),
                  sortTs: zod.iso
                    .datetime({})
                    .describe('Timestamp used for email thread sorting.'),
                  updatedAt: zod.iso
                    .datetime({})
                    .describe('Timestamp when the thread was last updated.'),
                  viewedAt: zod.iso
                    .datetime({})
                    .nullish()
                    .describe(
                      'Timestamp when the requesting user last viewed the thread.'
                    ),
                })
                .describe('Email thread preview data as displayed in Soup.')
                .and(
                  zod
                    .object({
                      properties: zod
                        .array(
                          zod
                            .object({
                              definition: zod
                                .object({
                                  created_at: zod.iso.datetime({}),
                                  data_type: zod
                                    .enum([
                                      'BOOLEAN',
                                      'DATE',
                                      'NUMBER',
                                      'STRING',
                                      'SELECT_NUMBER',
                                      'SELECT_STRING',
                                      'TAG',
                                      'ENTITY',
                                      'LINK',
                                    ])
                                    .describe(
                                      'Data type for property values, determining storage and validation.'
                                    ),
                                  display_name: zod.string(),
                                  id: zod.uuid(),
                                  is_metadata: zod
                                    .boolean()
                                    .describe(
                                      'Flag to indicate if this is a system-generated metadata property.\nNot stored in database - computed at service layer.'
                                    ),
                                  is_multi_select: zod.boolean(),
                                  is_system: zod
                                    .boolean()
                                    .describe(
                                      'Flag to indicate if this is a system property (stored in DB).'
                                    ),
                                  owner: zod
                                    .union([
                                      zod
                                        .object({
                                          scope: zod.enum(['user']),
                                          user_id: zod.string(),
                                        })
                                        .describe('User-scoped property.'),
                                      zod
                                        .object({
                                          scope: zod.enum(['team']),
                                          team_id: zod.uuid(),
                                        })
                                        .describe('Team-scoped property.'),
                                      zod
                                        .object({
                                          scope: zod.enum(['system']),
                                        })
                                        .describe(
                                          'System-owned property (no user or team owner).'
                                        ),
                                    ])
                                    .describe(
                                      'Defines who owns a property - user-scoped, team-scoped, or system.'
                                    ),
                                  specific_entity_type: zod
                                    .union([
                                      zod.null(),
                                      zod
                                        .enum([
                                          'CALENDAR_EVENT',
                                          'CALL_RECORD',
                                          'CHANNEL',
                                          'CHAT',
                                          'COMPANY',
                                          'DOCUMENT',
                                          'PROJECT',
                                          'TASK',
                                          'THREAD',
                                          'USER',
                                        ])
                                        .describe(
                                          'Type of entity that can be referenced by entity properties.'
                                        ),
                                    ])
                                    .optional(),
                                  updated_at: zod.iso.datetime({}),
                                })
                                .describe(
                                  'Property definition model (service representation).'
                                ),
                              id: zod
                                .uuid()
                                .describe(
                                  'Globally unique id of the assignment attaching this property to an entity.'
                                ),
                              value: zod
                                .union([
                                  zod.null(),
                                  zod
                                    .union([
                                      zod
                                        .object({
                                          type: zod.enum(['Boolean']),
                                          value: zod
                                            .boolean()
                                            .describe(
                                              'Boolean value\nSerializes as: {\"type\": \"Boolean\", \"value\": true}'
                                            ),
                                        })
                                        .describe(
                                          'Boolean value\nSerializes as: {\"type\": \"Boolean\", \"value\": true}'
                                        ),
                                      zod
                                        .object({
                                          type: zod.enum(['Number']),
                                          value: zod
                                            .number()
                                            .describe(
                                              'Numeric value\nSerializes as: {\"type\": \"Number\", \"value\": 42.5}'
                                            ),
                                        })
                                        .describe(
                                          'Numeric value\nSerializes as: {\"type\": \"Number\", \"value\": 42.5}'
                                        ),
                                      zod
                                        .object({
                                          type: zod.enum(['String']),
                                          value: zod
                                            .string()
                                            .describe(
                                              'String value\nSerializes as: {\"type\": \"String\", \"value\": \"text\"}'
                                            ),
                                        })
                                        .describe(
                                          'String value\nSerializes as: {\"type\": \"String\", \"value\": \"text\"}'
                                        ),
                                      zod
                                        .object({
                                          type: zod.enum(['Date']),
                                          value: zod.iso
                                            .datetime({})
                                            .describe(
                                              'Date\/timestamp value\nSerializes as: {\"type\": \"Date\", \"value\": \"2025-01-01T00:00:00Z\"}'
                                            ),
                                        })
                                        .describe(
                                          'Date\/timestamp value\nSerializes as: {\"type\": \"Date\", \"value\": \"2025-01-01T00:00:00Z\"}'
                                        ),
                                      zod
                                        .object({
                                          type: zod.enum(['SelectOption']),
                                          value: zod
                                            .array(zod.uuid())
                                            .describe(
                                              'Select option(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"SelectOption\", \"value\": [\"uuid\"]} (length 0 or 1)\nMulti-select: {\"type\": \"SelectOption\", \"value\": [\"uuid1\", \"uuid2\", ...]} (length 0+)'
                                            ),
                                        })
                                        .describe(
                                          'Select option(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"SelectOption\", \"value\": [\"uuid\"]} (length 0 or 1)\nMulti-select: {\"type\": \"SelectOption\", \"value\": [\"uuid1\", \"uuid2\", ...]} (length 0+)'
                                        ),
                                      zod
                                        .object({
                                          type: zod.enum(['EntityReference']),
                                          value: zod
                                            .array(
                                              zod
                                                .object({
                                                  entity_id: zod.string(),
                                                  entity_type: zod
                                                    .enum([
                                                      'CALENDAR_EVENT',
                                                      'CALL_RECORD',
                                                      'CHANNEL',
                                                      'CHAT',
                                                      'COMPANY',
                                                      'DOCUMENT',
                                                      'PROJECT',
                                                      'TASK',
                                                      'THREAD',
                                                      'USER',
                                                    ])
                                                    .describe(
                                                      'Type of entity that can be referenced by entity properties.'
                                                    ),
                                                  specific_message_id: zod
                                                    .uuid()
                                                    .nullish()
                                                    .describe(
                                                      'For CHANNEL, CHAT, THREAD entity types - optional specific message ID.\nThis allows referencing a specific message within a thread\/channel\/chat.'
                                                    ),
                                                })
                                                .describe(
                                                  'Entity reference for entity-type property values.'
                                                )
                                            )
                                            .describe(
                                              'Entity reference(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"EntityReference\", \"value\": [{...}]} (length 0 or 1)\nMulti-select: {\"type\": \"EntityReference\", \"value\": [{...}, {...}, ...]} (length 0+)'
                                            ),
                                        })
                                        .describe(
                                          'Entity reference(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"EntityReference\", \"value\": [{...}]} (length 0 or 1)\nMulti-select: {\"type\": \"EntityReference\", \"value\": [{...}, {...}, ...]} (length 0+)'
                                        ),
                                      zod
                                        .object({
                                          type: zod.enum(['Link']),
                                          value: zod
                                            .array(zod.string())
                                            .describe(
                                              'Link value(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"Link\", \"value\": [\"https:\/\/example.com\"]} (length 0 or 1)\nMulti-select: {\"type\": \"Link\", \"value\": [\"https:\/\/example.com\", \"https:\/\/other.com\"]} (length 0+)'
                                            ),
                                        })
                                        .describe(
                                          'Link value(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"Link\", \"value\": [\"https:\/\/example.com\"]} (length 0 or 1)\nMulti-select: {\"type\": \"Link\", \"value\": [\"https:\/\/example.com\", \"https:\/\/other.com\"]} (length 0+)'
                                        ),
                                    ])
                                    .describe(
                                      'Property value (service representation).\n\nRepresents the actual value stored for an entity property.\nThis is serialized to\/from JSONB in the database.'
                                    ),
                                ])
                                .optional(),
                            })
                            .describe(
                              'A property attached to a Soup item.\n\nThis is a simplified representation that includes only the definition and value,\nomitting the entity property assignment metadata and options.'
                            )
                        )
                        .describe('Properties attached to the entity.'),
                    })
                    .describe(
                      'Property fields that can be flattened into property-bearing Soup items.'
                    )
                )
                .and(
                  zod.object({
                    attachments: zod
                      .array(
                        zod
                          .object({
                            contentId: zod
                              .string()
                              .nullish()
                              .describe('Content id for inline attachments.'),
                            createdAt: zod.iso
                              .datetime({})
                              .describe(
                                'Timestamp when the attachment was created.'
                              ),
                            filename: zod
                              .string()
                              .nullish()
                              .describe('Attachment filename.'),
                            id: zod.uuid().describe('Attachment id.'),
                            messageId: zod
                              .uuid()
                              .describe(
                                'Message id that owns this attachment.'
                              ),
                            mimeType: zod
                              .string()
                              .nullish()
                              .describe('Attachment MIME type.'),
                            providerAttachmentId: zod
                              .string()
                              .nullish()
                              .describe('Provider-specific attachment id.'),
                            sizeBytes: zod
                              .number()
                              .nullish()
                              .describe('Attachment size in bytes.'),
                          })
                          .describe('An email attachment as displayed in Soup.')
                      )
                      .describe('Attachments on the thread.'),
                    labels: zod
                      .array(
                        zod
                          .object({
                            createdAt: zod.iso
                              .datetime({})
                              .describe(
                                'Timestamp when the label was created.'
                              ),
                            id: zod.uuid().describe('Label id.'),
                            labelListVisibility: zod
                              .enum([
                                'labelShow',
                                'labelShowIfUnread',
                                'labelHide',
                              ])
                              .describe('Gmail-style label list visibility.'),
                            linkId: zod
                              .uuid()
                              .describe(
                                'Connected account link id for the label.'
                              ),
                            messageListVisibility: zod
                              .enum(['show', 'hide'])
                              .describe(
                                'Gmail-style message list visibility for a label.'
                              ),
                            name: zod.string().describe('Label display name.'),
                            providerLabelId: zod
                              .string()
                              .describe('Provider-specific label id.'),
                            type: zod
                              .enum(['system', 'user'])
                              .describe(
                                'Whether an email label is provider-created or user-created.'
                              ),
                          })
                          .describe('An email label as displayed in Soup.')
                      )
                      .describe('Labels attached to the thread.'),
                    participants: zod
                      .array(
                        zod
                          .object({
                            emailAddress: zod
                              .string()
                              .nullish()
                              .describe('Contact email address.'),
                            id: zod.uuid().describe('Contact id.'),
                            linkId: zod
                              .uuid()
                              .describe(
                                'Connected account link id for the contact.'
                              ),
                            name: zod
                              .string()
                              .nullish()
                              .describe('Contact display name.'),
                            sfsPhotoUrl: zod
                              .string()
                              .nullish()
                              .describe(
                                'Contact photo URL from SFS, if available.'
                              ),
                          })
                          .describe(
                            'A contact participating in an email thread as displayed in Soup.'
                          )
                      )
                      .describe('Contacts participating in the thread.'),
                  })
                )
                .describe(
                  'Email thread preview enriched with related metadata for Soup.'
                ),
              tag: zod.enum(['emailThread']),
            })
            .describe('Email thread item.'),
          zod
            .object({
              data: zod
                .object({
                  channel: zod
                    .object({
                      channel_type: zod
                        .enum(['public', 'private', 'direct_message', 'team'])
                        .describe('Type of channel.'),
                      created_at: zod.iso
                        .datetime({})
                        .describe('Creation timestamp.'),
                      id: zod.uuid().describe('Channel id.'),
                      name: zod
                        .string()
                        .nullish()
                        .describe('Channel display name.'),
                      org_id: zod
                        .number()
                        .min(getItemsSoupResponseItemsItemDataChannelOrgIdMin)
                        .nullish()
                        .describe('Organization id.'),
                      owner_id: zod.string().describe('Channel owner.'),
                      team_id: zod.uuid().nullish().describe('Team id.'),
                      updated_at: zod.iso
                        .datetime({})
                        .describe('Update timestamp.'),
                    })
                    .describe('Channel metadata in soup payloads.'),
                  is_participant: zod
                    .boolean()
                    .optional()
                    .describe(
                      "Whether the requesting user is an active participant of the channel.\nFalse for team channels of the user's teams they have not joined."
                    ),
                  participants: zod
                    .array(
                      zod
                        .object({
                          channel_id: zod
                            .uuid()
                            .describe(
                              'Channel id for the participant membership.'
                            ),
                          joined_at: zod.iso
                            .datetime({})
                            .describe(
                              'Timestamp when the participant joined the channel.'
                            ),
                          left_at: zod.iso
                            .datetime({})
                            .nullish()
                            .describe(
                              'Timestamp when the participant left the channel, if any.'
                            ),
                          role: zod
                            .enum(['owner', 'admin', 'member'])
                            .describe('The role a user has within a channel.'),
                          user_id: zod
                            .string()
                            .describe('Participant user id.'),
                        })
                        .describe("A user's membership in a channel.")
                    )
                    .describe('Participants in the channel.'),
                })
                .describe('Channel metadata together with its participants.')
                .and(
                  zod
                    .object({
                      latest_message: zod
                        .union([
                          zod.null(),
                          zod
                            .object({
                              content: zod
                                .string()
                                .describe('Message content.'),
                              created_at: zod.iso
                                .datetime({})
                                .describe('Creation timestamp.'),
                              deleted_at: zod.iso
                                .datetime({})
                                .nullish()
                                .describe('Deletion timestamp.'),
                              mentions: zod
                                .array(zod.string())
                                .describe(
                                  'Message mentions formatted as `{ENTITY_TYPE}:{ENTITY_ID}`.'
                                ),
                              message_id: zod.uuid().describe('Message id.'),
                              sender_id: zod.string().describe('Sender id.'),
                              thread_id: zod
                                .uuid()
                                .nullish()
                                .describe('Thread parent id.'),
                              updated_at: zod.iso
                                .datetime({})
                                .describe('Update timestamp.'),
                            })
                            .describe(
                              'Lightweight channel message for soup payloads.'
                            ),
                        ])
                        .optional(),
                      latest_non_thread_message: zod
                        .union([
                          zod.null(),
                          zod
                            .object({
                              content: zod
                                .string()
                                .describe('Message content.'),
                              created_at: zod.iso
                                .datetime({})
                                .describe('Creation timestamp.'),
                              deleted_at: zod.iso
                                .datetime({})
                                .nullish()
                                .describe('Deletion timestamp.'),
                              mentions: zod
                                .array(zod.string())
                                .describe(
                                  'Message mentions formatted as `{ENTITY_TYPE}:{ENTITY_ID}`.'
                                ),
                              message_id: zod.uuid().describe('Message id.'),
                              sender_id: zod.string().describe('Sender id.'),
                              thread_id: zod
                                .uuid()
                                .nullish()
                                .describe('Thread parent id.'),
                              updated_at: zod.iso
                                .datetime({})
                                .describe('Update timestamp.'),
                            })
                            .describe(
                              'Lightweight channel message for soup payloads.'
                            ),
                        ])
                        .optional(),
                    })
                    .describe('Latest-message bundle for soup payloads.')
                )
                .and(
                  zod.object({
                    interacted_at: zod.iso
                      .datetime({})
                      .nullish()
                      .describe(
                        'Timestamp when the requesting user last interacted with this channel.'
                      ),
                    viewed_at: zod.iso
                      .datetime({})
                      .nullish()
                      .describe(
                        'Timestamp when the requesting user last viewed this channel.'
                      ),
                  })
                )
                .describe('A channel as displayed in Soup.'),
              tag: zod.enum(['channel']),
            })
            .describe('Channel item.'),
          zod
            .object({
              data: zod
                .object({
                  attachments: zod
                    .array(
                      zod
                        .object({
                          created_at: zod.iso
                            .datetime({})
                            .describe('Creation timestamp.'),
                          entity_id: zod.string().describe('Entity id.'),
                          entity_type: zod.string().describe('Type of entity.'),
                          height: zod
                            .number()
                            .nullish()
                            .describe('Height for images.'),
                          id: zod.uuid().describe('Attachment id.'),
                          width: zod
                            .number()
                            .nullish()
                            .describe('Width for images.'),
                        })
                        .describe('An attachment on a message.')
                    )
                    .describe('Attachments on this message.'),
                  channel_id: zod.uuid().describe('Channel id.'),
                  content: zod.string().describe('Message content.'),
                  created_at: zod.iso
                    .datetime({})
                    .describe('Creation timestamp.'),
                  deleted_at: zod.iso
                    .datetime({})
                    .nullish()
                    .describe('Deletion timestamp.'),
                  edited_at: zod.iso
                    .datetime({})
                    .nullish()
                    .describe('Edit timestamp.'),
                  id: zod.uuid().describe('Message id.'),
                  reactions: zod
                    .array(
                      zod
                        .object({
                          emoji: zod.string().describe('Emoji string.'),
                          users: zod
                            .array(zod.string())
                            .describe('User ids who added this reaction.'),
                        })
                        .describe('A reaction with emoji and user list.')
                    )
                    .describe('Reactions on this message.'),
                  sender: zod
                    .object({
                      avatar_url: zod
                        .string()
                        .nullish()
                        .describe('Avatar URL for bot senders.'),
                      id: zod
                        .string()
                        .describe(
                          'Sender id without the storage namespace prefix.'
                        ),
                      name: zod
                        .string()
                        .nullish()
                        .describe('Display name for bot senders.'),
                      type: zod
                        .enum(['user', 'bot'])
                        .describe(
                          'Public sender type for soup channel messages.'
                        ),
                    })
                    .describe(
                      'Public sender identity for soup channel messages.'
                    ),
                  sender_id: zod.string().describe('Sender id.'),
                  thread: zod
                    .object({
                      latest_reply_at: zod.iso
                        .datetime({})
                        .nullish()
                        .describe('Timestamp of the latest reply.'),
                      preview: zod
                        .array(
                          zod
                            .object({
                              attachments: zod
                                .array(
                                  zod
                                    .object({
                                      created_at: zod.iso
                                        .datetime({})
                                        .describe('Creation timestamp.'),
                                      entity_id: zod
                                        .string()
                                        .describe('Entity id.'),
                                      entity_type: zod
                                        .string()
                                        .describe('Type of entity.'),
                                      height: zod
                                        .number()
                                        .nullish()
                                        .describe('Height for images.'),
                                      id: zod.uuid().describe('Attachment id.'),
                                      width: zod
                                        .number()
                                        .nullish()
                                        .describe('Width for images.'),
                                    })
                                    .describe('An attachment on a message.')
                                )
                                .describe('Attachments on this reply.'),
                              content: zod.string().describe('Reply content.'),
                              created_at: zod.iso
                                .datetime({})
                                .describe('Creation timestamp.'),
                              edited_at: zod.iso
                                .datetime({})
                                .nullish()
                                .describe('Edit timestamp.'),
                              id: zod.uuid().describe('Reply id.'),
                              reactions: zod
                                .array(
                                  zod
                                    .object({
                                      emoji: zod
                                        .string()
                                        .describe('Emoji string.'),
                                      users: zod
                                        .array(zod.string())
                                        .describe(
                                          'User ids who added this reaction.'
                                        ),
                                    })
                                    .describe(
                                      'A reaction with emoji and user list.'
                                    )
                                )
                                .describe('Reactions on this reply.'),
                              sender: zod
                                .object({
                                  avatar_url: zod
                                    .string()
                                    .nullish()
                                    .describe('Avatar URL for bot senders.'),
                                  id: zod
                                    .string()
                                    .describe(
                                      'Sender id without the storage namespace prefix.'
                                    ),
                                  name: zod
                                    .string()
                                    .nullish()
                                    .describe('Display name for bot senders.'),
                                  type: zod
                                    .enum(['user', 'bot'])
                                    .describe(
                                      'Public sender type for soup channel messages.'
                                    ),
                                })
                                .describe(
                                  'Public sender identity for soup channel messages.'
                                ),
                              sender_id: zod.string().describe('Sender id.'),
                              updated_at: zod.iso
                                .datetime({})
                                .describe('Update timestamp.'),
                            })
                            .describe('A thread reply shown in preview.')
                        )
                        .describe('Preview replies.'),
                      reply_count: zod.number().describe('Total reply count.'),
                    })
                    .describe(
                      'Thread metadata and preview replies for soup channel messages.'
                    ),
                  updated_at: zod.iso
                    .datetime({})
                    .describe('Update timestamp.'),
                })
                .describe(
                  'A top-level channel message thread for soup payloads.\n\nThis mirrors the public channel-message API shape so soup consumers can\nrender a thread root the same way they render a channel timeline message.'
                ),
              tag: zod.enum(['channelThread']),
            })
            .describe('Channel thread item.'),
          zod
            .object({
              data: zod
                .object({
                  properties: zod
                    .array(
                      zod
                        .object({
                          definition: zod
                            .object({
                              created_at: zod.iso.datetime({}),
                              data_type: zod
                                .enum([
                                  'BOOLEAN',
                                  'DATE',
                                  'NUMBER',
                                  'STRING',
                                  'SELECT_NUMBER',
                                  'SELECT_STRING',
                                  'TAG',
                                  'ENTITY',
                                  'LINK',
                                ])
                                .describe(
                                  'Data type for property values, determining storage and validation.'
                                ),
                              display_name: zod.string(),
                              id: zod.uuid(),
                              is_metadata: zod
                                .boolean()
                                .describe(
                                  'Flag to indicate if this is a system-generated metadata property.\nNot stored in database - computed at service layer.'
                                ),
                              is_multi_select: zod.boolean(),
                              is_system: zod
                                .boolean()
                                .describe(
                                  'Flag to indicate if this is a system property (stored in DB).'
                                ),
                              owner: zod
                                .union([
                                  zod
                                    .object({
                                      scope: zod.enum(['user']),
                                      user_id: zod.string(),
                                    })
                                    .describe('User-scoped property.'),
                                  zod
                                    .object({
                                      scope: zod.enum(['team']),
                                      team_id: zod.uuid(),
                                    })
                                    .describe('Team-scoped property.'),
                                  zod
                                    .object({
                                      scope: zod.enum(['system']),
                                    })
                                    .describe(
                                      'System-owned property (no user or team owner).'
                                    ),
                                ])
                                .describe(
                                  'Defines who owns a property - user-scoped, team-scoped, or system.'
                                ),
                              specific_entity_type: zod
                                .union([
                                  zod.null(),
                                  zod
                                    .enum([
                                      'CALENDAR_EVENT',
                                      'CALL_RECORD',
                                      'CHANNEL',
                                      'CHAT',
                                      'COMPANY',
                                      'DOCUMENT',
                                      'PROJECT',
                                      'TASK',
                                      'THREAD',
                                      'USER',
                                    ])
                                    .describe(
                                      'Type of entity that can be referenced by entity properties.'
                                    ),
                                ])
                                .optional(),
                              updated_at: zod.iso.datetime({}),
                            })
                            .describe(
                              'Property definition model (service representation).'
                            ),
                          id: zod
                            .uuid()
                            .describe(
                              'Globally unique id of the assignment attaching this property to an entity.'
                            ),
                          value: zod
                            .union([
                              zod.null(),
                              zod
                                .union([
                                  zod
                                    .object({
                                      type: zod.enum(['Boolean']),
                                      value: zod
                                        .boolean()
                                        .describe(
                                          'Boolean value\nSerializes as: {\"type\": \"Boolean\", \"value\": true}'
                                        ),
                                    })
                                    .describe(
                                      'Boolean value\nSerializes as: {\"type\": \"Boolean\", \"value\": true}'
                                    ),
                                  zod
                                    .object({
                                      type: zod.enum(['Number']),
                                      value: zod
                                        .number()
                                        .describe(
                                          'Numeric value\nSerializes as: {\"type\": \"Number\", \"value\": 42.5}'
                                        ),
                                    })
                                    .describe(
                                      'Numeric value\nSerializes as: {\"type\": \"Number\", \"value\": 42.5}'
                                    ),
                                  zod
                                    .object({
                                      type: zod.enum(['String']),
                                      value: zod
                                        .string()
                                        .describe(
                                          'String value\nSerializes as: {\"type\": \"String\", \"value\": \"text\"}'
                                        ),
                                    })
                                    .describe(
                                      'String value\nSerializes as: {\"type\": \"String\", \"value\": \"text\"}'
                                    ),
                                  zod
                                    .object({
                                      type: zod.enum(['Date']),
                                      value: zod.iso
                                        .datetime({})
                                        .describe(
                                          'Date\/timestamp value\nSerializes as: {\"type\": \"Date\", \"value\": \"2025-01-01T00:00:00Z\"}'
                                        ),
                                    })
                                    .describe(
                                      'Date\/timestamp value\nSerializes as: {\"type\": \"Date\", \"value\": \"2025-01-01T00:00:00Z\"}'
                                    ),
                                  zod
                                    .object({
                                      type: zod.enum(['SelectOption']),
                                      value: zod
                                        .array(zod.uuid())
                                        .describe(
                                          'Select option(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"SelectOption\", \"value\": [\"uuid\"]} (length 0 or 1)\nMulti-select: {\"type\": \"SelectOption\", \"value\": [\"uuid1\", \"uuid2\", ...]} (length 0+)'
                                        ),
                                    })
                                    .describe(
                                      'Select option(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"SelectOption\", \"value\": [\"uuid\"]} (length 0 or 1)\nMulti-select: {\"type\": \"SelectOption\", \"value\": [\"uuid1\", \"uuid2\", ...]} (length 0+)'
                                    ),
                                  zod
                                    .object({
                                      type: zod.enum(['EntityReference']),
                                      value: zod
                                        .array(
                                          zod
                                            .object({
                                              entity_id: zod.string(),
                                              entity_type: zod
                                                .enum([
                                                  'CALENDAR_EVENT',
                                                  'CALL_RECORD',
                                                  'CHANNEL',
                                                  'CHAT',
                                                  'COMPANY',
                                                  'DOCUMENT',
                                                  'PROJECT',
                                                  'TASK',
                                                  'THREAD',
                                                  'USER',
                                                ])
                                                .describe(
                                                  'Type of entity that can be referenced by entity properties.'
                                                ),
                                              specific_message_id: zod
                                                .uuid()
                                                .nullish()
                                                .describe(
                                                  'For CHANNEL, CHAT, THREAD entity types - optional specific message ID.\nThis allows referencing a specific message within a thread\/channel\/chat.'
                                                ),
                                            })
                                            .describe(
                                              'Entity reference for entity-type property values.'
                                            )
                                        )
                                        .describe(
                                          'Entity reference(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"EntityReference\", \"value\": [{...}]} (length 0 or 1)\nMulti-select: {\"type\": \"EntityReference\", \"value\": [{...}, {...}, ...]} (length 0+)'
                                        ),
                                    })
                                    .describe(
                                      'Entity reference(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"EntityReference\", \"value\": [{...}]} (length 0 or 1)\nMulti-select: {\"type\": \"EntityReference\", \"value\": [{...}, {...}, ...]} (length 0+)'
                                    ),
                                  zod
                                    .object({
                                      type: zod.enum(['Link']),
                                      value: zod
                                        .array(zod.string())
                                        .describe(
                                          'Link value(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"Link\", \"value\": [\"https:\/\/example.com\"]} (length 0 or 1)\nMulti-select: {\"type\": \"Link\", \"value\": [\"https:\/\/example.com\", \"https:\/\/other.com\"]} (length 0+)'
                                        ),
                                    })
                                    .describe(
                                      'Link value(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"Link\", \"value\": [\"https:\/\/example.com\"]} (length 0 or 1)\nMulti-select: {\"type\": \"Link\", \"value\": [\"https:\/\/example.com\", \"https:\/\/other.com\"]} (length 0+)'
                                    ),
                                ])
                                .describe(
                                  'Property value (service representation).\n\nRepresents the actual value stored for an entity property.\nThis is serialized to\/from JSONB in the database.'
                                ),
                            ])
                            .optional(),
                        })
                        .describe(
                          'A property attached to a Soup item.\n\nThis is a simplified representation that includes only the definition and value,\nomitting the entity property assignment metadata and options.'
                        )
                    )
                    .describe('Properties attached to the entity.'),
                })
                .describe(
                  'Property fields that can be flattened into property-bearing Soup items.'
                )
                .and(
                  zod.object({
                    attended: zod
                      .boolean()
                      .describe(
                        'Whether the requesting user attended this call. Kept for compatibility\nand derived from `status == ATTENDED`.'
                      ),
                    callId: zod.uuid().describe('The call identifier.'),
                    channelId: zod
                      .uuid()
                      .describe('The channel this call belongs to.'),
                    channelName: zod
                      .string()
                      .nullish()
                      .describe('Resolved display name for the channel.'),
                    createdBy: zod
                      .string()
                      .describe('User who created the call.'),
                    customName: zod
                      .string()
                      .nullish()
                      .describe(
                        'User-supplied or AI-generated display name for the call.'
                      ),
                    durationMs: zod
                      .number()
                      .nullish()
                      .describe(
                        'Call duration in milliseconds (None if still active).'
                      ),
                    endedAt: zod.iso
                      .datetime({})
                      .nullish()
                      .describe('When the call ended (None if still active).'),
                    isActive: zod
                      .boolean()
                      .describe('Whether the call is currently active.'),
                    participants: zod
                      .array(
                        zod
                          .object({
                            joinedAt: zod.iso
                              .datetime({})
                              .describe('When the user joined the call.'),
                            leftAt: zod.iso
                              .datetime({})
                              .nullish()
                              .describe(
                                'When the user left (None if still in an active call).'
                              ),
                            userId: zod.string().describe('The user id.'),
                          })
                          .describe(
                            'A participant in a call record, as displayed in Soup.'
                          )
                      )
                      .describe('Participants in the call.'),
                    startedAt: zod.iso
                      .datetime({})
                      .describe('When the call started.'),
                    status: zod
                      .enum(['ATTENDED', 'MISSED', 'UNATTENDED'])
                      .describe(
                        'Viewer-relative attendance status for a call record.\nSerializes as `ATTENDED`, `MISSED`, or `UNATTENDED`.'
                      ),
                    summary: zod
                      .string()
                      .nullish()
                      .describe(
                        'AI-generated summary of the call. Only set on archived\n`call_records` once summarization has run; active calls always\nreturn `None`.'
                      ),
                  })
                )
                .describe(
                  'A call record as displayed in Soup. Excludes room_name, egress_id,\nand transcript — fields that are irrelevant for the soup feed.'
                ),
              tag: zod.enum(['call']),
            })
            .describe('Call record item.'),
          zod
            .object({
              data: zod
                .object({
                  conferenceProvider: zod
                    .string()
                    .nullish()
                    .describe(
                      'Which conferencing system backs `conference_url`.'
                    ),
                  conferenceUrl: zod
                    .string()
                    .nullish()
                    .describe('Direct conference join URL.'),
                  createdAt: zod.iso
                    .datetime({})
                    .describe('Entity creation timestamp.'),
                  description: zod
                    .string()
                    .nullish()
                    .describe('Optional description.'),
                  extra: zod
                    .object({
                      properties: zod
                        .array(
                          zod
                            .object({
                              definition: zod
                                .object({
                                  created_at: zod.iso.datetime({}),
                                  data_type: zod
                                    .enum([
                                      'BOOLEAN',
                                      'DATE',
                                      'NUMBER',
                                      'STRING',
                                      'SELECT_NUMBER',
                                      'SELECT_STRING',
                                      'TAG',
                                      'ENTITY',
                                      'LINK',
                                    ])
                                    .describe(
                                      'Data type for property values, determining storage and validation.'
                                    ),
                                  display_name: zod.string(),
                                  id: zod.uuid(),
                                  is_metadata: zod
                                    .boolean()
                                    .describe(
                                      'Flag to indicate if this is a system-generated metadata property.\nNot stored in database - computed at service layer.'
                                    ),
                                  is_multi_select: zod.boolean(),
                                  is_system: zod
                                    .boolean()
                                    .describe(
                                      'Flag to indicate if this is a system property (stored in DB).'
                                    ),
                                  owner: zod
                                    .union([
                                      zod
                                        .object({
                                          scope: zod.enum(['user']),
                                          user_id: zod.string(),
                                        })
                                        .describe('User-scoped property.'),
                                      zod
                                        .object({
                                          scope: zod.enum(['team']),
                                          team_id: zod.uuid(),
                                        })
                                        .describe('Team-scoped property.'),
                                      zod
                                        .object({
                                          scope: zod.enum(['system']),
                                        })
                                        .describe(
                                          'System-owned property (no user or team owner).'
                                        ),
                                    ])
                                    .describe(
                                      'Defines who owns a property - user-scoped, team-scoped, or system.'
                                    ),
                                  specific_entity_type: zod
                                    .union([
                                      zod.null(),
                                      zod
                                        .enum([
                                          'CALENDAR_EVENT',
                                          'CALL_RECORD',
                                          'CHANNEL',
                                          'CHAT',
                                          'COMPANY',
                                          'DOCUMENT',
                                          'PROJECT',
                                          'TASK',
                                          'THREAD',
                                          'USER',
                                        ])
                                        .describe(
                                          'Type of entity that can be referenced by entity properties.'
                                        ),
                                    ])
                                    .optional(),
                                  updated_at: zod.iso.datetime({}),
                                })
                                .describe(
                                  'Property definition model (service representation).'
                                ),
                              id: zod
                                .uuid()
                                .describe(
                                  'Globally unique id of the assignment attaching this property to an entity.'
                                ),
                              value: zod
                                .union([
                                  zod.null(),
                                  zod
                                    .union([
                                      zod
                                        .object({
                                          type: zod.enum(['Boolean']),
                                          value: zod
                                            .boolean()
                                            .describe(
                                              'Boolean value\nSerializes as: {\"type\": \"Boolean\", \"value\": true}'
                                            ),
                                        })
                                        .describe(
                                          'Boolean value\nSerializes as: {\"type\": \"Boolean\", \"value\": true}'
                                        ),
                                      zod
                                        .object({
                                          type: zod.enum(['Number']),
                                          value: zod
                                            .number()
                                            .describe(
                                              'Numeric value\nSerializes as: {\"type\": \"Number\", \"value\": 42.5}'
                                            ),
                                        })
                                        .describe(
                                          'Numeric value\nSerializes as: {\"type\": \"Number\", \"value\": 42.5}'
                                        ),
                                      zod
                                        .object({
                                          type: zod.enum(['String']),
                                          value: zod
                                            .string()
                                            .describe(
                                              'String value\nSerializes as: {\"type\": \"String\", \"value\": \"text\"}'
                                            ),
                                        })
                                        .describe(
                                          'String value\nSerializes as: {\"type\": \"String\", \"value\": \"text\"}'
                                        ),
                                      zod
                                        .object({
                                          type: zod.enum(['Date']),
                                          value: zod.iso
                                            .datetime({})
                                            .describe(
                                              'Date\/timestamp value\nSerializes as: {\"type\": \"Date\", \"value\": \"2025-01-01T00:00:00Z\"}'
                                            ),
                                        })
                                        .describe(
                                          'Date\/timestamp value\nSerializes as: {\"type\": \"Date\", \"value\": \"2025-01-01T00:00:00Z\"}'
                                        ),
                                      zod
                                        .object({
                                          type: zod.enum(['SelectOption']),
                                          value: zod
                                            .array(zod.uuid())
                                            .describe(
                                              'Select option(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"SelectOption\", \"value\": [\"uuid\"]} (length 0 or 1)\nMulti-select: {\"type\": \"SelectOption\", \"value\": [\"uuid1\", \"uuid2\", ...]} (length 0+)'
                                            ),
                                        })
                                        .describe(
                                          'Select option(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"SelectOption\", \"value\": [\"uuid\"]} (length 0 or 1)\nMulti-select: {\"type\": \"SelectOption\", \"value\": [\"uuid1\", \"uuid2\", ...]} (length 0+)'
                                        ),
                                      zod
                                        .object({
                                          type: zod.enum(['EntityReference']),
                                          value: zod
                                            .array(
                                              zod
                                                .object({
                                                  entity_id: zod.string(),
                                                  entity_type: zod
                                                    .enum([
                                                      'CALENDAR_EVENT',
                                                      'CALL_RECORD',
                                                      'CHANNEL',
                                                      'CHAT',
                                                      'COMPANY',
                                                      'DOCUMENT',
                                                      'PROJECT',
                                                      'TASK',
                                                      'THREAD',
                                                      'USER',
                                                    ])
                                                    .describe(
                                                      'Type of entity that can be referenced by entity properties.'
                                                    ),
                                                  specific_message_id: zod
                                                    .uuid()
                                                    .nullish()
                                                    .describe(
                                                      'For CHANNEL, CHAT, THREAD entity types - optional specific message ID.\nThis allows referencing a specific message within a thread\/channel\/chat.'
                                                    ),
                                                })
                                                .describe(
                                                  'Entity reference for entity-type property values.'
                                                )
                                            )
                                            .describe(
                                              'Entity reference(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"EntityReference\", \"value\": [{...}]} (length 0 or 1)\nMulti-select: {\"type\": \"EntityReference\", \"value\": [{...}, {...}, ...]} (length 0+)'
                                            ),
                                        })
                                        .describe(
                                          'Entity reference(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"EntityReference\", \"value\": [{...}]} (length 0 or 1)\nMulti-select: {\"type\": \"EntityReference\", \"value\": [{...}, {...}, ...]} (length 0+)'
                                        ),
                                      zod
                                        .object({
                                          type: zod.enum(['Link']),
                                          value: zod
                                            .array(zod.string())
                                            .describe(
                                              'Link value(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"Link\", \"value\": [\"https:\/\/example.com\"]} (length 0 or 1)\nMulti-select: {\"type\": \"Link\", \"value\": [\"https:\/\/example.com\", \"https:\/\/other.com\"]} (length 0+)'
                                            ),
                                        })
                                        .describe(
                                          'Link value(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"Link\", \"value\": [\"https:\/\/example.com\"]} (length 0 or 1)\nMulti-select: {\"type\": \"Link\", \"value\": [\"https:\/\/example.com\", \"https:\/\/other.com\"]} (length 0+)'
                                        ),
                                    ])
                                    .describe(
                                      'Property value (service representation).\n\nRepresents the actual value stored for an entity property.\nThis is serialized to\/from JSONB in the database.'
                                    ),
                                ])
                                .optional(),
                            })
                            .describe(
                              'A property attached to a Soup item.\n\nThis is a simplified representation that includes only the definition and value,\nomitting the entity property assignment metadata and options.'
                            )
                        )
                        .describe('Properties attached to the entity.'),
                    })
                    .describe(
                      'Property fields that can be flattened into property-bearing Soup items.'
                    ),
                  icalUid: zod
                    .string()
                    .describe('RFC 5545 UID used for source reconciliation.'),
                  id: zod.uuid().describe('Entity identifier.'),
                  isReadOnly: zod
                    .boolean()
                    .describe(
                      'Whether the selected canonical source is read-only.'
                    ),
                  location: zod
                    .string()
                    .nullish()
                    .describe('Optional location label.'),
                  organizerEmail: zod
                    .string()
                    .nullish()
                    .describe('Organizer email.'),
                  organizerName: zod
                    .string()
                    .nullish()
                    .describe('Organizer display name.'),
                  ownerId: zod.string().describe('Owning Macro user.'),
                  status: zod.string().describe('Canonical status.'),
                  time: zod
                    .union([
                      zod
                        .object({
                          endsAt: zod.iso
                            .datetime({})
                            .describe('Exclusive end.'),
                          kind: zod.enum(['timed']),
                          startsAt: zod.iso
                            .datetime({})
                            .describe('Inclusive start.'),
                          timeZone: zod
                            .string()
                            .nullish()
                            .describe('Original IANA time zone.'),
                        })
                        .describe('Absolute timed event.'),
                      zod
                        .object({
                          endDate: zod.iso
                            .date()
                            .describe('Exclusive end date.'),
                          kind: zod.enum(['allDay']),
                          startDate: zod.iso
                            .date()
                            .describe('Inclusive start date.'),
                        })
                        .describe('All-day event with an exclusive end date.'),
                    ])
                    .describe(
                      'Timed or all-day calendar event span.\n\nFields are camelCased per variant rather than via `rename_all_fields`,\nwhich utoipa ignores — the generated OpenAPI schema would otherwise\nclaim snake_case fields the wire never carries.'
                    ),
                  title: zod.string().describe('Display title.'),
                  transparency: zod
                    .string()
                    .describe('Availability transparency.'),
                  updatedAt: zod.iso
                    .datetime({})
                    .describe('Entity update timestamp.'),
                  visibility: zod.string().describe('Canonical visibility.'),
                })
                .describe('A canonical calendar event entity in Soup.'),
              tag: zod.enum(['calendarEvent']),
            })
            .describe('Calendar event item.'),
          zod
            .object({
              data: zod
                .object({
                  properties: zod
                    .array(
                      zod
                        .object({
                          definition: zod
                            .object({
                              created_at: zod.iso.datetime({}),
                              data_type: zod
                                .enum([
                                  'BOOLEAN',
                                  'DATE',
                                  'NUMBER',
                                  'STRING',
                                  'SELECT_NUMBER',
                                  'SELECT_STRING',
                                  'TAG',
                                  'ENTITY',
                                  'LINK',
                                ])
                                .describe(
                                  'Data type for property values, determining storage and validation.'
                                ),
                              display_name: zod.string(),
                              id: zod.uuid(),
                              is_metadata: zod
                                .boolean()
                                .describe(
                                  'Flag to indicate if this is a system-generated metadata property.\nNot stored in database - computed at service layer.'
                                ),
                              is_multi_select: zod.boolean(),
                              is_system: zod
                                .boolean()
                                .describe(
                                  'Flag to indicate if this is a system property (stored in DB).'
                                ),
                              owner: zod
                                .union([
                                  zod
                                    .object({
                                      scope: zod.enum(['user']),
                                      user_id: zod.string(),
                                    })
                                    .describe('User-scoped property.'),
                                  zod
                                    .object({
                                      scope: zod.enum(['team']),
                                      team_id: zod.uuid(),
                                    })
                                    .describe('Team-scoped property.'),
                                  zod
                                    .object({
                                      scope: zod.enum(['system']),
                                    })
                                    .describe(
                                      'System-owned property (no user or team owner).'
                                    ),
                                ])
                                .describe(
                                  'Defines who owns a property - user-scoped, team-scoped, or system.'
                                ),
                              specific_entity_type: zod
                                .union([
                                  zod.null(),
                                  zod
                                    .enum([
                                      'CALENDAR_EVENT',
                                      'CALL_RECORD',
                                      'CHANNEL',
                                      'CHAT',
                                      'COMPANY',
                                      'DOCUMENT',
                                      'PROJECT',
                                      'TASK',
                                      'THREAD',
                                      'USER',
                                    ])
                                    .describe(
                                      'Type of entity that can be referenced by entity properties.'
                                    ),
                                ])
                                .optional(),
                              updated_at: zod.iso.datetime({}),
                            })
                            .describe(
                              'Property definition model (service representation).'
                            ),
                          id: zod
                            .uuid()
                            .describe(
                              'Globally unique id of the assignment attaching this property to an entity.'
                            ),
                          value: zod
                            .union([
                              zod.null(),
                              zod
                                .union([
                                  zod
                                    .object({
                                      type: zod.enum(['Boolean']),
                                      value: zod
                                        .boolean()
                                        .describe(
                                          'Boolean value\nSerializes as: {\"type\": \"Boolean\", \"value\": true}'
                                        ),
                                    })
                                    .describe(
                                      'Boolean value\nSerializes as: {\"type\": \"Boolean\", \"value\": true}'
                                    ),
                                  zod
                                    .object({
                                      type: zod.enum(['Number']),
                                      value: zod
                                        .number()
                                        .describe(
                                          'Numeric value\nSerializes as: {\"type\": \"Number\", \"value\": 42.5}'
                                        ),
                                    })
                                    .describe(
                                      'Numeric value\nSerializes as: {\"type\": \"Number\", \"value\": 42.5}'
                                    ),
                                  zod
                                    .object({
                                      type: zod.enum(['String']),
                                      value: zod
                                        .string()
                                        .describe(
                                          'String value\nSerializes as: {\"type\": \"String\", \"value\": \"text\"}'
                                        ),
                                    })
                                    .describe(
                                      'String value\nSerializes as: {\"type\": \"String\", \"value\": \"text\"}'
                                    ),
                                  zod
                                    .object({
                                      type: zod.enum(['Date']),
                                      value: zod.iso
                                        .datetime({})
                                        .describe(
                                          'Date\/timestamp value\nSerializes as: {\"type\": \"Date\", \"value\": \"2025-01-01T00:00:00Z\"}'
                                        ),
                                    })
                                    .describe(
                                      'Date\/timestamp value\nSerializes as: {\"type\": \"Date\", \"value\": \"2025-01-01T00:00:00Z\"}'
                                    ),
                                  zod
                                    .object({
                                      type: zod.enum(['SelectOption']),
                                      value: zod
                                        .array(zod.uuid())
                                        .describe(
                                          'Select option(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"SelectOption\", \"value\": [\"uuid\"]} (length 0 or 1)\nMulti-select: {\"type\": \"SelectOption\", \"value\": [\"uuid1\", \"uuid2\", ...]} (length 0+)'
                                        ),
                                    })
                                    .describe(
                                      'Select option(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"SelectOption\", \"value\": [\"uuid\"]} (length 0 or 1)\nMulti-select: {\"type\": \"SelectOption\", \"value\": [\"uuid1\", \"uuid2\", ...]} (length 0+)'
                                    ),
                                  zod
                                    .object({
                                      type: zod.enum(['EntityReference']),
                                      value: zod
                                        .array(
                                          zod
                                            .object({
                                              entity_id: zod.string(),
                                              entity_type: zod
                                                .enum([
                                                  'CALENDAR_EVENT',
                                                  'CALL_RECORD',
                                                  'CHANNEL',
                                                  'CHAT',
                                                  'COMPANY',
                                                  'DOCUMENT',
                                                  'PROJECT',
                                                  'TASK',
                                                  'THREAD',
                                                  'USER',
                                                ])
                                                .describe(
                                                  'Type of entity that can be referenced by entity properties.'
                                                ),
                                              specific_message_id: zod
                                                .uuid()
                                                .nullish()
                                                .describe(
                                                  'For CHANNEL, CHAT, THREAD entity types - optional specific message ID.\nThis allows referencing a specific message within a thread\/channel\/chat.'
                                                ),
                                            })
                                            .describe(
                                              'Entity reference for entity-type property values.'
                                            )
                                        )
                                        .describe(
                                          'Entity reference(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"EntityReference\", \"value\": [{...}]} (length 0 or 1)\nMulti-select: {\"type\": \"EntityReference\", \"value\": [{...}, {...}, ...]} (length 0+)'
                                        ),
                                    })
                                    .describe(
                                      'Entity reference(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"EntityReference\", \"value\": [{...}]} (length 0 or 1)\nMulti-select: {\"type\": \"EntityReference\", \"value\": [{...}, {...}, ...]} (length 0+)'
                                    ),
                                  zod
                                    .object({
                                      type: zod.enum(['Link']),
                                      value: zod
                                        .array(zod.string())
                                        .describe(
                                          'Link value(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"Link\", \"value\": [\"https:\/\/example.com\"]} (length 0 or 1)\nMulti-select: {\"type\": \"Link\", \"value\": [\"https:\/\/example.com\", \"https:\/\/other.com\"]} (length 0+)'
                                        ),
                                    })
                                    .describe(
                                      'Link value(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"Link\", \"value\": [\"https:\/\/example.com\"]} (length 0 or 1)\nMulti-select: {\"type\": \"Link\", \"value\": [\"https:\/\/example.com\", \"https:\/\/other.com\"]} (length 0+)'
                                    ),
                                ])
                                .describe(
                                  'Property value (service representation).\n\nRepresents the actual value stored for an entity property.\nThis is serialized to\/from JSONB in the database.'
                                ),
                            ])
                            .optional(),
                        })
                        .describe(
                          'A property attached to a Soup item.\n\nThis is a simplified representation that includes only the definition and value,\nomitting the entity property assignment metadata and options.'
                        )
                    )
                    .describe('Properties attached to the entity.'),
                })
                .describe(
                  'Property fields that can be flattened into property-bearing Soup items.'
                )
                .and(
                  zod.object({
                    createdAt: zod.iso
                      .datetime({})
                      .describe('When the company was created.'),
                    description: zod
                      .string()
                      .nullish()
                      .describe(
                        "Display description from the primary domain's directory entry."
                      ),
                    domains: zod
                      .array(
                        zod
                          .object({
                            companyId: zod
                              .uuid()
                              .describe(
                                'The id of the company the domain belongs to.'
                              ),
                            createdAt: zod.iso
                              .datetime({})
                              .describe('When the domain record was created.'),
                            domain: zod
                              .string()
                              .describe(
                                'The domain (lowercased, e.g. \"acme.com\").'
                              ),
                            id: zod
                              .uuid()
                              .describe('The id of the domain record.'),
                          })
                          .describe(
                            "A CRM domain as displayed in Soup. Mirrors the crm crate's\n[`CrmDomain`] with a stable wire shape that the FE can rely on."
                          )
                      )
                      .describe(
                        'Domains associated with this company, ordered by creation time\nascending (primary first).'
                      ),
                    emailSync: zod
                      .boolean()
                      .describe(
                        'Whether email sync is enabled for this company.'
                      ),
                    hidden: zod
                      .boolean()
                      .describe(
                        'Whether the company is hidden from CRM listings. Soup filters\nthese out by default.'
                      ),
                    id: zod.uuid().describe('The id of the company.'),
                    name: zod
                      .string()
                      .nullish()
                      .describe(
                        "Display name from the primary domain's directory entry, or\n`None` when unresolved."
                      ),
                    teamId: zod
                      .uuid()
                      .describe(
                        'The id of the team that owns this company record.'
                      ),
                    updatedAt: zod.iso
                      .datetime({})
                      .describe('When the company was last updated.'),
                    viewedAt: zod.iso
                      .datetime({})
                      .nullish()
                      .describe(
                        'When the requesting user last viewed this company, or `None` if\nnever viewed. Mirrors the `viewed_at` other soup entities carry.'
                      ),
                  })
                )
                .describe(
                  'A CRM company as displayed in Soup. Carries the core company\nfields plus display metadata resolved from `crm_domain_directory`\nagainst the primary (earliest-created) domain.'
                ),
              tag: zod.enum(['crmCompany']),
            })
            .describe('CRM company item.'),
          zod
            .object({
              data: zod
                .object({
                  createdAt: zod.iso
                    .datetime({})
                    .describe('Timestamp when the record was created.'),
                  foreignEntityId: zod
                    .string()
                    .describe('Identifier assigned by the external system.'),
                  foreignEntitySource: zod
                    .string()
                    .describe(
                      'Source system that owns the external identifier.'
                    ),
                  id: zod
                    .uuid()
                    .describe(
                      'Internal primary key for this foreign entity record.'
                    ),
                  metadata: zod
                    .object({})
                    .describe('Arbitrary metadata stored with the mapping.'),
                  storedForAuthEntity: zod
                    .string()
                    .describe(
                      'Internal auth entity namespace this foreign entity is stored for.'
                    ),
                  storedForId: zod
                    .string()
                    .describe(
                      'Internal entity identifier this foreign entity is stored for.'
                    ),
                  updatedAt: zod.iso
                    .datetime({})
                    .describe('Timestamp when the record was last updated.'),
                })
                .describe('A foreign entity record as displayed in Soup.'),
              tag: zod.enum(['foreignEntity']),
            })
            .describe('Foreign entity item.'),
          zod
            .object({
              data: zod
                .object({
                  properties: zod
                    .array(
                      zod
                        .object({
                          definition: zod
                            .object({
                              created_at: zod.iso.datetime({}),
                              data_type: zod
                                .enum([
                                  'BOOLEAN',
                                  'DATE',
                                  'NUMBER',
                                  'STRING',
                                  'SELECT_NUMBER',
                                  'SELECT_STRING',
                                  'TAG',
                                  'ENTITY',
                                  'LINK',
                                ])
                                .describe(
                                  'Data type for property values, determining storage and validation.'
                                ),
                              display_name: zod.string(),
                              id: zod.uuid(),
                              is_metadata: zod
                                .boolean()
                                .describe(
                                  'Flag to indicate if this is a system-generated metadata property.\nNot stored in database - computed at service layer.'
                                ),
                              is_multi_select: zod.boolean(),
                              is_system: zod
                                .boolean()
                                .describe(
                                  'Flag to indicate if this is a system property (stored in DB).'
                                ),
                              owner: zod
                                .union([
                                  zod
                                    .object({
                                      scope: zod.enum(['user']),
                                      user_id: zod.string(),
                                    })
                                    .describe('User-scoped property.'),
                                  zod
                                    .object({
                                      scope: zod.enum(['team']),
                                      team_id: zod.uuid(),
                                    })
                                    .describe('Team-scoped property.'),
                                  zod
                                    .object({
                                      scope: zod.enum(['system']),
                                    })
                                    .describe(
                                      'System-owned property (no user or team owner).'
                                    ),
                                ])
                                .describe(
                                  'Defines who owns a property - user-scoped, team-scoped, or system.'
                                ),
                              specific_entity_type: zod
                                .union([
                                  zod.null(),
                                  zod
                                    .enum([
                                      'CALENDAR_EVENT',
                                      'CALL_RECORD',
                                      'CHANNEL',
                                      'CHAT',
                                      'COMPANY',
                                      'DOCUMENT',
                                      'PROJECT',
                                      'TASK',
                                      'THREAD',
                                      'USER',
                                    ])
                                    .describe(
                                      'Type of entity that can be referenced by entity properties.'
                                    ),
                                ])
                                .optional(),
                              updated_at: zod.iso.datetime({}),
                            })
                            .describe(
                              'Property definition model (service representation).'
                            ),
                          id: zod
                            .uuid()
                            .describe(
                              'Globally unique id of the assignment attaching this property to an entity.'
                            ),
                          value: zod
                            .union([
                              zod.null(),
                              zod
                                .union([
                                  zod
                                    .object({
                                      type: zod.enum(['Boolean']),
                                      value: zod
                                        .boolean()
                                        .describe(
                                          'Boolean value\nSerializes as: {\"type\": \"Boolean\", \"value\": true}'
                                        ),
                                    })
                                    .describe(
                                      'Boolean value\nSerializes as: {\"type\": \"Boolean\", \"value\": true}'
                                    ),
                                  zod
                                    .object({
                                      type: zod.enum(['Number']),
                                      value: zod
                                        .number()
                                        .describe(
                                          'Numeric value\nSerializes as: {\"type\": \"Number\", \"value\": 42.5}'
                                        ),
                                    })
                                    .describe(
                                      'Numeric value\nSerializes as: {\"type\": \"Number\", \"value\": 42.5}'
                                    ),
                                  zod
                                    .object({
                                      type: zod.enum(['String']),
                                      value: zod
                                        .string()
                                        .describe(
                                          'String value\nSerializes as: {\"type\": \"String\", \"value\": \"text\"}'
                                        ),
                                    })
                                    .describe(
                                      'String value\nSerializes as: {\"type\": \"String\", \"value\": \"text\"}'
                                    ),
                                  zod
                                    .object({
                                      type: zod.enum(['Date']),
                                      value: zod.iso
                                        .datetime({})
                                        .describe(
                                          'Date\/timestamp value\nSerializes as: {\"type\": \"Date\", \"value\": \"2025-01-01T00:00:00Z\"}'
                                        ),
                                    })
                                    .describe(
                                      'Date\/timestamp value\nSerializes as: {\"type\": \"Date\", \"value\": \"2025-01-01T00:00:00Z\"}'
                                    ),
                                  zod
                                    .object({
                                      type: zod.enum(['SelectOption']),
                                      value: zod
                                        .array(zod.uuid())
                                        .describe(
                                          'Select option(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"SelectOption\", \"value\": [\"uuid\"]} (length 0 or 1)\nMulti-select: {\"type\": \"SelectOption\", \"value\": [\"uuid1\", \"uuid2\", ...]} (length 0+)'
                                        ),
                                    })
                                    .describe(
                                      'Select option(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"SelectOption\", \"value\": [\"uuid\"]} (length 0 or 1)\nMulti-select: {\"type\": \"SelectOption\", \"value\": [\"uuid1\", \"uuid2\", ...]} (length 0+)'
                                    ),
                                  zod
                                    .object({
                                      type: zod.enum(['EntityReference']),
                                      value: zod
                                        .array(
                                          zod
                                            .object({
                                              entity_id: zod.string(),
                                              entity_type: zod
                                                .enum([
                                                  'CALENDAR_EVENT',
                                                  'CALL_RECORD',
                                                  'CHANNEL',
                                                  'CHAT',
                                                  'COMPANY',
                                                  'DOCUMENT',
                                                  'PROJECT',
                                                  'TASK',
                                                  'THREAD',
                                                  'USER',
                                                ])
                                                .describe(
                                                  'Type of entity that can be referenced by entity properties.'
                                                ),
                                              specific_message_id: zod
                                                .uuid()
                                                .nullish()
                                                .describe(
                                                  'For CHANNEL, CHAT, THREAD entity types - optional specific message ID.\nThis allows referencing a specific message within a thread\/channel\/chat.'
                                                ),
                                            })
                                            .describe(
                                              'Entity reference for entity-type property values.'
                                            )
                                        )
                                        .describe(
                                          'Entity reference(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"EntityReference\", \"value\": [{...}]} (length 0 or 1)\nMulti-select: {\"type\": \"EntityReference\", \"value\": [{...}, {...}, ...]} (length 0+)'
                                        ),
                                    })
                                    .describe(
                                      'Entity reference(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"EntityReference\", \"value\": [{...}]} (length 0 or 1)\nMulti-select: {\"type\": \"EntityReference\", \"value\": [{...}, {...}, ...]} (length 0+)'
                                    ),
                                  zod
                                    .object({
                                      type: zod.enum(['Link']),
                                      value: zod
                                        .array(zod.string())
                                        .describe(
                                          'Link value(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"Link\", \"value\": [\"https:\/\/example.com\"]} (length 0 or 1)\nMulti-select: {\"type\": \"Link\", \"value\": [\"https:\/\/example.com\", \"https:\/\/other.com\"]} (length 0+)'
                                        ),
                                    })
                                    .describe(
                                      'Link value(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"Link\", \"value\": [\"https:\/\/example.com\"]} (length 0 or 1)\nMulti-select: {\"type\": \"Link\", \"value\": [\"https:\/\/example.com\", \"https:\/\/other.com\"]} (length 0+)'
                                    ),
                                ])
                                .describe(
                                  'Property value (service representation).\n\nRepresents the actual value stored for an entity property.\nThis is serialized to\/from JSONB in the database.'
                                ),
                            ])
                            .optional(),
                        })
                        .describe(
                          'A property attached to a Soup item.\n\nThis is a simplified representation that includes only the definition and value,\nomitting the entity property assignment metadata and options.'
                        )
                    )
                    .describe('Properties attached to the entity.'),
                })
                .describe(
                  'Property fields that can be flattened into property-bearing Soup items.'
                )
                .and(
                  zod.object({
                    completedAt: zod.iso
                      .datetime({})
                      .nullish()
                      .describe('Set once a one-shot reminder has fired.'),
                    createdAt: zod.iso
                      .datetime({})
                      .describe('When the reminder was created.'),
                    description: zod
                      .string()
                      .describe(
                        'What to remind the user about. Doubles as the display name.'
                      ),
                    enabled: zod
                      .boolean()
                      .describe(
                        'When false, the dispatcher skips this reminder.'
                      ),
                    id: zod.uuid().describe('The reminder id.'),
                    nextRunAt: zod.iso
                      .datetime({})
                      .describe(
                        'The next firing. This is what Soup sorts reminders on.'
                      ),
                    referencedEntity: zod
                      .union([
                        zod.null(),
                        zod
                          .object({
                            entityType: zod
                              .enum([
                                'user',
                                'chat',
                                'channel',
                                'channel_message',
                                'document',
                                'project',
                                'email_thread',
                                'calendar_event',
                                'team',
                                'call',
                                'foreign_entity',
                                'static_file',
                                'crm_company',
                                'crm_contact',
                                'reminder',
                                'skill',
                              ])
                              .describe('The type of an entity in Macro')
                              .describe("The referenced entity's type."),
                            fileType: zod
                              .string()
                              .nullish()
                              .describe(
                                'File type, when the reference is a document — `md`, `pdf`, and so on.'
                              ),
                            id: zod
                              .string()
                              .describe("The referenced entity's id."),
                            subType: zod
                              .string()
                              .nullish()
                              .describe(
                                'Sub type, when the reference is a task or snippet document.'
                              ),
                          })
                          .describe(
                            "The entity a reminder is about, resolved server-side.\n\nA reminder has no block of its own — it opens, and is iconed as, whatever it\nreferences. Which block that is depends on the referenced document's file\ntype, and the client's icon path is synchronous, so this is resolved here\nrather than costing a fetch per row."
                          ),
                      ])
                      .optional(),
                    schedule: zod
                      .union([
                        zod
                          .object({
                            remindAt: zod.iso
                              .datetime({})
                              .describe('The instant to fire at.'),
                            type: zod.enum(['once']),
                          })
                          .describe('Fires once, at a fixed instant.'),
                        zod
                          .object({
                            cron: zod
                              .string()
                              .describe(
                                'Cron expression, normalized to the 6-field form.'
                              ),
                            timezone: zod
                              .string()
                              .describe(
                                'The timezone the cron expression is evaluated in.'
                              ),
                            type: zod.enum(['recurring']),
                          })
                          .describe(
                            'Fires repeatedly, on a cron schedule evaluated in `timezone`.'
                          ),
                      ])
                      .describe(
                        'How often a reminder fires, flattened for the wire.\n\nThe domain\'s [`ReminderSchedule`] is an internally-tagged enum carrying a\nvalidated cron type; Soup only needs enough to render \"once\" vs \"every\nweekday at 9am\", so the cron is exposed as a plain string.'
                      ),
                    updatedAt: zod.iso
                      .datetime({})
                      .describe('When the reminder was last modified.'),
                  })
                )
                .describe(
                  "A reminder as displayed in Soup.\n\nReminders are user-owned rather than shared, so unlike most Soup items they\ncarry no access metadata — the repository only ever returns the caller's own."
                ),
              tag: zod.enum(['reminder']),
            })
            .describe('Reminder item.'),
        ])
        .describe('A single item in the Soup feed.')
        .and(
          zod.object({
            frecency_score: zod.number(),
            is_favorited: zod
              .boolean()
              .describe(
                'Whether the requesting user has favorited this entity.'
              ),
          })
        )
        .describe('API representation of a soup item with its frecency score.')
    ),
    next_cursor: zod.string().nullish(),
  })
  .describe('Response page for non-grouped soup endpoints.');

/**
 * @summary Gets the items the user has access to
 */
export const postItemsSoupQueryParams = zod.object({
  cursor: zod.string().optional().describe('Base64 encoded cursor value.'),
});

export const postItemsSoupBodyLimitMin = 0;

export const postItemsSoupBody = zod
  .object({
    calendar_event_filters: zod
      .object({
        attendees: zod
          .array(zod.string())
          .optional()
          .describe('Attendee email addresses.'),
        calendar_event_ids: zod
          .array(zod.string())
          .optional()
          .describe('Canonical event ids.'),
        ends_after: zod.iso
          .datetime({})
          .nullish()
          .describe('Include master events ending after this instant.'),
        organizers: zod
          .array(zod.string())
          .optional()
          .describe('Organizer email addresses.'),
        starts_before: zod.iso
          .datetime({})
          .nullish()
          .describe('Include master events starting before this instant.'),
        statuses: zod
          .array(zod.string())
          .optional()
          .describe(
            'Event statuses such as `confirmed`, `tentative`, or `cancelled`.'
          ),
      })
      .optional()
      .describe('Filters for canonical calendar-event entities.'),
    call_filters: zod
      .object({
        attended: zod
          .boolean()
          .nullish()
          .describe(
            'Legacy filter by whether the requesting user attended the call.\nPrefer [`CallFilters::status`] for new callers.\n`None` = no filter, `Some(true)` = only calls the user joined,\n`Some(false)` = only calls the user did not join.'
          ),
        call_ids: zod
          .array(zod.string())
          .optional()
          .describe(
            'Call record IDs to filter by. Empty to include all calls.'
          ),
        channel_ids: zod
          .array(zod.string())
          .optional()
          .describe(
            'Channel IDs to filter calls by. Empty to include all calls.'
          ),
        speaker_ids: zod
          .array(zod.string())
          .optional()
          .describe('Speaker macro user ids. Empty to include all.'),
        status: zod
          .union([
            zod.null(),
            zod
              .enum(['ATTENDED', 'MISSED', 'UNATTENDED'])
              .describe(
                'Viewer-relative attendance status for a call record.\nSerializes as `ATTENDED`, `MISSED`, or `UNATTENDED`.'
              ),
          ])
          .optional(),
      })
      .optional()
      .describe('Filters for call records.'),
    channel_filters: zod
      .object({
        channel_ids: zod
          .array(zod.string())
          .optional()
          .describe(
            "Channel IDs to search within. Examples: ['general']. Empty to search all accessible channels."
          ),
        channel_types: zod
          .array(zod.string())
          .optional()
          .describe(
            "Channel types to filter by. Examples: ['public'], ['direct_message', 'private']. Empty to search all channel types."
          ),
        importance: zod
          .boolean()
          .nullish()
          .describe(
            'Filter by channel importance. None to ignore, true to pass through (no clause), false to short-circuit and return nothing.'
          ),
        is_participant: zod
          .boolean()
          .nullish()
          .describe(
            "Filter by whether the requesting user is an active participant of the channel.\nPresence of this filter also widens the candidate set to team channels of the\nuser's teams that they have not joined, so `false` matches those channels.\nNone to ignore (participant channels only, today's default)."
          ),
        mentions: zod
          .array(zod.string())
          .optional()
          .describe(
            "Channel user mentions to search for. Examples: ['@username']. Empty if not filtering by mentions."
          ),
        notification_filters: zod
          .object({
            done: zod
              .boolean()
              .nullish()
              .describe(
                'Filter by notification done state. `Some(true)` selects done\nnotifications; `Some(false)` selects not-done notifications.'
              ),
            seen: zod
              .boolean()
              .nullish()
              .describe(
                'Filter by notification seen state. `Some(true)` selects seen\nnotifications; `Some(false)` selects not-seen notifications.'
              ),
          })
          .optional()
          .describe('Notification state filters for channel message queries.'),
        org_id: zod
          .number()
          .nullish()
          .describe(
            'Channel organization ID to search within. Empty to ignore organization filtering.'
          ),
        sender_ids: zod
          .array(zod.string())
          .optional()
          .describe(
            "Sender IDs to search within. Examples: ['user1']. Empty to search all accessible senders."
          ),
        team_id: zod
          .string()
          .nullish()
          .describe(
            'Channel team ID to search within. Empty to ignore team filtering.'
          ),
        thread_ids: zod
          .array(zod.string())
          .optional()
          .describe(
            "Channel thread IDs to search within. Examples: ['thread123']. Empty to search all threads."
          ),
      })
      .optional()
      .describe(
        'The channel message filters used to filter down what channel messages you search over.'
      ),
    channel_thread_filters: zod
      .object({
        channel_ids: zod
          .array(zod.string())
          .optional()
          .describe(
            'Channel IDs containing the thread. Empty to include threads from all accessible channels.'
          ),
        participant_ids: zod
          .array(zod.string())
          .optional()
          .describe(
            'Thread participant user IDs. A participant is the root message sender, anyone\nwho replied in the thread, or anyone @-mentioned in the thread (group mentions\nlike @here count through their per-user expansion at send time). Empty to\ninclude threads regardless of participants.'
          ),
        root_sender_ids: zod
          .array(zod.string())
          .optional()
          .describe(
            'Sender IDs for the root thread message. Empty to include all root senders.'
          ),
        thread_ids: zod
          .array(zod.string())
          .optional()
          .describe(
            'Channel thread parent message IDs to include. Empty to include all accessible threads.'
          ),
      })
      .optional()
      .describe(
        'The channel thread filters used to filter down channel-thread entities.'
      ),
    chat_filters: zod
      .object({
        chat_ids: zod
          .array(zod.string())
          .optional()
          .describe(
            "Chat ids to search over. Examples: ['chat1'], ['chat1', 'chat2']. When provided, chat search will only match results on these chats. Empty to search all accessible chats."
          ),
        importance: zod
          .boolean()
          .nullish()
          .describe(
            'Filter by chat importance. None to ignore, true to pass through (no clause), false to short-circuit and return nothing.'
          ),
        notification_filters: zod
          .object({
            done: zod
              .boolean()
              .nullish()
              .describe(
                'Filter by notification done state. `Some(true)` selects done\nnotifications; `Some(false)` selects not-done notifications.'
              ),
            seen: zod
              .boolean()
              .nullish()
              .describe(
                'Filter by notification seen state. `Some(true)` selects seen\nnotifications; `Some(false)` selects not-seen notifications.'
              ),
          })
          .optional()
          .describe('Notification state filters for channel message queries.'),
        owners: zod
          .array(zod.string())
          .optional()
          .describe(
            "Filter by chat owner. Examples: ['macro|user1@user.com'], ['macro|user1@user.com', 'macro|user2@user.com']. Empty to search all owners."
          ),
        project_ids: zod
          .array(zod.string())
          .optional()
          .describe(
            "A list of project ids to search within. Examples: ['project1']. Empty to ignore project filtering."
          ),
        role: zod
          .array(zod.string())
          .optional()
          .describe(
            "Chat message roles to search. Examples: ['user'], ['assistant']. Empty to search all roles."
          ),
      })
      .optional()
      .describe(
        'The chat filters used to filter down what chats you search over.'
      ),
    crm_company_filters: zod
      .object({
        company_ids: zod
          .array(zod.string())
          .optional()
          .describe(
            "CRM company ids to filter by. Examples: ['11111111-...']. Empty to\ninclude all of the team's visible CRM companies."
          ),
        hidden: zod
          .boolean()
          .nullish()
          .describe(
            "Optional `crm_companies.hidden` filter. `None` = visible only\n(default for back-compat with non-admin callers). `Some(false)` =\nvisible only (explicit). `Some(true)` = hidden only — requires\nadmin\/owner team role; enforced by the CRM service from the\ncaller's team receipt."
          ),
      })
      .optional()
      .describe(
        'The crm company filters used to narrow which CRM companies appear in soup.'
      ),
    document_filters: zod
      .object({
        document_ids: zod
          .array(zod.string())
          .optional()
          .describe(
            "Document ids to search over. Examples: ['doc1'], ['doc1', 'doc2']. Empty to search all accessible documents."
          ),
        file_types: zod
          .array(zod.string())
          .optional()
          .describe(
            "Document file types to search. Examples: ['pdf'], ['md', 'txt']. Empty to search all file types."
          ),
        importance: zod
          .boolean()
          .nullish()
          .describe(
            'Filter by document importance. None to ignore, true to pass through (no clause), false to short-circuit and return nothing.'
          ),
        is_email_attachment: zod
          .boolean()
          .nullish()
          .describe(
            'Filter by email attachment status. true = only email attachments, false = only non-email attachments, None = both.'
          ),
        notification_filters: zod
          .object({
            done: zod
              .boolean()
              .nullish()
              .describe(
                'Filter by notification done state. `Some(true)` selects done\nnotifications; `Some(false)` selects not-done notifications.'
              ),
            seen: zod
              .boolean()
              .nullish()
              .describe(
                'Filter by notification seen state. `Some(true)` selects seen\nnotifications; `Some(false)` selects not-seen notifications.'
              ),
          })
          .optional()
          .describe('Notification state filters for channel message queries.'),
        owners: zod
          .array(zod.string())
          .optional()
          .describe(
            "Filter by document owner. Examples: ['macro|user1@user.com'], ['macro|user1@user.com', 'macro|user2@user.com']. Empty to search all owners."
          ),
        project_ids: zod
          .array(zod.string())
          .optional()
          .describe(
            "A list of project ids to search within. Examples: ['project1'].\nfiltering. Empty to ignore project filtering."
          ),
        sub_types: zod
          .array(zod.string())
          .optional()
          .describe(
            "Filter by document sub type. Examples: ['task']. Empty to search all sub types."
          ),
        task_filters: zod
          .object({
            include_cbm_atm_nc: zod
              .boolean()
              .nullish()
              .describe(
                'Include tasks that are created by me, assigned to me, and not completed,\neven when they do not match other document filters.'
              ),
          })
          .optional()
          .describe('Task-only filters nested under document filters.'),
      })
      .optional()
      .describe(
        'The document filters used to filter down what documents you search over.'
      ),
    email_filters: zod
      .object({
        bcc: zod
          .array(zod.string())
          .optional()
          .describe(
            "Email BCC addresses to filter by. Examples: ['user@example.com']. Empty if not filtering by BCC."
          ),
        calendar_only: zod
          .boolean()
          .nullish()
          .describe(
            'When `Some(true)`, only include threads that have at least one message\nwith an iCalendar attachment (`.ics` filename or `application\/ics` mime\ntype). `Some(false)` and `None` apply no constraint.'
          ),
        cc: zod
          .array(zod.string())
          .optional()
          .describe(
            "Email CC addresses to filter by. Examples: ['user@example.com']. Empty if not filtering by CC."
          ),
        crm_addresses: zod
          .array(zod.string())
          .optional()
          .describe(
            "CRM-scoped address filter. When non-empty, expands visibility to every\nteammate's mailbox and restricts to threads involving any of these\nfully-qualified addresses. Each address is authorized against\n`crm_contacts` + `crm_companies` (contact must not be hidden, company\nmust not be hidden, `email_sync` must be true).\nMutually exclusive with `crm_domains`."
          ),
        crm_domains: zod
          .array(zod.string())
          .optional()
          .describe(
            "CRM-scoped domain filter. When non-empty, expands visibility to every\nteammate's mailbox and restricts to threads involving any of these\ndomains (in any of sender\/cc\/bcc\/recipient). Each domain is authorized\nagainst `crm_domains` + `crm_companies` (must exist for the caller's\nteam, company must not be hidden, `email_sync` must be true).\nMutually exclusive with `crm_addresses`."
          ),
        email_thread_ids: zod
          .array(zod.string())
          .optional()
          .describe(
            "Email thread IDs to filter by. Examples: ['thread-uuid-1']. Empty to search all threads."
          ),
        exclude_labels: zod
          .array(zod.string())
          .optional()
          .describe(
            'Exclude emails that have any of these labels. Supports both Gmail system labels (e.g. \"CATEGORY_PROMOTIONS\") and user-created labels. Empty to not exclude any labels.\nNote: SPAM and TRASH emails are not indexed in OpenSearch, so they are already excluded by default.'
          ),
        importance: zod
          .boolean()
          .nullish()
          .describe(
            'Filter by email importance. None to not filter. True to show only important emails\n(drafts, personal, sent, or uncategorized). False to show only unimportant emails\n(those categorized as promotions, social, updates, or forums).'
          ),
        include_labels: zod
          .array(zod.string())
          .optional()
          .describe(
            'Only include emails that have at least one of these labels. Supports both Gmail system labels (e.g. \"INBOX\", \"CATEGORY_PROMOTIONS\") and user-created labels (e.g. \"github\"). Empty to not filter by included labels.\nNote: SPAM and TRASH emails are not indexed in OpenSearch, so they will never appear in results regardless of this filter.'
          ),
        link_ids: zod
          .array(zod.string())
          .optional()
          .describe(
            'Restrict to specific inboxes by email_links.id. Empty means \"any inbox the\ncaller can access\" (soup expands to the full set at the router edge).'
          ),
        notification_filters: zod
          .object({
            done: zod
              .boolean()
              .nullish()
              .describe(
                'Filter by notification done state. `Some(true)` selects done\nnotifications; `Some(false)` selects not-done notifications.'
              ),
            seen: zod
              .boolean()
              .nullish()
              .describe(
                'Filter by notification seen state. `Some(true)` selects seen\nnotifications; `Some(false)` selects not-seen notifications.'
              ),
          })
          .optional()
          .describe('Notification state filters for channel message queries.'),
        project_ids: zod
          .array(zod.string())
          .optional()
          .describe(
            'A list of project ids to search within. Empty to ignore project filtering.'
          ),
        recipients: zod
          .array(zod.string())
          .optional()
          .describe(
            "Email Recipient addresses to filter by. Examples: ['user@example.com']. Empty if not filtering by Recipient."
          ),
        senders: zod
          .array(zod.string())
          .optional()
          .describe(
            "Email sender addresses to filter by. Examples: ['user@example.com']. Empty to search all senders."
          ),
        shared: zod
          .enum(['exclude', 'include', 'only'])
          .optional()
          .describe(
            'Controls whether shared email threads are included in results.'
          ),
      })
      .optional()
      .describe(
        'The email filters used to filter down what emails you search over.'
      ),
    foreign_entity_filters: zod
      .object({
        foreign_entity_ids: zod
          .array(zod.string())
          .optional()
          .describe(
            'External entity identifiers to filter by. Empty to include all external IDs.'
          ),
        foreign_entity_sources: zod
          .array(zod.string())
          .optional()
          .describe(
            'External source names to filter by. Empty to include all sources.'
          ),
        ids: zod
          .array(zod.string())
          .optional()
          .describe(
            'Internal foreign entity record IDs to filter by. Empty to include all records.'
          ),
        includes_me: zod
          .boolean()
          .optional()
          .describe(
            'When true, only return foreign entities whose metadata lists the requesting user as a\nparticipant (GitHub `involves:me` semantics for `github_pull_request` records). False or\nabsent applies no filter. Serialized in filter ASTs as the `\"me\"` literal.'
          ),
        notification_filters: zod
          .object({
            done: zod
              .boolean()
              .nullish()
              .describe(
                'Filter by notification done state. `Some(true)` selects done\nnotifications; `Some(false)` selects not-done notifications.'
              ),
            seen: zod
              .boolean()
              .nullish()
              .describe(
                'Filter by notification seen state. `Some(true)` selects seen\nnotifications; `Some(false)` selects not-seen notifications.'
              ),
          })
          .optional()
          .describe('Notification state filters for channel message queries.'),
      })
      .optional()
      .describe('Filters for foreign entity records.'),
    project_filters: zod
      .object({
        importance: zod
          .boolean()
          .nullish()
          .describe(
            'Filter by project importance. None to ignore, true to pass through (no clause), false to short-circuit and return nothing.'
          ),
        include_root: zod
          .boolean()
          .optional()
          .describe(
            'When true, `project_ids` also matches the projects themselves in addition to their children.'
          ),
        notification_filters: zod
          .object({
            done: zod
              .boolean()
              .nullish()
              .describe(
                'Filter by notification done state. `Some(true)` selects done\nnotifications; `Some(false)` selects not-done notifications.'
              ),
            seen: zod
              .boolean()
              .nullish()
              .describe(
                'Filter by notification seen state. `Some(true)` selects seen\nnotifications; `Some(false)` selects not-seen notifications.'
              ),
          })
          .optional()
          .describe('Notification state filters for channel message queries.'),
        owners: zod
          .array(zod.string())
          .optional()
          .describe(
            "Filter by project owner. Examples: ['macro|user1@user.com'], ['macro|user1@user.com', 'macro|user2@user.com']. Empty to search all owners."
          ),
        project_ids: zod
          .array(zod.string())
          .optional()
          .describe(
            "Project IDs to search within. Examples: ['project1']. Empty to search all accessible projects.\nBy default matches children of these projects; set `include_root` to also match the projects themselves."
          ),
      })
      .optional()
      .describe(
        'The project filters used to filter down what projects you search over.'
      ),
    property_filters: zod
      .array(
        zod
          .object({
            entity_ids: zod
              .array(zod.string())
              .optional()
              .describe(
                "Entity reference IDs to match. Multiple values are OR'd together."
              ),
            entity_type: zod
              .string()
              .nullish()
              .describe(
                'The entity type for the property lookup (e.g., \"TASK\", \"DOCUMENT\", \"PROJECT\").\nWhen None, matches across all entity types.'
              ),
            option_ids: zod
              .array(zod.string())
              .optional()
              .describe(
                "Select option UUIDs to match. Multiple values are OR'd together."
              ),
            property_definition_id: zod
              .string()
              .describe('The UUID of the property definition to filter on.'),
          })
          .describe(
            "A single property-based filter condition.\n\nEach filter targets a specific property definition on entities of a given type,\nmatching against select option UUIDs or entity reference IDs.\nMultiple values within a single filter are OR'd together.\nMultiple filters are AND'd together."
          )
      )
      .optional()
      .describe('property-based filters applied across entity types'),
    reminder_filters: zod
      .object({
        completed: zod
          .boolean()
          .nullish()
          .describe(
            'Filter on whether the owner has marked the reminder done. `None` returns\nboth.'
          ),
        entities: zod
          .array(zod.string())
          .optional()
          .describe(
            'Restrict to reminders attached to these entities, each `\"{type}:{id}\"`.'
          ),
        fired: zod
          .boolean()
          .nullish()
          .describe(
            "Filter on whether the reminder's next run has come due, i.e. it has\nfired and is awaiting its owner. `None` returns both.\n\nEvaluated server-side against the database clock rather than a\ntimestamp supplied by the caller: a timestamp would land in the query\ncache key and change on every render."
          ),
        ids: zod
          .array(zod.string())
          .optional()
          .describe(
            "Reminder ids to filter by. Empty to include all of the caller's reminders."
          ),
        include: zod
          .boolean()
          .optional()
          .describe(
            'Opt this query into reminders at all. Reminders are off by default —\nsee [`crate::ast::reminder::ReminderLiteral::Include`]. Asking for\nspecific `ids` or `entities` also opts in.'
          ),
      })
      .optional()
      .describe('Filters for reminders.'),
    tag_filter_mode: zod
      .enum(['any', 'all'])
      .optional()
      .describe('How multiple `tag_option_ids` combine when filtering.'),
    tag_option_ids: zod
      .array(zod.string())
      .optional()
      .describe(
        "tag option ids matched against `properties.values`, OR'd together across\nall tag definitions. Option ids are globally unique, so the match ignores\nthe owning definition id (personal and team tags combine into one OR)."
      ),
  })
  .describe('a bundle of all of the filters for each entity type')
  .and(
    zod
      .object({
        expand: zod
          .boolean()
          .nullish()
          .describe('Whether to expand projects. Defaults to true.'),
        limit: zod
          .number()
          .min(postItemsSoupBodyLimitMin)
          .nullish()
          .describe(
            'Limit the number of items returned. Defaults to 20. Max 500.'
          ),
        sort_direction: zod
          .union([
            zod.null(),
            zod
              .enum(['asc', 'desc'])
              .describe(
                'Sort direction accepted by non-grouped soup API endpoints.'
              ),
          ])
          .optional(),
        sort_method: zod
          .union([
            zod.null(),
            zod
              .enum([
                'viewed_at',
                'created_at',
                'updated_at',
                'viewed_updated',
                'frecency',
                'touched_by_me',
              ])
              .describe(
                'Sort options accepted by non-grouped soup API endpoints.'
              ),
          ])
          .optional(),
      })
      .describe('Query parameters shared by soup endpoints.')
  )
  .and(
    zod.object({
      emailView: zod
        .string()
        .optional()
        .describe('the view of specific emails to display'),
    })
  )
  .describe('Request body for the typed soup endpoint.');

export const postItemsSoupResponseItemsItemDataChannelOrgIdMin = 0;

export const postItemsSoupResponse = zod
  .object({
    items: zod.array(
      zod
        .union([
          zod
            .object({
              data: zod
                .object({
                  properties: zod
                    .array(
                      zod
                        .object({
                          definition: zod
                            .object({
                              created_at: zod.iso.datetime({}),
                              data_type: zod
                                .enum([
                                  'BOOLEAN',
                                  'DATE',
                                  'NUMBER',
                                  'STRING',
                                  'SELECT_NUMBER',
                                  'SELECT_STRING',
                                  'TAG',
                                  'ENTITY',
                                  'LINK',
                                ])
                                .describe(
                                  'Data type for property values, determining storage and validation.'
                                ),
                              display_name: zod.string(),
                              id: zod.uuid(),
                              is_metadata: zod
                                .boolean()
                                .describe(
                                  'Flag to indicate if this is a system-generated metadata property.\nNot stored in database - computed at service layer.'
                                ),
                              is_multi_select: zod.boolean(),
                              is_system: zod
                                .boolean()
                                .describe(
                                  'Flag to indicate if this is a system property (stored in DB).'
                                ),
                              owner: zod
                                .union([
                                  zod
                                    .object({
                                      scope: zod.enum(['user']),
                                      user_id: zod.string(),
                                    })
                                    .describe('User-scoped property.'),
                                  zod
                                    .object({
                                      scope: zod.enum(['team']),
                                      team_id: zod.uuid(),
                                    })
                                    .describe('Team-scoped property.'),
                                  zod
                                    .object({
                                      scope: zod.enum(['system']),
                                    })
                                    .describe(
                                      'System-owned property (no user or team owner).'
                                    ),
                                ])
                                .describe(
                                  'Defines who owns a property - user-scoped, team-scoped, or system.'
                                ),
                              specific_entity_type: zod
                                .union([
                                  zod.null(),
                                  zod
                                    .enum([
                                      'CALENDAR_EVENT',
                                      'CALL_RECORD',
                                      'CHANNEL',
                                      'CHAT',
                                      'COMPANY',
                                      'DOCUMENT',
                                      'PROJECT',
                                      'TASK',
                                      'THREAD',
                                      'USER',
                                    ])
                                    .describe(
                                      'Type of entity that can be referenced by entity properties.'
                                    ),
                                ])
                                .optional(),
                              updated_at: zod.iso.datetime({}),
                            })
                            .describe(
                              'Property definition model (service representation).'
                            ),
                          id: zod
                            .uuid()
                            .describe(
                              'Globally unique id of the assignment attaching this property to an entity.'
                            ),
                          value: zod
                            .union([
                              zod.null(),
                              zod
                                .union([
                                  zod
                                    .object({
                                      type: zod.enum(['Boolean']),
                                      value: zod
                                        .boolean()
                                        .describe(
                                          'Boolean value\nSerializes as: {\"type\": \"Boolean\", \"value\": true}'
                                        ),
                                    })
                                    .describe(
                                      'Boolean value\nSerializes as: {\"type\": \"Boolean\", \"value\": true}'
                                    ),
                                  zod
                                    .object({
                                      type: zod.enum(['Number']),
                                      value: zod
                                        .number()
                                        .describe(
                                          'Numeric value\nSerializes as: {\"type\": \"Number\", \"value\": 42.5}'
                                        ),
                                    })
                                    .describe(
                                      'Numeric value\nSerializes as: {\"type\": \"Number\", \"value\": 42.5}'
                                    ),
                                  zod
                                    .object({
                                      type: zod.enum(['String']),
                                      value: zod
                                        .string()
                                        .describe(
                                          'String value\nSerializes as: {\"type\": \"String\", \"value\": \"text\"}'
                                        ),
                                    })
                                    .describe(
                                      'String value\nSerializes as: {\"type\": \"String\", \"value\": \"text\"}'
                                    ),
                                  zod
                                    .object({
                                      type: zod.enum(['Date']),
                                      value: zod.iso
                                        .datetime({})
                                        .describe(
                                          'Date\/timestamp value\nSerializes as: {\"type\": \"Date\", \"value\": \"2025-01-01T00:00:00Z\"}'
                                        ),
                                    })
                                    .describe(
                                      'Date\/timestamp value\nSerializes as: {\"type\": \"Date\", \"value\": \"2025-01-01T00:00:00Z\"}'
                                    ),
                                  zod
                                    .object({
                                      type: zod.enum(['SelectOption']),
                                      value: zod
                                        .array(zod.uuid())
                                        .describe(
                                          'Select option(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"SelectOption\", \"value\": [\"uuid\"]} (length 0 or 1)\nMulti-select: {\"type\": \"SelectOption\", \"value\": [\"uuid1\", \"uuid2\", ...]} (length 0+)'
                                        ),
                                    })
                                    .describe(
                                      'Select option(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"SelectOption\", \"value\": [\"uuid\"]} (length 0 or 1)\nMulti-select: {\"type\": \"SelectOption\", \"value\": [\"uuid1\", \"uuid2\", ...]} (length 0+)'
                                    ),
                                  zod
                                    .object({
                                      type: zod.enum(['EntityReference']),
                                      value: zod
                                        .array(
                                          zod
                                            .object({
                                              entity_id: zod.string(),
                                              entity_type: zod
                                                .enum([
                                                  'CALENDAR_EVENT',
                                                  'CALL_RECORD',
                                                  'CHANNEL',
                                                  'CHAT',
                                                  'COMPANY',
                                                  'DOCUMENT',
                                                  'PROJECT',
                                                  'TASK',
                                                  'THREAD',
                                                  'USER',
                                                ])
                                                .describe(
                                                  'Type of entity that can be referenced by entity properties.'
                                                ),
                                              specific_message_id: zod
                                                .uuid()
                                                .nullish()
                                                .describe(
                                                  'For CHANNEL, CHAT, THREAD entity types - optional specific message ID.\nThis allows referencing a specific message within a thread\/channel\/chat.'
                                                ),
                                            })
                                            .describe(
                                              'Entity reference for entity-type property values.'
                                            )
                                        )
                                        .describe(
                                          'Entity reference(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"EntityReference\", \"value\": [{...}]} (length 0 or 1)\nMulti-select: {\"type\": \"EntityReference\", \"value\": [{...}, {...}, ...]} (length 0+)'
                                        ),
                                    })
                                    .describe(
                                      'Entity reference(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"EntityReference\", \"value\": [{...}]} (length 0 or 1)\nMulti-select: {\"type\": \"EntityReference\", \"value\": [{...}, {...}, ...]} (length 0+)'
                                    ),
                                  zod
                                    .object({
                                      type: zod.enum(['Link']),
                                      value: zod
                                        .array(zod.string())
                                        .describe(
                                          'Link value(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"Link\", \"value\": [\"https:\/\/example.com\"]} (length 0 or 1)\nMulti-select: {\"type\": \"Link\", \"value\": [\"https:\/\/example.com\", \"https:\/\/other.com\"]} (length 0+)'
                                        ),
                                    })
                                    .describe(
                                      'Link value(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"Link\", \"value\": [\"https:\/\/example.com\"]} (length 0 or 1)\nMulti-select: {\"type\": \"Link\", \"value\": [\"https:\/\/example.com\", \"https:\/\/other.com\"]} (length 0+)'
                                    ),
                                ])
                                .describe(
                                  'Property value (service representation).\n\nRepresents the actual value stored for an entity property.\nThis is serialized to\/from JSONB in the database.'
                                ),
                            ])
                            .optional(),
                        })
                        .describe(
                          'A property attached to a Soup item.\n\nThis is a simplified representation that includes only the definition and value,\nomitting the entity property assignment metadata and options.'
                        )
                    )
                    .describe('Properties attached to the entity.'),
                })
                .describe(
                  'Property fields that can be flattened into property-bearing Soup items.'
                )
                .and(
                  zod.object({
                    branchedFromId: zod
                      .uuid()
                      .nullish()
                      .describe(
                        'The id of the document this document branched from'
                      ),
                    branchedFromVersionId: zod
                      .number()
                      .nullish()
                      .describe(
                        'The id of the version this document branched from\nThis could be either DocumentInstance or DocumentBom id depending on the file type'
                      ),
                    createdAt: zod.iso
                      .datetime({})
                      .describe('The time the document was created'),
                    deletedAt: zod.iso
                      .datetime({})
                      .nullish()
                      .describe('The time the document was deleted'),
                    documentFamilyId: zod
                      .number()
                      .nullish()
                      .describe(
                        'The id of the document family this document belongs to'
                      ),
                    documentVersionId: zod
                      .number()
                      .describe(
                        'The version of the document\nThis could be the document_instance_id or document_bom_id depending on the file type'
                      ),
                    fileType: zod
                      .string()
                      .nullish()
                      .describe(
                        'The file type of the document (e.g. pdf, docx)'
                      ),
                    id: zod.uuid().describe('The document id'),
                    name: zod.string().describe('The name of the document'),
                    ownerId: zod.string().describe('The owner of the document'),
                    projectId: zod
                      .uuid()
                      .nullish()
                      .describe(
                        'The id of the project that this document belongs to'
                      ),
                    sha: zod
                      .string()
                      .nullish()
                      .describe(
                        'If the document is a PDF, this is the SHA of the pdf\nIf the document is a DOCX, this will not be present'
                      ),
                    subType: zod
                      .union([
                        zod.null(),
                        zod
                          .union([
                            zod
                              .object({
                                is_completed: zod
                                  .boolean()
                                  .describe(
                                    'Whether the task is completed.\nTrue if the Status property is set to \"Completed\".'
                                  ),
                                type: zod.enum(['task']),
                              })
                              .describe(
                                'A task document with its associated properties'
                              ),
                            zod
                              .object({
                                type: zod.enum(['snippet']),
                              })
                              .describe(
                                'A snippet document — reusable markdown'
                              ),
                            zod
                              .object({
                                type: zod.enum(['skill']),
                              })
                              .describe(
                                'A skill document — markdown instructions for AI'
                              ),
                          ])
                          .describe(
                            'Sub type of a document with associated properties encoded in each variant.\nThis ensures type-safety: task properties only exist when the document is a task.'
                          ),
                      ])
                      .optional(),
                    updatedAt: zod.iso
                      .datetime({})
                      .describe(
                        'The time the document instance \/ document BOM was updated'
                      ),
                    viewedAt: zod.iso
                      .datetime({})
                      .nullish()
                      .describe('The time the document was last viewed'),
                  })
                )
                .describe('A document as displayed in Soup.'),
              tag: zod.enum(['document']),
            })
            .describe('Document item.'),
          zod
            .object({
              data: zod
                .object({
                  properties: zod
                    .array(
                      zod
                        .object({
                          definition: zod
                            .object({
                              created_at: zod.iso.datetime({}),
                              data_type: zod
                                .enum([
                                  'BOOLEAN',
                                  'DATE',
                                  'NUMBER',
                                  'STRING',
                                  'SELECT_NUMBER',
                                  'SELECT_STRING',
                                  'TAG',
                                  'ENTITY',
                                  'LINK',
                                ])
                                .describe(
                                  'Data type for property values, determining storage and validation.'
                                ),
                              display_name: zod.string(),
                              id: zod.uuid(),
                              is_metadata: zod
                                .boolean()
                                .describe(
                                  'Flag to indicate if this is a system-generated metadata property.\nNot stored in database - computed at service layer.'
                                ),
                              is_multi_select: zod.boolean(),
                              is_system: zod
                                .boolean()
                                .describe(
                                  'Flag to indicate if this is a system property (stored in DB).'
                                ),
                              owner: zod
                                .union([
                                  zod
                                    .object({
                                      scope: zod.enum(['user']),
                                      user_id: zod.string(),
                                    })
                                    .describe('User-scoped property.'),
                                  zod
                                    .object({
                                      scope: zod.enum(['team']),
                                      team_id: zod.uuid(),
                                    })
                                    .describe('Team-scoped property.'),
                                  zod
                                    .object({
                                      scope: zod.enum(['system']),
                                    })
                                    .describe(
                                      'System-owned property (no user or team owner).'
                                    ),
                                ])
                                .describe(
                                  'Defines who owns a property - user-scoped, team-scoped, or system.'
                                ),
                              specific_entity_type: zod
                                .union([
                                  zod.null(),
                                  zod
                                    .enum([
                                      'CALENDAR_EVENT',
                                      'CALL_RECORD',
                                      'CHANNEL',
                                      'CHAT',
                                      'COMPANY',
                                      'DOCUMENT',
                                      'PROJECT',
                                      'TASK',
                                      'THREAD',
                                      'USER',
                                    ])
                                    .describe(
                                      'Type of entity that can be referenced by entity properties.'
                                    ),
                                ])
                                .optional(),
                              updated_at: zod.iso.datetime({}),
                            })
                            .describe(
                              'Property definition model (service representation).'
                            ),
                          id: zod
                            .uuid()
                            .describe(
                              'Globally unique id of the assignment attaching this property to an entity.'
                            ),
                          value: zod
                            .union([
                              zod.null(),
                              zod
                                .union([
                                  zod
                                    .object({
                                      type: zod.enum(['Boolean']),
                                      value: zod
                                        .boolean()
                                        .describe(
                                          'Boolean value\nSerializes as: {\"type\": \"Boolean\", \"value\": true}'
                                        ),
                                    })
                                    .describe(
                                      'Boolean value\nSerializes as: {\"type\": \"Boolean\", \"value\": true}'
                                    ),
                                  zod
                                    .object({
                                      type: zod.enum(['Number']),
                                      value: zod
                                        .number()
                                        .describe(
                                          'Numeric value\nSerializes as: {\"type\": \"Number\", \"value\": 42.5}'
                                        ),
                                    })
                                    .describe(
                                      'Numeric value\nSerializes as: {\"type\": \"Number\", \"value\": 42.5}'
                                    ),
                                  zod
                                    .object({
                                      type: zod.enum(['String']),
                                      value: zod
                                        .string()
                                        .describe(
                                          'String value\nSerializes as: {\"type\": \"String\", \"value\": \"text\"}'
                                        ),
                                    })
                                    .describe(
                                      'String value\nSerializes as: {\"type\": \"String\", \"value\": \"text\"}'
                                    ),
                                  zod
                                    .object({
                                      type: zod.enum(['Date']),
                                      value: zod.iso
                                        .datetime({})
                                        .describe(
                                          'Date\/timestamp value\nSerializes as: {\"type\": \"Date\", \"value\": \"2025-01-01T00:00:00Z\"}'
                                        ),
                                    })
                                    .describe(
                                      'Date\/timestamp value\nSerializes as: {\"type\": \"Date\", \"value\": \"2025-01-01T00:00:00Z\"}'
                                    ),
                                  zod
                                    .object({
                                      type: zod.enum(['SelectOption']),
                                      value: zod
                                        .array(zod.uuid())
                                        .describe(
                                          'Select option(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"SelectOption\", \"value\": [\"uuid\"]} (length 0 or 1)\nMulti-select: {\"type\": \"SelectOption\", \"value\": [\"uuid1\", \"uuid2\", ...]} (length 0+)'
                                        ),
                                    })
                                    .describe(
                                      'Select option(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"SelectOption\", \"value\": [\"uuid\"]} (length 0 or 1)\nMulti-select: {\"type\": \"SelectOption\", \"value\": [\"uuid1\", \"uuid2\", ...]} (length 0+)'
                                    ),
                                  zod
                                    .object({
                                      type: zod.enum(['EntityReference']),
                                      value: zod
                                        .array(
                                          zod
                                            .object({
                                              entity_id: zod.string(),
                                              entity_type: zod
                                                .enum([
                                                  'CALENDAR_EVENT',
                                                  'CALL_RECORD',
                                                  'CHANNEL',
                                                  'CHAT',
                                                  'COMPANY',
                                                  'DOCUMENT',
                                                  'PROJECT',
                                                  'TASK',
                                                  'THREAD',
                                                  'USER',
                                                ])
                                                .describe(
                                                  'Type of entity that can be referenced by entity properties.'
                                                ),
                                              specific_message_id: zod
                                                .uuid()
                                                .nullish()
                                                .describe(
                                                  'For CHANNEL, CHAT, THREAD entity types - optional specific message ID.\nThis allows referencing a specific message within a thread\/channel\/chat.'
                                                ),
                                            })
                                            .describe(
                                              'Entity reference for entity-type property values.'
                                            )
                                        )
                                        .describe(
                                          'Entity reference(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"EntityReference\", \"value\": [{...}]} (length 0 or 1)\nMulti-select: {\"type\": \"EntityReference\", \"value\": [{...}, {...}, ...]} (length 0+)'
                                        ),
                                    })
                                    .describe(
                                      'Entity reference(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"EntityReference\", \"value\": [{...}]} (length 0 or 1)\nMulti-select: {\"type\": \"EntityReference\", \"value\": [{...}, {...}, ...]} (length 0+)'
                                    ),
                                  zod
                                    .object({
                                      type: zod.enum(['Link']),
                                      value: zod
                                        .array(zod.string())
                                        .describe(
                                          'Link value(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"Link\", \"value\": [\"https:\/\/example.com\"]} (length 0 or 1)\nMulti-select: {\"type\": \"Link\", \"value\": [\"https:\/\/example.com\", \"https:\/\/other.com\"]} (length 0+)'
                                        ),
                                    })
                                    .describe(
                                      'Link value(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"Link\", \"value\": [\"https:\/\/example.com\"]} (length 0 or 1)\nMulti-select: {\"type\": \"Link\", \"value\": [\"https:\/\/example.com\", \"https:\/\/other.com\"]} (length 0+)'
                                    ),
                                ])
                                .describe(
                                  'Property value (service representation).\n\nRepresents the actual value stored for an entity property.\nThis is serialized to\/from JSONB in the database.'
                                ),
                            ])
                            .optional(),
                        })
                        .describe(
                          'A property attached to a Soup item.\n\nThis is a simplified representation that includes only the definition and value,\nomitting the entity property assignment metadata and options.'
                        )
                    )
                    .describe('Properties attached to the entity.'),
                })
                .describe(
                  'Property fields that can be flattened into property-bearing Soup items.'
                )
                .and(
                  zod.object({
                    createdAt: zod.iso
                      .datetime({})
                      .describe('The time the chat was created'),
                    deletedAt: zod.iso
                      .datetime({})
                      .nullish()
                      .describe('The time the chat was deleted'),
                    id: zod.uuid().describe('The chat uuid'),
                    isPersistent: zod
                      .boolean()
                      .describe('Whether the chat is persistent or not'),
                    name: zod.string().describe('The name of the chat'),
                    ownerId: zod.string().describe('Who the chat belongs to'),
                    projectId: zod
                      .uuid()
                      .nullish()
                      .describe('The project id of the chat'),
                    updatedAt: zod.iso
                      .datetime({})
                      .describe('The time the chat was last updated'),
                    viewedAt: zod.iso
                      .datetime({})
                      .nullish()
                      .describe('The time the chat was last viewed'),
                  })
                )
                .describe('A chat as displayed in Soup.'),
              tag: zod.enum(['chat']),
            })
            .describe('Chat item.'),
          zod
            .object({
              data: zod
                .object({
                  properties: zod
                    .array(
                      zod
                        .object({
                          definition: zod
                            .object({
                              created_at: zod.iso.datetime({}),
                              data_type: zod
                                .enum([
                                  'BOOLEAN',
                                  'DATE',
                                  'NUMBER',
                                  'STRING',
                                  'SELECT_NUMBER',
                                  'SELECT_STRING',
                                  'TAG',
                                  'ENTITY',
                                  'LINK',
                                ])
                                .describe(
                                  'Data type for property values, determining storage and validation.'
                                ),
                              display_name: zod.string(),
                              id: zod.uuid(),
                              is_metadata: zod
                                .boolean()
                                .describe(
                                  'Flag to indicate if this is a system-generated metadata property.\nNot stored in database - computed at service layer.'
                                ),
                              is_multi_select: zod.boolean(),
                              is_system: zod
                                .boolean()
                                .describe(
                                  'Flag to indicate if this is a system property (stored in DB).'
                                ),
                              owner: zod
                                .union([
                                  zod
                                    .object({
                                      scope: zod.enum(['user']),
                                      user_id: zod.string(),
                                    })
                                    .describe('User-scoped property.'),
                                  zod
                                    .object({
                                      scope: zod.enum(['team']),
                                      team_id: zod.uuid(),
                                    })
                                    .describe('Team-scoped property.'),
                                  zod
                                    .object({
                                      scope: zod.enum(['system']),
                                    })
                                    .describe(
                                      'System-owned property (no user or team owner).'
                                    ),
                                ])
                                .describe(
                                  'Defines who owns a property - user-scoped, team-scoped, or system.'
                                ),
                              specific_entity_type: zod
                                .union([
                                  zod.null(),
                                  zod
                                    .enum([
                                      'CALENDAR_EVENT',
                                      'CALL_RECORD',
                                      'CHANNEL',
                                      'CHAT',
                                      'COMPANY',
                                      'DOCUMENT',
                                      'PROJECT',
                                      'TASK',
                                      'THREAD',
                                      'USER',
                                    ])
                                    .describe(
                                      'Type of entity that can be referenced by entity properties.'
                                    ),
                                ])
                                .optional(),
                              updated_at: zod.iso.datetime({}),
                            })
                            .describe(
                              'Property definition model (service representation).'
                            ),
                          id: zod
                            .uuid()
                            .describe(
                              'Globally unique id of the assignment attaching this property to an entity.'
                            ),
                          value: zod
                            .union([
                              zod.null(),
                              zod
                                .union([
                                  zod
                                    .object({
                                      type: zod.enum(['Boolean']),
                                      value: zod
                                        .boolean()
                                        .describe(
                                          'Boolean value\nSerializes as: {\"type\": \"Boolean\", \"value\": true}'
                                        ),
                                    })
                                    .describe(
                                      'Boolean value\nSerializes as: {\"type\": \"Boolean\", \"value\": true}'
                                    ),
                                  zod
                                    .object({
                                      type: zod.enum(['Number']),
                                      value: zod
                                        .number()
                                        .describe(
                                          'Numeric value\nSerializes as: {\"type\": \"Number\", \"value\": 42.5}'
                                        ),
                                    })
                                    .describe(
                                      'Numeric value\nSerializes as: {\"type\": \"Number\", \"value\": 42.5}'
                                    ),
                                  zod
                                    .object({
                                      type: zod.enum(['String']),
                                      value: zod
                                        .string()
                                        .describe(
                                          'String value\nSerializes as: {\"type\": \"String\", \"value\": \"text\"}'
                                        ),
                                    })
                                    .describe(
                                      'String value\nSerializes as: {\"type\": \"String\", \"value\": \"text\"}'
                                    ),
                                  zod
                                    .object({
                                      type: zod.enum(['Date']),
                                      value: zod.iso
                                        .datetime({})
                                        .describe(
                                          'Date\/timestamp value\nSerializes as: {\"type\": \"Date\", \"value\": \"2025-01-01T00:00:00Z\"}'
                                        ),
                                    })
                                    .describe(
                                      'Date\/timestamp value\nSerializes as: {\"type\": \"Date\", \"value\": \"2025-01-01T00:00:00Z\"}'
                                    ),
                                  zod
                                    .object({
                                      type: zod.enum(['SelectOption']),
                                      value: zod
                                        .array(zod.uuid())
                                        .describe(
                                          'Select option(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"SelectOption\", \"value\": [\"uuid\"]} (length 0 or 1)\nMulti-select: {\"type\": \"SelectOption\", \"value\": [\"uuid1\", \"uuid2\", ...]} (length 0+)'
                                        ),
                                    })
                                    .describe(
                                      'Select option(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"SelectOption\", \"value\": [\"uuid\"]} (length 0 or 1)\nMulti-select: {\"type\": \"SelectOption\", \"value\": [\"uuid1\", \"uuid2\", ...]} (length 0+)'
                                    ),
                                  zod
                                    .object({
                                      type: zod.enum(['EntityReference']),
                                      value: zod
                                        .array(
                                          zod
                                            .object({
                                              entity_id: zod.string(),
                                              entity_type: zod
                                                .enum([
                                                  'CALENDAR_EVENT',
                                                  'CALL_RECORD',
                                                  'CHANNEL',
                                                  'CHAT',
                                                  'COMPANY',
                                                  'DOCUMENT',
                                                  'PROJECT',
                                                  'TASK',
                                                  'THREAD',
                                                  'USER',
                                                ])
                                                .describe(
                                                  'Type of entity that can be referenced by entity properties.'
                                                ),
                                              specific_message_id: zod
                                                .uuid()
                                                .nullish()
                                                .describe(
                                                  'For CHANNEL, CHAT, THREAD entity types - optional specific message ID.\nThis allows referencing a specific message within a thread\/channel\/chat.'
                                                ),
                                            })
                                            .describe(
                                              'Entity reference for entity-type property values.'
                                            )
                                        )
                                        .describe(
                                          'Entity reference(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"EntityReference\", \"value\": [{...}]} (length 0 or 1)\nMulti-select: {\"type\": \"EntityReference\", \"value\": [{...}, {...}, ...]} (length 0+)'
                                        ),
                                    })
                                    .describe(
                                      'Entity reference(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"EntityReference\", \"value\": [{...}]} (length 0 or 1)\nMulti-select: {\"type\": \"EntityReference\", \"value\": [{...}, {...}, ...]} (length 0+)'
                                    ),
                                  zod
                                    .object({
                                      type: zod.enum(['Link']),
                                      value: zod
                                        .array(zod.string())
                                        .describe(
                                          'Link value(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"Link\", \"value\": [\"https:\/\/example.com\"]} (length 0 or 1)\nMulti-select: {\"type\": \"Link\", \"value\": [\"https:\/\/example.com\", \"https:\/\/other.com\"]} (length 0+)'
                                        ),
                                    })
                                    .describe(
                                      'Link value(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"Link\", \"value\": [\"https:\/\/example.com\"]} (length 0 or 1)\nMulti-select: {\"type\": \"Link\", \"value\": [\"https:\/\/example.com\", \"https:\/\/other.com\"]} (length 0+)'
                                    ),
                                ])
                                .describe(
                                  'Property value (service representation).\n\nRepresents the actual value stored for an entity property.\nThis is serialized to\/from JSONB in the database.'
                                ),
                            ])
                            .optional(),
                        })
                        .describe(
                          'A property attached to a Soup item.\n\nThis is a simplified representation that includes only the definition and value,\nomitting the entity property assignment metadata and options.'
                        )
                    )
                    .describe('Properties attached to the entity.'),
                })
                .describe(
                  'Property fields that can be flattened into property-bearing Soup items.'
                )
                .and(
                  zod.object({
                    createdAt: zod.iso
                      .datetime({})
                      .describe('The time the project was created'),
                    deletedAt: zod.iso
                      .datetime({})
                      .nullish()
                      .describe('The time the project was deleted'),
                    id: zod.uuid().describe('The id of the project'),
                    name: zod.string().describe('The name of the project'),
                    ownerId: zod
                      .string()
                      .describe('The user id of who created the project'),
                    parentId: zod
                      .uuid()
                      .nullish()
                      .describe('The parent project id'),
                    updatedAt: zod.iso
                      .datetime({})
                      .describe('The time the project was updated'),
                    viewedAt: zod.iso
                      .datetime({})
                      .nullish()
                      .describe('The time the document was last viewed'),
                  })
                )
                .describe('A project as displayed in Soup.'),
              tag: zod.enum(['project']),
            })
            .describe('Project item.'),
          zod
            .object({
              data: zod
                .object({
                  createdAt: zod.iso
                    .datetime({})
                    .describe('Timestamp when the thread was created.'),
                  id: zod.uuid().describe('Thread id.'),
                  inboxVisible: zod
                    .boolean()
                    .describe('Whether the thread should appear in the inbox.'),
                  isDraft: zod
                    .boolean()
                    .describe('Whether the thread contains a draft.'),
                  isImportant: zod
                    .boolean()
                    .describe('Whether the thread is marked important.'),
                  isRead: zod
                    .boolean()
                    .describe('Whether the thread has been read.'),
                  name: zod
                    .string()
                    .nullish()
                    .describe('Thread display name or subject.'),
                  ownerId: zod.string().describe('Owner user id.'),
                  projectId: zod
                    .string()
                    .nullish()
                    .describe('Project id associated with the thread.'),
                  providerId: zod
                    .string()
                    .nullish()
                    .describe('Provider-specific thread id.'),
                  senderEmail: zod
                    .string()
                    .nullish()
                    .describe('Sender email address for the preview.'),
                  senderName: zod
                    .string()
                    .nullish()
                    .describe('Sender display name for the preview.'),
                  senderPhotoUrl: zod
                    .string()
                    .nullish()
                    .describe('Sender photo URL for the preview.'),
                  snippet: zod.string().nullish().describe('Thread snippet.'),
                  sortTs: zod.iso
                    .datetime({})
                    .describe('Timestamp used for email thread sorting.'),
                  updatedAt: zod.iso
                    .datetime({})
                    .describe('Timestamp when the thread was last updated.'),
                  viewedAt: zod.iso
                    .datetime({})
                    .nullish()
                    .describe(
                      'Timestamp when the requesting user last viewed the thread.'
                    ),
                })
                .describe('Email thread preview data as displayed in Soup.')
                .and(
                  zod
                    .object({
                      properties: zod
                        .array(
                          zod
                            .object({
                              definition: zod
                                .object({
                                  created_at: zod.iso.datetime({}),
                                  data_type: zod
                                    .enum([
                                      'BOOLEAN',
                                      'DATE',
                                      'NUMBER',
                                      'STRING',
                                      'SELECT_NUMBER',
                                      'SELECT_STRING',
                                      'TAG',
                                      'ENTITY',
                                      'LINK',
                                    ])
                                    .describe(
                                      'Data type for property values, determining storage and validation.'
                                    ),
                                  display_name: zod.string(),
                                  id: zod.uuid(),
                                  is_metadata: zod
                                    .boolean()
                                    .describe(
                                      'Flag to indicate if this is a system-generated metadata property.\nNot stored in database - computed at service layer.'
                                    ),
                                  is_multi_select: zod.boolean(),
                                  is_system: zod
                                    .boolean()
                                    .describe(
                                      'Flag to indicate if this is a system property (stored in DB).'
                                    ),
                                  owner: zod
                                    .union([
                                      zod
                                        .object({
                                          scope: zod.enum(['user']),
                                          user_id: zod.string(),
                                        })
                                        .describe('User-scoped property.'),
                                      zod
                                        .object({
                                          scope: zod.enum(['team']),
                                          team_id: zod.uuid(),
                                        })
                                        .describe('Team-scoped property.'),
                                      zod
                                        .object({
                                          scope: zod.enum(['system']),
                                        })
                                        .describe(
                                          'System-owned property (no user or team owner).'
                                        ),
                                    ])
                                    .describe(
                                      'Defines who owns a property - user-scoped, team-scoped, or system.'
                                    ),
                                  specific_entity_type: zod
                                    .union([
                                      zod.null(),
                                      zod
                                        .enum([
                                          'CALENDAR_EVENT',
                                          'CALL_RECORD',
                                          'CHANNEL',
                                          'CHAT',
                                          'COMPANY',
                                          'DOCUMENT',
                                          'PROJECT',
                                          'TASK',
                                          'THREAD',
                                          'USER',
                                        ])
                                        .describe(
                                          'Type of entity that can be referenced by entity properties.'
                                        ),
                                    ])
                                    .optional(),
                                  updated_at: zod.iso.datetime({}),
                                })
                                .describe(
                                  'Property definition model (service representation).'
                                ),
                              id: zod
                                .uuid()
                                .describe(
                                  'Globally unique id of the assignment attaching this property to an entity.'
                                ),
                              value: zod
                                .union([
                                  zod.null(),
                                  zod
                                    .union([
                                      zod
                                        .object({
                                          type: zod.enum(['Boolean']),
                                          value: zod
                                            .boolean()
                                            .describe(
                                              'Boolean value\nSerializes as: {\"type\": \"Boolean\", \"value\": true}'
                                            ),
                                        })
                                        .describe(
                                          'Boolean value\nSerializes as: {\"type\": \"Boolean\", \"value\": true}'
                                        ),
                                      zod
                                        .object({
                                          type: zod.enum(['Number']),
                                          value: zod
                                            .number()
                                            .describe(
                                              'Numeric value\nSerializes as: {\"type\": \"Number\", \"value\": 42.5}'
                                            ),
                                        })
                                        .describe(
                                          'Numeric value\nSerializes as: {\"type\": \"Number\", \"value\": 42.5}'
                                        ),
                                      zod
                                        .object({
                                          type: zod.enum(['String']),
                                          value: zod
                                            .string()
                                            .describe(
                                              'String value\nSerializes as: {\"type\": \"String\", \"value\": \"text\"}'
                                            ),
                                        })
                                        .describe(
                                          'String value\nSerializes as: {\"type\": \"String\", \"value\": \"text\"}'
                                        ),
                                      zod
                                        .object({
                                          type: zod.enum(['Date']),
                                          value: zod.iso
                                            .datetime({})
                                            .describe(
                                              'Date\/timestamp value\nSerializes as: {\"type\": \"Date\", \"value\": \"2025-01-01T00:00:00Z\"}'
                                            ),
                                        })
                                        .describe(
                                          'Date\/timestamp value\nSerializes as: {\"type\": \"Date\", \"value\": \"2025-01-01T00:00:00Z\"}'
                                        ),
                                      zod
                                        .object({
                                          type: zod.enum(['SelectOption']),
                                          value: zod
                                            .array(zod.uuid())
                                            .describe(
                                              'Select option(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"SelectOption\", \"value\": [\"uuid\"]} (length 0 or 1)\nMulti-select: {\"type\": \"SelectOption\", \"value\": [\"uuid1\", \"uuid2\", ...]} (length 0+)'
                                            ),
                                        })
                                        .describe(
                                          'Select option(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"SelectOption\", \"value\": [\"uuid\"]} (length 0 or 1)\nMulti-select: {\"type\": \"SelectOption\", \"value\": [\"uuid1\", \"uuid2\", ...]} (length 0+)'
                                        ),
                                      zod
                                        .object({
                                          type: zod.enum(['EntityReference']),
                                          value: zod
                                            .array(
                                              zod
                                                .object({
                                                  entity_id: zod.string(),
                                                  entity_type: zod
                                                    .enum([
                                                      'CALENDAR_EVENT',
                                                      'CALL_RECORD',
                                                      'CHANNEL',
                                                      'CHAT',
                                                      'COMPANY',
                                                      'DOCUMENT',
                                                      'PROJECT',
                                                      'TASK',
                                                      'THREAD',
                                                      'USER',
                                                    ])
                                                    .describe(
                                                      'Type of entity that can be referenced by entity properties.'
                                                    ),
                                                  specific_message_id: zod
                                                    .uuid()
                                                    .nullish()
                                                    .describe(
                                                      'For CHANNEL, CHAT, THREAD entity types - optional specific message ID.\nThis allows referencing a specific message within a thread\/channel\/chat.'
                                                    ),
                                                })
                                                .describe(
                                                  'Entity reference for entity-type property values.'
                                                )
                                            )
                                            .describe(
                                              'Entity reference(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"EntityReference\", \"value\": [{...}]} (length 0 or 1)\nMulti-select: {\"type\": \"EntityReference\", \"value\": [{...}, {...}, ...]} (length 0+)'
                                            ),
                                        })
                                        .describe(
                                          'Entity reference(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"EntityReference\", \"value\": [{...}]} (length 0 or 1)\nMulti-select: {\"type\": \"EntityReference\", \"value\": [{...}, {...}, ...]} (length 0+)'
                                        ),
                                      zod
                                        .object({
                                          type: zod.enum(['Link']),
                                          value: zod
                                            .array(zod.string())
                                            .describe(
                                              'Link value(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"Link\", \"value\": [\"https:\/\/example.com\"]} (length 0 or 1)\nMulti-select: {\"type\": \"Link\", \"value\": [\"https:\/\/example.com\", \"https:\/\/other.com\"]} (length 0+)'
                                            ),
                                        })
                                        .describe(
                                          'Link value(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"Link\", \"value\": [\"https:\/\/example.com\"]} (length 0 or 1)\nMulti-select: {\"type\": \"Link\", \"value\": [\"https:\/\/example.com\", \"https:\/\/other.com\"]} (length 0+)'
                                        ),
                                    ])
                                    .describe(
                                      'Property value (service representation).\n\nRepresents the actual value stored for an entity property.\nThis is serialized to\/from JSONB in the database.'
                                    ),
                                ])
                                .optional(),
                            })
                            .describe(
                              'A property attached to a Soup item.\n\nThis is a simplified representation that includes only the definition and value,\nomitting the entity property assignment metadata and options.'
                            )
                        )
                        .describe('Properties attached to the entity.'),
                    })
                    .describe(
                      'Property fields that can be flattened into property-bearing Soup items.'
                    )
                )
                .and(
                  zod.object({
                    attachments: zod
                      .array(
                        zod
                          .object({
                            contentId: zod
                              .string()
                              .nullish()
                              .describe('Content id for inline attachments.'),
                            createdAt: zod.iso
                              .datetime({})
                              .describe(
                                'Timestamp when the attachment was created.'
                              ),
                            filename: zod
                              .string()
                              .nullish()
                              .describe('Attachment filename.'),
                            id: zod.uuid().describe('Attachment id.'),
                            messageId: zod
                              .uuid()
                              .describe(
                                'Message id that owns this attachment.'
                              ),
                            mimeType: zod
                              .string()
                              .nullish()
                              .describe('Attachment MIME type.'),
                            providerAttachmentId: zod
                              .string()
                              .nullish()
                              .describe('Provider-specific attachment id.'),
                            sizeBytes: zod
                              .number()
                              .nullish()
                              .describe('Attachment size in bytes.'),
                          })
                          .describe('An email attachment as displayed in Soup.')
                      )
                      .describe('Attachments on the thread.'),
                    labels: zod
                      .array(
                        zod
                          .object({
                            createdAt: zod.iso
                              .datetime({})
                              .describe(
                                'Timestamp when the label was created.'
                              ),
                            id: zod.uuid().describe('Label id.'),
                            labelListVisibility: zod
                              .enum([
                                'labelShow',
                                'labelShowIfUnread',
                                'labelHide',
                              ])
                              .describe('Gmail-style label list visibility.'),
                            linkId: zod
                              .uuid()
                              .describe(
                                'Connected account link id for the label.'
                              ),
                            messageListVisibility: zod
                              .enum(['show', 'hide'])
                              .describe(
                                'Gmail-style message list visibility for a label.'
                              ),
                            name: zod.string().describe('Label display name.'),
                            providerLabelId: zod
                              .string()
                              .describe('Provider-specific label id.'),
                            type: zod
                              .enum(['system', 'user'])
                              .describe(
                                'Whether an email label is provider-created or user-created.'
                              ),
                          })
                          .describe('An email label as displayed in Soup.')
                      )
                      .describe('Labels attached to the thread.'),
                    participants: zod
                      .array(
                        zod
                          .object({
                            emailAddress: zod
                              .string()
                              .nullish()
                              .describe('Contact email address.'),
                            id: zod.uuid().describe('Contact id.'),
                            linkId: zod
                              .uuid()
                              .describe(
                                'Connected account link id for the contact.'
                              ),
                            name: zod
                              .string()
                              .nullish()
                              .describe('Contact display name.'),
                            sfsPhotoUrl: zod
                              .string()
                              .nullish()
                              .describe(
                                'Contact photo URL from SFS, if available.'
                              ),
                          })
                          .describe(
                            'A contact participating in an email thread as displayed in Soup.'
                          )
                      )
                      .describe('Contacts participating in the thread.'),
                  })
                )
                .describe(
                  'Email thread preview enriched with related metadata for Soup.'
                ),
              tag: zod.enum(['emailThread']),
            })
            .describe('Email thread item.'),
          zod
            .object({
              data: zod
                .object({
                  channel: zod
                    .object({
                      channel_type: zod
                        .enum(['public', 'private', 'direct_message', 'team'])
                        .describe('Type of channel.'),
                      created_at: zod.iso
                        .datetime({})
                        .describe('Creation timestamp.'),
                      id: zod.uuid().describe('Channel id.'),
                      name: zod
                        .string()
                        .nullish()
                        .describe('Channel display name.'),
                      org_id: zod
                        .number()
                        .min(postItemsSoupResponseItemsItemDataChannelOrgIdMin)
                        .nullish()
                        .describe('Organization id.'),
                      owner_id: zod.string().describe('Channel owner.'),
                      team_id: zod.uuid().nullish().describe('Team id.'),
                      updated_at: zod.iso
                        .datetime({})
                        .describe('Update timestamp.'),
                    })
                    .describe('Channel metadata in soup payloads.'),
                  is_participant: zod
                    .boolean()
                    .optional()
                    .describe(
                      "Whether the requesting user is an active participant of the channel.\nFalse for team channels of the user's teams they have not joined."
                    ),
                  participants: zod
                    .array(
                      zod
                        .object({
                          channel_id: zod
                            .uuid()
                            .describe(
                              'Channel id for the participant membership.'
                            ),
                          joined_at: zod.iso
                            .datetime({})
                            .describe(
                              'Timestamp when the participant joined the channel.'
                            ),
                          left_at: zod.iso
                            .datetime({})
                            .nullish()
                            .describe(
                              'Timestamp when the participant left the channel, if any.'
                            ),
                          role: zod
                            .enum(['owner', 'admin', 'member'])
                            .describe('The role a user has within a channel.'),
                          user_id: zod
                            .string()
                            .describe('Participant user id.'),
                        })
                        .describe("A user's membership in a channel.")
                    )
                    .describe('Participants in the channel.'),
                })
                .describe('Channel metadata together with its participants.')
                .and(
                  zod
                    .object({
                      latest_message: zod
                        .union([
                          zod.null(),
                          zod
                            .object({
                              content: zod
                                .string()
                                .describe('Message content.'),
                              created_at: zod.iso
                                .datetime({})
                                .describe('Creation timestamp.'),
                              deleted_at: zod.iso
                                .datetime({})
                                .nullish()
                                .describe('Deletion timestamp.'),
                              mentions: zod
                                .array(zod.string())
                                .describe(
                                  'Message mentions formatted as `{ENTITY_TYPE}:{ENTITY_ID}`.'
                                ),
                              message_id: zod.uuid().describe('Message id.'),
                              sender_id: zod.string().describe('Sender id.'),
                              thread_id: zod
                                .uuid()
                                .nullish()
                                .describe('Thread parent id.'),
                              updated_at: zod.iso
                                .datetime({})
                                .describe('Update timestamp.'),
                            })
                            .describe(
                              'Lightweight channel message for soup payloads.'
                            ),
                        ])
                        .optional(),
                      latest_non_thread_message: zod
                        .union([
                          zod.null(),
                          zod
                            .object({
                              content: zod
                                .string()
                                .describe('Message content.'),
                              created_at: zod.iso
                                .datetime({})
                                .describe('Creation timestamp.'),
                              deleted_at: zod.iso
                                .datetime({})
                                .nullish()
                                .describe('Deletion timestamp.'),
                              mentions: zod
                                .array(zod.string())
                                .describe(
                                  'Message mentions formatted as `{ENTITY_TYPE}:{ENTITY_ID}`.'
                                ),
                              message_id: zod.uuid().describe('Message id.'),
                              sender_id: zod.string().describe('Sender id.'),
                              thread_id: zod
                                .uuid()
                                .nullish()
                                .describe('Thread parent id.'),
                              updated_at: zod.iso
                                .datetime({})
                                .describe('Update timestamp.'),
                            })
                            .describe(
                              'Lightweight channel message for soup payloads.'
                            ),
                        ])
                        .optional(),
                    })
                    .describe('Latest-message bundle for soup payloads.')
                )
                .and(
                  zod.object({
                    interacted_at: zod.iso
                      .datetime({})
                      .nullish()
                      .describe(
                        'Timestamp when the requesting user last interacted with this channel.'
                      ),
                    viewed_at: zod.iso
                      .datetime({})
                      .nullish()
                      .describe(
                        'Timestamp when the requesting user last viewed this channel.'
                      ),
                  })
                )
                .describe('A channel as displayed in Soup.'),
              tag: zod.enum(['channel']),
            })
            .describe('Channel item.'),
          zod
            .object({
              data: zod
                .object({
                  attachments: zod
                    .array(
                      zod
                        .object({
                          created_at: zod.iso
                            .datetime({})
                            .describe('Creation timestamp.'),
                          entity_id: zod.string().describe('Entity id.'),
                          entity_type: zod.string().describe('Type of entity.'),
                          height: zod
                            .number()
                            .nullish()
                            .describe('Height for images.'),
                          id: zod.uuid().describe('Attachment id.'),
                          width: zod
                            .number()
                            .nullish()
                            .describe('Width for images.'),
                        })
                        .describe('An attachment on a message.')
                    )
                    .describe('Attachments on this message.'),
                  channel_id: zod.uuid().describe('Channel id.'),
                  content: zod.string().describe('Message content.'),
                  created_at: zod.iso
                    .datetime({})
                    .describe('Creation timestamp.'),
                  deleted_at: zod.iso
                    .datetime({})
                    .nullish()
                    .describe('Deletion timestamp.'),
                  edited_at: zod.iso
                    .datetime({})
                    .nullish()
                    .describe('Edit timestamp.'),
                  id: zod.uuid().describe('Message id.'),
                  reactions: zod
                    .array(
                      zod
                        .object({
                          emoji: zod.string().describe('Emoji string.'),
                          users: zod
                            .array(zod.string())
                            .describe('User ids who added this reaction.'),
                        })
                        .describe('A reaction with emoji and user list.')
                    )
                    .describe('Reactions on this message.'),
                  sender: zod
                    .object({
                      avatar_url: zod
                        .string()
                        .nullish()
                        .describe('Avatar URL for bot senders.'),
                      id: zod
                        .string()
                        .describe(
                          'Sender id without the storage namespace prefix.'
                        ),
                      name: zod
                        .string()
                        .nullish()
                        .describe('Display name for bot senders.'),
                      type: zod
                        .enum(['user', 'bot'])
                        .describe(
                          'Public sender type for soup channel messages.'
                        ),
                    })
                    .describe(
                      'Public sender identity for soup channel messages.'
                    ),
                  sender_id: zod.string().describe('Sender id.'),
                  thread: zod
                    .object({
                      latest_reply_at: zod.iso
                        .datetime({})
                        .nullish()
                        .describe('Timestamp of the latest reply.'),
                      preview: zod
                        .array(
                          zod
                            .object({
                              attachments: zod
                                .array(
                                  zod
                                    .object({
                                      created_at: zod.iso
                                        .datetime({})
                                        .describe('Creation timestamp.'),
                                      entity_id: zod
                                        .string()
                                        .describe('Entity id.'),
                                      entity_type: zod
                                        .string()
                                        .describe('Type of entity.'),
                                      height: zod
                                        .number()
                                        .nullish()
                                        .describe('Height for images.'),
                                      id: zod.uuid().describe('Attachment id.'),
                                      width: zod
                                        .number()
                                        .nullish()
                                        .describe('Width for images.'),
                                    })
                                    .describe('An attachment on a message.')
                                )
                                .describe('Attachments on this reply.'),
                              content: zod.string().describe('Reply content.'),
                              created_at: zod.iso
                                .datetime({})
                                .describe('Creation timestamp.'),
                              edited_at: zod.iso
                                .datetime({})
                                .nullish()
                                .describe('Edit timestamp.'),
                              id: zod.uuid().describe('Reply id.'),
                              reactions: zod
                                .array(
                                  zod
                                    .object({
                                      emoji: zod
                                        .string()
                                        .describe('Emoji string.'),
                                      users: zod
                                        .array(zod.string())
                                        .describe(
                                          'User ids who added this reaction.'
                                        ),
                                    })
                                    .describe(
                                      'A reaction with emoji and user list.'
                                    )
                                )
                                .describe('Reactions on this reply.'),
                              sender: zod
                                .object({
                                  avatar_url: zod
                                    .string()
                                    .nullish()
                                    .describe('Avatar URL for bot senders.'),
                                  id: zod
                                    .string()
                                    .describe(
                                      'Sender id without the storage namespace prefix.'
                                    ),
                                  name: zod
                                    .string()
                                    .nullish()
                                    .describe('Display name for bot senders.'),
                                  type: zod
                                    .enum(['user', 'bot'])
                                    .describe(
                                      'Public sender type for soup channel messages.'
                                    ),
                                })
                                .describe(
                                  'Public sender identity for soup channel messages.'
                                ),
                              sender_id: zod.string().describe('Sender id.'),
                              updated_at: zod.iso
                                .datetime({})
                                .describe('Update timestamp.'),
                            })
                            .describe('A thread reply shown in preview.')
                        )
                        .describe('Preview replies.'),
                      reply_count: zod.number().describe('Total reply count.'),
                    })
                    .describe(
                      'Thread metadata and preview replies for soup channel messages.'
                    ),
                  updated_at: zod.iso
                    .datetime({})
                    .describe('Update timestamp.'),
                })
                .describe(
                  'A top-level channel message thread for soup payloads.\n\nThis mirrors the public channel-message API shape so soup consumers can\nrender a thread root the same way they render a channel timeline message.'
                ),
              tag: zod.enum(['channelThread']),
            })
            .describe('Channel thread item.'),
          zod
            .object({
              data: zod
                .object({
                  properties: zod
                    .array(
                      zod
                        .object({
                          definition: zod
                            .object({
                              created_at: zod.iso.datetime({}),
                              data_type: zod
                                .enum([
                                  'BOOLEAN',
                                  'DATE',
                                  'NUMBER',
                                  'STRING',
                                  'SELECT_NUMBER',
                                  'SELECT_STRING',
                                  'TAG',
                                  'ENTITY',
                                  'LINK',
                                ])
                                .describe(
                                  'Data type for property values, determining storage and validation.'
                                ),
                              display_name: zod.string(),
                              id: zod.uuid(),
                              is_metadata: zod
                                .boolean()
                                .describe(
                                  'Flag to indicate if this is a system-generated metadata property.\nNot stored in database - computed at service layer.'
                                ),
                              is_multi_select: zod.boolean(),
                              is_system: zod
                                .boolean()
                                .describe(
                                  'Flag to indicate if this is a system property (stored in DB).'
                                ),
                              owner: zod
                                .union([
                                  zod
                                    .object({
                                      scope: zod.enum(['user']),
                                      user_id: zod.string(),
                                    })
                                    .describe('User-scoped property.'),
                                  zod
                                    .object({
                                      scope: zod.enum(['team']),
                                      team_id: zod.uuid(),
                                    })
                                    .describe('Team-scoped property.'),
                                  zod
                                    .object({
                                      scope: zod.enum(['system']),
                                    })
                                    .describe(
                                      'System-owned property (no user or team owner).'
                                    ),
                                ])
                                .describe(
                                  'Defines who owns a property - user-scoped, team-scoped, or system.'
                                ),
                              specific_entity_type: zod
                                .union([
                                  zod.null(),
                                  zod
                                    .enum([
                                      'CALENDAR_EVENT',
                                      'CALL_RECORD',
                                      'CHANNEL',
                                      'CHAT',
                                      'COMPANY',
                                      'DOCUMENT',
                                      'PROJECT',
                                      'TASK',
                                      'THREAD',
                                      'USER',
                                    ])
                                    .describe(
                                      'Type of entity that can be referenced by entity properties.'
                                    ),
                                ])
                                .optional(),
                              updated_at: zod.iso.datetime({}),
                            })
                            .describe(
                              'Property definition model (service representation).'
                            ),
                          id: zod
                            .uuid()
                            .describe(
                              'Globally unique id of the assignment attaching this property to an entity.'
                            ),
                          value: zod
                            .union([
                              zod.null(),
                              zod
                                .union([
                                  zod
                                    .object({
                                      type: zod.enum(['Boolean']),
                                      value: zod
                                        .boolean()
                                        .describe(
                                          'Boolean value\nSerializes as: {\"type\": \"Boolean\", \"value\": true}'
                                        ),
                                    })
                                    .describe(
                                      'Boolean value\nSerializes as: {\"type\": \"Boolean\", \"value\": true}'
                                    ),
                                  zod
                                    .object({
                                      type: zod.enum(['Number']),
                                      value: zod
                                        .number()
                                        .describe(
                                          'Numeric value\nSerializes as: {\"type\": \"Number\", \"value\": 42.5}'
                                        ),
                                    })
                                    .describe(
                                      'Numeric value\nSerializes as: {\"type\": \"Number\", \"value\": 42.5}'
                                    ),
                                  zod
                                    .object({
                                      type: zod.enum(['String']),
                                      value: zod
                                        .string()
                                        .describe(
                                          'String value\nSerializes as: {\"type\": \"String\", \"value\": \"text\"}'
                                        ),
                                    })
                                    .describe(
                                      'String value\nSerializes as: {\"type\": \"String\", \"value\": \"text\"}'
                                    ),
                                  zod
                                    .object({
                                      type: zod.enum(['Date']),
                                      value: zod.iso
                                        .datetime({})
                                        .describe(
                                          'Date\/timestamp value\nSerializes as: {\"type\": \"Date\", \"value\": \"2025-01-01T00:00:00Z\"}'
                                        ),
                                    })
                                    .describe(
                                      'Date\/timestamp value\nSerializes as: {\"type\": \"Date\", \"value\": \"2025-01-01T00:00:00Z\"}'
                                    ),
                                  zod
                                    .object({
                                      type: zod.enum(['SelectOption']),
                                      value: zod
                                        .array(zod.uuid())
                                        .describe(
                                          'Select option(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"SelectOption\", \"value\": [\"uuid\"]} (length 0 or 1)\nMulti-select: {\"type\": \"SelectOption\", \"value\": [\"uuid1\", \"uuid2\", ...]} (length 0+)'
                                        ),
                                    })
                                    .describe(
                                      'Select option(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"SelectOption\", \"value\": [\"uuid\"]} (length 0 or 1)\nMulti-select: {\"type\": \"SelectOption\", \"value\": [\"uuid1\", \"uuid2\", ...]} (length 0+)'
                                    ),
                                  zod
                                    .object({
                                      type: zod.enum(['EntityReference']),
                                      value: zod
                                        .array(
                                          zod
                                            .object({
                                              entity_id: zod.string(),
                                              entity_type: zod
                                                .enum([
                                                  'CALENDAR_EVENT',
                                                  'CALL_RECORD',
                                                  'CHANNEL',
                                                  'CHAT',
                                                  'COMPANY',
                                                  'DOCUMENT',
                                                  'PROJECT',
                                                  'TASK',
                                                  'THREAD',
                                                  'USER',
                                                ])
                                                .describe(
                                                  'Type of entity that can be referenced by entity properties.'
                                                ),
                                              specific_message_id: zod
                                                .uuid()
                                                .nullish()
                                                .describe(
                                                  'For CHANNEL, CHAT, THREAD entity types - optional specific message ID.\nThis allows referencing a specific message within a thread\/channel\/chat.'
                                                ),
                                            })
                                            .describe(
                                              'Entity reference for entity-type property values.'
                                            )
                                        )
                                        .describe(
                                          'Entity reference(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"EntityReference\", \"value\": [{...}]} (length 0 or 1)\nMulti-select: {\"type\": \"EntityReference\", \"value\": [{...}, {...}, ...]} (length 0+)'
                                        ),
                                    })
                                    .describe(
                                      'Entity reference(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"EntityReference\", \"value\": [{...}]} (length 0 or 1)\nMulti-select: {\"type\": \"EntityReference\", \"value\": [{...}, {...}, ...]} (length 0+)'
                                    ),
                                  zod
                                    .object({
                                      type: zod.enum(['Link']),
                                      value: zod
                                        .array(zod.string())
                                        .describe(
                                          'Link value(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"Link\", \"value\": [\"https:\/\/example.com\"]} (length 0 or 1)\nMulti-select: {\"type\": \"Link\", \"value\": [\"https:\/\/example.com\", \"https:\/\/other.com\"]} (length 0+)'
                                        ),
                                    })
                                    .describe(
                                      'Link value(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"Link\", \"value\": [\"https:\/\/example.com\"]} (length 0 or 1)\nMulti-select: {\"type\": \"Link\", \"value\": [\"https:\/\/example.com\", \"https:\/\/other.com\"]} (length 0+)'
                                    ),
                                ])
                                .describe(
                                  'Property value (service representation).\n\nRepresents the actual value stored for an entity property.\nThis is serialized to\/from JSONB in the database.'
                                ),
                            ])
                            .optional(),
                        })
                        .describe(
                          'A property attached to a Soup item.\n\nThis is a simplified representation that includes only the definition and value,\nomitting the entity property assignment metadata and options.'
                        )
                    )
                    .describe('Properties attached to the entity.'),
                })
                .describe(
                  'Property fields that can be flattened into property-bearing Soup items.'
                )
                .and(
                  zod.object({
                    attended: zod
                      .boolean()
                      .describe(
                        'Whether the requesting user attended this call. Kept for compatibility\nand derived from `status == ATTENDED`.'
                      ),
                    callId: zod.uuid().describe('The call identifier.'),
                    channelId: zod
                      .uuid()
                      .describe('The channel this call belongs to.'),
                    channelName: zod
                      .string()
                      .nullish()
                      .describe('Resolved display name for the channel.'),
                    createdBy: zod
                      .string()
                      .describe('User who created the call.'),
                    customName: zod
                      .string()
                      .nullish()
                      .describe(
                        'User-supplied or AI-generated display name for the call.'
                      ),
                    durationMs: zod
                      .number()
                      .nullish()
                      .describe(
                        'Call duration in milliseconds (None if still active).'
                      ),
                    endedAt: zod.iso
                      .datetime({})
                      .nullish()
                      .describe('When the call ended (None if still active).'),
                    isActive: zod
                      .boolean()
                      .describe('Whether the call is currently active.'),
                    participants: zod
                      .array(
                        zod
                          .object({
                            joinedAt: zod.iso
                              .datetime({})
                              .describe('When the user joined the call.'),
                            leftAt: zod.iso
                              .datetime({})
                              .nullish()
                              .describe(
                                'When the user left (None if still in an active call).'
                              ),
                            userId: zod.string().describe('The user id.'),
                          })
                          .describe(
                            'A participant in a call record, as displayed in Soup.'
                          )
                      )
                      .describe('Participants in the call.'),
                    startedAt: zod.iso
                      .datetime({})
                      .describe('When the call started.'),
                    status: zod
                      .enum(['ATTENDED', 'MISSED', 'UNATTENDED'])
                      .describe(
                        'Viewer-relative attendance status for a call record.\nSerializes as `ATTENDED`, `MISSED`, or `UNATTENDED`.'
                      ),
                    summary: zod
                      .string()
                      .nullish()
                      .describe(
                        'AI-generated summary of the call. Only set on archived\n`call_records` once summarization has run; active calls always\nreturn `None`.'
                      ),
                  })
                )
                .describe(
                  'A call record as displayed in Soup. Excludes room_name, egress_id,\nand transcript — fields that are irrelevant for the soup feed.'
                ),
              tag: zod.enum(['call']),
            })
            .describe('Call record item.'),
          zod
            .object({
              data: zod
                .object({
                  conferenceProvider: zod
                    .string()
                    .nullish()
                    .describe(
                      'Which conferencing system backs `conference_url`.'
                    ),
                  conferenceUrl: zod
                    .string()
                    .nullish()
                    .describe('Direct conference join URL.'),
                  createdAt: zod.iso
                    .datetime({})
                    .describe('Entity creation timestamp.'),
                  description: zod
                    .string()
                    .nullish()
                    .describe('Optional description.'),
                  extra: zod
                    .object({
                      properties: zod
                        .array(
                          zod
                            .object({
                              definition: zod
                                .object({
                                  created_at: zod.iso.datetime({}),
                                  data_type: zod
                                    .enum([
                                      'BOOLEAN',
                                      'DATE',
                                      'NUMBER',
                                      'STRING',
                                      'SELECT_NUMBER',
                                      'SELECT_STRING',
                                      'TAG',
                                      'ENTITY',
                                      'LINK',
                                    ])
                                    .describe(
                                      'Data type for property values, determining storage and validation.'
                                    ),
                                  display_name: zod.string(),
                                  id: zod.uuid(),
                                  is_metadata: zod
                                    .boolean()
                                    .describe(
                                      'Flag to indicate if this is a system-generated metadata property.\nNot stored in database - computed at service layer.'
                                    ),
                                  is_multi_select: zod.boolean(),
                                  is_system: zod
                                    .boolean()
                                    .describe(
                                      'Flag to indicate if this is a system property (stored in DB).'
                                    ),
                                  owner: zod
                                    .union([
                                      zod
                                        .object({
                                          scope: zod.enum(['user']),
                                          user_id: zod.string(),
                                        })
                                        .describe('User-scoped property.'),
                                      zod
                                        .object({
                                          scope: zod.enum(['team']),
                                          team_id: zod.uuid(),
                                        })
                                        .describe('Team-scoped property.'),
                                      zod
                                        .object({
                                          scope: zod.enum(['system']),
                                        })
                                        .describe(
                                          'System-owned property (no user or team owner).'
                                        ),
                                    ])
                                    .describe(
                                      'Defines who owns a property - user-scoped, team-scoped, or system.'
                                    ),
                                  specific_entity_type: zod
                                    .union([
                                      zod.null(),
                                      zod
                                        .enum([
                                          'CALENDAR_EVENT',
                                          'CALL_RECORD',
                                          'CHANNEL',
                                          'CHAT',
                                          'COMPANY',
                                          'DOCUMENT',
                                          'PROJECT',
                                          'TASK',
                                          'THREAD',
                                          'USER',
                                        ])
                                        .describe(
                                          'Type of entity that can be referenced by entity properties.'
                                        ),
                                    ])
                                    .optional(),
                                  updated_at: zod.iso.datetime({}),
                                })
                                .describe(
                                  'Property definition model (service representation).'
                                ),
                              id: zod
                                .uuid()
                                .describe(
                                  'Globally unique id of the assignment attaching this property to an entity.'
                                ),
                              value: zod
                                .union([
                                  zod.null(),
                                  zod
                                    .union([
                                      zod
                                        .object({
                                          type: zod.enum(['Boolean']),
                                          value: zod
                                            .boolean()
                                            .describe(
                                              'Boolean value\nSerializes as: {\"type\": \"Boolean\", \"value\": true}'
                                            ),
                                        })
                                        .describe(
                                          'Boolean value\nSerializes as: {\"type\": \"Boolean\", \"value\": true}'
                                        ),
                                      zod
                                        .object({
                                          type: zod.enum(['Number']),
                                          value: zod
                                            .number()
                                            .describe(
                                              'Numeric value\nSerializes as: {\"type\": \"Number\", \"value\": 42.5}'
                                            ),
                                        })
                                        .describe(
                                          'Numeric value\nSerializes as: {\"type\": \"Number\", \"value\": 42.5}'
                                        ),
                                      zod
                                        .object({
                                          type: zod.enum(['String']),
                                          value: zod
                                            .string()
                                            .describe(
                                              'String value\nSerializes as: {\"type\": \"String\", \"value\": \"text\"}'
                                            ),
                                        })
                                        .describe(
                                          'String value\nSerializes as: {\"type\": \"String\", \"value\": \"text\"}'
                                        ),
                                      zod
                                        .object({
                                          type: zod.enum(['Date']),
                                          value: zod.iso
                                            .datetime({})
                                            .describe(
                                              'Date\/timestamp value\nSerializes as: {\"type\": \"Date\", \"value\": \"2025-01-01T00:00:00Z\"}'
                                            ),
                                        })
                                        .describe(
                                          'Date\/timestamp value\nSerializes as: {\"type\": \"Date\", \"value\": \"2025-01-01T00:00:00Z\"}'
                                        ),
                                      zod
                                        .object({
                                          type: zod.enum(['SelectOption']),
                                          value: zod
                                            .array(zod.uuid())
                                            .describe(
                                              'Select option(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"SelectOption\", \"value\": [\"uuid\"]} (length 0 or 1)\nMulti-select: {\"type\": \"SelectOption\", \"value\": [\"uuid1\", \"uuid2\", ...]} (length 0+)'
                                            ),
                                        })
                                        .describe(
                                          'Select option(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"SelectOption\", \"value\": [\"uuid\"]} (length 0 or 1)\nMulti-select: {\"type\": \"SelectOption\", \"value\": [\"uuid1\", \"uuid2\", ...]} (length 0+)'
                                        ),
                                      zod
                                        .object({
                                          type: zod.enum(['EntityReference']),
                                          value: zod
                                            .array(
                                              zod
                                                .object({
                                                  entity_id: zod.string(),
                                                  entity_type: zod
                                                    .enum([
                                                      'CALENDAR_EVENT',
                                                      'CALL_RECORD',
                                                      'CHANNEL',
                                                      'CHAT',
                                                      'COMPANY',
                                                      'DOCUMENT',
                                                      'PROJECT',
                                                      'TASK',
                                                      'THREAD',
                                                      'USER',
                                                    ])
                                                    .describe(
                                                      'Type of entity that can be referenced by entity properties.'
                                                    ),
                                                  specific_message_id: zod
                                                    .uuid()
                                                    .nullish()
                                                    .describe(
                                                      'For CHANNEL, CHAT, THREAD entity types - optional specific message ID.\nThis allows referencing a specific message within a thread\/channel\/chat.'
                                                    ),
                                                })
                                                .describe(
                                                  'Entity reference for entity-type property values.'
                                                )
                                            )
                                            .describe(
                                              'Entity reference(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"EntityReference\", \"value\": [{...}]} (length 0 or 1)\nMulti-select: {\"type\": \"EntityReference\", \"value\": [{...}, {...}, ...]} (length 0+)'
                                            ),
                                        })
                                        .describe(
                                          'Entity reference(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"EntityReference\", \"value\": [{...}]} (length 0 or 1)\nMulti-select: {\"type\": \"EntityReference\", \"value\": [{...}, {...}, ...]} (length 0+)'
                                        ),
                                      zod
                                        .object({
                                          type: zod.enum(['Link']),
                                          value: zod
                                            .array(zod.string())
                                            .describe(
                                              'Link value(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"Link\", \"value\": [\"https:\/\/example.com\"]} (length 0 or 1)\nMulti-select: {\"type\": \"Link\", \"value\": [\"https:\/\/example.com\", \"https:\/\/other.com\"]} (length 0+)'
                                            ),
                                        })
                                        .describe(
                                          'Link value(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"Link\", \"value\": [\"https:\/\/example.com\"]} (length 0 or 1)\nMulti-select: {\"type\": \"Link\", \"value\": [\"https:\/\/example.com\", \"https:\/\/other.com\"]} (length 0+)'
                                        ),
                                    ])
                                    .describe(
                                      'Property value (service representation).\n\nRepresents the actual value stored for an entity property.\nThis is serialized to\/from JSONB in the database.'
                                    ),
                                ])
                                .optional(),
                            })
                            .describe(
                              'A property attached to a Soup item.\n\nThis is a simplified representation that includes only the definition and value,\nomitting the entity property assignment metadata and options.'
                            )
                        )
                        .describe('Properties attached to the entity.'),
                    })
                    .describe(
                      'Property fields that can be flattened into property-bearing Soup items.'
                    ),
                  icalUid: zod
                    .string()
                    .describe('RFC 5545 UID used for source reconciliation.'),
                  id: zod.uuid().describe('Entity identifier.'),
                  isReadOnly: zod
                    .boolean()
                    .describe(
                      'Whether the selected canonical source is read-only.'
                    ),
                  location: zod
                    .string()
                    .nullish()
                    .describe('Optional location label.'),
                  organizerEmail: zod
                    .string()
                    .nullish()
                    .describe('Organizer email.'),
                  organizerName: zod
                    .string()
                    .nullish()
                    .describe('Organizer display name.'),
                  ownerId: zod.string().describe('Owning Macro user.'),
                  status: zod.string().describe('Canonical status.'),
                  time: zod
                    .union([
                      zod
                        .object({
                          endsAt: zod.iso
                            .datetime({})
                            .describe('Exclusive end.'),
                          kind: zod.enum(['timed']),
                          startsAt: zod.iso
                            .datetime({})
                            .describe('Inclusive start.'),
                          timeZone: zod
                            .string()
                            .nullish()
                            .describe('Original IANA time zone.'),
                        })
                        .describe('Absolute timed event.'),
                      zod
                        .object({
                          endDate: zod.iso
                            .date()
                            .describe('Exclusive end date.'),
                          kind: zod.enum(['allDay']),
                          startDate: zod.iso
                            .date()
                            .describe('Inclusive start date.'),
                        })
                        .describe('All-day event with an exclusive end date.'),
                    ])
                    .describe(
                      'Timed or all-day calendar event span.\n\nFields are camelCased per variant rather than via `rename_all_fields`,\nwhich utoipa ignores — the generated OpenAPI schema would otherwise\nclaim snake_case fields the wire never carries.'
                    ),
                  title: zod.string().describe('Display title.'),
                  transparency: zod
                    .string()
                    .describe('Availability transparency.'),
                  updatedAt: zod.iso
                    .datetime({})
                    .describe('Entity update timestamp.'),
                  visibility: zod.string().describe('Canonical visibility.'),
                })
                .describe('A canonical calendar event entity in Soup.'),
              tag: zod.enum(['calendarEvent']),
            })
            .describe('Calendar event item.'),
          zod
            .object({
              data: zod
                .object({
                  properties: zod
                    .array(
                      zod
                        .object({
                          definition: zod
                            .object({
                              created_at: zod.iso.datetime({}),
                              data_type: zod
                                .enum([
                                  'BOOLEAN',
                                  'DATE',
                                  'NUMBER',
                                  'STRING',
                                  'SELECT_NUMBER',
                                  'SELECT_STRING',
                                  'TAG',
                                  'ENTITY',
                                  'LINK',
                                ])
                                .describe(
                                  'Data type for property values, determining storage and validation.'
                                ),
                              display_name: zod.string(),
                              id: zod.uuid(),
                              is_metadata: zod
                                .boolean()
                                .describe(
                                  'Flag to indicate if this is a system-generated metadata property.\nNot stored in database - computed at service layer.'
                                ),
                              is_multi_select: zod.boolean(),
                              is_system: zod
                                .boolean()
                                .describe(
                                  'Flag to indicate if this is a system property (stored in DB).'
                                ),
                              owner: zod
                                .union([
                                  zod
                                    .object({
                                      scope: zod.enum(['user']),
                                      user_id: zod.string(),
                                    })
                                    .describe('User-scoped property.'),
                                  zod
                                    .object({
                                      scope: zod.enum(['team']),
                                      team_id: zod.uuid(),
                                    })
                                    .describe('Team-scoped property.'),
                                  zod
                                    .object({
                                      scope: zod.enum(['system']),
                                    })
                                    .describe(
                                      'System-owned property (no user or team owner).'
                                    ),
                                ])
                                .describe(
                                  'Defines who owns a property - user-scoped, team-scoped, or system.'
                                ),
                              specific_entity_type: zod
                                .union([
                                  zod.null(),
                                  zod
                                    .enum([
                                      'CALENDAR_EVENT',
                                      'CALL_RECORD',
                                      'CHANNEL',
                                      'CHAT',
                                      'COMPANY',
                                      'DOCUMENT',
                                      'PROJECT',
                                      'TASK',
                                      'THREAD',
                                      'USER',
                                    ])
                                    .describe(
                                      'Type of entity that can be referenced by entity properties.'
                                    ),
                                ])
                                .optional(),
                              updated_at: zod.iso.datetime({}),
                            })
                            .describe(
                              'Property definition model (service representation).'
                            ),
                          id: zod
                            .uuid()
                            .describe(
                              'Globally unique id of the assignment attaching this property to an entity.'
                            ),
                          value: zod
                            .union([
                              zod.null(),
                              zod
                                .union([
                                  zod
                                    .object({
                                      type: zod.enum(['Boolean']),
                                      value: zod
                                        .boolean()
                                        .describe(
                                          'Boolean value\nSerializes as: {\"type\": \"Boolean\", \"value\": true}'
                                        ),
                                    })
                                    .describe(
                                      'Boolean value\nSerializes as: {\"type\": \"Boolean\", \"value\": true}'
                                    ),
                                  zod
                                    .object({
                                      type: zod.enum(['Number']),
                                      value: zod
                                        .number()
                                        .describe(
                                          'Numeric value\nSerializes as: {\"type\": \"Number\", \"value\": 42.5}'
                                        ),
                                    })
                                    .describe(
                                      'Numeric value\nSerializes as: {\"type\": \"Number\", \"value\": 42.5}'
                                    ),
                                  zod
                                    .object({
                                      type: zod.enum(['String']),
                                      value: zod
                                        .string()
                                        .describe(
                                          'String value\nSerializes as: {\"type\": \"String\", \"value\": \"text\"}'
                                        ),
                                    })
                                    .describe(
                                      'String value\nSerializes as: {\"type\": \"String\", \"value\": \"text\"}'
                                    ),
                                  zod
                                    .object({
                                      type: zod.enum(['Date']),
                                      value: zod.iso
                                        .datetime({})
                                        .describe(
                                          'Date\/timestamp value\nSerializes as: {\"type\": \"Date\", \"value\": \"2025-01-01T00:00:00Z\"}'
                                        ),
                                    })
                                    .describe(
                                      'Date\/timestamp value\nSerializes as: {\"type\": \"Date\", \"value\": \"2025-01-01T00:00:00Z\"}'
                                    ),
                                  zod
                                    .object({
                                      type: zod.enum(['SelectOption']),
                                      value: zod
                                        .array(zod.uuid())
                                        .describe(
                                          'Select option(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"SelectOption\", \"value\": [\"uuid\"]} (length 0 or 1)\nMulti-select: {\"type\": \"SelectOption\", \"value\": [\"uuid1\", \"uuid2\", ...]} (length 0+)'
                                        ),
                                    })
                                    .describe(
                                      'Select option(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"SelectOption\", \"value\": [\"uuid\"]} (length 0 or 1)\nMulti-select: {\"type\": \"SelectOption\", \"value\": [\"uuid1\", \"uuid2\", ...]} (length 0+)'
                                    ),
                                  zod
                                    .object({
                                      type: zod.enum(['EntityReference']),
                                      value: zod
                                        .array(
                                          zod
                                            .object({
                                              entity_id: zod.string(),
                                              entity_type: zod
                                                .enum([
                                                  'CALENDAR_EVENT',
                                                  'CALL_RECORD',
                                                  'CHANNEL',
                                                  'CHAT',
                                                  'COMPANY',
                                                  'DOCUMENT',
                                                  'PROJECT',
                                                  'TASK',
                                                  'THREAD',
                                                  'USER',
                                                ])
                                                .describe(
                                                  'Type of entity that can be referenced by entity properties.'
                                                ),
                                              specific_message_id: zod
                                                .uuid()
                                                .nullish()
                                                .describe(
                                                  'For CHANNEL, CHAT, THREAD entity types - optional specific message ID.\nThis allows referencing a specific message within a thread\/channel\/chat.'
                                                ),
                                            })
                                            .describe(
                                              'Entity reference for entity-type property values.'
                                            )
                                        )
                                        .describe(
                                          'Entity reference(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"EntityReference\", \"value\": [{...}]} (length 0 or 1)\nMulti-select: {\"type\": \"EntityReference\", \"value\": [{...}, {...}, ...]} (length 0+)'
                                        ),
                                    })
                                    .describe(
                                      'Entity reference(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"EntityReference\", \"value\": [{...}]} (length 0 or 1)\nMulti-select: {\"type\": \"EntityReference\", \"value\": [{...}, {...}, ...]} (length 0+)'
                                    ),
                                  zod
                                    .object({
                                      type: zod.enum(['Link']),
                                      value: zod
                                        .array(zod.string())
                                        .describe(
                                          'Link value(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"Link\", \"value\": [\"https:\/\/example.com\"]} (length 0 or 1)\nMulti-select: {\"type\": \"Link\", \"value\": [\"https:\/\/example.com\", \"https:\/\/other.com\"]} (length 0+)'
                                        ),
                                    })
                                    .describe(
                                      'Link value(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"Link\", \"value\": [\"https:\/\/example.com\"]} (length 0 or 1)\nMulti-select: {\"type\": \"Link\", \"value\": [\"https:\/\/example.com\", \"https:\/\/other.com\"]} (length 0+)'
                                    ),
                                ])
                                .describe(
                                  'Property value (service representation).\n\nRepresents the actual value stored for an entity property.\nThis is serialized to\/from JSONB in the database.'
                                ),
                            ])
                            .optional(),
                        })
                        .describe(
                          'A property attached to a Soup item.\n\nThis is a simplified representation that includes only the definition and value,\nomitting the entity property assignment metadata and options.'
                        )
                    )
                    .describe('Properties attached to the entity.'),
                })
                .describe(
                  'Property fields that can be flattened into property-bearing Soup items.'
                )
                .and(
                  zod.object({
                    createdAt: zod.iso
                      .datetime({})
                      .describe('When the company was created.'),
                    description: zod
                      .string()
                      .nullish()
                      .describe(
                        "Display description from the primary domain's directory entry."
                      ),
                    domains: zod
                      .array(
                        zod
                          .object({
                            companyId: zod
                              .uuid()
                              .describe(
                                'The id of the company the domain belongs to.'
                              ),
                            createdAt: zod.iso
                              .datetime({})
                              .describe('When the domain record was created.'),
                            domain: zod
                              .string()
                              .describe(
                                'The domain (lowercased, e.g. \"acme.com\").'
                              ),
                            id: zod
                              .uuid()
                              .describe('The id of the domain record.'),
                          })
                          .describe(
                            "A CRM domain as displayed in Soup. Mirrors the crm crate's\n[`CrmDomain`] with a stable wire shape that the FE can rely on."
                          )
                      )
                      .describe(
                        'Domains associated with this company, ordered by creation time\nascending (primary first).'
                      ),
                    emailSync: zod
                      .boolean()
                      .describe(
                        'Whether email sync is enabled for this company.'
                      ),
                    hidden: zod
                      .boolean()
                      .describe(
                        'Whether the company is hidden from CRM listings. Soup filters\nthese out by default.'
                      ),
                    id: zod.uuid().describe('The id of the company.'),
                    name: zod
                      .string()
                      .nullish()
                      .describe(
                        "Display name from the primary domain's directory entry, or\n`None` when unresolved."
                      ),
                    teamId: zod
                      .uuid()
                      .describe(
                        'The id of the team that owns this company record.'
                      ),
                    updatedAt: zod.iso
                      .datetime({})
                      .describe('When the company was last updated.'),
                    viewedAt: zod.iso
                      .datetime({})
                      .nullish()
                      .describe(
                        'When the requesting user last viewed this company, or `None` if\nnever viewed. Mirrors the `viewed_at` other soup entities carry.'
                      ),
                  })
                )
                .describe(
                  'A CRM company as displayed in Soup. Carries the core company\nfields plus display metadata resolved from `crm_domain_directory`\nagainst the primary (earliest-created) domain.'
                ),
              tag: zod.enum(['crmCompany']),
            })
            .describe('CRM company item.'),
          zod
            .object({
              data: zod
                .object({
                  createdAt: zod.iso
                    .datetime({})
                    .describe('Timestamp when the record was created.'),
                  foreignEntityId: zod
                    .string()
                    .describe('Identifier assigned by the external system.'),
                  foreignEntitySource: zod
                    .string()
                    .describe(
                      'Source system that owns the external identifier.'
                    ),
                  id: zod
                    .uuid()
                    .describe(
                      'Internal primary key for this foreign entity record.'
                    ),
                  metadata: zod
                    .object({})
                    .describe('Arbitrary metadata stored with the mapping.'),
                  storedForAuthEntity: zod
                    .string()
                    .describe(
                      'Internal auth entity namespace this foreign entity is stored for.'
                    ),
                  storedForId: zod
                    .string()
                    .describe(
                      'Internal entity identifier this foreign entity is stored for.'
                    ),
                  updatedAt: zod.iso
                    .datetime({})
                    .describe('Timestamp when the record was last updated.'),
                })
                .describe('A foreign entity record as displayed in Soup.'),
              tag: zod.enum(['foreignEntity']),
            })
            .describe('Foreign entity item.'),
          zod
            .object({
              data: zod
                .object({
                  properties: zod
                    .array(
                      zod
                        .object({
                          definition: zod
                            .object({
                              created_at: zod.iso.datetime({}),
                              data_type: zod
                                .enum([
                                  'BOOLEAN',
                                  'DATE',
                                  'NUMBER',
                                  'STRING',
                                  'SELECT_NUMBER',
                                  'SELECT_STRING',
                                  'TAG',
                                  'ENTITY',
                                  'LINK',
                                ])
                                .describe(
                                  'Data type for property values, determining storage and validation.'
                                ),
                              display_name: zod.string(),
                              id: zod.uuid(),
                              is_metadata: zod
                                .boolean()
                                .describe(
                                  'Flag to indicate if this is a system-generated metadata property.\nNot stored in database - computed at service layer.'
                                ),
                              is_multi_select: zod.boolean(),
                              is_system: zod
                                .boolean()
                                .describe(
                                  'Flag to indicate if this is a system property (stored in DB).'
                                ),
                              owner: zod
                                .union([
                                  zod
                                    .object({
                                      scope: zod.enum(['user']),
                                      user_id: zod.string(),
                                    })
                                    .describe('User-scoped property.'),
                                  zod
                                    .object({
                                      scope: zod.enum(['team']),
                                      team_id: zod.uuid(),
                                    })
                                    .describe('Team-scoped property.'),
                                  zod
                                    .object({
                                      scope: zod.enum(['system']),
                                    })
                                    .describe(
                                      'System-owned property (no user or team owner).'
                                    ),
                                ])
                                .describe(
                                  'Defines who owns a property - user-scoped, team-scoped, or system.'
                                ),
                              specific_entity_type: zod
                                .union([
                                  zod.null(),
                                  zod
                                    .enum([
                                      'CALENDAR_EVENT',
                                      'CALL_RECORD',
                                      'CHANNEL',
                                      'CHAT',
                                      'COMPANY',
                                      'DOCUMENT',
                                      'PROJECT',
                                      'TASK',
                                      'THREAD',
                                      'USER',
                                    ])
                                    .describe(
                                      'Type of entity that can be referenced by entity properties.'
                                    ),
                                ])
                                .optional(),
                              updated_at: zod.iso.datetime({}),
                            })
                            .describe(
                              'Property definition model (service representation).'
                            ),
                          id: zod
                            .uuid()
                            .describe(
                              'Globally unique id of the assignment attaching this property to an entity.'
                            ),
                          value: zod
                            .union([
                              zod.null(),
                              zod
                                .union([
                                  zod
                                    .object({
                                      type: zod.enum(['Boolean']),
                                      value: zod
                                        .boolean()
                                        .describe(
                                          'Boolean value\nSerializes as: {\"type\": \"Boolean\", \"value\": true}'
                                        ),
                                    })
                                    .describe(
                                      'Boolean value\nSerializes as: {\"type\": \"Boolean\", \"value\": true}'
                                    ),
                                  zod
                                    .object({
                                      type: zod.enum(['Number']),
                                      value: zod
                                        .number()
                                        .describe(
                                          'Numeric value\nSerializes as: {\"type\": \"Number\", \"value\": 42.5}'
                                        ),
                                    })
                                    .describe(
                                      'Numeric value\nSerializes as: {\"type\": \"Number\", \"value\": 42.5}'
                                    ),
                                  zod
                                    .object({
                                      type: zod.enum(['String']),
                                      value: zod
                                        .string()
                                        .describe(
                                          'String value\nSerializes as: {\"type\": \"String\", \"value\": \"text\"}'
                                        ),
                                    })
                                    .describe(
                                      'String value\nSerializes as: {\"type\": \"String\", \"value\": \"text\"}'
                                    ),
                                  zod
                                    .object({
                                      type: zod.enum(['Date']),
                                      value: zod.iso
                                        .datetime({})
                                        .describe(
                                          'Date\/timestamp value\nSerializes as: {\"type\": \"Date\", \"value\": \"2025-01-01T00:00:00Z\"}'
                                        ),
                                    })
                                    .describe(
                                      'Date\/timestamp value\nSerializes as: {\"type\": \"Date\", \"value\": \"2025-01-01T00:00:00Z\"}'
                                    ),
                                  zod
                                    .object({
                                      type: zod.enum(['SelectOption']),
                                      value: zod
                                        .array(zod.uuid())
                                        .describe(
                                          'Select option(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"SelectOption\", \"value\": [\"uuid\"]} (length 0 or 1)\nMulti-select: {\"type\": \"SelectOption\", \"value\": [\"uuid1\", \"uuid2\", ...]} (length 0+)'
                                        ),
                                    })
                                    .describe(
                                      'Select option(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"SelectOption\", \"value\": [\"uuid\"]} (length 0 or 1)\nMulti-select: {\"type\": \"SelectOption\", \"value\": [\"uuid1\", \"uuid2\", ...]} (length 0+)'
                                    ),
                                  zod
                                    .object({
                                      type: zod.enum(['EntityReference']),
                                      value: zod
                                        .array(
                                          zod
                                            .object({
                                              entity_id: zod.string(),
                                              entity_type: zod
                                                .enum([
                                                  'CALENDAR_EVENT',
                                                  'CALL_RECORD',
                                                  'CHANNEL',
                                                  'CHAT',
                                                  'COMPANY',
                                                  'DOCUMENT',
                                                  'PROJECT',
                                                  'TASK',
                                                  'THREAD',
                                                  'USER',
                                                ])
                                                .describe(
                                                  'Type of entity that can be referenced by entity properties.'
                                                ),
                                              specific_message_id: zod
                                                .uuid()
                                                .nullish()
                                                .describe(
                                                  'For CHANNEL, CHAT, THREAD entity types - optional specific message ID.\nThis allows referencing a specific message within a thread\/channel\/chat.'
                                                ),
                                            })
                                            .describe(
                                              'Entity reference for entity-type property values.'
                                            )
                                        )
                                        .describe(
                                          'Entity reference(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"EntityReference\", \"value\": [{...}]} (length 0 or 1)\nMulti-select: {\"type\": \"EntityReference\", \"value\": [{...}, {...}, ...]} (length 0+)'
                                        ),
                                    })
                                    .describe(
                                      'Entity reference(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"EntityReference\", \"value\": [{...}]} (length 0 or 1)\nMulti-select: {\"type\": \"EntityReference\", \"value\": [{...}, {...}, ...]} (length 0+)'
                                    ),
                                  zod
                                    .object({
                                      type: zod.enum(['Link']),
                                      value: zod
                                        .array(zod.string())
                                        .describe(
                                          'Link value(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"Link\", \"value\": [\"https:\/\/example.com\"]} (length 0 or 1)\nMulti-select: {\"type\": \"Link\", \"value\": [\"https:\/\/example.com\", \"https:\/\/other.com\"]} (length 0+)'
                                        ),
                                    })
                                    .describe(
                                      'Link value(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"Link\", \"value\": [\"https:\/\/example.com\"]} (length 0 or 1)\nMulti-select: {\"type\": \"Link\", \"value\": [\"https:\/\/example.com\", \"https:\/\/other.com\"]} (length 0+)'
                                    ),
                                ])
                                .describe(
                                  'Property value (service representation).\n\nRepresents the actual value stored for an entity property.\nThis is serialized to\/from JSONB in the database.'
                                ),
                            ])
                            .optional(),
                        })
                        .describe(
                          'A property attached to a Soup item.\n\nThis is a simplified representation that includes only the definition and value,\nomitting the entity property assignment metadata and options.'
                        )
                    )
                    .describe('Properties attached to the entity.'),
                })
                .describe(
                  'Property fields that can be flattened into property-bearing Soup items.'
                )
                .and(
                  zod.object({
                    completedAt: zod.iso
                      .datetime({})
                      .nullish()
                      .describe('Set once a one-shot reminder has fired.'),
                    createdAt: zod.iso
                      .datetime({})
                      .describe('When the reminder was created.'),
                    description: zod
                      .string()
                      .describe(
                        'What to remind the user about. Doubles as the display name.'
                      ),
                    enabled: zod
                      .boolean()
                      .describe(
                        'When false, the dispatcher skips this reminder.'
                      ),
                    id: zod.uuid().describe('The reminder id.'),
                    nextRunAt: zod.iso
                      .datetime({})
                      .describe(
                        'The next firing. This is what Soup sorts reminders on.'
                      ),
                    referencedEntity: zod
                      .union([
                        zod.null(),
                        zod
                          .object({
                            entityType: zod
                              .enum([
                                'user',
                                'chat',
                                'channel',
                                'channel_message',
                                'document',
                                'project',
                                'email_thread',
                                'calendar_event',
                                'team',
                                'call',
                                'foreign_entity',
                                'static_file',
                                'crm_company',
                                'crm_contact',
                                'reminder',
                                'skill',
                              ])
                              .describe('The type of an entity in Macro')
                              .describe("The referenced entity's type."),
                            fileType: zod
                              .string()
                              .nullish()
                              .describe(
                                'File type, when the reference is a document — `md`, `pdf`, and so on.'
                              ),
                            id: zod
                              .string()
                              .describe("The referenced entity's id."),
                            subType: zod
                              .string()
                              .nullish()
                              .describe(
                                'Sub type, when the reference is a task or snippet document.'
                              ),
                          })
                          .describe(
                            "The entity a reminder is about, resolved server-side.\n\nA reminder has no block of its own — it opens, and is iconed as, whatever it\nreferences. Which block that is depends on the referenced document's file\ntype, and the client's icon path is synchronous, so this is resolved here\nrather than costing a fetch per row."
                          ),
                      ])
                      .optional(),
                    schedule: zod
                      .union([
                        zod
                          .object({
                            remindAt: zod.iso
                              .datetime({})
                              .describe('The instant to fire at.'),
                            type: zod.enum(['once']),
                          })
                          .describe('Fires once, at a fixed instant.'),
                        zod
                          .object({
                            cron: zod
                              .string()
                              .describe(
                                'Cron expression, normalized to the 6-field form.'
                              ),
                            timezone: zod
                              .string()
                              .describe(
                                'The timezone the cron expression is evaluated in.'
                              ),
                            type: zod.enum(['recurring']),
                          })
                          .describe(
                            'Fires repeatedly, on a cron schedule evaluated in `timezone`.'
                          ),
                      ])
                      .describe(
                        'How often a reminder fires, flattened for the wire.\n\nThe domain\'s [`ReminderSchedule`] is an internally-tagged enum carrying a\nvalidated cron type; Soup only needs enough to render \"once\" vs \"every\nweekday at 9am\", so the cron is exposed as a plain string.'
                      ),
                    updatedAt: zod.iso
                      .datetime({})
                      .describe('When the reminder was last modified.'),
                  })
                )
                .describe(
                  "A reminder as displayed in Soup.\n\nReminders are user-owned rather than shared, so unlike most Soup items they\ncarry no access metadata — the repository only ever returns the caller's own."
                ),
              tag: zod.enum(['reminder']),
            })
            .describe('Reminder item.'),
        ])
        .describe('A single item in the Soup feed.')
        .and(
          zod.object({
            frecency_score: zod.number(),
            is_favorited: zod
              .boolean()
              .describe(
                'Whether the requesting user has favorited this entity.'
              ),
          })
        )
        .describe('API representation of a soup item with its frecency score.')
    ),
    next_cursor: zod.string().nullish(),
  })
  .describe('Response page for non-grouped soup endpoints.');

/**
 * @summary Gets the items the user has access to using AST filters
 */
export const postItemsSoupAstQueryParams = zod.object({
  cursor: zod.string().optional().describe('Base64 encoded cursor value.'),
});

export const postItemsSoupAstBodyLimitMin = 0;

export const postItemsSoupAstBody = zod
  .object({
    calf: zod
      .unknown()
      .optional()
      .describe('filters applied to canonical calendar events'),
    callf: zod
      .unknown()
      .optional()
      .describe('the filters that should be applied to the call entity'),
    ccf: zod
      .unknown()
      .optional()
      .describe(
        "Filters applied to the crm_company entity (wire key `ccf`).\nEmpty\/omitted = team's full visible list."
      ),
    cf: zod
      .unknown()
      .optional()
      .describe('the filters that should be applied to the chat entity'),
    chanf: zod
      .unknown()
      .optional()
      .describe('the filters that should be applied to the channel entity'),
    cthf: zod
      .unknown()
      .optional()
      .describe(
        'the filters that should be applied to the channel-thread entity'
      ),
    df: zod
      .unknown()
      .optional()
      .describe('the filters that should be applied to the document entity'),
    eca: zod
      .array(zod.string())
      .optional()
      .describe(
        'CRM-scoped address filter (wire key: `eca`). Symmetric counterpart\nto `ecd` for fully-qualified email addresses.'
      ),
    ecd: zod
      .array(zod.string())
      .optional()
      .describe(
        'CRM-scoped domain filter (wire key: `ecd`). Parallel to the\nfreeform `ef` AST. Expanded by the router into an any-direction\nOR sub-tree AND-merged into `ef`, plus a `CrmScope` tag stamped\non the resulting [`item_filters::ast::EmailFilterAst::crm_scope`].\nDrives the per-team CRM authorization pre-check and candidate-set\nwidening downstream. Mutually exclusive with `eca`.'
      ),
    ef: zod
      .unknown()
      .optional()
      .describe(
        'the filters that should be applied to the email entity (raw AST\ntree only; CRM scope is carried by the `ecd` \/ `eca` sibling\nfields). On this endpoint the email filter stays a bare tree,\nunlike the materialized [`EntityFilterAst`] used for cursors.'
      ),
    fef: zod
      .unknown()
      .optional()
      .describe('the filters that should be applied to foreign entity records'),
    pf: zod
      .unknown()
      .optional()
      .describe('the filters that should be applied to the project entity'),
    propf: zod
      .unknown()
      .optional()
      .describe(
        'the filters that should be applied based on entity properties'
      ),
    remf: zod
      .unknown()
      .optional()
      .describe(
        'Filters applied to reminders (wire key `remf`). Unlike every other\nfilter here, empty\/omitted returns \*\*no\*\* reminders: they are opt-in,\nso the caller must send `inc`, an id, or an entity to get any.'
      ),
  })
  .describe('Wire-format entity filter AST accepted by soup AST endpoints.')
  .and(
    zod
      .object({
        expand: zod
          .boolean()
          .nullish()
          .describe('Whether to expand projects. Defaults to true.'),
        limit: zod
          .number()
          .min(postItemsSoupAstBodyLimitMin)
          .nullish()
          .describe(
            'Limit the number of items returned. Defaults to 20. Max 500.'
          ),
        sort_direction: zod
          .union([
            zod.null(),
            zod
              .enum(['asc', 'desc'])
              .describe(
                'Sort direction accepted by non-grouped soup API endpoints.'
              ),
          ])
          .optional(),
        sort_method: zod
          .union([
            zod.null(),
            zod
              .enum([
                'viewed_at',
                'created_at',
                'updated_at',
                'viewed_updated',
                'frecency',
                'touched_by_me',
              ])
              .describe(
                'Sort options accepted by non-grouped soup API endpoints.'
              ),
          ])
          .optional(),
      })
      .describe('Query parameters shared by soup endpoints.')
  )
  .and(
    zod.object({
      emailView: zod
        .string()
        .optional()
        .describe('the view of specific emails to display'),
    })
  )
  .describe('Request body for the AST soup endpoint.');

export const postItemsSoupAstResponseItemsItemDataChannelOrgIdMin = 0;

export const postItemsSoupAstResponse = zod
  .object({
    items: zod.array(
      zod
        .union([
          zod
            .object({
              data: zod
                .object({
                  properties: zod
                    .array(
                      zod
                        .object({
                          definition: zod
                            .object({
                              created_at: zod.iso.datetime({}),
                              data_type: zod
                                .enum([
                                  'BOOLEAN',
                                  'DATE',
                                  'NUMBER',
                                  'STRING',
                                  'SELECT_NUMBER',
                                  'SELECT_STRING',
                                  'TAG',
                                  'ENTITY',
                                  'LINK',
                                ])
                                .describe(
                                  'Data type for property values, determining storage and validation.'
                                ),
                              display_name: zod.string(),
                              id: zod.uuid(),
                              is_metadata: zod
                                .boolean()
                                .describe(
                                  'Flag to indicate if this is a system-generated metadata property.\nNot stored in database - computed at service layer.'
                                ),
                              is_multi_select: zod.boolean(),
                              is_system: zod
                                .boolean()
                                .describe(
                                  'Flag to indicate if this is a system property (stored in DB).'
                                ),
                              owner: zod
                                .union([
                                  zod
                                    .object({
                                      scope: zod.enum(['user']),
                                      user_id: zod.string(),
                                    })
                                    .describe('User-scoped property.'),
                                  zod
                                    .object({
                                      scope: zod.enum(['team']),
                                      team_id: zod.uuid(),
                                    })
                                    .describe('Team-scoped property.'),
                                  zod
                                    .object({
                                      scope: zod.enum(['system']),
                                    })
                                    .describe(
                                      'System-owned property (no user or team owner).'
                                    ),
                                ])
                                .describe(
                                  'Defines who owns a property - user-scoped, team-scoped, or system.'
                                ),
                              specific_entity_type: zod
                                .union([
                                  zod.null(),
                                  zod
                                    .enum([
                                      'CALENDAR_EVENT',
                                      'CALL_RECORD',
                                      'CHANNEL',
                                      'CHAT',
                                      'COMPANY',
                                      'DOCUMENT',
                                      'PROJECT',
                                      'TASK',
                                      'THREAD',
                                      'USER',
                                    ])
                                    .describe(
                                      'Type of entity that can be referenced by entity properties.'
                                    ),
                                ])
                                .optional(),
                              updated_at: zod.iso.datetime({}),
                            })
                            .describe(
                              'Property definition model (service representation).'
                            ),
                          id: zod
                            .uuid()
                            .describe(
                              'Globally unique id of the assignment attaching this property to an entity.'
                            ),
                          value: zod
                            .union([
                              zod.null(),
                              zod
                                .union([
                                  zod
                                    .object({
                                      type: zod.enum(['Boolean']),
                                      value: zod
                                        .boolean()
                                        .describe(
                                          'Boolean value\nSerializes as: {\"type\": \"Boolean\", \"value\": true}'
                                        ),
                                    })
                                    .describe(
                                      'Boolean value\nSerializes as: {\"type\": \"Boolean\", \"value\": true}'
                                    ),
                                  zod
                                    .object({
                                      type: zod.enum(['Number']),
                                      value: zod
                                        .number()
                                        .describe(
                                          'Numeric value\nSerializes as: {\"type\": \"Number\", \"value\": 42.5}'
                                        ),
                                    })
                                    .describe(
                                      'Numeric value\nSerializes as: {\"type\": \"Number\", \"value\": 42.5}'
                                    ),
                                  zod
                                    .object({
                                      type: zod.enum(['String']),
                                      value: zod
                                        .string()
                                        .describe(
                                          'String value\nSerializes as: {\"type\": \"String\", \"value\": \"text\"}'
                                        ),
                                    })
                                    .describe(
                                      'String value\nSerializes as: {\"type\": \"String\", \"value\": \"text\"}'
                                    ),
                                  zod
                                    .object({
                                      type: zod.enum(['Date']),
                                      value: zod.iso
                                        .datetime({})
                                        .describe(
                                          'Date\/timestamp value\nSerializes as: {\"type\": \"Date\", \"value\": \"2025-01-01T00:00:00Z\"}'
                                        ),
                                    })
                                    .describe(
                                      'Date\/timestamp value\nSerializes as: {\"type\": \"Date\", \"value\": \"2025-01-01T00:00:00Z\"}'
                                    ),
                                  zod
                                    .object({
                                      type: zod.enum(['SelectOption']),
                                      value: zod
                                        .array(zod.uuid())
                                        .describe(
                                          'Select option(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"SelectOption\", \"value\": [\"uuid\"]} (length 0 or 1)\nMulti-select: {\"type\": \"SelectOption\", \"value\": [\"uuid1\", \"uuid2\", ...]} (length 0+)'
                                        ),
                                    })
                                    .describe(
                                      'Select option(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"SelectOption\", \"value\": [\"uuid\"]} (length 0 or 1)\nMulti-select: {\"type\": \"SelectOption\", \"value\": [\"uuid1\", \"uuid2\", ...]} (length 0+)'
                                    ),
                                  zod
                                    .object({
                                      type: zod.enum(['EntityReference']),
                                      value: zod
                                        .array(
                                          zod
                                            .object({
                                              entity_id: zod.string(),
                                              entity_type: zod
                                                .enum([
                                                  'CALENDAR_EVENT',
                                                  'CALL_RECORD',
                                                  'CHANNEL',
                                                  'CHAT',
                                                  'COMPANY',
                                                  'DOCUMENT',
                                                  'PROJECT',
                                                  'TASK',
                                                  'THREAD',
                                                  'USER',
                                                ])
                                                .describe(
                                                  'Type of entity that can be referenced by entity properties.'
                                                ),
                                              specific_message_id: zod
                                                .uuid()
                                                .nullish()
                                                .describe(
                                                  'For CHANNEL, CHAT, THREAD entity types - optional specific message ID.\nThis allows referencing a specific message within a thread\/channel\/chat.'
                                                ),
                                            })
                                            .describe(
                                              'Entity reference for entity-type property values.'
                                            )
                                        )
                                        .describe(
                                          'Entity reference(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"EntityReference\", \"value\": [{...}]} (length 0 or 1)\nMulti-select: {\"type\": \"EntityReference\", \"value\": [{...}, {...}, ...]} (length 0+)'
                                        ),
                                    })
                                    .describe(
                                      'Entity reference(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"EntityReference\", \"value\": [{...}]} (length 0 or 1)\nMulti-select: {\"type\": \"EntityReference\", \"value\": [{...}, {...}, ...]} (length 0+)'
                                    ),
                                  zod
                                    .object({
                                      type: zod.enum(['Link']),
                                      value: zod
                                        .array(zod.string())
                                        .describe(
                                          'Link value(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"Link\", \"value\": [\"https:\/\/example.com\"]} (length 0 or 1)\nMulti-select: {\"type\": \"Link\", \"value\": [\"https:\/\/example.com\", \"https:\/\/other.com\"]} (length 0+)'
                                        ),
                                    })
                                    .describe(
                                      'Link value(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"Link\", \"value\": [\"https:\/\/example.com\"]} (length 0 or 1)\nMulti-select: {\"type\": \"Link\", \"value\": [\"https:\/\/example.com\", \"https:\/\/other.com\"]} (length 0+)'
                                    ),
                                ])
                                .describe(
                                  'Property value (service representation).\n\nRepresents the actual value stored for an entity property.\nThis is serialized to\/from JSONB in the database.'
                                ),
                            ])
                            .optional(),
                        })
                        .describe(
                          'A property attached to a Soup item.\n\nThis is a simplified representation that includes only the definition and value,\nomitting the entity property assignment metadata and options.'
                        )
                    )
                    .describe('Properties attached to the entity.'),
                })
                .describe(
                  'Property fields that can be flattened into property-bearing Soup items.'
                )
                .and(
                  zod.object({
                    branchedFromId: zod
                      .uuid()
                      .nullish()
                      .describe(
                        'The id of the document this document branched from'
                      ),
                    branchedFromVersionId: zod
                      .number()
                      .nullish()
                      .describe(
                        'The id of the version this document branched from\nThis could be either DocumentInstance or DocumentBom id depending on the file type'
                      ),
                    createdAt: zod.iso
                      .datetime({})
                      .describe('The time the document was created'),
                    deletedAt: zod.iso
                      .datetime({})
                      .nullish()
                      .describe('The time the document was deleted'),
                    documentFamilyId: zod
                      .number()
                      .nullish()
                      .describe(
                        'The id of the document family this document belongs to'
                      ),
                    documentVersionId: zod
                      .number()
                      .describe(
                        'The version of the document\nThis could be the document_instance_id or document_bom_id depending on the file type'
                      ),
                    fileType: zod
                      .string()
                      .nullish()
                      .describe(
                        'The file type of the document (e.g. pdf, docx)'
                      ),
                    id: zod.uuid().describe('The document id'),
                    name: zod.string().describe('The name of the document'),
                    ownerId: zod.string().describe('The owner of the document'),
                    projectId: zod
                      .uuid()
                      .nullish()
                      .describe(
                        'The id of the project that this document belongs to'
                      ),
                    sha: zod
                      .string()
                      .nullish()
                      .describe(
                        'If the document is a PDF, this is the SHA of the pdf\nIf the document is a DOCX, this will not be present'
                      ),
                    subType: zod
                      .union([
                        zod.null(),
                        zod
                          .union([
                            zod
                              .object({
                                is_completed: zod
                                  .boolean()
                                  .describe(
                                    'Whether the task is completed.\nTrue if the Status property is set to \"Completed\".'
                                  ),
                                type: zod.enum(['task']),
                              })
                              .describe(
                                'A task document with its associated properties'
                              ),
                            zod
                              .object({
                                type: zod.enum(['snippet']),
                              })
                              .describe(
                                'A snippet document — reusable markdown'
                              ),
                            zod
                              .object({
                                type: zod.enum(['skill']),
                              })
                              .describe(
                                'A skill document — markdown instructions for AI'
                              ),
                          ])
                          .describe(
                            'Sub type of a document with associated properties encoded in each variant.\nThis ensures type-safety: task properties only exist when the document is a task.'
                          ),
                      ])
                      .optional(),
                    updatedAt: zod.iso
                      .datetime({})
                      .describe(
                        'The time the document instance \/ document BOM was updated'
                      ),
                    viewedAt: zod.iso
                      .datetime({})
                      .nullish()
                      .describe('The time the document was last viewed'),
                  })
                )
                .describe('A document as displayed in Soup.'),
              tag: zod.enum(['document']),
            })
            .describe('Document item.'),
          zod
            .object({
              data: zod
                .object({
                  properties: zod
                    .array(
                      zod
                        .object({
                          definition: zod
                            .object({
                              created_at: zod.iso.datetime({}),
                              data_type: zod
                                .enum([
                                  'BOOLEAN',
                                  'DATE',
                                  'NUMBER',
                                  'STRING',
                                  'SELECT_NUMBER',
                                  'SELECT_STRING',
                                  'TAG',
                                  'ENTITY',
                                  'LINK',
                                ])
                                .describe(
                                  'Data type for property values, determining storage and validation.'
                                ),
                              display_name: zod.string(),
                              id: zod.uuid(),
                              is_metadata: zod
                                .boolean()
                                .describe(
                                  'Flag to indicate if this is a system-generated metadata property.\nNot stored in database - computed at service layer.'
                                ),
                              is_multi_select: zod.boolean(),
                              is_system: zod
                                .boolean()
                                .describe(
                                  'Flag to indicate if this is a system property (stored in DB).'
                                ),
                              owner: zod
                                .union([
                                  zod
                                    .object({
                                      scope: zod.enum(['user']),
                                      user_id: zod.string(),
                                    })
                                    .describe('User-scoped property.'),
                                  zod
                                    .object({
                                      scope: zod.enum(['team']),
                                      team_id: zod.uuid(),
                                    })
                                    .describe('Team-scoped property.'),
                                  zod
                                    .object({
                                      scope: zod.enum(['system']),
                                    })
                                    .describe(
                                      'System-owned property (no user or team owner).'
                                    ),
                                ])
                                .describe(
                                  'Defines who owns a property - user-scoped, team-scoped, or system.'
                                ),
                              specific_entity_type: zod
                                .union([
                                  zod.null(),
                                  zod
                                    .enum([
                                      'CALENDAR_EVENT',
                                      'CALL_RECORD',
                                      'CHANNEL',
                                      'CHAT',
                                      'COMPANY',
                                      'DOCUMENT',
                                      'PROJECT',
                                      'TASK',
                                      'THREAD',
                                      'USER',
                                    ])
                                    .describe(
                                      'Type of entity that can be referenced by entity properties.'
                                    ),
                                ])
                                .optional(),
                              updated_at: zod.iso.datetime({}),
                            })
                            .describe(
                              'Property definition model (service representation).'
                            ),
                          id: zod
                            .uuid()
                            .describe(
                              'Globally unique id of the assignment attaching this property to an entity.'
                            ),
                          value: zod
                            .union([
                              zod.null(),
                              zod
                                .union([
                                  zod
                                    .object({
                                      type: zod.enum(['Boolean']),
                                      value: zod
                                        .boolean()
                                        .describe(
                                          'Boolean value\nSerializes as: {\"type\": \"Boolean\", \"value\": true}'
                                        ),
                                    })
                                    .describe(
                                      'Boolean value\nSerializes as: {\"type\": \"Boolean\", \"value\": true}'
                                    ),
                                  zod
                                    .object({
                                      type: zod.enum(['Number']),
                                      value: zod
                                        .number()
                                        .describe(
                                          'Numeric value\nSerializes as: {\"type\": \"Number\", \"value\": 42.5}'
                                        ),
                                    })
                                    .describe(
                                      'Numeric value\nSerializes as: {\"type\": \"Number\", \"value\": 42.5}'
                                    ),
                                  zod
                                    .object({
                                      type: zod.enum(['String']),
                                      value: zod
                                        .string()
                                        .describe(
                                          'String value\nSerializes as: {\"type\": \"String\", \"value\": \"text\"}'
                                        ),
                                    })
                                    .describe(
                                      'String value\nSerializes as: {\"type\": \"String\", \"value\": \"text\"}'
                                    ),
                                  zod
                                    .object({
                                      type: zod.enum(['Date']),
                                      value: zod.iso
                                        .datetime({})
                                        .describe(
                                          'Date\/timestamp value\nSerializes as: {\"type\": \"Date\", \"value\": \"2025-01-01T00:00:00Z\"}'
                                        ),
                                    })
                                    .describe(
                                      'Date\/timestamp value\nSerializes as: {\"type\": \"Date\", \"value\": \"2025-01-01T00:00:00Z\"}'
                                    ),
                                  zod
                                    .object({
                                      type: zod.enum(['SelectOption']),
                                      value: zod
                                        .array(zod.uuid())
                                        .describe(
                                          'Select option(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"SelectOption\", \"value\": [\"uuid\"]} (length 0 or 1)\nMulti-select: {\"type\": \"SelectOption\", \"value\": [\"uuid1\", \"uuid2\", ...]} (length 0+)'
                                        ),
                                    })
                                    .describe(
                                      'Select option(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"SelectOption\", \"value\": [\"uuid\"]} (length 0 or 1)\nMulti-select: {\"type\": \"SelectOption\", \"value\": [\"uuid1\", \"uuid2\", ...]} (length 0+)'
                                    ),
                                  zod
                                    .object({
                                      type: zod.enum(['EntityReference']),
                                      value: zod
                                        .array(
                                          zod
                                            .object({
                                              entity_id: zod.string(),
                                              entity_type: zod
                                                .enum([
                                                  'CALENDAR_EVENT',
                                                  'CALL_RECORD',
                                                  'CHANNEL',
                                                  'CHAT',
                                                  'COMPANY',
                                                  'DOCUMENT',
                                                  'PROJECT',
                                                  'TASK',
                                                  'THREAD',
                                                  'USER',
                                                ])
                                                .describe(
                                                  'Type of entity that can be referenced by entity properties.'
                                                ),
                                              specific_message_id: zod
                                                .uuid()
                                                .nullish()
                                                .describe(
                                                  'For CHANNEL, CHAT, THREAD entity types - optional specific message ID.\nThis allows referencing a specific message within a thread\/channel\/chat.'
                                                ),
                                            })
                                            .describe(
                                              'Entity reference for entity-type property values.'
                                            )
                                        )
                                        .describe(
                                          'Entity reference(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"EntityReference\", \"value\": [{...}]} (length 0 or 1)\nMulti-select: {\"type\": \"EntityReference\", \"value\": [{...}, {...}, ...]} (length 0+)'
                                        ),
                                    })
                                    .describe(
                                      'Entity reference(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"EntityReference\", \"value\": [{...}]} (length 0 or 1)\nMulti-select: {\"type\": \"EntityReference\", \"value\": [{...}, {...}, ...]} (length 0+)'
                                    ),
                                  zod
                                    .object({
                                      type: zod.enum(['Link']),
                                      value: zod
                                        .array(zod.string())
                                        .describe(
                                          'Link value(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"Link\", \"value\": [\"https:\/\/example.com\"]} (length 0 or 1)\nMulti-select: {\"type\": \"Link\", \"value\": [\"https:\/\/example.com\", \"https:\/\/other.com\"]} (length 0+)'
                                        ),
                                    })
                                    .describe(
                                      'Link value(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"Link\", \"value\": [\"https:\/\/example.com\"]} (length 0 or 1)\nMulti-select: {\"type\": \"Link\", \"value\": [\"https:\/\/example.com\", \"https:\/\/other.com\"]} (length 0+)'
                                    ),
                                ])
                                .describe(
                                  'Property value (service representation).\n\nRepresents the actual value stored for an entity property.\nThis is serialized to\/from JSONB in the database.'
                                ),
                            ])
                            .optional(),
                        })
                        .describe(
                          'A property attached to a Soup item.\n\nThis is a simplified representation that includes only the definition and value,\nomitting the entity property assignment metadata and options.'
                        )
                    )
                    .describe('Properties attached to the entity.'),
                })
                .describe(
                  'Property fields that can be flattened into property-bearing Soup items.'
                )
                .and(
                  zod.object({
                    createdAt: zod.iso
                      .datetime({})
                      .describe('The time the chat was created'),
                    deletedAt: zod.iso
                      .datetime({})
                      .nullish()
                      .describe('The time the chat was deleted'),
                    id: zod.uuid().describe('The chat uuid'),
                    isPersistent: zod
                      .boolean()
                      .describe('Whether the chat is persistent or not'),
                    name: zod.string().describe('The name of the chat'),
                    ownerId: zod.string().describe('Who the chat belongs to'),
                    projectId: zod
                      .uuid()
                      .nullish()
                      .describe('The project id of the chat'),
                    updatedAt: zod.iso
                      .datetime({})
                      .describe('The time the chat was last updated'),
                    viewedAt: zod.iso
                      .datetime({})
                      .nullish()
                      .describe('The time the chat was last viewed'),
                  })
                )
                .describe('A chat as displayed in Soup.'),
              tag: zod.enum(['chat']),
            })
            .describe('Chat item.'),
          zod
            .object({
              data: zod
                .object({
                  properties: zod
                    .array(
                      zod
                        .object({
                          definition: zod
                            .object({
                              created_at: zod.iso.datetime({}),
                              data_type: zod
                                .enum([
                                  'BOOLEAN',
                                  'DATE',
                                  'NUMBER',
                                  'STRING',
                                  'SELECT_NUMBER',
                                  'SELECT_STRING',
                                  'TAG',
                                  'ENTITY',
                                  'LINK',
                                ])
                                .describe(
                                  'Data type for property values, determining storage and validation.'
                                ),
                              display_name: zod.string(),
                              id: zod.uuid(),
                              is_metadata: zod
                                .boolean()
                                .describe(
                                  'Flag to indicate if this is a system-generated metadata property.\nNot stored in database - computed at service layer.'
                                ),
                              is_multi_select: zod.boolean(),
                              is_system: zod
                                .boolean()
                                .describe(
                                  'Flag to indicate if this is a system property (stored in DB).'
                                ),
                              owner: zod
                                .union([
                                  zod
                                    .object({
                                      scope: zod.enum(['user']),
                                      user_id: zod.string(),
                                    })
                                    .describe('User-scoped property.'),
                                  zod
                                    .object({
                                      scope: zod.enum(['team']),
                                      team_id: zod.uuid(),
                                    })
                                    .describe('Team-scoped property.'),
                                  zod
                                    .object({
                                      scope: zod.enum(['system']),
                                    })
                                    .describe(
                                      'System-owned property (no user or team owner).'
                                    ),
                                ])
                                .describe(
                                  'Defines who owns a property - user-scoped, team-scoped, or system.'
                                ),
                              specific_entity_type: zod
                                .union([
                                  zod.null(),
                                  zod
                                    .enum([
                                      'CALENDAR_EVENT',
                                      'CALL_RECORD',
                                      'CHANNEL',
                                      'CHAT',
                                      'COMPANY',
                                      'DOCUMENT',
                                      'PROJECT',
                                      'TASK',
                                      'THREAD',
                                      'USER',
                                    ])
                                    .describe(
                                      'Type of entity that can be referenced by entity properties.'
                                    ),
                                ])
                                .optional(),
                              updated_at: zod.iso.datetime({}),
                            })
                            .describe(
                              'Property definition model (service representation).'
                            ),
                          id: zod
                            .uuid()
                            .describe(
                              'Globally unique id of the assignment attaching this property to an entity.'
                            ),
                          value: zod
                            .union([
                              zod.null(),
                              zod
                                .union([
                                  zod
                                    .object({
                                      type: zod.enum(['Boolean']),
                                      value: zod
                                        .boolean()
                                        .describe(
                                          'Boolean value\nSerializes as: {\"type\": \"Boolean\", \"value\": true}'
                                        ),
                                    })
                                    .describe(
                                      'Boolean value\nSerializes as: {\"type\": \"Boolean\", \"value\": true}'
                                    ),
                                  zod
                                    .object({
                                      type: zod.enum(['Number']),
                                      value: zod
                                        .number()
                                        .describe(
                                          'Numeric value\nSerializes as: {\"type\": \"Number\", \"value\": 42.5}'
                                        ),
                                    })
                                    .describe(
                                      'Numeric value\nSerializes as: {\"type\": \"Number\", \"value\": 42.5}'
                                    ),
                                  zod
                                    .object({
                                      type: zod.enum(['String']),
                                      value: zod
                                        .string()
                                        .describe(
                                          'String value\nSerializes as: {\"type\": \"String\", \"value\": \"text\"}'
                                        ),
                                    })
                                    .describe(
                                      'String value\nSerializes as: {\"type\": \"String\", \"value\": \"text\"}'
                                    ),
                                  zod
                                    .object({
                                      type: zod.enum(['Date']),
                                      value: zod.iso
                                        .datetime({})
                                        .describe(
                                          'Date\/timestamp value\nSerializes as: {\"type\": \"Date\", \"value\": \"2025-01-01T00:00:00Z\"}'
                                        ),
                                    })
                                    .describe(
                                      'Date\/timestamp value\nSerializes as: {\"type\": \"Date\", \"value\": \"2025-01-01T00:00:00Z\"}'
                                    ),
                                  zod
                                    .object({
                                      type: zod.enum(['SelectOption']),
                                      value: zod
                                        .array(zod.uuid())
                                        .describe(
                                          'Select option(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"SelectOption\", \"value\": [\"uuid\"]} (length 0 or 1)\nMulti-select: {\"type\": \"SelectOption\", \"value\": [\"uuid1\", \"uuid2\", ...]} (length 0+)'
                                        ),
                                    })
                                    .describe(
                                      'Select option(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"SelectOption\", \"value\": [\"uuid\"]} (length 0 or 1)\nMulti-select: {\"type\": \"SelectOption\", \"value\": [\"uuid1\", \"uuid2\", ...]} (length 0+)'
                                    ),
                                  zod
                                    .object({
                                      type: zod.enum(['EntityReference']),
                                      value: zod
                                        .array(
                                          zod
                                            .object({
                                              entity_id: zod.string(),
                                              entity_type: zod
                                                .enum([
                                                  'CALENDAR_EVENT',
                                                  'CALL_RECORD',
                                                  'CHANNEL',
                                                  'CHAT',
                                                  'COMPANY',
                                                  'DOCUMENT',
                                                  'PROJECT',
                                                  'TASK',
                                                  'THREAD',
                                                  'USER',
                                                ])
                                                .describe(
                                                  'Type of entity that can be referenced by entity properties.'
                                                ),
                                              specific_message_id: zod
                                                .uuid()
                                                .nullish()
                                                .describe(
                                                  'For CHANNEL, CHAT, THREAD entity types - optional specific message ID.\nThis allows referencing a specific message within a thread\/channel\/chat.'
                                                ),
                                            })
                                            .describe(
                                              'Entity reference for entity-type property values.'
                                            )
                                        )
                                        .describe(
                                          'Entity reference(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"EntityReference\", \"value\": [{...}]} (length 0 or 1)\nMulti-select: {\"type\": \"EntityReference\", \"value\": [{...}, {...}, ...]} (length 0+)'
                                        ),
                                    })
                                    .describe(
                                      'Entity reference(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"EntityReference\", \"value\": [{...}]} (length 0 or 1)\nMulti-select: {\"type\": \"EntityReference\", \"value\": [{...}, {...}, ...]} (length 0+)'
                                    ),
                                  zod
                                    .object({
                                      type: zod.enum(['Link']),
                                      value: zod
                                        .array(zod.string())
                                        .describe(
                                          'Link value(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"Link\", \"value\": [\"https:\/\/example.com\"]} (length 0 or 1)\nMulti-select: {\"type\": \"Link\", \"value\": [\"https:\/\/example.com\", \"https:\/\/other.com\"]} (length 0+)'
                                        ),
                                    })
                                    .describe(
                                      'Link value(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"Link\", \"value\": [\"https:\/\/example.com\"]} (length 0 or 1)\nMulti-select: {\"type\": \"Link\", \"value\": [\"https:\/\/example.com\", \"https:\/\/other.com\"]} (length 0+)'
                                    ),
                                ])
                                .describe(
                                  'Property value (service representation).\n\nRepresents the actual value stored for an entity property.\nThis is serialized to\/from JSONB in the database.'
                                ),
                            ])
                            .optional(),
                        })
                        .describe(
                          'A property attached to a Soup item.\n\nThis is a simplified representation that includes only the definition and value,\nomitting the entity property assignment metadata and options.'
                        )
                    )
                    .describe('Properties attached to the entity.'),
                })
                .describe(
                  'Property fields that can be flattened into property-bearing Soup items.'
                )
                .and(
                  zod.object({
                    createdAt: zod.iso
                      .datetime({})
                      .describe('The time the project was created'),
                    deletedAt: zod.iso
                      .datetime({})
                      .nullish()
                      .describe('The time the project was deleted'),
                    id: zod.uuid().describe('The id of the project'),
                    name: zod.string().describe('The name of the project'),
                    ownerId: zod
                      .string()
                      .describe('The user id of who created the project'),
                    parentId: zod
                      .uuid()
                      .nullish()
                      .describe('The parent project id'),
                    updatedAt: zod.iso
                      .datetime({})
                      .describe('The time the project was updated'),
                    viewedAt: zod.iso
                      .datetime({})
                      .nullish()
                      .describe('The time the document was last viewed'),
                  })
                )
                .describe('A project as displayed in Soup.'),
              tag: zod.enum(['project']),
            })
            .describe('Project item.'),
          zod
            .object({
              data: zod
                .object({
                  createdAt: zod.iso
                    .datetime({})
                    .describe('Timestamp when the thread was created.'),
                  id: zod.uuid().describe('Thread id.'),
                  inboxVisible: zod
                    .boolean()
                    .describe('Whether the thread should appear in the inbox.'),
                  isDraft: zod
                    .boolean()
                    .describe('Whether the thread contains a draft.'),
                  isImportant: zod
                    .boolean()
                    .describe('Whether the thread is marked important.'),
                  isRead: zod
                    .boolean()
                    .describe('Whether the thread has been read.'),
                  name: zod
                    .string()
                    .nullish()
                    .describe('Thread display name or subject.'),
                  ownerId: zod.string().describe('Owner user id.'),
                  projectId: zod
                    .string()
                    .nullish()
                    .describe('Project id associated with the thread.'),
                  providerId: zod
                    .string()
                    .nullish()
                    .describe('Provider-specific thread id.'),
                  senderEmail: zod
                    .string()
                    .nullish()
                    .describe('Sender email address for the preview.'),
                  senderName: zod
                    .string()
                    .nullish()
                    .describe('Sender display name for the preview.'),
                  senderPhotoUrl: zod
                    .string()
                    .nullish()
                    .describe('Sender photo URL for the preview.'),
                  snippet: zod.string().nullish().describe('Thread snippet.'),
                  sortTs: zod.iso
                    .datetime({})
                    .describe('Timestamp used for email thread sorting.'),
                  updatedAt: zod.iso
                    .datetime({})
                    .describe('Timestamp when the thread was last updated.'),
                  viewedAt: zod.iso
                    .datetime({})
                    .nullish()
                    .describe(
                      'Timestamp when the requesting user last viewed the thread.'
                    ),
                })
                .describe('Email thread preview data as displayed in Soup.')
                .and(
                  zod
                    .object({
                      properties: zod
                        .array(
                          zod
                            .object({
                              definition: zod
                                .object({
                                  created_at: zod.iso.datetime({}),
                                  data_type: zod
                                    .enum([
                                      'BOOLEAN',
                                      'DATE',
                                      'NUMBER',
                                      'STRING',
                                      'SELECT_NUMBER',
                                      'SELECT_STRING',
                                      'TAG',
                                      'ENTITY',
                                      'LINK',
                                    ])
                                    .describe(
                                      'Data type for property values, determining storage and validation.'
                                    ),
                                  display_name: zod.string(),
                                  id: zod.uuid(),
                                  is_metadata: zod
                                    .boolean()
                                    .describe(
                                      'Flag to indicate if this is a system-generated metadata property.\nNot stored in database - computed at service layer.'
                                    ),
                                  is_multi_select: zod.boolean(),
                                  is_system: zod
                                    .boolean()
                                    .describe(
                                      'Flag to indicate if this is a system property (stored in DB).'
                                    ),
                                  owner: zod
                                    .union([
                                      zod
                                        .object({
                                          scope: zod.enum(['user']),
                                          user_id: zod.string(),
                                        })
                                        .describe('User-scoped property.'),
                                      zod
                                        .object({
                                          scope: zod.enum(['team']),
                                          team_id: zod.uuid(),
                                        })
                                        .describe('Team-scoped property.'),
                                      zod
                                        .object({
                                          scope: zod.enum(['system']),
                                        })
                                        .describe(
                                          'System-owned property (no user or team owner).'
                                        ),
                                    ])
                                    .describe(
                                      'Defines who owns a property - user-scoped, team-scoped, or system.'
                                    ),
                                  specific_entity_type: zod
                                    .union([
                                      zod.null(),
                                      zod
                                        .enum([
                                          'CALENDAR_EVENT',
                                          'CALL_RECORD',
                                          'CHANNEL',
                                          'CHAT',
                                          'COMPANY',
                                          'DOCUMENT',
                                          'PROJECT',
                                          'TASK',
                                          'THREAD',
                                          'USER',
                                        ])
                                        .describe(
                                          'Type of entity that can be referenced by entity properties.'
                                        ),
                                    ])
                                    .optional(),
                                  updated_at: zod.iso.datetime({}),
                                })
                                .describe(
                                  'Property definition model (service representation).'
                                ),
                              id: zod
                                .uuid()
                                .describe(
                                  'Globally unique id of the assignment attaching this property to an entity.'
                                ),
                              value: zod
                                .union([
                                  zod.null(),
                                  zod
                                    .union([
                                      zod
                                        .object({
                                          type: zod.enum(['Boolean']),
                                          value: zod
                                            .boolean()
                                            .describe(
                                              'Boolean value\nSerializes as: {\"type\": \"Boolean\", \"value\": true}'
                                            ),
                                        })
                                        .describe(
                                          'Boolean value\nSerializes as: {\"type\": \"Boolean\", \"value\": true}'
                                        ),
                                      zod
                                        .object({
                                          type: zod.enum(['Number']),
                                          value: zod
                                            .number()
                                            .describe(
                                              'Numeric value\nSerializes as: {\"type\": \"Number\", \"value\": 42.5}'
                                            ),
                                        })
                                        .describe(
                                          'Numeric value\nSerializes as: {\"type\": \"Number\", \"value\": 42.5}'
                                        ),
                                      zod
                                        .object({
                                          type: zod.enum(['String']),
                                          value: zod
                                            .string()
                                            .describe(
                                              'String value\nSerializes as: {\"type\": \"String\", \"value\": \"text\"}'
                                            ),
                                        })
                                        .describe(
                                          'String value\nSerializes as: {\"type\": \"String\", \"value\": \"text\"}'
                                        ),
                                      zod
                                        .object({
                                          type: zod.enum(['Date']),
                                          value: zod.iso
                                            .datetime({})
                                            .describe(
                                              'Date\/timestamp value\nSerializes as: {\"type\": \"Date\", \"value\": \"2025-01-01T00:00:00Z\"}'
                                            ),
                                        })
                                        .describe(
                                          'Date\/timestamp value\nSerializes as: {\"type\": \"Date\", \"value\": \"2025-01-01T00:00:00Z\"}'
                                        ),
                                      zod
                                        .object({
                                          type: zod.enum(['SelectOption']),
                                          value: zod
                                            .array(zod.uuid())
                                            .describe(
                                              'Select option(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"SelectOption\", \"value\": [\"uuid\"]} (length 0 or 1)\nMulti-select: {\"type\": \"SelectOption\", \"value\": [\"uuid1\", \"uuid2\", ...]} (length 0+)'
                                            ),
                                        })
                                        .describe(
                                          'Select option(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"SelectOption\", \"value\": [\"uuid\"]} (length 0 or 1)\nMulti-select: {\"type\": \"SelectOption\", \"value\": [\"uuid1\", \"uuid2\", ...]} (length 0+)'
                                        ),
                                      zod
                                        .object({
                                          type: zod.enum(['EntityReference']),
                                          value: zod
                                            .array(
                                              zod
                                                .object({
                                                  entity_id: zod.string(),
                                                  entity_type: zod
                                                    .enum([
                                                      'CALENDAR_EVENT',
                                                      'CALL_RECORD',
                                                      'CHANNEL',
                                                      'CHAT',
                                                      'COMPANY',
                                                      'DOCUMENT',
                                                      'PROJECT',
                                                      'TASK',
                                                      'THREAD',
                                                      'USER',
                                                    ])
                                                    .describe(
                                                      'Type of entity that can be referenced by entity properties.'
                                                    ),
                                                  specific_message_id: zod
                                                    .uuid()
                                                    .nullish()
                                                    .describe(
                                                      'For CHANNEL, CHAT, THREAD entity types - optional specific message ID.\nThis allows referencing a specific message within a thread\/channel\/chat.'
                                                    ),
                                                })
                                                .describe(
                                                  'Entity reference for entity-type property values.'
                                                )
                                            )
                                            .describe(
                                              'Entity reference(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"EntityReference\", \"value\": [{...}]} (length 0 or 1)\nMulti-select: {\"type\": \"EntityReference\", \"value\": [{...}, {...}, ...]} (length 0+)'
                                            ),
                                        })
                                        .describe(
                                          'Entity reference(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"EntityReference\", \"value\": [{...}]} (length 0 or 1)\nMulti-select: {\"type\": \"EntityReference\", \"value\": [{...}, {...}, ...]} (length 0+)'
                                        ),
                                      zod
                                        .object({
                                          type: zod.enum(['Link']),
                                          value: zod
                                            .array(zod.string())
                                            .describe(
                                              'Link value(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"Link\", \"value\": [\"https:\/\/example.com\"]} (length 0 or 1)\nMulti-select: {\"type\": \"Link\", \"value\": [\"https:\/\/example.com\", \"https:\/\/other.com\"]} (length 0+)'
                                            ),
                                        })
                                        .describe(
                                          'Link value(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"Link\", \"value\": [\"https:\/\/example.com\"]} (length 0 or 1)\nMulti-select: {\"type\": \"Link\", \"value\": [\"https:\/\/example.com\", \"https:\/\/other.com\"]} (length 0+)'
                                        ),
                                    ])
                                    .describe(
                                      'Property value (service representation).\n\nRepresents the actual value stored for an entity property.\nThis is serialized to\/from JSONB in the database.'
                                    ),
                                ])
                                .optional(),
                            })
                            .describe(
                              'A property attached to a Soup item.\n\nThis is a simplified representation that includes only the definition and value,\nomitting the entity property assignment metadata and options.'
                            )
                        )
                        .describe('Properties attached to the entity.'),
                    })
                    .describe(
                      'Property fields that can be flattened into property-bearing Soup items.'
                    )
                )
                .and(
                  zod.object({
                    attachments: zod
                      .array(
                        zod
                          .object({
                            contentId: zod
                              .string()
                              .nullish()
                              .describe('Content id for inline attachments.'),
                            createdAt: zod.iso
                              .datetime({})
                              .describe(
                                'Timestamp when the attachment was created.'
                              ),
                            filename: zod
                              .string()
                              .nullish()
                              .describe('Attachment filename.'),
                            id: zod.uuid().describe('Attachment id.'),
                            messageId: zod
                              .uuid()
                              .describe(
                                'Message id that owns this attachment.'
                              ),
                            mimeType: zod
                              .string()
                              .nullish()
                              .describe('Attachment MIME type.'),
                            providerAttachmentId: zod
                              .string()
                              .nullish()
                              .describe('Provider-specific attachment id.'),
                            sizeBytes: zod
                              .number()
                              .nullish()
                              .describe('Attachment size in bytes.'),
                          })
                          .describe('An email attachment as displayed in Soup.')
                      )
                      .describe('Attachments on the thread.'),
                    labels: zod
                      .array(
                        zod
                          .object({
                            createdAt: zod.iso
                              .datetime({})
                              .describe(
                                'Timestamp when the label was created.'
                              ),
                            id: zod.uuid().describe('Label id.'),
                            labelListVisibility: zod
                              .enum([
                                'labelShow',
                                'labelShowIfUnread',
                                'labelHide',
                              ])
                              .describe('Gmail-style label list visibility.'),
                            linkId: zod
                              .uuid()
                              .describe(
                                'Connected account link id for the label.'
                              ),
                            messageListVisibility: zod
                              .enum(['show', 'hide'])
                              .describe(
                                'Gmail-style message list visibility for a label.'
                              ),
                            name: zod.string().describe('Label display name.'),
                            providerLabelId: zod
                              .string()
                              .describe('Provider-specific label id.'),
                            type: zod
                              .enum(['system', 'user'])
                              .describe(
                                'Whether an email label is provider-created or user-created.'
                              ),
                          })
                          .describe('An email label as displayed in Soup.')
                      )
                      .describe('Labels attached to the thread.'),
                    participants: zod
                      .array(
                        zod
                          .object({
                            emailAddress: zod
                              .string()
                              .nullish()
                              .describe('Contact email address.'),
                            id: zod.uuid().describe('Contact id.'),
                            linkId: zod
                              .uuid()
                              .describe(
                                'Connected account link id for the contact.'
                              ),
                            name: zod
                              .string()
                              .nullish()
                              .describe('Contact display name.'),
                            sfsPhotoUrl: zod
                              .string()
                              .nullish()
                              .describe(
                                'Contact photo URL from SFS, if available.'
                              ),
                          })
                          .describe(
                            'A contact participating in an email thread as displayed in Soup.'
                          )
                      )
                      .describe('Contacts participating in the thread.'),
                  })
                )
                .describe(
                  'Email thread preview enriched with related metadata for Soup.'
                ),
              tag: zod.enum(['emailThread']),
            })
            .describe('Email thread item.'),
          zod
            .object({
              data: zod
                .object({
                  channel: zod
                    .object({
                      channel_type: zod
                        .enum(['public', 'private', 'direct_message', 'team'])
                        .describe('Type of channel.'),
                      created_at: zod.iso
                        .datetime({})
                        .describe('Creation timestamp.'),
                      id: zod.uuid().describe('Channel id.'),
                      name: zod
                        .string()
                        .nullish()
                        .describe('Channel display name.'),
                      org_id: zod
                        .number()
                        .min(
                          postItemsSoupAstResponseItemsItemDataChannelOrgIdMin
                        )
                        .nullish()
                        .describe('Organization id.'),
                      owner_id: zod.string().describe('Channel owner.'),
                      team_id: zod.uuid().nullish().describe('Team id.'),
                      updated_at: zod.iso
                        .datetime({})
                        .describe('Update timestamp.'),
                    })
                    .describe('Channel metadata in soup payloads.'),
                  is_participant: zod
                    .boolean()
                    .optional()
                    .describe(
                      "Whether the requesting user is an active participant of the channel.\nFalse for team channels of the user's teams they have not joined."
                    ),
                  participants: zod
                    .array(
                      zod
                        .object({
                          channel_id: zod
                            .uuid()
                            .describe(
                              'Channel id for the participant membership.'
                            ),
                          joined_at: zod.iso
                            .datetime({})
                            .describe(
                              'Timestamp when the participant joined the channel.'
                            ),
                          left_at: zod.iso
                            .datetime({})
                            .nullish()
                            .describe(
                              'Timestamp when the participant left the channel, if any.'
                            ),
                          role: zod
                            .enum(['owner', 'admin', 'member'])
                            .describe('The role a user has within a channel.'),
                          user_id: zod
                            .string()
                            .describe('Participant user id.'),
                        })
                        .describe("A user's membership in a channel.")
                    )
                    .describe('Participants in the channel.'),
                })
                .describe('Channel metadata together with its participants.')
                .and(
                  zod
                    .object({
                      latest_message: zod
                        .union([
                          zod.null(),
                          zod
                            .object({
                              content: zod
                                .string()
                                .describe('Message content.'),
                              created_at: zod.iso
                                .datetime({})
                                .describe('Creation timestamp.'),
                              deleted_at: zod.iso
                                .datetime({})
                                .nullish()
                                .describe('Deletion timestamp.'),
                              mentions: zod
                                .array(zod.string())
                                .describe(
                                  'Message mentions formatted as `{ENTITY_TYPE}:{ENTITY_ID}`.'
                                ),
                              message_id: zod.uuid().describe('Message id.'),
                              sender_id: zod.string().describe('Sender id.'),
                              thread_id: zod
                                .uuid()
                                .nullish()
                                .describe('Thread parent id.'),
                              updated_at: zod.iso
                                .datetime({})
                                .describe('Update timestamp.'),
                            })
                            .describe(
                              'Lightweight channel message for soup payloads.'
                            ),
                        ])
                        .optional(),
                      latest_non_thread_message: zod
                        .union([
                          zod.null(),
                          zod
                            .object({
                              content: zod
                                .string()
                                .describe('Message content.'),
                              created_at: zod.iso
                                .datetime({})
                                .describe('Creation timestamp.'),
                              deleted_at: zod.iso
                                .datetime({})
                                .nullish()
                                .describe('Deletion timestamp.'),
                              mentions: zod
                                .array(zod.string())
                                .describe(
                                  'Message mentions formatted as `{ENTITY_TYPE}:{ENTITY_ID}`.'
                                ),
                              message_id: zod.uuid().describe('Message id.'),
                              sender_id: zod.string().describe('Sender id.'),
                              thread_id: zod
                                .uuid()
                                .nullish()
                                .describe('Thread parent id.'),
                              updated_at: zod.iso
                                .datetime({})
                                .describe('Update timestamp.'),
                            })
                            .describe(
                              'Lightweight channel message for soup payloads.'
                            ),
                        ])
                        .optional(),
                    })
                    .describe('Latest-message bundle for soup payloads.')
                )
                .and(
                  zod.object({
                    interacted_at: zod.iso
                      .datetime({})
                      .nullish()
                      .describe(
                        'Timestamp when the requesting user last interacted with this channel.'
                      ),
                    viewed_at: zod.iso
                      .datetime({})
                      .nullish()
                      .describe(
                        'Timestamp when the requesting user last viewed this channel.'
                      ),
                  })
                )
                .describe('A channel as displayed in Soup.'),
              tag: zod.enum(['channel']),
            })
            .describe('Channel item.'),
          zod
            .object({
              data: zod
                .object({
                  attachments: zod
                    .array(
                      zod
                        .object({
                          created_at: zod.iso
                            .datetime({})
                            .describe('Creation timestamp.'),
                          entity_id: zod.string().describe('Entity id.'),
                          entity_type: zod.string().describe('Type of entity.'),
                          height: zod
                            .number()
                            .nullish()
                            .describe('Height for images.'),
                          id: zod.uuid().describe('Attachment id.'),
                          width: zod
                            .number()
                            .nullish()
                            .describe('Width for images.'),
                        })
                        .describe('An attachment on a message.')
                    )
                    .describe('Attachments on this message.'),
                  channel_id: zod.uuid().describe('Channel id.'),
                  content: zod.string().describe('Message content.'),
                  created_at: zod.iso
                    .datetime({})
                    .describe('Creation timestamp.'),
                  deleted_at: zod.iso
                    .datetime({})
                    .nullish()
                    .describe('Deletion timestamp.'),
                  edited_at: zod.iso
                    .datetime({})
                    .nullish()
                    .describe('Edit timestamp.'),
                  id: zod.uuid().describe('Message id.'),
                  reactions: zod
                    .array(
                      zod
                        .object({
                          emoji: zod.string().describe('Emoji string.'),
                          users: zod
                            .array(zod.string())
                            .describe('User ids who added this reaction.'),
                        })
                        .describe('A reaction with emoji and user list.')
                    )
                    .describe('Reactions on this message.'),
                  sender: zod
                    .object({
                      avatar_url: zod
                        .string()
                        .nullish()
                        .describe('Avatar URL for bot senders.'),
                      id: zod
                        .string()
                        .describe(
                          'Sender id without the storage namespace prefix.'
                        ),
                      name: zod
                        .string()
                        .nullish()
                        .describe('Display name for bot senders.'),
                      type: zod
                        .enum(['user', 'bot'])
                        .describe(
                          'Public sender type for soup channel messages.'
                        ),
                    })
                    .describe(
                      'Public sender identity for soup channel messages.'
                    ),
                  sender_id: zod.string().describe('Sender id.'),
                  thread: zod
                    .object({
                      latest_reply_at: zod.iso
                        .datetime({})
                        .nullish()
                        .describe('Timestamp of the latest reply.'),
                      preview: zod
                        .array(
                          zod
                            .object({
                              attachments: zod
                                .array(
                                  zod
                                    .object({
                                      created_at: zod.iso
                                        .datetime({})
                                        .describe('Creation timestamp.'),
                                      entity_id: zod
                                        .string()
                                        .describe('Entity id.'),
                                      entity_type: zod
                                        .string()
                                        .describe('Type of entity.'),
                                      height: zod
                                        .number()
                                        .nullish()
                                        .describe('Height for images.'),
                                      id: zod.uuid().describe('Attachment id.'),
                                      width: zod
                                        .number()
                                        .nullish()
                                        .describe('Width for images.'),
                                    })
                                    .describe('An attachment on a message.')
                                )
                                .describe('Attachments on this reply.'),
                              content: zod.string().describe('Reply content.'),
                              created_at: zod.iso
                                .datetime({})
                                .describe('Creation timestamp.'),
                              edited_at: zod.iso
                                .datetime({})
                                .nullish()
                                .describe('Edit timestamp.'),
                              id: zod.uuid().describe('Reply id.'),
                              reactions: zod
                                .array(
                                  zod
                                    .object({
                                      emoji: zod
                                        .string()
                                        .describe('Emoji string.'),
                                      users: zod
                                        .array(zod.string())
                                        .describe(
                                          'User ids who added this reaction.'
                                        ),
                                    })
                                    .describe(
                                      'A reaction with emoji and user list.'
                                    )
                                )
                                .describe('Reactions on this reply.'),
                              sender: zod
                                .object({
                                  avatar_url: zod
                                    .string()
                                    .nullish()
                                    .describe('Avatar URL for bot senders.'),
                                  id: zod
                                    .string()
                                    .describe(
                                      'Sender id without the storage namespace prefix.'
                                    ),
                                  name: zod
                                    .string()
                                    .nullish()
                                    .describe('Display name for bot senders.'),
                                  type: zod
                                    .enum(['user', 'bot'])
                                    .describe(
                                      'Public sender type for soup channel messages.'
                                    ),
                                })
                                .describe(
                                  'Public sender identity for soup channel messages.'
                                ),
                              sender_id: zod.string().describe('Sender id.'),
                              updated_at: zod.iso
                                .datetime({})
                                .describe('Update timestamp.'),
                            })
                            .describe('A thread reply shown in preview.')
                        )
                        .describe('Preview replies.'),
                      reply_count: zod.number().describe('Total reply count.'),
                    })
                    .describe(
                      'Thread metadata and preview replies for soup channel messages.'
                    ),
                  updated_at: zod.iso
                    .datetime({})
                    .describe('Update timestamp.'),
                })
                .describe(
                  'A top-level channel message thread for soup payloads.\n\nThis mirrors the public channel-message API shape so soup consumers can\nrender a thread root the same way they render a channel timeline message.'
                ),
              tag: zod.enum(['channelThread']),
            })
            .describe('Channel thread item.'),
          zod
            .object({
              data: zod
                .object({
                  properties: zod
                    .array(
                      zod
                        .object({
                          definition: zod
                            .object({
                              created_at: zod.iso.datetime({}),
                              data_type: zod
                                .enum([
                                  'BOOLEAN',
                                  'DATE',
                                  'NUMBER',
                                  'STRING',
                                  'SELECT_NUMBER',
                                  'SELECT_STRING',
                                  'TAG',
                                  'ENTITY',
                                  'LINK',
                                ])
                                .describe(
                                  'Data type for property values, determining storage and validation.'
                                ),
                              display_name: zod.string(),
                              id: zod.uuid(),
                              is_metadata: zod
                                .boolean()
                                .describe(
                                  'Flag to indicate if this is a system-generated metadata property.\nNot stored in database - computed at service layer.'
                                ),
                              is_multi_select: zod.boolean(),
                              is_system: zod
                                .boolean()
                                .describe(
                                  'Flag to indicate if this is a system property (stored in DB).'
                                ),
                              owner: zod
                                .union([
                                  zod
                                    .object({
                                      scope: zod.enum(['user']),
                                      user_id: zod.string(),
                                    })
                                    .describe('User-scoped property.'),
                                  zod
                                    .object({
                                      scope: zod.enum(['team']),
                                      team_id: zod.uuid(),
                                    })
                                    .describe('Team-scoped property.'),
                                  zod
                                    .object({
                                      scope: zod.enum(['system']),
                                    })
                                    .describe(
                                      'System-owned property (no user or team owner).'
                                    ),
                                ])
                                .describe(
                                  'Defines who owns a property - user-scoped, team-scoped, or system.'
                                ),
                              specific_entity_type: zod
                                .union([
                                  zod.null(),
                                  zod
                                    .enum([
                                      'CALENDAR_EVENT',
                                      'CALL_RECORD',
                                      'CHANNEL',
                                      'CHAT',
                                      'COMPANY',
                                      'DOCUMENT',
                                      'PROJECT',
                                      'TASK',
                                      'THREAD',
                                      'USER',
                                    ])
                                    .describe(
                                      'Type of entity that can be referenced by entity properties.'
                                    ),
                                ])
                                .optional(),
                              updated_at: zod.iso.datetime({}),
                            })
                            .describe(
                              'Property definition model (service representation).'
                            ),
                          id: zod
                            .uuid()
                            .describe(
                              'Globally unique id of the assignment attaching this property to an entity.'
                            ),
                          value: zod
                            .union([
                              zod.null(),
                              zod
                                .union([
                                  zod
                                    .object({
                                      type: zod.enum(['Boolean']),
                                      value: zod
                                        .boolean()
                                        .describe(
                                          'Boolean value\nSerializes as: {\"type\": \"Boolean\", \"value\": true}'
                                        ),
                                    })
                                    .describe(
                                      'Boolean value\nSerializes as: {\"type\": \"Boolean\", \"value\": true}'
                                    ),
                                  zod
                                    .object({
                                      type: zod.enum(['Number']),
                                      value: zod
                                        .number()
                                        .describe(
                                          'Numeric value\nSerializes as: {\"type\": \"Number\", \"value\": 42.5}'
                                        ),
                                    })
                                    .describe(
                                      'Numeric value\nSerializes as: {\"type\": \"Number\", \"value\": 42.5}'
                                    ),
                                  zod
                                    .object({
                                      type: zod.enum(['String']),
                                      value: zod
                                        .string()
                                        .describe(
                                          'String value\nSerializes as: {\"type\": \"String\", \"value\": \"text\"}'
                                        ),
                                    })
                                    .describe(
                                      'String value\nSerializes as: {\"type\": \"String\", \"value\": \"text\"}'
                                    ),
                                  zod
                                    .object({
                                      type: zod.enum(['Date']),
                                      value: zod.iso
                                        .datetime({})
                                        .describe(
                                          'Date\/timestamp value\nSerializes as: {\"type\": \"Date\", \"value\": \"2025-01-01T00:00:00Z\"}'
                                        ),
                                    })
                                    .describe(
                                      'Date\/timestamp value\nSerializes as: {\"type\": \"Date\", \"value\": \"2025-01-01T00:00:00Z\"}'
                                    ),
                                  zod
                                    .object({
                                      type: zod.enum(['SelectOption']),
                                      value: zod
                                        .array(zod.uuid())
                                        .describe(
                                          'Select option(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"SelectOption\", \"value\": [\"uuid\"]} (length 0 or 1)\nMulti-select: {\"type\": \"SelectOption\", \"value\": [\"uuid1\", \"uuid2\", ...]} (length 0+)'
                                        ),
                                    })
                                    .describe(
                                      'Select option(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"SelectOption\", \"value\": [\"uuid\"]} (length 0 or 1)\nMulti-select: {\"type\": \"SelectOption\", \"value\": [\"uuid1\", \"uuid2\", ...]} (length 0+)'
                                    ),
                                  zod
                                    .object({
                                      type: zod.enum(['EntityReference']),
                                      value: zod
                                        .array(
                                          zod
                                            .object({
                                              entity_id: zod.string(),
                                              entity_type: zod
                                                .enum([
                                                  'CALENDAR_EVENT',
                                                  'CALL_RECORD',
                                                  'CHANNEL',
                                                  'CHAT',
                                                  'COMPANY',
                                                  'DOCUMENT',
                                                  'PROJECT',
                                                  'TASK',
                                                  'THREAD',
                                                  'USER',
                                                ])
                                                .describe(
                                                  'Type of entity that can be referenced by entity properties.'
                                                ),
                                              specific_message_id: zod
                                                .uuid()
                                                .nullish()
                                                .describe(
                                                  'For CHANNEL, CHAT, THREAD entity types - optional specific message ID.\nThis allows referencing a specific message within a thread\/channel\/chat.'
                                                ),
                                            })
                                            .describe(
                                              'Entity reference for entity-type property values.'
                                            )
                                        )
                                        .describe(
                                          'Entity reference(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"EntityReference\", \"value\": [{...}]} (length 0 or 1)\nMulti-select: {\"type\": \"EntityReference\", \"value\": [{...}, {...}, ...]} (length 0+)'
                                        ),
                                    })
                                    .describe(
                                      'Entity reference(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"EntityReference\", \"value\": [{...}]} (length 0 or 1)\nMulti-select: {\"type\": \"EntityReference\", \"value\": [{...}, {...}, ...]} (length 0+)'
                                    ),
                                  zod
                                    .object({
                                      type: zod.enum(['Link']),
                                      value: zod
                                        .array(zod.string())
                                        .describe(
                                          'Link value(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"Link\", \"value\": [\"https:\/\/example.com\"]} (length 0 or 1)\nMulti-select: {\"type\": \"Link\", \"value\": [\"https:\/\/example.com\", \"https:\/\/other.com\"]} (length 0+)'
                                        ),
                                    })
                                    .describe(
                                      'Link value(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"Link\", \"value\": [\"https:\/\/example.com\"]} (length 0 or 1)\nMulti-select: {\"type\": \"Link\", \"value\": [\"https:\/\/example.com\", \"https:\/\/other.com\"]} (length 0+)'
                                    ),
                                ])
                                .describe(
                                  'Property value (service representation).\n\nRepresents the actual value stored for an entity property.\nThis is serialized to\/from JSONB in the database.'
                                ),
                            ])
                            .optional(),
                        })
                        .describe(
                          'A property attached to a Soup item.\n\nThis is a simplified representation that includes only the definition and value,\nomitting the entity property assignment metadata and options.'
                        )
                    )
                    .describe('Properties attached to the entity.'),
                })
                .describe(
                  'Property fields that can be flattened into property-bearing Soup items.'
                )
                .and(
                  zod.object({
                    attended: zod
                      .boolean()
                      .describe(
                        'Whether the requesting user attended this call. Kept for compatibility\nand derived from `status == ATTENDED`.'
                      ),
                    callId: zod.uuid().describe('The call identifier.'),
                    channelId: zod
                      .uuid()
                      .describe('The channel this call belongs to.'),
                    channelName: zod
                      .string()
                      .nullish()
                      .describe('Resolved display name for the channel.'),
                    createdBy: zod
                      .string()
                      .describe('User who created the call.'),
                    customName: zod
                      .string()
                      .nullish()
                      .describe(
                        'User-supplied or AI-generated display name for the call.'
                      ),
                    durationMs: zod
                      .number()
                      .nullish()
                      .describe(
                        'Call duration in milliseconds (None if still active).'
                      ),
                    endedAt: zod.iso
                      .datetime({})
                      .nullish()
                      .describe('When the call ended (None if still active).'),
                    isActive: zod
                      .boolean()
                      .describe('Whether the call is currently active.'),
                    participants: zod
                      .array(
                        zod
                          .object({
                            joinedAt: zod.iso
                              .datetime({})
                              .describe('When the user joined the call.'),
                            leftAt: zod.iso
                              .datetime({})
                              .nullish()
                              .describe(
                                'When the user left (None if still in an active call).'
                              ),
                            userId: zod.string().describe('The user id.'),
                          })
                          .describe(
                            'A participant in a call record, as displayed in Soup.'
                          )
                      )
                      .describe('Participants in the call.'),
                    startedAt: zod.iso
                      .datetime({})
                      .describe('When the call started.'),
                    status: zod
                      .enum(['ATTENDED', 'MISSED', 'UNATTENDED'])
                      .describe(
                        'Viewer-relative attendance status for a call record.\nSerializes as `ATTENDED`, `MISSED`, or `UNATTENDED`.'
                      ),
                    summary: zod
                      .string()
                      .nullish()
                      .describe(
                        'AI-generated summary of the call. Only set on archived\n`call_records` once summarization has run; active calls always\nreturn `None`.'
                      ),
                  })
                )
                .describe(
                  'A call record as displayed in Soup. Excludes room_name, egress_id,\nand transcript — fields that are irrelevant for the soup feed.'
                ),
              tag: zod.enum(['call']),
            })
            .describe('Call record item.'),
          zod
            .object({
              data: zod
                .object({
                  conferenceProvider: zod
                    .string()
                    .nullish()
                    .describe(
                      'Which conferencing system backs `conference_url`.'
                    ),
                  conferenceUrl: zod
                    .string()
                    .nullish()
                    .describe('Direct conference join URL.'),
                  createdAt: zod.iso
                    .datetime({})
                    .describe('Entity creation timestamp.'),
                  description: zod
                    .string()
                    .nullish()
                    .describe('Optional description.'),
                  extra: zod
                    .object({
                      properties: zod
                        .array(
                          zod
                            .object({
                              definition: zod
                                .object({
                                  created_at: zod.iso.datetime({}),
                                  data_type: zod
                                    .enum([
                                      'BOOLEAN',
                                      'DATE',
                                      'NUMBER',
                                      'STRING',
                                      'SELECT_NUMBER',
                                      'SELECT_STRING',
                                      'TAG',
                                      'ENTITY',
                                      'LINK',
                                    ])
                                    .describe(
                                      'Data type for property values, determining storage and validation.'
                                    ),
                                  display_name: zod.string(),
                                  id: zod.uuid(),
                                  is_metadata: zod
                                    .boolean()
                                    .describe(
                                      'Flag to indicate if this is a system-generated metadata property.\nNot stored in database - computed at service layer.'
                                    ),
                                  is_multi_select: zod.boolean(),
                                  is_system: zod
                                    .boolean()
                                    .describe(
                                      'Flag to indicate if this is a system property (stored in DB).'
                                    ),
                                  owner: zod
                                    .union([
                                      zod
                                        .object({
                                          scope: zod.enum(['user']),
                                          user_id: zod.string(),
                                        })
                                        .describe('User-scoped property.'),
                                      zod
                                        .object({
                                          scope: zod.enum(['team']),
                                          team_id: zod.uuid(),
                                        })
                                        .describe('Team-scoped property.'),
                                      zod
                                        .object({
                                          scope: zod.enum(['system']),
                                        })
                                        .describe(
                                          'System-owned property (no user or team owner).'
                                        ),
                                    ])
                                    .describe(
                                      'Defines who owns a property - user-scoped, team-scoped, or system.'
                                    ),
                                  specific_entity_type: zod
                                    .union([
                                      zod.null(),
                                      zod
                                        .enum([
                                          'CALENDAR_EVENT',
                                          'CALL_RECORD',
                                          'CHANNEL',
                                          'CHAT',
                                          'COMPANY',
                                          'DOCUMENT',
                                          'PROJECT',
                                          'TASK',
                                          'THREAD',
                                          'USER',
                                        ])
                                        .describe(
                                          'Type of entity that can be referenced by entity properties.'
                                        ),
                                    ])
                                    .optional(),
                                  updated_at: zod.iso.datetime({}),
                                })
                                .describe(
                                  'Property definition model (service representation).'
                                ),
                              id: zod
                                .uuid()
                                .describe(
                                  'Globally unique id of the assignment attaching this property to an entity.'
                                ),
                              value: zod
                                .union([
                                  zod.null(),
                                  zod
                                    .union([
                                      zod
                                        .object({
                                          type: zod.enum(['Boolean']),
                                          value: zod
                                            .boolean()
                                            .describe(
                                              'Boolean value\nSerializes as: {\"type\": \"Boolean\", \"value\": true}'
                                            ),
                                        })
                                        .describe(
                                          'Boolean value\nSerializes as: {\"type\": \"Boolean\", \"value\": true}'
                                        ),
                                      zod
                                        .object({
                                          type: zod.enum(['Number']),
                                          value: zod
                                            .number()
                                            .describe(
                                              'Numeric value\nSerializes as: {\"type\": \"Number\", \"value\": 42.5}'
                                            ),
                                        })
                                        .describe(
                                          'Numeric value\nSerializes as: {\"type\": \"Number\", \"value\": 42.5}'
                                        ),
                                      zod
                                        .object({
                                          type: zod.enum(['String']),
                                          value: zod
                                            .string()
                                            .describe(
                                              'String value\nSerializes as: {\"type\": \"String\", \"value\": \"text\"}'
                                            ),
                                        })
                                        .describe(
                                          'String value\nSerializes as: {\"type\": \"String\", \"value\": \"text\"}'
                                        ),
                                      zod
                                        .object({
                                          type: zod.enum(['Date']),
                                          value: zod.iso
                                            .datetime({})
                                            .describe(
                                              'Date\/timestamp value\nSerializes as: {\"type\": \"Date\", \"value\": \"2025-01-01T00:00:00Z\"}'
                                            ),
                                        })
                                        .describe(
                                          'Date\/timestamp value\nSerializes as: {\"type\": \"Date\", \"value\": \"2025-01-01T00:00:00Z\"}'
                                        ),
                                      zod
                                        .object({
                                          type: zod.enum(['SelectOption']),
                                          value: zod
                                            .array(zod.uuid())
                                            .describe(
                                              'Select option(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"SelectOption\", \"value\": [\"uuid\"]} (length 0 or 1)\nMulti-select: {\"type\": \"SelectOption\", \"value\": [\"uuid1\", \"uuid2\", ...]} (length 0+)'
                                            ),
                                        })
                                        .describe(
                                          'Select option(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"SelectOption\", \"value\": [\"uuid\"]} (length 0 or 1)\nMulti-select: {\"type\": \"SelectOption\", \"value\": [\"uuid1\", \"uuid2\", ...]} (length 0+)'
                                        ),
                                      zod
                                        .object({
                                          type: zod.enum(['EntityReference']),
                                          value: zod
                                            .array(
                                              zod
                                                .object({
                                                  entity_id: zod.string(),
                                                  entity_type: zod
                                                    .enum([
                                                      'CALENDAR_EVENT',
                                                      'CALL_RECORD',
                                                      'CHANNEL',
                                                      'CHAT',
                                                      'COMPANY',
                                                      'DOCUMENT',
                                                      'PROJECT',
                                                      'TASK',
                                                      'THREAD',
                                                      'USER',
                                                    ])
                                                    .describe(
                                                      'Type of entity that can be referenced by entity properties.'
                                                    ),
                                                  specific_message_id: zod
                                                    .uuid()
                                                    .nullish()
                                                    .describe(
                                                      'For CHANNEL, CHAT, THREAD entity types - optional specific message ID.\nThis allows referencing a specific message within a thread\/channel\/chat.'
                                                    ),
                                                })
                                                .describe(
                                                  'Entity reference for entity-type property values.'
                                                )
                                            )
                                            .describe(
                                              'Entity reference(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"EntityReference\", \"value\": [{...}]} (length 0 or 1)\nMulti-select: {\"type\": \"EntityReference\", \"value\": [{...}, {...}, ...]} (length 0+)'
                                            ),
                                        })
                                        .describe(
                                          'Entity reference(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"EntityReference\", \"value\": [{...}]} (length 0 or 1)\nMulti-select: {\"type\": \"EntityReference\", \"value\": [{...}, {...}, ...]} (length 0+)'
                                        ),
                                      zod
                                        .object({
                                          type: zod.enum(['Link']),
                                          value: zod
                                            .array(zod.string())
                                            .describe(
                                              'Link value(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"Link\", \"value\": [\"https:\/\/example.com\"]} (length 0 or 1)\nMulti-select: {\"type\": \"Link\", \"value\": [\"https:\/\/example.com\", \"https:\/\/other.com\"]} (length 0+)'
                                            ),
                                        })
                                        .describe(
                                          'Link value(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"Link\", \"value\": [\"https:\/\/example.com\"]} (length 0 or 1)\nMulti-select: {\"type\": \"Link\", \"value\": [\"https:\/\/example.com\", \"https:\/\/other.com\"]} (length 0+)'
                                        ),
                                    ])
                                    .describe(
                                      'Property value (service representation).\n\nRepresents the actual value stored for an entity property.\nThis is serialized to\/from JSONB in the database.'
                                    ),
                                ])
                                .optional(),
                            })
                            .describe(
                              'A property attached to a Soup item.\n\nThis is a simplified representation that includes only the definition and value,\nomitting the entity property assignment metadata and options.'
                            )
                        )
                        .describe('Properties attached to the entity.'),
                    })
                    .describe(
                      'Property fields that can be flattened into property-bearing Soup items.'
                    ),
                  icalUid: zod
                    .string()
                    .describe('RFC 5545 UID used for source reconciliation.'),
                  id: zod.uuid().describe('Entity identifier.'),
                  isReadOnly: zod
                    .boolean()
                    .describe(
                      'Whether the selected canonical source is read-only.'
                    ),
                  location: zod
                    .string()
                    .nullish()
                    .describe('Optional location label.'),
                  organizerEmail: zod
                    .string()
                    .nullish()
                    .describe('Organizer email.'),
                  organizerName: zod
                    .string()
                    .nullish()
                    .describe('Organizer display name.'),
                  ownerId: zod.string().describe('Owning Macro user.'),
                  status: zod.string().describe('Canonical status.'),
                  time: zod
                    .union([
                      zod
                        .object({
                          endsAt: zod.iso
                            .datetime({})
                            .describe('Exclusive end.'),
                          kind: zod.enum(['timed']),
                          startsAt: zod.iso
                            .datetime({})
                            .describe('Inclusive start.'),
                          timeZone: zod
                            .string()
                            .nullish()
                            .describe('Original IANA time zone.'),
                        })
                        .describe('Absolute timed event.'),
                      zod
                        .object({
                          endDate: zod.iso
                            .date()
                            .describe('Exclusive end date.'),
                          kind: zod.enum(['allDay']),
                          startDate: zod.iso
                            .date()
                            .describe('Inclusive start date.'),
                        })
                        .describe('All-day event with an exclusive end date.'),
                    ])
                    .describe(
                      'Timed or all-day calendar event span.\n\nFields are camelCased per variant rather than via `rename_all_fields`,\nwhich utoipa ignores — the generated OpenAPI schema would otherwise\nclaim snake_case fields the wire never carries.'
                    ),
                  title: zod.string().describe('Display title.'),
                  transparency: zod
                    .string()
                    .describe('Availability transparency.'),
                  updatedAt: zod.iso
                    .datetime({})
                    .describe('Entity update timestamp.'),
                  visibility: zod.string().describe('Canonical visibility.'),
                })
                .describe('A canonical calendar event entity in Soup.'),
              tag: zod.enum(['calendarEvent']),
            })
            .describe('Calendar event item.'),
          zod
            .object({
              data: zod
                .object({
                  properties: zod
                    .array(
                      zod
                        .object({
                          definition: zod
                            .object({
                              created_at: zod.iso.datetime({}),
                              data_type: zod
                                .enum([
                                  'BOOLEAN',
                                  'DATE',
                                  'NUMBER',
                                  'STRING',
                                  'SELECT_NUMBER',
                                  'SELECT_STRING',
                                  'TAG',
                                  'ENTITY',
                                  'LINK',
                                ])
                                .describe(
                                  'Data type for property values, determining storage and validation.'
                                ),
                              display_name: zod.string(),
                              id: zod.uuid(),
                              is_metadata: zod
                                .boolean()
                                .describe(
                                  'Flag to indicate if this is a system-generated metadata property.\nNot stored in database - computed at service layer.'
                                ),
                              is_multi_select: zod.boolean(),
                              is_system: zod
                                .boolean()
                                .describe(
                                  'Flag to indicate if this is a system property (stored in DB).'
                                ),
                              owner: zod
                                .union([
                                  zod
                                    .object({
                                      scope: zod.enum(['user']),
                                      user_id: zod.string(),
                                    })
                                    .describe('User-scoped property.'),
                                  zod
                                    .object({
                                      scope: zod.enum(['team']),
                                      team_id: zod.uuid(),
                                    })
                                    .describe('Team-scoped property.'),
                                  zod
                                    .object({
                                      scope: zod.enum(['system']),
                                    })
                                    .describe(
                                      'System-owned property (no user or team owner).'
                                    ),
                                ])
                                .describe(
                                  'Defines who owns a property - user-scoped, team-scoped, or system.'
                                ),
                              specific_entity_type: zod
                                .union([
                                  zod.null(),
                                  zod
                                    .enum([
                                      'CALENDAR_EVENT',
                                      'CALL_RECORD',
                                      'CHANNEL',
                                      'CHAT',
                                      'COMPANY',
                                      'DOCUMENT',
                                      'PROJECT',
                                      'TASK',
                                      'THREAD',
                                      'USER',
                                    ])
                                    .describe(
                                      'Type of entity that can be referenced by entity properties.'
                                    ),
                                ])
                                .optional(),
                              updated_at: zod.iso.datetime({}),
                            })
                            .describe(
                              'Property definition model (service representation).'
                            ),
                          id: zod
                            .uuid()
                            .describe(
                              'Globally unique id of the assignment attaching this property to an entity.'
                            ),
                          value: zod
                            .union([
                              zod.null(),
                              zod
                                .union([
                                  zod
                                    .object({
                                      type: zod.enum(['Boolean']),
                                      value: zod
                                        .boolean()
                                        .describe(
                                          'Boolean value\nSerializes as: {\"type\": \"Boolean\", \"value\": true}'
                                        ),
                                    })
                                    .describe(
                                      'Boolean value\nSerializes as: {\"type\": \"Boolean\", \"value\": true}'
                                    ),
                                  zod
                                    .object({
                                      type: zod.enum(['Number']),
                                      value: zod
                                        .number()
                                        .describe(
                                          'Numeric value\nSerializes as: {\"type\": \"Number\", \"value\": 42.5}'
                                        ),
                                    })
                                    .describe(
                                      'Numeric value\nSerializes as: {\"type\": \"Number\", \"value\": 42.5}'
                                    ),
                                  zod
                                    .object({
                                      type: zod.enum(['String']),
                                      value: zod
                                        .string()
                                        .describe(
                                          'String value\nSerializes as: {\"type\": \"String\", \"value\": \"text\"}'
                                        ),
                                    })
                                    .describe(
                                      'String value\nSerializes as: {\"type\": \"String\", \"value\": \"text\"}'
                                    ),
                                  zod
                                    .object({
                                      type: zod.enum(['Date']),
                                      value: zod.iso
                                        .datetime({})
                                        .describe(
                                          'Date\/timestamp value\nSerializes as: {\"type\": \"Date\", \"value\": \"2025-01-01T00:00:00Z\"}'
                                        ),
                                    })
                                    .describe(
                                      'Date\/timestamp value\nSerializes as: {\"type\": \"Date\", \"value\": \"2025-01-01T00:00:00Z\"}'
                                    ),
                                  zod
                                    .object({
                                      type: zod.enum(['SelectOption']),
                                      value: zod
                                        .array(zod.uuid())
                                        .describe(
                                          'Select option(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"SelectOption\", \"value\": [\"uuid\"]} (length 0 or 1)\nMulti-select: {\"type\": \"SelectOption\", \"value\": [\"uuid1\", \"uuid2\", ...]} (length 0+)'
                                        ),
                                    })
                                    .describe(
                                      'Select option(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"SelectOption\", \"value\": [\"uuid\"]} (length 0 or 1)\nMulti-select: {\"type\": \"SelectOption\", \"value\": [\"uuid1\", \"uuid2\", ...]} (length 0+)'
                                    ),
                                  zod
                                    .object({
                                      type: zod.enum(['EntityReference']),
                                      value: zod
                                        .array(
                                          zod
                                            .object({
                                              entity_id: zod.string(),
                                              entity_type: zod
                                                .enum([
                                                  'CALENDAR_EVENT',
                                                  'CALL_RECORD',
                                                  'CHANNEL',
                                                  'CHAT',
                                                  'COMPANY',
                                                  'DOCUMENT',
                                                  'PROJECT',
                                                  'TASK',
                                                  'THREAD',
                                                  'USER',
                                                ])
                                                .describe(
                                                  'Type of entity that can be referenced by entity properties.'
                                                ),
                                              specific_message_id: zod
                                                .uuid()
                                                .nullish()
                                                .describe(
                                                  'For CHANNEL, CHAT, THREAD entity types - optional specific message ID.\nThis allows referencing a specific message within a thread\/channel\/chat.'
                                                ),
                                            })
                                            .describe(
                                              'Entity reference for entity-type property values.'
                                            )
                                        )
                                        .describe(
                                          'Entity reference(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"EntityReference\", \"value\": [{...}]} (length 0 or 1)\nMulti-select: {\"type\": \"EntityReference\", \"value\": [{...}, {...}, ...]} (length 0+)'
                                        ),
                                    })
                                    .describe(
                                      'Entity reference(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"EntityReference\", \"value\": [{...}]} (length 0 or 1)\nMulti-select: {\"type\": \"EntityReference\", \"value\": [{...}, {...}, ...]} (length 0+)'
                                    ),
                                  zod
                                    .object({
                                      type: zod.enum(['Link']),
                                      value: zod
                                        .array(zod.string())
                                        .describe(
                                          'Link value(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"Link\", \"value\": [\"https:\/\/example.com\"]} (length 0 or 1)\nMulti-select: {\"type\": \"Link\", \"value\": [\"https:\/\/example.com\", \"https:\/\/other.com\"]} (length 0+)'
                                        ),
                                    })
                                    .describe(
                                      'Link value(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"Link\", \"value\": [\"https:\/\/example.com\"]} (length 0 or 1)\nMulti-select: {\"type\": \"Link\", \"value\": [\"https:\/\/example.com\", \"https:\/\/other.com\"]} (length 0+)'
                                    ),
                                ])
                                .describe(
                                  'Property value (service representation).\n\nRepresents the actual value stored for an entity property.\nThis is serialized to\/from JSONB in the database.'
                                ),
                            ])
                            .optional(),
                        })
                        .describe(
                          'A property attached to a Soup item.\n\nThis is a simplified representation that includes only the definition and value,\nomitting the entity property assignment metadata and options.'
                        )
                    )
                    .describe('Properties attached to the entity.'),
                })
                .describe(
                  'Property fields that can be flattened into property-bearing Soup items.'
                )
                .and(
                  zod.object({
                    createdAt: zod.iso
                      .datetime({})
                      .describe('When the company was created.'),
                    description: zod
                      .string()
                      .nullish()
                      .describe(
                        "Display description from the primary domain's directory entry."
                      ),
                    domains: zod
                      .array(
                        zod
                          .object({
                            companyId: zod
                              .uuid()
                              .describe(
                                'The id of the company the domain belongs to.'
                              ),
                            createdAt: zod.iso
                              .datetime({})
                              .describe('When the domain record was created.'),
                            domain: zod
                              .string()
                              .describe(
                                'The domain (lowercased, e.g. \"acme.com\").'
                              ),
                            id: zod
                              .uuid()
                              .describe('The id of the domain record.'),
                          })
                          .describe(
                            "A CRM domain as displayed in Soup. Mirrors the crm crate's\n[`CrmDomain`] with a stable wire shape that the FE can rely on."
                          )
                      )
                      .describe(
                        'Domains associated with this company, ordered by creation time\nascending (primary first).'
                      ),
                    emailSync: zod
                      .boolean()
                      .describe(
                        'Whether email sync is enabled for this company.'
                      ),
                    hidden: zod
                      .boolean()
                      .describe(
                        'Whether the company is hidden from CRM listings. Soup filters\nthese out by default.'
                      ),
                    id: zod.uuid().describe('The id of the company.'),
                    name: zod
                      .string()
                      .nullish()
                      .describe(
                        "Display name from the primary domain's directory entry, or\n`None` when unresolved."
                      ),
                    teamId: zod
                      .uuid()
                      .describe(
                        'The id of the team that owns this company record.'
                      ),
                    updatedAt: zod.iso
                      .datetime({})
                      .describe('When the company was last updated.'),
                    viewedAt: zod.iso
                      .datetime({})
                      .nullish()
                      .describe(
                        'When the requesting user last viewed this company, or `None` if\nnever viewed. Mirrors the `viewed_at` other soup entities carry.'
                      ),
                  })
                )
                .describe(
                  'A CRM company as displayed in Soup. Carries the core company\nfields plus display metadata resolved from `crm_domain_directory`\nagainst the primary (earliest-created) domain.'
                ),
              tag: zod.enum(['crmCompany']),
            })
            .describe('CRM company item.'),
          zod
            .object({
              data: zod
                .object({
                  createdAt: zod.iso
                    .datetime({})
                    .describe('Timestamp when the record was created.'),
                  foreignEntityId: zod
                    .string()
                    .describe('Identifier assigned by the external system.'),
                  foreignEntitySource: zod
                    .string()
                    .describe(
                      'Source system that owns the external identifier.'
                    ),
                  id: zod
                    .uuid()
                    .describe(
                      'Internal primary key for this foreign entity record.'
                    ),
                  metadata: zod
                    .object({})
                    .describe('Arbitrary metadata stored with the mapping.'),
                  storedForAuthEntity: zod
                    .string()
                    .describe(
                      'Internal auth entity namespace this foreign entity is stored for.'
                    ),
                  storedForId: zod
                    .string()
                    .describe(
                      'Internal entity identifier this foreign entity is stored for.'
                    ),
                  updatedAt: zod.iso
                    .datetime({})
                    .describe('Timestamp when the record was last updated.'),
                })
                .describe('A foreign entity record as displayed in Soup.'),
              tag: zod.enum(['foreignEntity']),
            })
            .describe('Foreign entity item.'),
          zod
            .object({
              data: zod
                .object({
                  properties: zod
                    .array(
                      zod
                        .object({
                          definition: zod
                            .object({
                              created_at: zod.iso.datetime({}),
                              data_type: zod
                                .enum([
                                  'BOOLEAN',
                                  'DATE',
                                  'NUMBER',
                                  'STRING',
                                  'SELECT_NUMBER',
                                  'SELECT_STRING',
                                  'TAG',
                                  'ENTITY',
                                  'LINK',
                                ])
                                .describe(
                                  'Data type for property values, determining storage and validation.'
                                ),
                              display_name: zod.string(),
                              id: zod.uuid(),
                              is_metadata: zod
                                .boolean()
                                .describe(
                                  'Flag to indicate if this is a system-generated metadata property.\nNot stored in database - computed at service layer.'
                                ),
                              is_multi_select: zod.boolean(),
                              is_system: zod
                                .boolean()
                                .describe(
                                  'Flag to indicate if this is a system property (stored in DB).'
                                ),
                              owner: zod
                                .union([
                                  zod
                                    .object({
                                      scope: zod.enum(['user']),
                                      user_id: zod.string(),
                                    })
                                    .describe('User-scoped property.'),
                                  zod
                                    .object({
                                      scope: zod.enum(['team']),
                                      team_id: zod.uuid(),
                                    })
                                    .describe('Team-scoped property.'),
                                  zod
                                    .object({
                                      scope: zod.enum(['system']),
                                    })
                                    .describe(
                                      'System-owned property (no user or team owner).'
                                    ),
                                ])
                                .describe(
                                  'Defines who owns a property - user-scoped, team-scoped, or system.'
                                ),
                              specific_entity_type: zod
                                .union([
                                  zod.null(),
                                  zod
                                    .enum([
                                      'CALENDAR_EVENT',
                                      'CALL_RECORD',
                                      'CHANNEL',
                                      'CHAT',
                                      'COMPANY',
                                      'DOCUMENT',
                                      'PROJECT',
                                      'TASK',
                                      'THREAD',
                                      'USER',
                                    ])
                                    .describe(
                                      'Type of entity that can be referenced by entity properties.'
                                    ),
                                ])
                                .optional(),
                              updated_at: zod.iso.datetime({}),
                            })
                            .describe(
                              'Property definition model (service representation).'
                            ),
                          id: zod
                            .uuid()
                            .describe(
                              'Globally unique id of the assignment attaching this property to an entity.'
                            ),
                          value: zod
                            .union([
                              zod.null(),
                              zod
                                .union([
                                  zod
                                    .object({
                                      type: zod.enum(['Boolean']),
                                      value: zod
                                        .boolean()
                                        .describe(
                                          'Boolean value\nSerializes as: {\"type\": \"Boolean\", \"value\": true}'
                                        ),
                                    })
                                    .describe(
                                      'Boolean value\nSerializes as: {\"type\": \"Boolean\", \"value\": true}'
                                    ),
                                  zod
                                    .object({
                                      type: zod.enum(['Number']),
                                      value: zod
                                        .number()
                                        .describe(
                                          'Numeric value\nSerializes as: {\"type\": \"Number\", \"value\": 42.5}'
                                        ),
                                    })
                                    .describe(
                                      'Numeric value\nSerializes as: {\"type\": \"Number\", \"value\": 42.5}'
                                    ),
                                  zod
                                    .object({
                                      type: zod.enum(['String']),
                                      value: zod
                                        .string()
                                        .describe(
                                          'String value\nSerializes as: {\"type\": \"String\", \"value\": \"text\"}'
                                        ),
                                    })
                                    .describe(
                                      'String value\nSerializes as: {\"type\": \"String\", \"value\": \"text\"}'
                                    ),
                                  zod
                                    .object({
                                      type: zod.enum(['Date']),
                                      value: zod.iso
                                        .datetime({})
                                        .describe(
                                          'Date\/timestamp value\nSerializes as: {\"type\": \"Date\", \"value\": \"2025-01-01T00:00:00Z\"}'
                                        ),
                                    })
                                    .describe(
                                      'Date\/timestamp value\nSerializes as: {\"type\": \"Date\", \"value\": \"2025-01-01T00:00:00Z\"}'
                                    ),
                                  zod
                                    .object({
                                      type: zod.enum(['SelectOption']),
                                      value: zod
                                        .array(zod.uuid())
                                        .describe(
                                          'Select option(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"SelectOption\", \"value\": [\"uuid\"]} (length 0 or 1)\nMulti-select: {\"type\": \"SelectOption\", \"value\": [\"uuid1\", \"uuid2\", ...]} (length 0+)'
                                        ),
                                    })
                                    .describe(
                                      'Select option(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"SelectOption\", \"value\": [\"uuid\"]} (length 0 or 1)\nMulti-select: {\"type\": \"SelectOption\", \"value\": [\"uuid1\", \"uuid2\", ...]} (length 0+)'
                                    ),
                                  zod
                                    .object({
                                      type: zod.enum(['EntityReference']),
                                      value: zod
                                        .array(
                                          zod
                                            .object({
                                              entity_id: zod.string(),
                                              entity_type: zod
                                                .enum([
                                                  'CALENDAR_EVENT',
                                                  'CALL_RECORD',
                                                  'CHANNEL',
                                                  'CHAT',
                                                  'COMPANY',
                                                  'DOCUMENT',
                                                  'PROJECT',
                                                  'TASK',
                                                  'THREAD',
                                                  'USER',
                                                ])
                                                .describe(
                                                  'Type of entity that can be referenced by entity properties.'
                                                ),
                                              specific_message_id: zod
                                                .uuid()
                                                .nullish()
                                                .describe(
                                                  'For CHANNEL, CHAT, THREAD entity types - optional specific message ID.\nThis allows referencing a specific message within a thread\/channel\/chat.'
                                                ),
                                            })
                                            .describe(
                                              'Entity reference for entity-type property values.'
                                            )
                                        )
                                        .describe(
                                          'Entity reference(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"EntityReference\", \"value\": [{...}]} (length 0 or 1)\nMulti-select: {\"type\": \"EntityReference\", \"value\": [{...}, {...}, ...]} (length 0+)'
                                        ),
                                    })
                                    .describe(
                                      'Entity reference(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"EntityReference\", \"value\": [{...}]} (length 0 or 1)\nMulti-select: {\"type\": \"EntityReference\", \"value\": [{...}, {...}, ...]} (length 0+)'
                                    ),
                                  zod
                                    .object({
                                      type: zod.enum(['Link']),
                                      value: zod
                                        .array(zod.string())
                                        .describe(
                                          'Link value(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"Link\", \"value\": [\"https:\/\/example.com\"]} (length 0 or 1)\nMulti-select: {\"type\": \"Link\", \"value\": [\"https:\/\/example.com\", \"https:\/\/other.com\"]} (length 0+)'
                                        ),
                                    })
                                    .describe(
                                      'Link value(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"Link\", \"value\": [\"https:\/\/example.com\"]} (length 0 or 1)\nMulti-select: {\"type\": \"Link\", \"value\": [\"https:\/\/example.com\", \"https:\/\/other.com\"]} (length 0+)'
                                    ),
                                ])
                                .describe(
                                  'Property value (service representation).\n\nRepresents the actual value stored for an entity property.\nThis is serialized to\/from JSONB in the database.'
                                ),
                            ])
                            .optional(),
                        })
                        .describe(
                          'A property attached to a Soup item.\n\nThis is a simplified representation that includes only the definition and value,\nomitting the entity property assignment metadata and options.'
                        )
                    )
                    .describe('Properties attached to the entity.'),
                })
                .describe(
                  'Property fields that can be flattened into property-bearing Soup items.'
                )
                .and(
                  zod.object({
                    completedAt: zod.iso
                      .datetime({})
                      .nullish()
                      .describe('Set once a one-shot reminder has fired.'),
                    createdAt: zod.iso
                      .datetime({})
                      .describe('When the reminder was created.'),
                    description: zod
                      .string()
                      .describe(
                        'What to remind the user about. Doubles as the display name.'
                      ),
                    enabled: zod
                      .boolean()
                      .describe(
                        'When false, the dispatcher skips this reminder.'
                      ),
                    id: zod.uuid().describe('The reminder id.'),
                    nextRunAt: zod.iso
                      .datetime({})
                      .describe(
                        'The next firing. This is what Soup sorts reminders on.'
                      ),
                    referencedEntity: zod
                      .union([
                        zod.null(),
                        zod
                          .object({
                            entityType: zod
                              .enum([
                                'user',
                                'chat',
                                'channel',
                                'channel_message',
                                'document',
                                'project',
                                'email_thread',
                                'calendar_event',
                                'team',
                                'call',
                                'foreign_entity',
                                'static_file',
                                'crm_company',
                                'crm_contact',
                                'reminder',
                                'skill',
                              ])
                              .describe('The type of an entity in Macro')
                              .describe("The referenced entity's type."),
                            fileType: zod
                              .string()
                              .nullish()
                              .describe(
                                'File type, when the reference is a document — `md`, `pdf`, and so on.'
                              ),
                            id: zod
                              .string()
                              .describe("The referenced entity's id."),
                            subType: zod
                              .string()
                              .nullish()
                              .describe(
                                'Sub type, when the reference is a task or snippet document.'
                              ),
                          })
                          .describe(
                            "The entity a reminder is about, resolved server-side.\n\nA reminder has no block of its own — it opens, and is iconed as, whatever it\nreferences. Which block that is depends on the referenced document's file\ntype, and the client's icon path is synchronous, so this is resolved here\nrather than costing a fetch per row."
                          ),
                      ])
                      .optional(),
                    schedule: zod
                      .union([
                        zod
                          .object({
                            remindAt: zod.iso
                              .datetime({})
                              .describe('The instant to fire at.'),
                            type: zod.enum(['once']),
                          })
                          .describe('Fires once, at a fixed instant.'),
                        zod
                          .object({
                            cron: zod
                              .string()
                              .describe(
                                'Cron expression, normalized to the 6-field form.'
                              ),
                            timezone: zod
                              .string()
                              .describe(
                                'The timezone the cron expression is evaluated in.'
                              ),
                            type: zod.enum(['recurring']),
                          })
                          .describe(
                            'Fires repeatedly, on a cron schedule evaluated in `timezone`.'
                          ),
                      ])
                      .describe(
                        'How often a reminder fires, flattened for the wire.\n\nThe domain\'s [`ReminderSchedule`] is an internally-tagged enum carrying a\nvalidated cron type; Soup only needs enough to render \"once\" vs \"every\nweekday at 9am\", so the cron is exposed as a plain string.'
                      ),
                    updatedAt: zod.iso
                      .datetime({})
                      .describe('When the reminder was last modified.'),
                  })
                )
                .describe(
                  "A reminder as displayed in Soup.\n\nReminders are user-owned rather than shared, so unlike most Soup items they\ncarry no access metadata — the repository only ever returns the caller's own."
                ),
              tag: zod.enum(['reminder']),
            })
            .describe('Reminder item.'),
        ])
        .describe('A single item in the Soup feed.')
        .and(
          zod.object({
            frecency_score: zod.number(),
            is_favorited: zod
              .boolean()
              .describe(
                'Whether the requesting user has favorited this entity.'
              ),
          })
        )
        .describe('API representation of a soup item with its frecency score.')
    ),
    next_cursor: zod.string().nullish(),
  })
  .describe('Response page for non-grouped soup endpoints.');

/**
 * @summary Gets the items grouped by the specified field using AST filters.
 */
export const postItemsSoupAstGroupedQueryParams = zod.object({
  cursor: zod.string().optional().describe('Base64 encoded cursor value.'),
});

export const postItemsSoupAstGroupedBodyPerGroupLimitMin = 0;

export const postItemsSoupAstGroupedBodyLimitMin = 0;

export const postItemsSoupAstGroupedBody = zod
  .union([
    zod
      .object({
        calf: zod
          .unknown()
          .optional()
          .describe('filters applied to canonical calendar events'),
        callf: zod
          .unknown()
          .optional()
          .describe('the filters that should be applied to the call entity'),
        ccf: zod
          .unknown()
          .optional()
          .describe(
            "Filters applied to the crm_company entity (wire key `ccf`).\nEmpty\/omitted = team's full visible list."
          ),
        cf: zod
          .unknown()
          .optional()
          .describe('the filters that should be applied to the chat entity'),
        chanf: zod
          .unknown()
          .optional()
          .describe('the filters that should be applied to the channel entity'),
        cthf: zod
          .unknown()
          .optional()
          .describe(
            'the filters that should be applied to the channel-thread entity'
          ),
        df: zod
          .unknown()
          .optional()
          .describe(
            'the filters that should be applied to the document entity'
          ),
        eca: zod
          .array(zod.string())
          .optional()
          .describe(
            'CRM-scoped address filter (wire key: `eca`). Symmetric counterpart\nto `ecd` for fully-qualified email addresses.'
          ),
        ecd: zod
          .array(zod.string())
          .optional()
          .describe(
            'CRM-scoped domain filter (wire key: `ecd`). Parallel to the\nfreeform `ef` AST. Expanded by the router into an any-direction\nOR sub-tree AND-merged into `ef`, plus a `CrmScope` tag stamped\non the resulting [`item_filters::ast::EmailFilterAst::crm_scope`].\nDrives the per-team CRM authorization pre-check and candidate-set\nwidening downstream. Mutually exclusive with `eca`.'
          ),
        ef: zod
          .unknown()
          .optional()
          .describe(
            'the filters that should be applied to the email entity (raw AST\ntree only; CRM scope is carried by the `ecd` \/ `eca` sibling\nfields). On this endpoint the email filter stays a bare tree,\nunlike the materialized [`EntityFilterAst`] used for cursors.'
          ),
        fef: zod
          .unknown()
          .optional()
          .describe(
            'the filters that should be applied to foreign entity records'
          ),
        pf: zod
          .unknown()
          .optional()
          .describe('the filters that should be applied to the project entity'),
        propf: zod
          .unknown()
          .optional()
          .describe(
            'the filters that should be applied based on entity properties'
          ),
        remf: zod
          .unknown()
          .optional()
          .describe(
            'Filters applied to reminders (wire key `remf`). Unlike every other\nfilter here, empty\/omitted returns \*\*no\*\* reminders: they are opt-in,\nso the caller must send `inc`, an id, or an entity to get any.'
          ),
      })
      .describe('Wire-format entity filter AST accepted by soup AST endpoints.')
      .and(
        zod
          .object({
            group_by: zod
              .union([
                zod
                  .enum(['date'])
                  .describe(
                    'Smart date buckets: Today, Yesterday, This Week, Last Week, This Month, Last Month, Older'
                  ),
                zod
                  .enum(['entity_type'])
                  .describe(
                    'Group by entity type (document, email, channel, etc.)'
                  ),
                zod.enum(['project']).describe('Group by project'),
                zod
                  .object({
                    property: zod
                      .object({
                        entity_type: zod
                          .union([
                            zod.null(),
                            zod
                              .enum([
                                'CHANNEL',
                                'CHAT',
                                'COMPANY',
                                'DOCUMENT',
                                'PROJECT',
                                'TASK',
                                'THREAD',
                                'USER',
                              ])
                              .describe(
                                'Entity type for property lookups (API representation).'
                              ),
                          ])
                          .optional(),
                        property_definition_id: zod
                          .uuid()
                          .describe('The property definition UUID to group by'),
                      })
                      .describe(
                        'Group by a property value (e.g., status, priority, or custom properties)'
                      ),
                  })
                  .describe(
                    'Group by a property value (e.g., status, priority, or custom properties)'
                  ),
              ])
              .describe('API representation of group-by field.'),
            per_group_limit: zod
              .number()
              .min(postItemsSoupAstGroupedBodyPerGroupLimitMin)
              .nullish()
              .describe(
                'Limit the number of items returned per group. Defaults to 20. Max 500.'
              ),
            sort_method: zod
              .union([
                zod.null(),
                zod
                  .enum([
                    'viewed_at',
                    'created_at',
                    'updated_at',
                    'viewed_updated',
                  ])
                  .describe(
                    'Sort method for grouped queries (frecency not supported).'
                  ),
              ])
              .optional(),
          })
          .describe('Parameters for the initial grouped soup query.')
      )
      .describe('Request body for the initial grouped soup query.')
      .and(
        zod.object({
          mode: zod.enum(['initial']),
        })
      )
      .describe('Initial grouped soup request.'),
    zod
      .object({
        calf: zod
          .unknown()
          .optional()
          .describe('filters applied to canonical calendar events'),
        callf: zod
          .unknown()
          .optional()
          .describe('the filters that should be applied to the call entity'),
        ccf: zod
          .unknown()
          .optional()
          .describe(
            "Filters applied to the crm_company entity (wire key `ccf`).\nEmpty\/omitted = team's full visible list."
          ),
        cf: zod
          .unknown()
          .optional()
          .describe('the filters that should be applied to the chat entity'),
        chanf: zod
          .unknown()
          .optional()
          .describe('the filters that should be applied to the channel entity'),
        cthf: zod
          .unknown()
          .optional()
          .describe(
            'the filters that should be applied to the channel-thread entity'
          ),
        df: zod
          .unknown()
          .optional()
          .describe(
            'the filters that should be applied to the document entity'
          ),
        eca: zod
          .array(zod.string())
          .optional()
          .describe(
            'CRM-scoped address filter (wire key: `eca`). Symmetric counterpart\nto `ecd` for fully-qualified email addresses.'
          ),
        ecd: zod
          .array(zod.string())
          .optional()
          .describe(
            'CRM-scoped domain filter (wire key: `ecd`). Parallel to the\nfreeform `ef` AST. Expanded by the router into an any-direction\nOR sub-tree AND-merged into `ef`, plus a `CrmScope` tag stamped\non the resulting [`item_filters::ast::EmailFilterAst::crm_scope`].\nDrives the per-team CRM authorization pre-check and candidate-set\nwidening downstream. Mutually exclusive with `eca`.'
          ),
        ef: zod
          .unknown()
          .optional()
          .describe(
            'the filters that should be applied to the email entity (raw AST\ntree only; CRM scope is carried by the `ecd` \/ `eca` sibling\nfields). On this endpoint the email filter stays a bare tree,\nunlike the materialized [`EntityFilterAst`] used for cursors.'
          ),
        fef: zod
          .unknown()
          .optional()
          .describe(
            'the filters that should be applied to foreign entity records'
          ),
        pf: zod
          .unknown()
          .optional()
          .describe('the filters that should be applied to the project entity'),
        propf: zod
          .unknown()
          .optional()
          .describe(
            'the filters that should be applied based on entity properties'
          ),
        remf: zod
          .unknown()
          .optional()
          .describe(
            'Filters applied to reminders (wire key `remf`). Unlike every other\nfilter here, empty\/omitted returns \*\*no\*\* reminders: they are opt-in,\nso the caller must send `inc`, an id, or an entity to get any.'
          ),
      })
      .describe('Wire-format entity filter AST accepted by soup AST endpoints.')
      .and(
        zod
          .object({
            group_by: zod
              .union([
                zod
                  .enum(['date'])
                  .describe(
                    'Smart date buckets: Today, Yesterday, This Week, Last Week, This Month, Last Month, Older'
                  ),
                zod
                  .enum(['entity_type'])
                  .describe(
                    'Group by entity type (document, email, channel, etc.)'
                  ),
                zod.enum(['project']).describe('Group by project'),
                zod
                  .object({
                    property: zod
                      .object({
                        entity_type: zod
                          .union([
                            zod.null(),
                            zod
                              .enum([
                                'CHANNEL',
                                'CHAT',
                                'COMPANY',
                                'DOCUMENT',
                                'PROJECT',
                                'TASK',
                                'THREAD',
                                'USER',
                              ])
                              .describe(
                                'Entity type for property lookups (API representation).'
                              ),
                          ])
                          .optional(),
                        property_definition_id: zod
                          .uuid()
                          .describe('The property definition UUID to group by'),
                      })
                      .describe(
                        'Group by a property value (e.g., status, priority, or custom properties)'
                      ),
                  })
                  .describe(
                    'Group by a property value (e.g., status, priority, or custom properties)'
                  ),
              ])
              .describe('API representation of group-by field.'),
            group_key: zod.string().describe('Group key to fetch.'),
            limit: zod
              .number()
              .min(postItemsSoupAstGroupedBodyLimitMin)
              .nullish()
              .describe(
                'Limit the number of items returned. Defaults to 20. Max 500.'
              ),
            sort_method: zod
              .union([
                zod.null(),
                zod
                  .enum([
                    'viewed_at',
                    'created_at',
                    'updated_at',
                    'viewed_updated',
                  ])
                  .describe(
                    'Sort method for grouped queries (frecency not supported).'
                  ),
              ])
              .optional(),
          })
          .describe('Parameters for fetching one page within a specific group.')
      )
      .describe('Request body for fetching one page within a specific group.')
      .and(
        zod.object({
          mode: zod.enum(['group_page']),
        })
      )
      .describe('Request for a page within one group.'),
  ])
  .describe('Request body for grouped soup queries with AST filters.');

export const postItemsSoupAstGroupedResponseGroupsItemTotalCountMin = 0;

export const postItemsSoupAstGroupedResponseItemsDataChannelOrgIdMin = 0;

export const postItemsSoupAstGroupedResponseGroupTotalCountMin = 0;

export const postItemsSoupAstGroupedResponseItemsDataChannelOrgIdMinOne = 0;

export const postItemsSoupAstGroupedResponse = zod
  .union([
    zod
      .object({
        groups: zod
          .array(
            zod
              .object({
                display_order: zod
                  .number()
                  .nullish()
                  .describe('Display order for sorting groups (lower = first)'),
                item_ids: zod
                  .array(zod.uuid())
                  .describe(
                    'Ordered ids of items in this group for the current page.\nEach id keys into `GroupedSoupPage.items`.'
                  ),
                key: zod
                  .string()
                  .describe('Group key - format depends on group_by field'),
                label: zod
                  .string()
                  .describe('Human-readable label for the group'),
                next_cursor: zod
                  .string()
                  .nullish()
                  .describe(
                    'Cursor to load more items specifically from this group'
                  ),
                total_count: zod
                  .number()
                  .min(postItemsSoupAstGroupedResponseGroupsItemTotalCountMin)
                  .describe(
                    'Total count of items in this group across all pages'
                  ),
              })
              .describe(
                'API representation of group metadata.\n\nItems belonging to this group are referenced by `item_ids`, each of which\nlooks up an entry in `GroupedSoupPage.items` (a normalized pool).'
              )
          )
          .describe('Ordered group metadata for this grouped response.'),
        items: zod
          .record(
            zod.string(),
            zod
              .union([
                zod
                  .object({
                    data: zod
                      .object({
                        properties: zod
                          .array(
                            zod
                              .object({
                                definition: zod
                                  .object({
                                    created_at: zod.iso.datetime({}),
                                    data_type: zod
                                      .enum([
                                        'BOOLEAN',
                                        'DATE',
                                        'NUMBER',
                                        'STRING',
                                        'SELECT_NUMBER',
                                        'SELECT_STRING',
                                        'TAG',
                                        'ENTITY',
                                        'LINK',
                                      ])
                                      .describe(
                                        'Data type for property values, determining storage and validation.'
                                      ),
                                    display_name: zod.string(),
                                    id: zod.uuid(),
                                    is_metadata: zod
                                      .boolean()
                                      .describe(
                                        'Flag to indicate if this is a system-generated metadata property.\nNot stored in database - computed at service layer.'
                                      ),
                                    is_multi_select: zod.boolean(),
                                    is_system: zod
                                      .boolean()
                                      .describe(
                                        'Flag to indicate if this is a system property (stored in DB).'
                                      ),
                                    owner: zod
                                      .union([
                                        zod
                                          .object({
                                            scope: zod.enum(['user']),
                                            user_id: zod.string(),
                                          })
                                          .describe('User-scoped property.'),
                                        zod
                                          .object({
                                            scope: zod.enum(['team']),
                                            team_id: zod.uuid(),
                                          })
                                          .describe('Team-scoped property.'),
                                        zod
                                          .object({
                                            scope: zod.enum(['system']),
                                          })
                                          .describe(
                                            'System-owned property (no user or team owner).'
                                          ),
                                      ])
                                      .describe(
                                        'Defines who owns a property - user-scoped, team-scoped, or system.'
                                      ),
                                    specific_entity_type: zod
                                      .union([
                                        zod.null(),
                                        zod
                                          .enum([
                                            'CALENDAR_EVENT',
                                            'CALL_RECORD',
                                            'CHANNEL',
                                            'CHAT',
                                            'COMPANY',
                                            'DOCUMENT',
                                            'PROJECT',
                                            'TASK',
                                            'THREAD',
                                            'USER',
                                          ])
                                          .describe(
                                            'Type of entity that can be referenced by entity properties.'
                                          ),
                                      ])
                                      .optional(),
                                    updated_at: zod.iso.datetime({}),
                                  })
                                  .describe(
                                    'Property definition model (service representation).'
                                  ),
                                id: zod
                                  .uuid()
                                  .describe(
                                    'Globally unique id of the assignment attaching this property to an entity.'
                                  ),
                                value: zod
                                  .union([
                                    zod.null(),
                                    zod
                                      .union([
                                        zod
                                          .object({
                                            type: zod.enum(['Boolean']),
                                            value: zod
                                              .boolean()
                                              .describe(
                                                'Boolean value\nSerializes as: {\"type\": \"Boolean\", \"value\": true}'
                                              ),
                                          })
                                          .describe(
                                            'Boolean value\nSerializes as: {\"type\": \"Boolean\", \"value\": true}'
                                          ),
                                        zod
                                          .object({
                                            type: zod.enum(['Number']),
                                            value: zod
                                              .number()
                                              .describe(
                                                'Numeric value\nSerializes as: {\"type\": \"Number\", \"value\": 42.5}'
                                              ),
                                          })
                                          .describe(
                                            'Numeric value\nSerializes as: {\"type\": \"Number\", \"value\": 42.5}'
                                          ),
                                        zod
                                          .object({
                                            type: zod.enum(['String']),
                                            value: zod
                                              .string()
                                              .describe(
                                                'String value\nSerializes as: {\"type\": \"String\", \"value\": \"text\"}'
                                              ),
                                          })
                                          .describe(
                                            'String value\nSerializes as: {\"type\": \"String\", \"value\": \"text\"}'
                                          ),
                                        zod
                                          .object({
                                            type: zod.enum(['Date']),
                                            value: zod.iso
                                              .datetime({})
                                              .describe(
                                                'Date\/timestamp value\nSerializes as: {\"type\": \"Date\", \"value\": \"2025-01-01T00:00:00Z\"}'
                                              ),
                                          })
                                          .describe(
                                            'Date\/timestamp value\nSerializes as: {\"type\": \"Date\", \"value\": \"2025-01-01T00:00:00Z\"}'
                                          ),
                                        zod
                                          .object({
                                            type: zod.enum(['SelectOption']),
                                            value: zod
                                              .array(zod.uuid())
                                              .describe(
                                                'Select option(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"SelectOption\", \"value\": [\"uuid\"]} (length 0 or 1)\nMulti-select: {\"type\": \"SelectOption\", \"value\": [\"uuid1\", \"uuid2\", ...]} (length 0+)'
                                              ),
                                          })
                                          .describe(
                                            'Select option(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"SelectOption\", \"value\": [\"uuid\"]} (length 0 or 1)\nMulti-select: {\"type\": \"SelectOption\", \"value\": [\"uuid1\", \"uuid2\", ...]} (length 0+)'
                                          ),
                                        zod
                                          .object({
                                            type: zod.enum(['EntityReference']),
                                            value: zod
                                              .array(
                                                zod
                                                  .object({
                                                    entity_id: zod.string(),
                                                    entity_type: zod
                                                      .enum([
                                                        'CALENDAR_EVENT',
                                                        'CALL_RECORD',
                                                        'CHANNEL',
                                                        'CHAT',
                                                        'COMPANY',
                                                        'DOCUMENT',
                                                        'PROJECT',
                                                        'TASK',
                                                        'THREAD',
                                                        'USER',
                                                      ])
                                                      .describe(
                                                        'Type of entity that can be referenced by entity properties.'
                                                      ),
                                                    specific_message_id: zod
                                                      .uuid()
                                                      .nullish()
                                                      .describe(
                                                        'For CHANNEL, CHAT, THREAD entity types - optional specific message ID.\nThis allows referencing a specific message within a thread\/channel\/chat.'
                                                      ),
                                                  })
                                                  .describe(
                                                    'Entity reference for entity-type property values.'
                                                  )
                                              )
                                              .describe(
                                                'Entity reference(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"EntityReference\", \"value\": [{...}]} (length 0 or 1)\nMulti-select: {\"type\": \"EntityReference\", \"value\": [{...}, {...}, ...]} (length 0+)'
                                              ),
                                          })
                                          .describe(
                                            'Entity reference(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"EntityReference\", \"value\": [{...}]} (length 0 or 1)\nMulti-select: {\"type\": \"EntityReference\", \"value\": [{...}, {...}, ...]} (length 0+)'
                                          ),
                                        zod
                                          .object({
                                            type: zod.enum(['Link']),
                                            value: zod
                                              .array(zod.string())
                                              .describe(
                                                'Link value(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"Link\", \"value\": [\"https:\/\/example.com\"]} (length 0 or 1)\nMulti-select: {\"type\": \"Link\", \"value\": [\"https:\/\/example.com\", \"https:\/\/other.com\"]} (length 0+)'
                                              ),
                                          })
                                          .describe(
                                            'Link value(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"Link\", \"value\": [\"https:\/\/example.com\"]} (length 0 or 1)\nMulti-select: {\"type\": \"Link\", \"value\": [\"https:\/\/example.com\", \"https:\/\/other.com\"]} (length 0+)'
                                          ),
                                      ])
                                      .describe(
                                        'Property value (service representation).\n\nRepresents the actual value stored for an entity property.\nThis is serialized to\/from JSONB in the database.'
                                      ),
                                  ])
                                  .optional(),
                              })
                              .describe(
                                'A property attached to a Soup item.\n\nThis is a simplified representation that includes only the definition and value,\nomitting the entity property assignment metadata and options.'
                              )
                          )
                          .describe('Properties attached to the entity.'),
                      })
                      .describe(
                        'Property fields that can be flattened into property-bearing Soup items.'
                      )
                      .and(
                        zod.object({
                          branchedFromId: zod
                            .uuid()
                            .nullish()
                            .describe(
                              'The id of the document this document branched from'
                            ),
                          branchedFromVersionId: zod
                            .number()
                            .nullish()
                            .describe(
                              'The id of the version this document branched from\nThis could be either DocumentInstance or DocumentBom id depending on the file type'
                            ),
                          createdAt: zod.iso
                            .datetime({})
                            .describe('The time the document was created'),
                          deletedAt: zod.iso
                            .datetime({})
                            .nullish()
                            .describe('The time the document was deleted'),
                          documentFamilyId: zod
                            .number()
                            .nullish()
                            .describe(
                              'The id of the document family this document belongs to'
                            ),
                          documentVersionId: zod
                            .number()
                            .describe(
                              'The version of the document\nThis could be the document_instance_id or document_bom_id depending on the file type'
                            ),
                          fileType: zod
                            .string()
                            .nullish()
                            .describe(
                              'The file type of the document (e.g. pdf, docx)'
                            ),
                          id: zod.uuid().describe('The document id'),
                          name: zod
                            .string()
                            .describe('The name of the document'),
                          ownerId: zod
                            .string()
                            .describe('The owner of the document'),
                          projectId: zod
                            .uuid()
                            .nullish()
                            .describe(
                              'The id of the project that this document belongs to'
                            ),
                          sha: zod
                            .string()
                            .nullish()
                            .describe(
                              'If the document is a PDF, this is the SHA of the pdf\nIf the document is a DOCX, this will not be present'
                            ),
                          subType: zod
                            .union([
                              zod.null(),
                              zod
                                .union([
                                  zod
                                    .object({
                                      is_completed: zod
                                        .boolean()
                                        .describe(
                                          'Whether the task is completed.\nTrue if the Status property is set to \"Completed\".'
                                        ),
                                      type: zod.enum(['task']),
                                    })
                                    .describe(
                                      'A task document with its associated properties'
                                    ),
                                  zod
                                    .object({
                                      type: zod.enum(['snippet']),
                                    })
                                    .describe(
                                      'A snippet document — reusable markdown'
                                    ),
                                  zod
                                    .object({
                                      type: zod.enum(['skill']),
                                    })
                                    .describe(
                                      'A skill document — markdown instructions for AI'
                                    ),
                                ])
                                .describe(
                                  'Sub type of a document with associated properties encoded in each variant.\nThis ensures type-safety: task properties only exist when the document is a task.'
                                ),
                            ])
                            .optional(),
                          updatedAt: zod.iso
                            .datetime({})
                            .describe(
                              'The time the document instance \/ document BOM was updated'
                            ),
                          viewedAt: zod.iso
                            .datetime({})
                            .nullish()
                            .describe('The time the document was last viewed'),
                        })
                      )
                      .describe('A document as displayed in Soup.'),
                    tag: zod.enum(['document']),
                  })
                  .describe('Document item.'),
                zod
                  .object({
                    data: zod
                      .object({
                        properties: zod
                          .array(
                            zod
                              .object({
                                definition: zod
                                  .object({
                                    created_at: zod.iso.datetime({}),
                                    data_type: zod
                                      .enum([
                                        'BOOLEAN',
                                        'DATE',
                                        'NUMBER',
                                        'STRING',
                                        'SELECT_NUMBER',
                                        'SELECT_STRING',
                                        'TAG',
                                        'ENTITY',
                                        'LINK',
                                      ])
                                      .describe(
                                        'Data type for property values, determining storage and validation.'
                                      ),
                                    display_name: zod.string(),
                                    id: zod.uuid(),
                                    is_metadata: zod
                                      .boolean()
                                      .describe(
                                        'Flag to indicate if this is a system-generated metadata property.\nNot stored in database - computed at service layer.'
                                      ),
                                    is_multi_select: zod.boolean(),
                                    is_system: zod
                                      .boolean()
                                      .describe(
                                        'Flag to indicate if this is a system property (stored in DB).'
                                      ),
                                    owner: zod
                                      .union([
                                        zod
                                          .object({
                                            scope: zod.enum(['user']),
                                            user_id: zod.string(),
                                          })
                                          .describe('User-scoped property.'),
                                        zod
                                          .object({
                                            scope: zod.enum(['team']),
                                            team_id: zod.uuid(),
                                          })
                                          .describe('Team-scoped property.'),
                                        zod
                                          .object({
                                            scope: zod.enum(['system']),
                                          })
                                          .describe(
                                            'System-owned property (no user or team owner).'
                                          ),
                                      ])
                                      .describe(
                                        'Defines who owns a property - user-scoped, team-scoped, or system.'
                                      ),
                                    specific_entity_type: zod
                                      .union([
                                        zod.null(),
                                        zod
                                          .enum([
                                            'CALENDAR_EVENT',
                                            'CALL_RECORD',
                                            'CHANNEL',
                                            'CHAT',
                                            'COMPANY',
                                            'DOCUMENT',
                                            'PROJECT',
                                            'TASK',
                                            'THREAD',
                                            'USER',
                                          ])
                                          .describe(
                                            'Type of entity that can be referenced by entity properties.'
                                          ),
                                      ])
                                      .optional(),
                                    updated_at: zod.iso.datetime({}),
                                  })
                                  .describe(
                                    'Property definition model (service representation).'
                                  ),
                                id: zod
                                  .uuid()
                                  .describe(
                                    'Globally unique id of the assignment attaching this property to an entity.'
                                  ),
                                value: zod
                                  .union([
                                    zod.null(),
                                    zod
                                      .union([
                                        zod
                                          .object({
                                            type: zod.enum(['Boolean']),
                                            value: zod
                                              .boolean()
                                              .describe(
                                                'Boolean value\nSerializes as: {\"type\": \"Boolean\", \"value\": true}'
                                              ),
                                          })
                                          .describe(
                                            'Boolean value\nSerializes as: {\"type\": \"Boolean\", \"value\": true}'
                                          ),
                                        zod
                                          .object({
                                            type: zod.enum(['Number']),
                                            value: zod
                                              .number()
                                              .describe(
                                                'Numeric value\nSerializes as: {\"type\": \"Number\", \"value\": 42.5}'
                                              ),
                                          })
                                          .describe(
                                            'Numeric value\nSerializes as: {\"type\": \"Number\", \"value\": 42.5}'
                                          ),
                                        zod
                                          .object({
                                            type: zod.enum(['String']),
                                            value: zod
                                              .string()
                                              .describe(
                                                'String value\nSerializes as: {\"type\": \"String\", \"value\": \"text\"}'
                                              ),
                                          })
                                          .describe(
                                            'String value\nSerializes as: {\"type\": \"String\", \"value\": \"text\"}'
                                          ),
                                        zod
                                          .object({
                                            type: zod.enum(['Date']),
                                            value: zod.iso
                                              .datetime({})
                                              .describe(
                                                'Date\/timestamp value\nSerializes as: {\"type\": \"Date\", \"value\": \"2025-01-01T00:00:00Z\"}'
                                              ),
                                          })
                                          .describe(
                                            'Date\/timestamp value\nSerializes as: {\"type\": \"Date\", \"value\": \"2025-01-01T00:00:00Z\"}'
                                          ),
                                        zod
                                          .object({
                                            type: zod.enum(['SelectOption']),
                                            value: zod
                                              .array(zod.uuid())
                                              .describe(
                                                'Select option(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"SelectOption\", \"value\": [\"uuid\"]} (length 0 or 1)\nMulti-select: {\"type\": \"SelectOption\", \"value\": [\"uuid1\", \"uuid2\", ...]} (length 0+)'
                                              ),
                                          })
                                          .describe(
                                            'Select option(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"SelectOption\", \"value\": [\"uuid\"]} (length 0 or 1)\nMulti-select: {\"type\": \"SelectOption\", \"value\": [\"uuid1\", \"uuid2\", ...]} (length 0+)'
                                          ),
                                        zod
                                          .object({
                                            type: zod.enum(['EntityReference']),
                                            value: zod
                                              .array(
                                                zod
                                                  .object({
                                                    entity_id: zod.string(),
                                                    entity_type: zod
                                                      .enum([
                                                        'CALENDAR_EVENT',
                                                        'CALL_RECORD',
                                                        'CHANNEL',
                                                        'CHAT',
                                                        'COMPANY',
                                                        'DOCUMENT',
                                                        'PROJECT',
                                                        'TASK',
                                                        'THREAD',
                                                        'USER',
                                                      ])
                                                      .describe(
                                                        'Type of entity that can be referenced by entity properties.'
                                                      ),
                                                    specific_message_id: zod
                                                      .uuid()
                                                      .nullish()
                                                      .describe(
                                                        'For CHANNEL, CHAT, THREAD entity types - optional specific message ID.\nThis allows referencing a specific message within a thread\/channel\/chat.'
                                                      ),
                                                  })
                                                  .describe(
                                                    'Entity reference for entity-type property values.'
                                                  )
                                              )
                                              .describe(
                                                'Entity reference(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"EntityReference\", \"value\": [{...}]} (length 0 or 1)\nMulti-select: {\"type\": \"EntityReference\", \"value\": [{...}, {...}, ...]} (length 0+)'
                                              ),
                                          })
                                          .describe(
                                            'Entity reference(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"EntityReference\", \"value\": [{...}]} (length 0 or 1)\nMulti-select: {\"type\": \"EntityReference\", \"value\": [{...}, {...}, ...]} (length 0+)'
                                          ),
                                        zod
                                          .object({
                                            type: zod.enum(['Link']),
                                            value: zod
                                              .array(zod.string())
                                              .describe(
                                                'Link value(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"Link\", \"value\": [\"https:\/\/example.com\"]} (length 0 or 1)\nMulti-select: {\"type\": \"Link\", \"value\": [\"https:\/\/example.com\", \"https:\/\/other.com\"]} (length 0+)'
                                              ),
                                          })
                                          .describe(
                                            'Link value(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"Link\", \"value\": [\"https:\/\/example.com\"]} (length 0 or 1)\nMulti-select: {\"type\": \"Link\", \"value\": [\"https:\/\/example.com\", \"https:\/\/other.com\"]} (length 0+)'
                                          ),
                                      ])
                                      .describe(
                                        'Property value (service representation).\n\nRepresents the actual value stored for an entity property.\nThis is serialized to\/from JSONB in the database.'
                                      ),
                                  ])
                                  .optional(),
                              })
                              .describe(
                                'A property attached to a Soup item.\n\nThis is a simplified representation that includes only the definition and value,\nomitting the entity property assignment metadata and options.'
                              )
                          )
                          .describe('Properties attached to the entity.'),
                      })
                      .describe(
                        'Property fields that can be flattened into property-bearing Soup items.'
                      )
                      .and(
                        zod.object({
                          createdAt: zod.iso
                            .datetime({})
                            .describe('The time the chat was created'),
                          deletedAt: zod.iso
                            .datetime({})
                            .nullish()
                            .describe('The time the chat was deleted'),
                          id: zod.uuid().describe('The chat uuid'),
                          isPersistent: zod
                            .boolean()
                            .describe('Whether the chat is persistent or not'),
                          name: zod.string().describe('The name of the chat'),
                          ownerId: zod
                            .string()
                            .describe('Who the chat belongs to'),
                          projectId: zod
                            .uuid()
                            .nullish()
                            .describe('The project id of the chat'),
                          updatedAt: zod.iso
                            .datetime({})
                            .describe('The time the chat was last updated'),
                          viewedAt: zod.iso
                            .datetime({})
                            .nullish()
                            .describe('The time the chat was last viewed'),
                        })
                      )
                      .describe('A chat as displayed in Soup.'),
                    tag: zod.enum(['chat']),
                  })
                  .describe('Chat item.'),
                zod
                  .object({
                    data: zod
                      .object({
                        properties: zod
                          .array(
                            zod
                              .object({
                                definition: zod
                                  .object({
                                    created_at: zod.iso.datetime({}),
                                    data_type: zod
                                      .enum([
                                        'BOOLEAN',
                                        'DATE',
                                        'NUMBER',
                                        'STRING',
                                        'SELECT_NUMBER',
                                        'SELECT_STRING',
                                        'TAG',
                                        'ENTITY',
                                        'LINK',
                                      ])
                                      .describe(
                                        'Data type for property values, determining storage and validation.'
                                      ),
                                    display_name: zod.string(),
                                    id: zod.uuid(),
                                    is_metadata: zod
                                      .boolean()
                                      .describe(
                                        'Flag to indicate if this is a system-generated metadata property.\nNot stored in database - computed at service layer.'
                                      ),
                                    is_multi_select: zod.boolean(),
                                    is_system: zod
                                      .boolean()
                                      .describe(
                                        'Flag to indicate if this is a system property (stored in DB).'
                                      ),
                                    owner: zod
                                      .union([
                                        zod
                                          .object({
                                            scope: zod.enum(['user']),
                                            user_id: zod.string(),
                                          })
                                          .describe('User-scoped property.'),
                                        zod
                                          .object({
                                            scope: zod.enum(['team']),
                                            team_id: zod.uuid(),
                                          })
                                          .describe('Team-scoped property.'),
                                        zod
                                          .object({
                                            scope: zod.enum(['system']),
                                          })
                                          .describe(
                                            'System-owned property (no user or team owner).'
                                          ),
                                      ])
                                      .describe(
                                        'Defines who owns a property - user-scoped, team-scoped, or system.'
                                      ),
                                    specific_entity_type: zod
                                      .union([
                                        zod.null(),
                                        zod
                                          .enum([
                                            'CALENDAR_EVENT',
                                            'CALL_RECORD',
                                            'CHANNEL',
                                            'CHAT',
                                            'COMPANY',
                                            'DOCUMENT',
                                            'PROJECT',
                                            'TASK',
                                            'THREAD',
                                            'USER',
                                          ])
                                          .describe(
                                            'Type of entity that can be referenced by entity properties.'
                                          ),
                                      ])
                                      .optional(),
                                    updated_at: zod.iso.datetime({}),
                                  })
                                  .describe(
                                    'Property definition model (service representation).'
                                  ),
                                id: zod
                                  .uuid()
                                  .describe(
                                    'Globally unique id of the assignment attaching this property to an entity.'
                                  ),
                                value: zod
                                  .union([
                                    zod.null(),
                                    zod
                                      .union([
                                        zod
                                          .object({
                                            type: zod.enum(['Boolean']),
                                            value: zod
                                              .boolean()
                                              .describe(
                                                'Boolean value\nSerializes as: {\"type\": \"Boolean\", \"value\": true}'
                                              ),
                                          })
                                          .describe(
                                            'Boolean value\nSerializes as: {\"type\": \"Boolean\", \"value\": true}'
                                          ),
                                        zod
                                          .object({
                                            type: zod.enum(['Number']),
                                            value: zod
                                              .number()
                                              .describe(
                                                'Numeric value\nSerializes as: {\"type\": \"Number\", \"value\": 42.5}'
                                              ),
                                          })
                                          .describe(
                                            'Numeric value\nSerializes as: {\"type\": \"Number\", \"value\": 42.5}'
                                          ),
                                        zod
                                          .object({
                                            type: zod.enum(['String']),
                                            value: zod
                                              .string()
                                              .describe(
                                                'String value\nSerializes as: {\"type\": \"String\", \"value\": \"text\"}'
                                              ),
                                          })
                                          .describe(
                                            'String value\nSerializes as: {\"type\": \"String\", \"value\": \"text\"}'
                                          ),
                                        zod
                                          .object({
                                            type: zod.enum(['Date']),
                                            value: zod.iso
                                              .datetime({})
                                              .describe(
                                                'Date\/timestamp value\nSerializes as: {\"type\": \"Date\", \"value\": \"2025-01-01T00:00:00Z\"}'
                                              ),
                                          })
                                          .describe(
                                            'Date\/timestamp value\nSerializes as: {\"type\": \"Date\", \"value\": \"2025-01-01T00:00:00Z\"}'
                                          ),
                                        zod
                                          .object({
                                            type: zod.enum(['SelectOption']),
                                            value: zod
                                              .array(zod.uuid())
                                              .describe(
                                                'Select option(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"SelectOption\", \"value\": [\"uuid\"]} (length 0 or 1)\nMulti-select: {\"type\": \"SelectOption\", \"value\": [\"uuid1\", \"uuid2\", ...]} (length 0+)'
                                              ),
                                          })
                                          .describe(
                                            'Select option(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"SelectOption\", \"value\": [\"uuid\"]} (length 0 or 1)\nMulti-select: {\"type\": \"SelectOption\", \"value\": [\"uuid1\", \"uuid2\", ...]} (length 0+)'
                                          ),
                                        zod
                                          .object({
                                            type: zod.enum(['EntityReference']),
                                            value: zod
                                              .array(
                                                zod
                                                  .object({
                                                    entity_id: zod.string(),
                                                    entity_type: zod
                                                      .enum([
                                                        'CALENDAR_EVENT',
                                                        'CALL_RECORD',
                                                        'CHANNEL',
                                                        'CHAT',
                                                        'COMPANY',
                                                        'DOCUMENT',
                                                        'PROJECT',
                                                        'TASK',
                                                        'THREAD',
                                                        'USER',
                                                      ])
                                                      .describe(
                                                        'Type of entity that can be referenced by entity properties.'
                                                      ),
                                                    specific_message_id: zod
                                                      .uuid()
                                                      .nullish()
                                                      .describe(
                                                        'For CHANNEL, CHAT, THREAD entity types - optional specific message ID.\nThis allows referencing a specific message within a thread\/channel\/chat.'
                                                      ),
                                                  })
                                                  .describe(
                                                    'Entity reference for entity-type property values.'
                                                  )
                                              )
                                              .describe(
                                                'Entity reference(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"EntityReference\", \"value\": [{...}]} (length 0 or 1)\nMulti-select: {\"type\": \"EntityReference\", \"value\": [{...}, {...}, ...]} (length 0+)'
                                              ),
                                          })
                                          .describe(
                                            'Entity reference(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"EntityReference\", \"value\": [{...}]} (length 0 or 1)\nMulti-select: {\"type\": \"EntityReference\", \"value\": [{...}, {...}, ...]} (length 0+)'
                                          ),
                                        zod
                                          .object({
                                            type: zod.enum(['Link']),
                                            value: zod
                                              .array(zod.string())
                                              .describe(
                                                'Link value(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"Link\", \"value\": [\"https:\/\/example.com\"]} (length 0 or 1)\nMulti-select: {\"type\": \"Link\", \"value\": [\"https:\/\/example.com\", \"https:\/\/other.com\"]} (length 0+)'
                                              ),
                                          })
                                          .describe(
                                            'Link value(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"Link\", \"value\": [\"https:\/\/example.com\"]} (length 0 or 1)\nMulti-select: {\"type\": \"Link\", \"value\": [\"https:\/\/example.com\", \"https:\/\/other.com\"]} (length 0+)'
                                          ),
                                      ])
                                      .describe(
                                        'Property value (service representation).\n\nRepresents the actual value stored for an entity property.\nThis is serialized to\/from JSONB in the database.'
                                      ),
                                  ])
                                  .optional(),
                              })
                              .describe(
                                'A property attached to a Soup item.\n\nThis is a simplified representation that includes only the definition and value,\nomitting the entity property assignment metadata and options.'
                              )
                          )
                          .describe('Properties attached to the entity.'),
                      })
                      .describe(
                        'Property fields that can be flattened into property-bearing Soup items.'
                      )
                      .and(
                        zod.object({
                          createdAt: zod.iso
                            .datetime({})
                            .describe('The time the project was created'),
                          deletedAt: zod.iso
                            .datetime({})
                            .nullish()
                            .describe('The time the project was deleted'),
                          id: zod.uuid().describe('The id of the project'),
                          name: zod
                            .string()
                            .describe('The name of the project'),
                          ownerId: zod
                            .string()
                            .describe('The user id of who created the project'),
                          parentId: zod
                            .uuid()
                            .nullish()
                            .describe('The parent project id'),
                          updatedAt: zod.iso
                            .datetime({})
                            .describe('The time the project was updated'),
                          viewedAt: zod.iso
                            .datetime({})
                            .nullish()
                            .describe('The time the document was last viewed'),
                        })
                      )
                      .describe('A project as displayed in Soup.'),
                    tag: zod.enum(['project']),
                  })
                  .describe('Project item.'),
                zod
                  .object({
                    data: zod
                      .object({
                        createdAt: zod.iso
                          .datetime({})
                          .describe('Timestamp when the thread was created.'),
                        id: zod.uuid().describe('Thread id.'),
                        inboxVisible: zod
                          .boolean()
                          .describe(
                            'Whether the thread should appear in the inbox.'
                          ),
                        isDraft: zod
                          .boolean()
                          .describe('Whether the thread contains a draft.'),
                        isImportant: zod
                          .boolean()
                          .describe('Whether the thread is marked important.'),
                        isRead: zod
                          .boolean()
                          .describe('Whether the thread has been read.'),
                        name: zod
                          .string()
                          .nullish()
                          .describe('Thread display name or subject.'),
                        ownerId: zod.string().describe('Owner user id.'),
                        projectId: zod
                          .string()
                          .nullish()
                          .describe('Project id associated with the thread.'),
                        providerId: zod
                          .string()
                          .nullish()
                          .describe('Provider-specific thread id.'),
                        senderEmail: zod
                          .string()
                          .nullish()
                          .describe('Sender email address for the preview.'),
                        senderName: zod
                          .string()
                          .nullish()
                          .describe('Sender display name for the preview.'),
                        senderPhotoUrl: zod
                          .string()
                          .nullish()
                          .describe('Sender photo URL for the preview.'),
                        snippet: zod
                          .string()
                          .nullish()
                          .describe('Thread snippet.'),
                        sortTs: zod.iso
                          .datetime({})
                          .describe('Timestamp used for email thread sorting.'),
                        updatedAt: zod.iso
                          .datetime({})
                          .describe(
                            'Timestamp when the thread was last updated.'
                          ),
                        viewedAt: zod.iso
                          .datetime({})
                          .nullish()
                          .describe(
                            'Timestamp when the requesting user last viewed the thread.'
                          ),
                      })
                      .describe(
                        'Email thread preview data as displayed in Soup.'
                      )
                      .and(
                        zod
                          .object({
                            properties: zod
                              .array(
                                zod
                                  .object({
                                    definition: zod
                                      .object({
                                        created_at: zod.iso.datetime({}),
                                        data_type: zod
                                          .enum([
                                            'BOOLEAN',
                                            'DATE',
                                            'NUMBER',
                                            'STRING',
                                            'SELECT_NUMBER',
                                            'SELECT_STRING',
                                            'TAG',
                                            'ENTITY',
                                            'LINK',
                                          ])
                                          .describe(
                                            'Data type for property values, determining storage and validation.'
                                          ),
                                        display_name: zod.string(),
                                        id: zod.uuid(),
                                        is_metadata: zod
                                          .boolean()
                                          .describe(
                                            'Flag to indicate if this is a system-generated metadata property.\nNot stored in database - computed at service layer.'
                                          ),
                                        is_multi_select: zod.boolean(),
                                        is_system: zod
                                          .boolean()
                                          .describe(
                                            'Flag to indicate if this is a system property (stored in DB).'
                                          ),
                                        owner: zod
                                          .union([
                                            zod
                                              .object({
                                                scope: zod.enum(['user']),
                                                user_id: zod.string(),
                                              })
                                              .describe(
                                                'User-scoped property.'
                                              ),
                                            zod
                                              .object({
                                                scope: zod.enum(['team']),
                                                team_id: zod.uuid(),
                                              })
                                              .describe(
                                                'Team-scoped property.'
                                              ),
                                            zod
                                              .object({
                                                scope: zod.enum(['system']),
                                              })
                                              .describe(
                                                'System-owned property (no user or team owner).'
                                              ),
                                          ])
                                          .describe(
                                            'Defines who owns a property - user-scoped, team-scoped, or system.'
                                          ),
                                        specific_entity_type: zod
                                          .union([
                                            zod.null(),
                                            zod
                                              .enum([
                                                'CALENDAR_EVENT',
                                                'CALL_RECORD',
                                                'CHANNEL',
                                                'CHAT',
                                                'COMPANY',
                                                'DOCUMENT',
                                                'PROJECT',
                                                'TASK',
                                                'THREAD',
                                                'USER',
                                              ])
                                              .describe(
                                                'Type of entity that can be referenced by entity properties.'
                                              ),
                                          ])
                                          .optional(),
                                        updated_at: zod.iso.datetime({}),
                                      })
                                      .describe(
                                        'Property definition model (service representation).'
                                      ),
                                    id: zod
                                      .uuid()
                                      .describe(
                                        'Globally unique id of the assignment attaching this property to an entity.'
                                      ),
                                    value: zod
                                      .union([
                                        zod.null(),
                                        zod
                                          .union([
                                            zod
                                              .object({
                                                type: zod.enum(['Boolean']),
                                                value: zod
                                                  .boolean()
                                                  .describe(
                                                    'Boolean value\nSerializes as: {\"type\": \"Boolean\", \"value\": true}'
                                                  ),
                                              })
                                              .describe(
                                                'Boolean value\nSerializes as: {\"type\": \"Boolean\", \"value\": true}'
                                              ),
                                            zod
                                              .object({
                                                type: zod.enum(['Number']),
                                                value: zod
                                                  .number()
                                                  .describe(
                                                    'Numeric value\nSerializes as: {\"type\": \"Number\", \"value\": 42.5}'
                                                  ),
                                              })
                                              .describe(
                                                'Numeric value\nSerializes as: {\"type\": \"Number\", \"value\": 42.5}'
                                              ),
                                            zod
                                              .object({
                                                type: zod.enum(['String']),
                                                value: zod
                                                  .string()
                                                  .describe(
                                                    'String value\nSerializes as: {\"type\": \"String\", \"value\": \"text\"}'
                                                  ),
                                              })
                                              .describe(
                                                'String value\nSerializes as: {\"type\": \"String\", \"value\": \"text\"}'
                                              ),
                                            zod
                                              .object({
                                                type: zod.enum(['Date']),
                                                value: zod.iso
                                                  .datetime({})
                                                  .describe(
                                                    'Date\/timestamp value\nSerializes as: {\"type\": \"Date\", \"value\": \"2025-01-01T00:00:00Z\"}'
                                                  ),
                                              })
                                              .describe(
                                                'Date\/timestamp value\nSerializes as: {\"type\": \"Date\", \"value\": \"2025-01-01T00:00:00Z\"}'
                                              ),
                                            zod
                                              .object({
                                                type: zod.enum([
                                                  'SelectOption',
                                                ]),
                                                value: zod
                                                  .array(zod.uuid())
                                                  .describe(
                                                    'Select option(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"SelectOption\", \"value\": [\"uuid\"]} (length 0 or 1)\nMulti-select: {\"type\": \"SelectOption\", \"value\": [\"uuid1\", \"uuid2\", ...]} (length 0+)'
                                                  ),
                                              })
                                              .describe(
                                                'Select option(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"SelectOption\", \"value\": [\"uuid\"]} (length 0 or 1)\nMulti-select: {\"type\": \"SelectOption\", \"value\": [\"uuid1\", \"uuid2\", ...]} (length 0+)'
                                              ),
                                            zod
                                              .object({
                                                type: zod.enum([
                                                  'EntityReference',
                                                ]),
                                                value: zod
                                                  .array(
                                                    zod
                                                      .object({
                                                        entity_id: zod.string(),
                                                        entity_type: zod
                                                          .enum([
                                                            'CALENDAR_EVENT',
                                                            'CALL_RECORD',
                                                            'CHANNEL',
                                                            'CHAT',
                                                            'COMPANY',
                                                            'DOCUMENT',
                                                            'PROJECT',
                                                            'TASK',
                                                            'THREAD',
                                                            'USER',
                                                          ])
                                                          .describe(
                                                            'Type of entity that can be referenced by entity properties.'
                                                          ),
                                                        specific_message_id: zod
                                                          .uuid()
                                                          .nullish()
                                                          .describe(
                                                            'For CHANNEL, CHAT, THREAD entity types - optional specific message ID.\nThis allows referencing a specific message within a thread\/channel\/chat.'
                                                          ),
                                                      })
                                                      .describe(
                                                        'Entity reference for entity-type property values.'
                                                      )
                                                  )
                                                  .describe(
                                                    'Entity reference(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"EntityReference\", \"value\": [{...}]} (length 0 or 1)\nMulti-select: {\"type\": \"EntityReference\", \"value\": [{...}, {...}, ...]} (length 0+)'
                                                  ),
                                              })
                                              .describe(
                                                'Entity reference(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"EntityReference\", \"value\": [{...}]} (length 0 or 1)\nMulti-select: {\"type\": \"EntityReference\", \"value\": [{...}, {...}, ...]} (length 0+)'
                                              ),
                                            zod
                                              .object({
                                                type: zod.enum(['Link']),
                                                value: zod
                                                  .array(zod.string())
                                                  .describe(
                                                    'Link value(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"Link\", \"value\": [\"https:\/\/example.com\"]} (length 0 or 1)\nMulti-select: {\"type\": \"Link\", \"value\": [\"https:\/\/example.com\", \"https:\/\/other.com\"]} (length 0+)'
                                                  ),
                                              })
                                              .describe(
                                                'Link value(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"Link\", \"value\": [\"https:\/\/example.com\"]} (length 0 or 1)\nMulti-select: {\"type\": \"Link\", \"value\": [\"https:\/\/example.com\", \"https:\/\/other.com\"]} (length 0+)'
                                              ),
                                          ])
                                          .describe(
                                            'Property value (service representation).\n\nRepresents the actual value stored for an entity property.\nThis is serialized to\/from JSONB in the database.'
                                          ),
                                      ])
                                      .optional(),
                                  })
                                  .describe(
                                    'A property attached to a Soup item.\n\nThis is a simplified representation that includes only the definition and value,\nomitting the entity property assignment metadata and options.'
                                  )
                              )
                              .describe('Properties attached to the entity.'),
                          })
                          .describe(
                            'Property fields that can be flattened into property-bearing Soup items.'
                          )
                      )
                      .and(
                        zod.object({
                          attachments: zod
                            .array(
                              zod
                                .object({
                                  contentId: zod
                                    .string()
                                    .nullish()
                                    .describe(
                                      'Content id for inline attachments.'
                                    ),
                                  createdAt: zod.iso
                                    .datetime({})
                                    .describe(
                                      'Timestamp when the attachment was created.'
                                    ),
                                  filename: zod
                                    .string()
                                    .nullish()
                                    .describe('Attachment filename.'),
                                  id: zod.uuid().describe('Attachment id.'),
                                  messageId: zod
                                    .uuid()
                                    .describe(
                                      'Message id that owns this attachment.'
                                    ),
                                  mimeType: zod
                                    .string()
                                    .nullish()
                                    .describe('Attachment MIME type.'),
                                  providerAttachmentId: zod
                                    .string()
                                    .nullish()
                                    .describe(
                                      'Provider-specific attachment id.'
                                    ),
                                  sizeBytes: zod
                                    .number()
                                    .nullish()
                                    .describe('Attachment size in bytes.'),
                                })
                                .describe(
                                  'An email attachment as displayed in Soup.'
                                )
                            )
                            .describe('Attachments on the thread.'),
                          labels: zod
                            .array(
                              zod
                                .object({
                                  createdAt: zod.iso
                                    .datetime({})
                                    .describe(
                                      'Timestamp when the label was created.'
                                    ),
                                  id: zod.uuid().describe('Label id.'),
                                  labelListVisibility: zod
                                    .enum([
                                      'labelShow',
                                      'labelShowIfUnread',
                                      'labelHide',
                                    ])
                                    .describe(
                                      'Gmail-style label list visibility.'
                                    ),
                                  linkId: zod
                                    .uuid()
                                    .describe(
                                      'Connected account link id for the label.'
                                    ),
                                  messageListVisibility: zod
                                    .enum(['show', 'hide'])
                                    .describe(
                                      'Gmail-style message list visibility for a label.'
                                    ),
                                  name: zod
                                    .string()
                                    .describe('Label display name.'),
                                  providerLabelId: zod
                                    .string()
                                    .describe('Provider-specific label id.'),
                                  type: zod
                                    .enum(['system', 'user'])
                                    .describe(
                                      'Whether an email label is provider-created or user-created.'
                                    ),
                                })
                                .describe(
                                  'An email label as displayed in Soup.'
                                )
                            )
                            .describe('Labels attached to the thread.'),
                          participants: zod
                            .array(
                              zod
                                .object({
                                  emailAddress: zod
                                    .string()
                                    .nullish()
                                    .describe('Contact email address.'),
                                  id: zod.uuid().describe('Contact id.'),
                                  linkId: zod
                                    .uuid()
                                    .describe(
                                      'Connected account link id for the contact.'
                                    ),
                                  name: zod
                                    .string()
                                    .nullish()
                                    .describe('Contact display name.'),
                                  sfsPhotoUrl: zod
                                    .string()
                                    .nullish()
                                    .describe(
                                      'Contact photo URL from SFS, if available.'
                                    ),
                                })
                                .describe(
                                  'A contact participating in an email thread as displayed in Soup.'
                                )
                            )
                            .describe('Contacts participating in the thread.'),
                        })
                      )
                      .describe(
                        'Email thread preview enriched with related metadata for Soup.'
                      ),
                    tag: zod.enum(['emailThread']),
                  })
                  .describe('Email thread item.'),
                zod
                  .object({
                    data: zod
                      .object({
                        channel: zod
                          .object({
                            channel_type: zod
                              .enum([
                                'public',
                                'private',
                                'direct_message',
                                'team',
                              ])
                              .describe('Type of channel.'),
                            created_at: zod.iso
                              .datetime({})
                              .describe('Creation timestamp.'),
                            id: zod.uuid().describe('Channel id.'),
                            name: zod
                              .string()
                              .nullish()
                              .describe('Channel display name.'),
                            org_id: zod
                              .number()
                              .min(
                                postItemsSoupAstGroupedResponseItemsDataChannelOrgIdMin
                              )
                              .nullish()
                              .describe('Organization id.'),
                            owner_id: zod.string().describe('Channel owner.'),
                            team_id: zod.uuid().nullish().describe('Team id.'),
                            updated_at: zod.iso
                              .datetime({})
                              .describe('Update timestamp.'),
                          })
                          .describe('Channel metadata in soup payloads.'),
                        is_participant: zod
                          .boolean()
                          .optional()
                          .describe(
                            "Whether the requesting user is an active participant of the channel.\nFalse for team channels of the user's teams they have not joined."
                          ),
                        participants: zod
                          .array(
                            zod
                              .object({
                                channel_id: zod
                                  .uuid()
                                  .describe(
                                    'Channel id for the participant membership.'
                                  ),
                                joined_at: zod.iso
                                  .datetime({})
                                  .describe(
                                    'Timestamp when the participant joined the channel.'
                                  ),
                                left_at: zod.iso
                                  .datetime({})
                                  .nullish()
                                  .describe(
                                    'Timestamp when the participant left the channel, if any.'
                                  ),
                                role: zod
                                  .enum(['owner', 'admin', 'member'])
                                  .describe(
                                    'The role a user has within a channel.'
                                  ),
                                user_id: zod
                                  .string()
                                  .describe('Participant user id.'),
                              })
                              .describe("A user's membership in a channel.")
                          )
                          .describe('Participants in the channel.'),
                      })
                      .describe(
                        'Channel metadata together with its participants.'
                      )
                      .and(
                        zod
                          .object({
                            latest_message: zod
                              .union([
                                zod.null(),
                                zod
                                  .object({
                                    content: zod
                                      .string()
                                      .describe('Message content.'),
                                    created_at: zod.iso
                                      .datetime({})
                                      .describe('Creation timestamp.'),
                                    deleted_at: zod.iso
                                      .datetime({})
                                      .nullish()
                                      .describe('Deletion timestamp.'),
                                    mentions: zod
                                      .array(zod.string())
                                      .describe(
                                        'Message mentions formatted as `{ENTITY_TYPE}:{ENTITY_ID}`.'
                                      ),
                                    message_id: zod
                                      .uuid()
                                      .describe('Message id.'),
                                    sender_id: zod
                                      .string()
                                      .describe('Sender id.'),
                                    thread_id: zod
                                      .uuid()
                                      .nullish()
                                      .describe('Thread parent id.'),
                                    updated_at: zod.iso
                                      .datetime({})
                                      .describe('Update timestamp.'),
                                  })
                                  .describe(
                                    'Lightweight channel message for soup payloads.'
                                  ),
                              ])
                              .optional(),
                            latest_non_thread_message: zod
                              .union([
                                zod.null(),
                                zod
                                  .object({
                                    content: zod
                                      .string()
                                      .describe('Message content.'),
                                    created_at: zod.iso
                                      .datetime({})
                                      .describe('Creation timestamp.'),
                                    deleted_at: zod.iso
                                      .datetime({})
                                      .nullish()
                                      .describe('Deletion timestamp.'),
                                    mentions: zod
                                      .array(zod.string())
                                      .describe(
                                        'Message mentions formatted as `{ENTITY_TYPE}:{ENTITY_ID}`.'
                                      ),
                                    message_id: zod
                                      .uuid()
                                      .describe('Message id.'),
                                    sender_id: zod
                                      .string()
                                      .describe('Sender id.'),
                                    thread_id: zod
                                      .uuid()
                                      .nullish()
                                      .describe('Thread parent id.'),
                                    updated_at: zod.iso
                                      .datetime({})
                                      .describe('Update timestamp.'),
                                  })
                                  .describe(
                                    'Lightweight channel message for soup payloads.'
                                  ),
                              ])
                              .optional(),
                          })
                          .describe('Latest-message bundle for soup payloads.')
                      )
                      .and(
                        zod.object({
                          interacted_at: zod.iso
                            .datetime({})
                            .nullish()
                            .describe(
                              'Timestamp when the requesting user last interacted with this channel.'
                            ),
                          viewed_at: zod.iso
                            .datetime({})
                            .nullish()
                            .describe(
                              'Timestamp when the requesting user last viewed this channel.'
                            ),
                        })
                      )
                      .describe('A channel as displayed in Soup.'),
                    tag: zod.enum(['channel']),
                  })
                  .describe('Channel item.'),
                zod
                  .object({
                    data: zod
                      .object({
                        attachments: zod
                          .array(
                            zod
                              .object({
                                created_at: zod.iso
                                  .datetime({})
                                  .describe('Creation timestamp.'),
                                entity_id: zod.string().describe('Entity id.'),
                                entity_type: zod
                                  .string()
                                  .describe('Type of entity.'),
                                height: zod
                                  .number()
                                  .nullish()
                                  .describe('Height for images.'),
                                id: zod.uuid().describe('Attachment id.'),
                                width: zod
                                  .number()
                                  .nullish()
                                  .describe('Width for images.'),
                              })
                              .describe('An attachment on a message.')
                          )
                          .describe('Attachments on this message.'),
                        channel_id: zod.uuid().describe('Channel id.'),
                        content: zod.string().describe('Message content.'),
                        created_at: zod.iso
                          .datetime({})
                          .describe('Creation timestamp.'),
                        deleted_at: zod.iso
                          .datetime({})
                          .nullish()
                          .describe('Deletion timestamp.'),
                        edited_at: zod.iso
                          .datetime({})
                          .nullish()
                          .describe('Edit timestamp.'),
                        id: zod.uuid().describe('Message id.'),
                        reactions: zod
                          .array(
                            zod
                              .object({
                                emoji: zod.string().describe('Emoji string.'),
                                users: zod
                                  .array(zod.string())
                                  .describe(
                                    'User ids who added this reaction.'
                                  ),
                              })
                              .describe('A reaction with emoji and user list.')
                          )
                          .describe('Reactions on this message.'),
                        sender: zod
                          .object({
                            avatar_url: zod
                              .string()
                              .nullish()
                              .describe('Avatar URL for bot senders.'),
                            id: zod
                              .string()
                              .describe(
                                'Sender id without the storage namespace prefix.'
                              ),
                            name: zod
                              .string()
                              .nullish()
                              .describe('Display name for bot senders.'),
                            type: zod
                              .enum(['user', 'bot'])
                              .describe(
                                'Public sender type for soup channel messages.'
                              ),
                          })
                          .describe(
                            'Public sender identity for soup channel messages.'
                          ),
                        sender_id: zod.string().describe('Sender id.'),
                        thread: zod
                          .object({
                            latest_reply_at: zod.iso
                              .datetime({})
                              .nullish()
                              .describe('Timestamp of the latest reply.'),
                            preview: zod
                              .array(
                                zod
                                  .object({
                                    attachments: zod
                                      .array(
                                        zod
                                          .object({
                                            created_at: zod.iso
                                              .datetime({})
                                              .describe('Creation timestamp.'),
                                            entity_id: zod
                                              .string()
                                              .describe('Entity id.'),
                                            entity_type: zod
                                              .string()
                                              .describe('Type of entity.'),
                                            height: zod
                                              .number()
                                              .nullish()
                                              .describe('Height for images.'),
                                            id: zod
                                              .uuid()
                                              .describe('Attachment id.'),
                                            width: zod
                                              .number()
                                              .nullish()
                                              .describe('Width for images.'),
                                          })
                                          .describe(
                                            'An attachment on a message.'
                                          )
                                      )
                                      .describe('Attachments on this reply.'),
                                    content: zod
                                      .string()
                                      .describe('Reply content.'),
                                    created_at: zod.iso
                                      .datetime({})
                                      .describe('Creation timestamp.'),
                                    edited_at: zod.iso
                                      .datetime({})
                                      .nullish()
                                      .describe('Edit timestamp.'),
                                    id: zod.uuid().describe('Reply id.'),
                                    reactions: zod
                                      .array(
                                        zod
                                          .object({
                                            emoji: zod
                                              .string()
                                              .describe('Emoji string.'),
                                            users: zod
                                              .array(zod.string())
                                              .describe(
                                                'User ids who added this reaction.'
                                              ),
                                          })
                                          .describe(
                                            'A reaction with emoji and user list.'
                                          )
                                      )
                                      .describe('Reactions on this reply.'),
                                    sender: zod
                                      .object({
                                        avatar_url: zod
                                          .string()
                                          .nullish()
                                          .describe(
                                            'Avatar URL for bot senders.'
                                          ),
                                        id: zod
                                          .string()
                                          .describe(
                                            'Sender id without the storage namespace prefix.'
                                          ),
                                        name: zod
                                          .string()
                                          .nullish()
                                          .describe(
                                            'Display name for bot senders.'
                                          ),
                                        type: zod
                                          .enum(['user', 'bot'])
                                          .describe(
                                            'Public sender type for soup channel messages.'
                                          ),
                                      })
                                      .describe(
                                        'Public sender identity for soup channel messages.'
                                      ),
                                    sender_id: zod
                                      .string()
                                      .describe('Sender id.'),
                                    updated_at: zod.iso
                                      .datetime({})
                                      .describe('Update timestamp.'),
                                  })
                                  .describe('A thread reply shown in preview.')
                              )
                              .describe('Preview replies.'),
                            reply_count: zod
                              .number()
                              .describe('Total reply count.'),
                          })
                          .describe(
                            'Thread metadata and preview replies for soup channel messages.'
                          ),
                        updated_at: zod.iso
                          .datetime({})
                          .describe('Update timestamp.'),
                      })
                      .describe(
                        'A top-level channel message thread for soup payloads.\n\nThis mirrors the public channel-message API shape so soup consumers can\nrender a thread root the same way they render a channel timeline message.'
                      ),
                    tag: zod.enum(['channelThread']),
                  })
                  .describe('Channel thread item.'),
                zod
                  .object({
                    data: zod
                      .object({
                        properties: zod
                          .array(
                            zod
                              .object({
                                definition: zod
                                  .object({
                                    created_at: zod.iso.datetime({}),
                                    data_type: zod
                                      .enum([
                                        'BOOLEAN',
                                        'DATE',
                                        'NUMBER',
                                        'STRING',
                                        'SELECT_NUMBER',
                                        'SELECT_STRING',
                                        'TAG',
                                        'ENTITY',
                                        'LINK',
                                      ])
                                      .describe(
                                        'Data type for property values, determining storage and validation.'
                                      ),
                                    display_name: zod.string(),
                                    id: zod.uuid(),
                                    is_metadata: zod
                                      .boolean()
                                      .describe(
                                        'Flag to indicate if this is a system-generated metadata property.\nNot stored in database - computed at service layer.'
                                      ),
                                    is_multi_select: zod.boolean(),
                                    is_system: zod
                                      .boolean()
                                      .describe(
                                        'Flag to indicate if this is a system property (stored in DB).'
                                      ),
                                    owner: zod
                                      .union([
                                        zod
                                          .object({
                                            scope: zod.enum(['user']),
                                            user_id: zod.string(),
                                          })
                                          .describe('User-scoped property.'),
                                        zod
                                          .object({
                                            scope: zod.enum(['team']),
                                            team_id: zod.uuid(),
                                          })
                                          .describe('Team-scoped property.'),
                                        zod
                                          .object({
                                            scope: zod.enum(['system']),
                                          })
                                          .describe(
                                            'System-owned property (no user or team owner).'
                                          ),
                                      ])
                                      .describe(
                                        'Defines who owns a property - user-scoped, team-scoped, or system.'
                                      ),
                                    specific_entity_type: zod
                                      .union([
                                        zod.null(),
                                        zod
                                          .enum([
                                            'CALENDAR_EVENT',
                                            'CALL_RECORD',
                                            'CHANNEL',
                                            'CHAT',
                                            'COMPANY',
                                            'DOCUMENT',
                                            'PROJECT',
                                            'TASK',
                                            'THREAD',
                                            'USER',
                                          ])
                                          .describe(
                                            'Type of entity that can be referenced by entity properties.'
                                          ),
                                      ])
                                      .optional(),
                                    updated_at: zod.iso.datetime({}),
                                  })
                                  .describe(
                                    'Property definition model (service representation).'
                                  ),
                                id: zod
                                  .uuid()
                                  .describe(
                                    'Globally unique id of the assignment attaching this property to an entity.'
                                  ),
                                value: zod
                                  .union([
                                    zod.null(),
                                    zod
                                      .union([
                                        zod
                                          .object({
                                            type: zod.enum(['Boolean']),
                                            value: zod
                                              .boolean()
                                              .describe(
                                                'Boolean value\nSerializes as: {\"type\": \"Boolean\", \"value\": true}'
                                              ),
                                          })
                                          .describe(
                                            'Boolean value\nSerializes as: {\"type\": \"Boolean\", \"value\": true}'
                                          ),
                                        zod
                                          .object({
                                            type: zod.enum(['Number']),
                                            value: zod
                                              .number()
                                              .describe(
                                                'Numeric value\nSerializes as: {\"type\": \"Number\", \"value\": 42.5}'
                                              ),
                                          })
                                          .describe(
                                            'Numeric value\nSerializes as: {\"type\": \"Number\", \"value\": 42.5}'
                                          ),
                                        zod
                                          .object({
                                            type: zod.enum(['String']),
                                            value: zod
                                              .string()
                                              .describe(
                                                'String value\nSerializes as: {\"type\": \"String\", \"value\": \"text\"}'
                                              ),
                                          })
                                          .describe(
                                            'String value\nSerializes as: {\"type\": \"String\", \"value\": \"text\"}'
                                          ),
                                        zod
                                          .object({
                                            type: zod.enum(['Date']),
                                            value: zod.iso
                                              .datetime({})
                                              .describe(
                                                'Date\/timestamp value\nSerializes as: {\"type\": \"Date\", \"value\": \"2025-01-01T00:00:00Z\"}'
                                              ),
                                          })
                                          .describe(
                                            'Date\/timestamp value\nSerializes as: {\"type\": \"Date\", \"value\": \"2025-01-01T00:00:00Z\"}'
                                          ),
                                        zod
                                          .object({
                                            type: zod.enum(['SelectOption']),
                                            value: zod
                                              .array(zod.uuid())
                                              .describe(
                                                'Select option(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"SelectOption\", \"value\": [\"uuid\"]} (length 0 or 1)\nMulti-select: {\"type\": \"SelectOption\", \"value\": [\"uuid1\", \"uuid2\", ...]} (length 0+)'
                                              ),
                                          })
                                          .describe(
                                            'Select option(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"SelectOption\", \"value\": [\"uuid\"]} (length 0 or 1)\nMulti-select: {\"type\": \"SelectOption\", \"value\": [\"uuid1\", \"uuid2\", ...]} (length 0+)'
                                          ),
                                        zod
                                          .object({
                                            type: zod.enum(['EntityReference']),
                                            value: zod
                                              .array(
                                                zod
                                                  .object({
                                                    entity_id: zod.string(),
                                                    entity_type: zod
                                                      .enum([
                                                        'CALENDAR_EVENT',
                                                        'CALL_RECORD',
                                                        'CHANNEL',
                                                        'CHAT',
                                                        'COMPANY',
                                                        'DOCUMENT',
                                                        'PROJECT',
                                                        'TASK',
                                                        'THREAD',
                                                        'USER',
                                                      ])
                                                      .describe(
                                                        'Type of entity that can be referenced by entity properties.'
                                                      ),
                                                    specific_message_id: zod
                                                      .uuid()
                                                      .nullish()
                                                      .describe(
                                                        'For CHANNEL, CHAT, THREAD entity types - optional specific message ID.\nThis allows referencing a specific message within a thread\/channel\/chat.'
                                                      ),
                                                  })
                                                  .describe(
                                                    'Entity reference for entity-type property values.'
                                                  )
                                              )
                                              .describe(
                                                'Entity reference(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"EntityReference\", \"value\": [{...}]} (length 0 or 1)\nMulti-select: {\"type\": \"EntityReference\", \"value\": [{...}, {...}, ...]} (length 0+)'
                                              ),
                                          })
                                          .describe(
                                            'Entity reference(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"EntityReference\", \"value\": [{...}]} (length 0 or 1)\nMulti-select: {\"type\": \"EntityReference\", \"value\": [{...}, {...}, ...]} (length 0+)'
                                          ),
                                        zod
                                          .object({
                                            type: zod.enum(['Link']),
                                            value: zod
                                              .array(zod.string())
                                              .describe(
                                                'Link value(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"Link\", \"value\": [\"https:\/\/example.com\"]} (length 0 or 1)\nMulti-select: {\"type\": \"Link\", \"value\": [\"https:\/\/example.com\", \"https:\/\/other.com\"]} (length 0+)'
                                              ),
                                          })
                                          .describe(
                                            'Link value(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"Link\", \"value\": [\"https:\/\/example.com\"]} (length 0 or 1)\nMulti-select: {\"type\": \"Link\", \"value\": [\"https:\/\/example.com\", \"https:\/\/other.com\"]} (length 0+)'
                                          ),
                                      ])
                                      .describe(
                                        'Property value (service representation).\n\nRepresents the actual value stored for an entity property.\nThis is serialized to\/from JSONB in the database.'
                                      ),
                                  ])
                                  .optional(),
                              })
                              .describe(
                                'A property attached to a Soup item.\n\nThis is a simplified representation that includes only the definition and value,\nomitting the entity property assignment metadata and options.'
                              )
                          )
                          .describe('Properties attached to the entity.'),
                      })
                      .describe(
                        'Property fields that can be flattened into property-bearing Soup items.'
                      )
                      .and(
                        zod.object({
                          attended: zod
                            .boolean()
                            .describe(
                              'Whether the requesting user attended this call. Kept for compatibility\nand derived from `status == ATTENDED`.'
                            ),
                          callId: zod.uuid().describe('The call identifier.'),
                          channelId: zod
                            .uuid()
                            .describe('The channel this call belongs to.'),
                          channelName: zod
                            .string()
                            .nullish()
                            .describe('Resolved display name for the channel.'),
                          createdBy: zod
                            .string()
                            .describe('User who created the call.'),
                          customName: zod
                            .string()
                            .nullish()
                            .describe(
                              'User-supplied or AI-generated display name for the call.'
                            ),
                          durationMs: zod
                            .number()
                            .nullish()
                            .describe(
                              'Call duration in milliseconds (None if still active).'
                            ),
                          endedAt: zod.iso
                            .datetime({})
                            .nullish()
                            .describe(
                              'When the call ended (None if still active).'
                            ),
                          isActive: zod
                            .boolean()
                            .describe('Whether the call is currently active.'),
                          participants: zod
                            .array(
                              zod
                                .object({
                                  joinedAt: zod.iso
                                    .datetime({})
                                    .describe('When the user joined the call.'),
                                  leftAt: zod.iso
                                    .datetime({})
                                    .nullish()
                                    .describe(
                                      'When the user left (None if still in an active call).'
                                    ),
                                  userId: zod.string().describe('The user id.'),
                                })
                                .describe(
                                  'A participant in a call record, as displayed in Soup.'
                                )
                            )
                            .describe('Participants in the call.'),
                          startedAt: zod.iso
                            .datetime({})
                            .describe('When the call started.'),
                          status: zod
                            .enum(['ATTENDED', 'MISSED', 'UNATTENDED'])
                            .describe(
                              'Viewer-relative attendance status for a call record.\nSerializes as `ATTENDED`, `MISSED`, or `UNATTENDED`.'
                            ),
                          summary: zod
                            .string()
                            .nullish()
                            .describe(
                              'AI-generated summary of the call. Only set on archived\n`call_records` once summarization has run; active calls always\nreturn `None`.'
                            ),
                        })
                      )
                      .describe(
                        'A call record as displayed in Soup. Excludes room_name, egress_id,\nand transcript — fields that are irrelevant for the soup feed.'
                      ),
                    tag: zod.enum(['call']),
                  })
                  .describe('Call record item.'),
                zod
                  .object({
                    data: zod
                      .object({
                        conferenceProvider: zod
                          .string()
                          .nullish()
                          .describe(
                            'Which conferencing system backs `conference_url`.'
                          ),
                        conferenceUrl: zod
                          .string()
                          .nullish()
                          .describe('Direct conference join URL.'),
                        createdAt: zod.iso
                          .datetime({})
                          .describe('Entity creation timestamp.'),
                        description: zod
                          .string()
                          .nullish()
                          .describe('Optional description.'),
                        extra: zod
                          .object({
                            properties: zod
                              .array(
                                zod
                                  .object({
                                    definition: zod
                                      .object({
                                        created_at: zod.iso.datetime({}),
                                        data_type: zod
                                          .enum([
                                            'BOOLEAN',
                                            'DATE',
                                            'NUMBER',
                                            'STRING',
                                            'SELECT_NUMBER',
                                            'SELECT_STRING',
                                            'TAG',
                                            'ENTITY',
                                            'LINK',
                                          ])
                                          .describe(
                                            'Data type for property values, determining storage and validation.'
                                          ),
                                        display_name: zod.string(),
                                        id: zod.uuid(),
                                        is_metadata: zod
                                          .boolean()
                                          .describe(
                                            'Flag to indicate if this is a system-generated metadata property.\nNot stored in database - computed at service layer.'
                                          ),
                                        is_multi_select: zod.boolean(),
                                        is_system: zod
                                          .boolean()
                                          .describe(
                                            'Flag to indicate if this is a system property (stored in DB).'
                                          ),
                                        owner: zod
                                          .union([
                                            zod
                                              .object({
                                                scope: zod.enum(['user']),
                                                user_id: zod.string(),
                                              })
                                              .describe(
                                                'User-scoped property.'
                                              ),
                                            zod
                                              .object({
                                                scope: zod.enum(['team']),
                                                team_id: zod.uuid(),
                                              })
                                              .describe(
                                                'Team-scoped property.'
                                              ),
                                            zod
                                              .object({
                                                scope: zod.enum(['system']),
                                              })
                                              .describe(
                                                'System-owned property (no user or team owner).'
                                              ),
                                          ])
                                          .describe(
                                            'Defines who owns a property - user-scoped, team-scoped, or system.'
                                          ),
                                        specific_entity_type: zod
                                          .union([
                                            zod.null(),
                                            zod
                                              .enum([
                                                'CALENDAR_EVENT',
                                                'CALL_RECORD',
                                                'CHANNEL',
                                                'CHAT',
                                                'COMPANY',
                                                'DOCUMENT',
                                                'PROJECT',
                                                'TASK',
                                                'THREAD',
                                                'USER',
                                              ])
                                              .describe(
                                                'Type of entity that can be referenced by entity properties.'
                                              ),
                                          ])
                                          .optional(),
                                        updated_at: zod.iso.datetime({}),
                                      })
                                      .describe(
                                        'Property definition model (service representation).'
                                      ),
                                    id: zod
                                      .uuid()
                                      .describe(
                                        'Globally unique id of the assignment attaching this property to an entity.'
                                      ),
                                    value: zod
                                      .union([
                                        zod.null(),
                                        zod
                                          .union([
                                            zod
                                              .object({
                                                type: zod.enum(['Boolean']),
                                                value: zod
                                                  .boolean()
                                                  .describe(
                                                    'Boolean value\nSerializes as: {\"type\": \"Boolean\", \"value\": true}'
                                                  ),
                                              })
                                              .describe(
                                                'Boolean value\nSerializes as: {\"type\": \"Boolean\", \"value\": true}'
                                              ),
                                            zod
                                              .object({
                                                type: zod.enum(['Number']),
                                                value: zod
                                                  .number()
                                                  .describe(
                                                    'Numeric value\nSerializes as: {\"type\": \"Number\", \"value\": 42.5}'
                                                  ),
                                              })
                                              .describe(
                                                'Numeric value\nSerializes as: {\"type\": \"Number\", \"value\": 42.5}'
                                              ),
                                            zod
                                              .object({
                                                type: zod.enum(['String']),
                                                value: zod
                                                  .string()
                                                  .describe(
                                                    'String value\nSerializes as: {\"type\": \"String\", \"value\": \"text\"}'
                                                  ),
                                              })
                                              .describe(
                                                'String value\nSerializes as: {\"type\": \"String\", \"value\": \"text\"}'
                                              ),
                                            zod
                                              .object({
                                                type: zod.enum(['Date']),
                                                value: zod.iso
                                                  .datetime({})
                                                  .describe(
                                                    'Date\/timestamp value\nSerializes as: {\"type\": \"Date\", \"value\": \"2025-01-01T00:00:00Z\"}'
                                                  ),
                                              })
                                              .describe(
                                                'Date\/timestamp value\nSerializes as: {\"type\": \"Date\", \"value\": \"2025-01-01T00:00:00Z\"}'
                                              ),
                                            zod
                                              .object({
                                                type: zod.enum([
                                                  'SelectOption',
                                                ]),
                                                value: zod
                                                  .array(zod.uuid())
                                                  .describe(
                                                    'Select option(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"SelectOption\", \"value\": [\"uuid\"]} (length 0 or 1)\nMulti-select: {\"type\": \"SelectOption\", \"value\": [\"uuid1\", \"uuid2\", ...]} (length 0+)'
                                                  ),
                                              })
                                              .describe(
                                                'Select option(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"SelectOption\", \"value\": [\"uuid\"]} (length 0 or 1)\nMulti-select: {\"type\": \"SelectOption\", \"value\": [\"uuid1\", \"uuid2\", ...]} (length 0+)'
                                              ),
                                            zod
                                              .object({
                                                type: zod.enum([
                                                  'EntityReference',
                                                ]),
                                                value: zod
                                                  .array(
                                                    zod
                                                      .object({
                                                        entity_id: zod.string(),
                                                        entity_type: zod
                                                          .enum([
                                                            'CALENDAR_EVENT',
                                                            'CALL_RECORD',
                                                            'CHANNEL',
                                                            'CHAT',
                                                            'COMPANY',
                                                            'DOCUMENT',
                                                            'PROJECT',
                                                            'TASK',
                                                            'THREAD',
                                                            'USER',
                                                          ])
                                                          .describe(
                                                            'Type of entity that can be referenced by entity properties.'
                                                          ),
                                                        specific_message_id: zod
                                                          .uuid()
                                                          .nullish()
                                                          .describe(
                                                            'For CHANNEL, CHAT, THREAD entity types - optional specific message ID.\nThis allows referencing a specific message within a thread\/channel\/chat.'
                                                          ),
                                                      })
                                                      .describe(
                                                        'Entity reference for entity-type property values.'
                                                      )
                                                  )
                                                  .describe(
                                                    'Entity reference(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"EntityReference\", \"value\": [{...}]} (length 0 or 1)\nMulti-select: {\"type\": \"EntityReference\", \"value\": [{...}, {...}, ...]} (length 0+)'
                                                  ),
                                              })
                                              .describe(
                                                'Entity reference(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"EntityReference\", \"value\": [{...}]} (length 0 or 1)\nMulti-select: {\"type\": \"EntityReference\", \"value\": [{...}, {...}, ...]} (length 0+)'
                                              ),
                                            zod
                                              .object({
                                                type: zod.enum(['Link']),
                                                value: zod
                                                  .array(zod.string())
                                                  .describe(
                                                    'Link value(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"Link\", \"value\": [\"https:\/\/example.com\"]} (length 0 or 1)\nMulti-select: {\"type\": \"Link\", \"value\": [\"https:\/\/example.com\", \"https:\/\/other.com\"]} (length 0+)'
                                                  ),
                                              })
                                              .describe(
                                                'Link value(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"Link\", \"value\": [\"https:\/\/example.com\"]} (length 0 or 1)\nMulti-select: {\"type\": \"Link\", \"value\": [\"https:\/\/example.com\", \"https:\/\/other.com\"]} (length 0+)'
                                              ),
                                          ])
                                          .describe(
                                            'Property value (service representation).\n\nRepresents the actual value stored for an entity property.\nThis is serialized to\/from JSONB in the database.'
                                          ),
                                      ])
                                      .optional(),
                                  })
                                  .describe(
                                    'A property attached to a Soup item.\n\nThis is a simplified representation that includes only the definition and value,\nomitting the entity property assignment metadata and options.'
                                  )
                              )
                              .describe('Properties attached to the entity.'),
                          })
                          .describe(
                            'Property fields that can be flattened into property-bearing Soup items.'
                          ),
                        icalUid: zod
                          .string()
                          .describe(
                            'RFC 5545 UID used for source reconciliation.'
                          ),
                        id: zod.uuid().describe('Entity identifier.'),
                        isReadOnly: zod
                          .boolean()
                          .describe(
                            'Whether the selected canonical source is read-only.'
                          ),
                        location: zod
                          .string()
                          .nullish()
                          .describe('Optional location label.'),
                        organizerEmail: zod
                          .string()
                          .nullish()
                          .describe('Organizer email.'),
                        organizerName: zod
                          .string()
                          .nullish()
                          .describe('Organizer display name.'),
                        ownerId: zod.string().describe('Owning Macro user.'),
                        status: zod.string().describe('Canonical status.'),
                        time: zod
                          .union([
                            zod
                              .object({
                                endsAt: zod.iso
                                  .datetime({})
                                  .describe('Exclusive end.'),
                                kind: zod.enum(['timed']),
                                startsAt: zod.iso
                                  .datetime({})
                                  .describe('Inclusive start.'),
                                timeZone: zod
                                  .string()
                                  .nullish()
                                  .describe('Original IANA time zone.'),
                              })
                              .describe('Absolute timed event.'),
                            zod
                              .object({
                                endDate: zod.iso
                                  .date()
                                  .describe('Exclusive end date.'),
                                kind: zod.enum(['allDay']),
                                startDate: zod.iso
                                  .date()
                                  .describe('Inclusive start date.'),
                              })
                              .describe(
                                'All-day event with an exclusive end date.'
                              ),
                          ])
                          .describe(
                            'Timed or all-day calendar event span.\n\nFields are camelCased per variant rather than via `rename_all_fields`,\nwhich utoipa ignores — the generated OpenAPI schema would otherwise\nclaim snake_case fields the wire never carries.'
                          ),
                        title: zod.string().describe('Display title.'),
                        transparency: zod
                          .string()
                          .describe('Availability transparency.'),
                        updatedAt: zod.iso
                          .datetime({})
                          .describe('Entity update timestamp.'),
                        visibility: zod
                          .string()
                          .describe('Canonical visibility.'),
                      })
                      .describe('A canonical calendar event entity in Soup.'),
                    tag: zod.enum(['calendarEvent']),
                  })
                  .describe('Calendar event item.'),
                zod
                  .object({
                    data: zod
                      .object({
                        properties: zod
                          .array(
                            zod
                              .object({
                                definition: zod
                                  .object({
                                    created_at: zod.iso.datetime({}),
                                    data_type: zod
                                      .enum([
                                        'BOOLEAN',
                                        'DATE',
                                        'NUMBER',
                                        'STRING',
                                        'SELECT_NUMBER',
                                        'SELECT_STRING',
                                        'TAG',
                                        'ENTITY',
                                        'LINK',
                                      ])
                                      .describe(
                                        'Data type for property values, determining storage and validation.'
                                      ),
                                    display_name: zod.string(),
                                    id: zod.uuid(),
                                    is_metadata: zod
                                      .boolean()
                                      .describe(
                                        'Flag to indicate if this is a system-generated metadata property.\nNot stored in database - computed at service layer.'
                                      ),
                                    is_multi_select: zod.boolean(),
                                    is_system: zod
                                      .boolean()
                                      .describe(
                                        'Flag to indicate if this is a system property (stored in DB).'
                                      ),
                                    owner: zod
                                      .union([
                                        zod
                                          .object({
                                            scope: zod.enum(['user']),
                                            user_id: zod.string(),
                                          })
                                          .describe('User-scoped property.'),
                                        zod
                                          .object({
                                            scope: zod.enum(['team']),
                                            team_id: zod.uuid(),
                                          })
                                          .describe('Team-scoped property.'),
                                        zod
                                          .object({
                                            scope: zod.enum(['system']),
                                          })
                                          .describe(
                                            'System-owned property (no user or team owner).'
                                          ),
                                      ])
                                      .describe(
                                        'Defines who owns a property - user-scoped, team-scoped, or system.'
                                      ),
                                    specific_entity_type: zod
                                      .union([
                                        zod.null(),
                                        zod
                                          .enum([
                                            'CALENDAR_EVENT',
                                            'CALL_RECORD',
                                            'CHANNEL',
                                            'CHAT',
                                            'COMPANY',
                                            'DOCUMENT',
                                            'PROJECT',
                                            'TASK',
                                            'THREAD',
                                            'USER',
                                          ])
                                          .describe(
                                            'Type of entity that can be referenced by entity properties.'
                                          ),
                                      ])
                                      .optional(),
                                    updated_at: zod.iso.datetime({}),
                                  })
                                  .describe(
                                    'Property definition model (service representation).'
                                  ),
                                id: zod
                                  .uuid()
                                  .describe(
                                    'Globally unique id of the assignment attaching this property to an entity.'
                                  ),
                                value: zod
                                  .union([
                                    zod.null(),
                                    zod
                                      .union([
                                        zod
                                          .object({
                                            type: zod.enum(['Boolean']),
                                            value: zod
                                              .boolean()
                                              .describe(
                                                'Boolean value\nSerializes as: {\"type\": \"Boolean\", \"value\": true}'
                                              ),
                                          })
                                          .describe(
                                            'Boolean value\nSerializes as: {\"type\": \"Boolean\", \"value\": true}'
                                          ),
                                        zod
                                          .object({
                                            type: zod.enum(['Number']),
                                            value: zod
                                              .number()
                                              .describe(
                                                'Numeric value\nSerializes as: {\"type\": \"Number\", \"value\": 42.5}'
                                              ),
                                          })
                                          .describe(
                                            'Numeric value\nSerializes as: {\"type\": \"Number\", \"value\": 42.5}'
                                          ),
                                        zod
                                          .object({
                                            type: zod.enum(['String']),
                                            value: zod
                                              .string()
                                              .describe(
                                                'String value\nSerializes as: {\"type\": \"String\", \"value\": \"text\"}'
                                              ),
                                          })
                                          .describe(
                                            'String value\nSerializes as: {\"type\": \"String\", \"value\": \"text\"}'
                                          ),
                                        zod
                                          .object({
                                            type: zod.enum(['Date']),
                                            value: zod.iso
                                              .datetime({})
                                              .describe(
                                                'Date\/timestamp value\nSerializes as: {\"type\": \"Date\", \"value\": \"2025-01-01T00:00:00Z\"}'
                                              ),
                                          })
                                          .describe(
                                            'Date\/timestamp value\nSerializes as: {\"type\": \"Date\", \"value\": \"2025-01-01T00:00:00Z\"}'
                                          ),
                                        zod
                                          .object({
                                            type: zod.enum(['SelectOption']),
                                            value: zod
                                              .array(zod.uuid())
                                              .describe(
                                                'Select option(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"SelectOption\", \"value\": [\"uuid\"]} (length 0 or 1)\nMulti-select: {\"type\": \"SelectOption\", \"value\": [\"uuid1\", \"uuid2\", ...]} (length 0+)'
                                              ),
                                          })
                                          .describe(
                                            'Select option(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"SelectOption\", \"value\": [\"uuid\"]} (length 0 or 1)\nMulti-select: {\"type\": \"SelectOption\", \"value\": [\"uuid1\", \"uuid2\", ...]} (length 0+)'
                                          ),
                                        zod
                                          .object({
                                            type: zod.enum(['EntityReference']),
                                            value: zod
                                              .array(
                                                zod
                                                  .object({
                                                    entity_id: zod.string(),
                                                    entity_type: zod
                                                      .enum([
                                                        'CALENDAR_EVENT',
                                                        'CALL_RECORD',
                                                        'CHANNEL',
                                                        'CHAT',
                                                        'COMPANY',
                                                        'DOCUMENT',
                                                        'PROJECT',
                                                        'TASK',
                                                        'THREAD',
                                                        'USER',
                                                      ])
                                                      .describe(
                                                        'Type of entity that can be referenced by entity properties.'
                                                      ),
                                                    specific_message_id: zod
                                                      .uuid()
                                                      .nullish()
                                                      .describe(
                                                        'For CHANNEL, CHAT, THREAD entity types - optional specific message ID.\nThis allows referencing a specific message within a thread\/channel\/chat.'
                                                      ),
                                                  })
                                                  .describe(
                                                    'Entity reference for entity-type property values.'
                                                  )
                                              )
                                              .describe(
                                                'Entity reference(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"EntityReference\", \"value\": [{...}]} (length 0 or 1)\nMulti-select: {\"type\": \"EntityReference\", \"value\": [{...}, {...}, ...]} (length 0+)'
                                              ),
                                          })
                                          .describe(
                                            'Entity reference(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"EntityReference\", \"value\": [{...}]} (length 0 or 1)\nMulti-select: {\"type\": \"EntityReference\", \"value\": [{...}, {...}, ...]} (length 0+)'
                                          ),
                                        zod
                                          .object({
                                            type: zod.enum(['Link']),
                                            value: zod
                                              .array(zod.string())
                                              .describe(
                                                'Link value(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"Link\", \"value\": [\"https:\/\/example.com\"]} (length 0 or 1)\nMulti-select: {\"type\": \"Link\", \"value\": [\"https:\/\/example.com\", \"https:\/\/other.com\"]} (length 0+)'
                                              ),
                                          })
                                          .describe(
                                            'Link value(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"Link\", \"value\": [\"https:\/\/example.com\"]} (length 0 or 1)\nMulti-select: {\"type\": \"Link\", \"value\": [\"https:\/\/example.com\", \"https:\/\/other.com\"]} (length 0+)'
                                          ),
                                      ])
                                      .describe(
                                        'Property value (service representation).\n\nRepresents the actual value stored for an entity property.\nThis is serialized to\/from JSONB in the database.'
                                      ),
                                  ])
                                  .optional(),
                              })
                              .describe(
                                'A property attached to a Soup item.\n\nThis is a simplified representation that includes only the definition and value,\nomitting the entity property assignment metadata and options.'
                              )
                          )
                          .describe('Properties attached to the entity.'),
                      })
                      .describe(
                        'Property fields that can be flattened into property-bearing Soup items.'
                      )
                      .and(
                        zod.object({
                          createdAt: zod.iso
                            .datetime({})
                            .describe('When the company was created.'),
                          description: zod
                            .string()
                            .nullish()
                            .describe(
                              "Display description from the primary domain's directory entry."
                            ),
                          domains: zod
                            .array(
                              zod
                                .object({
                                  companyId: zod
                                    .uuid()
                                    .describe(
                                      'The id of the company the domain belongs to.'
                                    ),
                                  createdAt: zod.iso
                                    .datetime({})
                                    .describe(
                                      'When the domain record was created.'
                                    ),
                                  domain: zod
                                    .string()
                                    .describe(
                                      'The domain (lowercased, e.g. \"acme.com\").'
                                    ),
                                  id: zod
                                    .uuid()
                                    .describe('The id of the domain record.'),
                                })
                                .describe(
                                  "A CRM domain as displayed in Soup. Mirrors the crm crate's\n[`CrmDomain`] with a stable wire shape that the FE can rely on."
                                )
                            )
                            .describe(
                              'Domains associated with this company, ordered by creation time\nascending (primary first).'
                            ),
                          emailSync: zod
                            .boolean()
                            .describe(
                              'Whether email sync is enabled for this company.'
                            ),
                          hidden: zod
                            .boolean()
                            .describe(
                              'Whether the company is hidden from CRM listings. Soup filters\nthese out by default.'
                            ),
                          id: zod.uuid().describe('The id of the company.'),
                          name: zod
                            .string()
                            .nullish()
                            .describe(
                              "Display name from the primary domain's directory entry, or\n`None` when unresolved."
                            ),
                          teamId: zod
                            .uuid()
                            .describe(
                              'The id of the team that owns this company record.'
                            ),
                          updatedAt: zod.iso
                            .datetime({})
                            .describe('When the company was last updated.'),
                          viewedAt: zod.iso
                            .datetime({})
                            .nullish()
                            .describe(
                              'When the requesting user last viewed this company, or `None` if\nnever viewed. Mirrors the `viewed_at` other soup entities carry.'
                            ),
                        })
                      )
                      .describe(
                        'A CRM company as displayed in Soup. Carries the core company\nfields plus display metadata resolved from `crm_domain_directory`\nagainst the primary (earliest-created) domain.'
                      ),
                    tag: zod.enum(['crmCompany']),
                  })
                  .describe('CRM company item.'),
                zod
                  .object({
                    data: zod
                      .object({
                        createdAt: zod.iso
                          .datetime({})
                          .describe('Timestamp when the record was created.'),
                        foreignEntityId: zod
                          .string()
                          .describe(
                            'Identifier assigned by the external system.'
                          ),
                        foreignEntitySource: zod
                          .string()
                          .describe(
                            'Source system that owns the external identifier.'
                          ),
                        id: zod
                          .uuid()
                          .describe(
                            'Internal primary key for this foreign entity record.'
                          ),
                        metadata: zod
                          .object({})
                          .describe(
                            'Arbitrary metadata stored with the mapping.'
                          ),
                        storedForAuthEntity: zod
                          .string()
                          .describe(
                            'Internal auth entity namespace this foreign entity is stored for.'
                          ),
                        storedForId: zod
                          .string()
                          .describe(
                            'Internal entity identifier this foreign entity is stored for.'
                          ),
                        updatedAt: zod.iso
                          .datetime({})
                          .describe(
                            'Timestamp when the record was last updated.'
                          ),
                      })
                      .describe(
                        'A foreign entity record as displayed in Soup.'
                      ),
                    tag: zod.enum(['foreignEntity']),
                  })
                  .describe('Foreign entity item.'),
                zod
                  .object({
                    data: zod
                      .object({
                        properties: zod
                          .array(
                            zod
                              .object({
                                definition: zod
                                  .object({
                                    created_at: zod.iso.datetime({}),
                                    data_type: zod
                                      .enum([
                                        'BOOLEAN',
                                        'DATE',
                                        'NUMBER',
                                        'STRING',
                                        'SELECT_NUMBER',
                                        'SELECT_STRING',
                                        'TAG',
                                        'ENTITY',
                                        'LINK',
                                      ])
                                      .describe(
                                        'Data type for property values, determining storage and validation.'
                                      ),
                                    display_name: zod.string(),
                                    id: zod.uuid(),
                                    is_metadata: zod
                                      .boolean()
                                      .describe(
                                        'Flag to indicate if this is a system-generated metadata property.\nNot stored in database - computed at service layer.'
                                      ),
                                    is_multi_select: zod.boolean(),
                                    is_system: zod
                                      .boolean()
                                      .describe(
                                        'Flag to indicate if this is a system property (stored in DB).'
                                      ),
                                    owner: zod
                                      .union([
                                        zod
                                          .object({
                                            scope: zod.enum(['user']),
                                            user_id: zod.string(),
                                          })
                                          .describe('User-scoped property.'),
                                        zod
                                          .object({
                                            scope: zod.enum(['team']),
                                            team_id: zod.uuid(),
                                          })
                                          .describe('Team-scoped property.'),
                                        zod
                                          .object({
                                            scope: zod.enum(['system']),
                                          })
                                          .describe(
                                            'System-owned property (no user or team owner).'
                                          ),
                                      ])
                                      .describe(
                                        'Defines who owns a property - user-scoped, team-scoped, or system.'
                                      ),
                                    specific_entity_type: zod
                                      .union([
                                        zod.null(),
                                        zod
                                          .enum([
                                            'CALENDAR_EVENT',
                                            'CALL_RECORD',
                                            'CHANNEL',
                                            'CHAT',
                                            'COMPANY',
                                            'DOCUMENT',
                                            'PROJECT',
                                            'TASK',
                                            'THREAD',
                                            'USER',
                                          ])
                                          .describe(
                                            'Type of entity that can be referenced by entity properties.'
                                          ),
                                      ])
                                      .optional(),
                                    updated_at: zod.iso.datetime({}),
                                  })
                                  .describe(
                                    'Property definition model (service representation).'
                                  ),
                                id: zod
                                  .uuid()
                                  .describe(
                                    'Globally unique id of the assignment attaching this property to an entity.'
                                  ),
                                value: zod
                                  .union([
                                    zod.null(),
                                    zod
                                      .union([
                                        zod
                                          .object({
                                            type: zod.enum(['Boolean']),
                                            value: zod
                                              .boolean()
                                              .describe(
                                                'Boolean value\nSerializes as: {\"type\": \"Boolean\", \"value\": true}'
                                              ),
                                          })
                                          .describe(
                                            'Boolean value\nSerializes as: {\"type\": \"Boolean\", \"value\": true}'
                                          ),
                                        zod
                                          .object({
                                            type: zod.enum(['Number']),
                                            value: zod
                                              .number()
                                              .describe(
                                                'Numeric value\nSerializes as: {\"type\": \"Number\", \"value\": 42.5}'
                                              ),
                                          })
                                          .describe(
                                            'Numeric value\nSerializes as: {\"type\": \"Number\", \"value\": 42.5}'
                                          ),
                                        zod
                                          .object({
                                            type: zod.enum(['String']),
                                            value: zod
                                              .string()
                                              .describe(
                                                'String value\nSerializes as: {\"type\": \"String\", \"value\": \"text\"}'
                                              ),
                                          })
                                          .describe(
                                            'String value\nSerializes as: {\"type\": \"String\", \"value\": \"text\"}'
                                          ),
                                        zod
                                          .object({
                                            type: zod.enum(['Date']),
                                            value: zod.iso
                                              .datetime({})
                                              .describe(
                                                'Date\/timestamp value\nSerializes as: {\"type\": \"Date\", \"value\": \"2025-01-01T00:00:00Z\"}'
                                              ),
                                          })
                                          .describe(
                                            'Date\/timestamp value\nSerializes as: {\"type\": \"Date\", \"value\": \"2025-01-01T00:00:00Z\"}'
                                          ),
                                        zod
                                          .object({
                                            type: zod.enum(['SelectOption']),
                                            value: zod
                                              .array(zod.uuid())
                                              .describe(
                                                'Select option(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"SelectOption\", \"value\": [\"uuid\"]} (length 0 or 1)\nMulti-select: {\"type\": \"SelectOption\", \"value\": [\"uuid1\", \"uuid2\", ...]} (length 0+)'
                                              ),
                                          })
                                          .describe(
                                            'Select option(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"SelectOption\", \"value\": [\"uuid\"]} (length 0 or 1)\nMulti-select: {\"type\": \"SelectOption\", \"value\": [\"uuid1\", \"uuid2\", ...]} (length 0+)'
                                          ),
                                        zod
                                          .object({
                                            type: zod.enum(['EntityReference']),
                                            value: zod
                                              .array(
                                                zod
                                                  .object({
                                                    entity_id: zod.string(),
                                                    entity_type: zod
                                                      .enum([
                                                        'CALENDAR_EVENT',
                                                        'CALL_RECORD',
                                                        'CHANNEL',
                                                        'CHAT',
                                                        'COMPANY',
                                                        'DOCUMENT',
                                                        'PROJECT',
                                                        'TASK',
                                                        'THREAD',
                                                        'USER',
                                                      ])
                                                      .describe(
                                                        'Type of entity that can be referenced by entity properties.'
                                                      ),
                                                    specific_message_id: zod
                                                      .uuid()
                                                      .nullish()
                                                      .describe(
                                                        'For CHANNEL, CHAT, THREAD entity types - optional specific message ID.\nThis allows referencing a specific message within a thread\/channel\/chat.'
                                                      ),
                                                  })
                                                  .describe(
                                                    'Entity reference for entity-type property values.'
                                                  )
                                              )
                                              .describe(
                                                'Entity reference(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"EntityReference\", \"value\": [{...}]} (length 0 or 1)\nMulti-select: {\"type\": \"EntityReference\", \"value\": [{...}, {...}, ...]} (length 0+)'
                                              ),
                                          })
                                          .describe(
                                            'Entity reference(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"EntityReference\", \"value\": [{...}]} (length 0 or 1)\nMulti-select: {\"type\": \"EntityReference\", \"value\": [{...}, {...}, ...]} (length 0+)'
                                          ),
                                        zod
                                          .object({
                                            type: zod.enum(['Link']),
                                            value: zod
                                              .array(zod.string())
                                              .describe(
                                                'Link value(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"Link\", \"value\": [\"https:\/\/example.com\"]} (length 0 or 1)\nMulti-select: {\"type\": \"Link\", \"value\": [\"https:\/\/example.com\", \"https:\/\/other.com\"]} (length 0+)'
                                              ),
                                          })
                                          .describe(
                                            'Link value(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"Link\", \"value\": [\"https:\/\/example.com\"]} (length 0 or 1)\nMulti-select: {\"type\": \"Link\", \"value\": [\"https:\/\/example.com\", \"https:\/\/other.com\"]} (length 0+)'
                                          ),
                                      ])
                                      .describe(
                                        'Property value (service representation).\n\nRepresents the actual value stored for an entity property.\nThis is serialized to\/from JSONB in the database.'
                                      ),
                                  ])
                                  .optional(),
                              })
                              .describe(
                                'A property attached to a Soup item.\n\nThis is a simplified representation that includes only the definition and value,\nomitting the entity property assignment metadata and options.'
                              )
                          )
                          .describe('Properties attached to the entity.'),
                      })
                      .describe(
                        'Property fields that can be flattened into property-bearing Soup items.'
                      )
                      .and(
                        zod.object({
                          completedAt: zod.iso
                            .datetime({})
                            .nullish()
                            .describe(
                              'Set once a one-shot reminder has fired.'
                            ),
                          createdAt: zod.iso
                            .datetime({})
                            .describe('When the reminder was created.'),
                          description: zod
                            .string()
                            .describe(
                              'What to remind the user about. Doubles as the display name.'
                            ),
                          enabled: zod
                            .boolean()
                            .describe(
                              'When false, the dispatcher skips this reminder.'
                            ),
                          id: zod.uuid().describe('The reminder id.'),
                          nextRunAt: zod.iso
                            .datetime({})
                            .describe(
                              'The next firing. This is what Soup sorts reminders on.'
                            ),
                          referencedEntity: zod
                            .union([
                              zod.null(),
                              zod
                                .object({
                                  entityType: zod
                                    .enum([
                                      'user',
                                      'chat',
                                      'channel',
                                      'channel_message',
                                      'document',
                                      'project',
                                      'email_thread',
                                      'calendar_event',
                                      'team',
                                      'call',
                                      'foreign_entity',
                                      'static_file',
                                      'crm_company',
                                      'crm_contact',
                                      'reminder',
                                      'skill',
                                    ])
                                    .describe('The type of an entity in Macro')
                                    .describe("The referenced entity's type."),
                                  fileType: zod
                                    .string()
                                    .nullish()
                                    .describe(
                                      'File type, when the reference is a document — `md`, `pdf`, and so on.'
                                    ),
                                  id: zod
                                    .string()
                                    .describe("The referenced entity's id."),
                                  subType: zod
                                    .string()
                                    .nullish()
                                    .describe(
                                      'Sub type, when the reference is a task or snippet document.'
                                    ),
                                })
                                .describe(
                                  "The entity a reminder is about, resolved server-side.\n\nA reminder has no block of its own — it opens, and is iconed as, whatever it\nreferences. Which block that is depends on the referenced document's file\ntype, and the client's icon path is synchronous, so this is resolved here\nrather than costing a fetch per row."
                                ),
                            ])
                            .optional(),
                          schedule: zod
                            .union([
                              zod
                                .object({
                                  remindAt: zod.iso
                                    .datetime({})
                                    .describe('The instant to fire at.'),
                                  type: zod.enum(['once']),
                                })
                                .describe('Fires once, at a fixed instant.'),
                              zod
                                .object({
                                  cron: zod
                                    .string()
                                    .describe(
                                      'Cron expression, normalized to the 6-field form.'
                                    ),
                                  timezone: zod
                                    .string()
                                    .describe(
                                      'The timezone the cron expression is evaluated in.'
                                    ),
                                  type: zod.enum(['recurring']),
                                })
                                .describe(
                                  'Fires repeatedly, on a cron schedule evaluated in `timezone`.'
                                ),
                            ])
                            .describe(
                              'How often a reminder fires, flattened for the wire.\n\nThe domain\'s [`ReminderSchedule`] is an internally-tagged enum carrying a\nvalidated cron type; Soup only needs enough to render \"once\" vs \"every\nweekday at 9am\", so the cron is exposed as a plain string.'
                            ),
                          updatedAt: zod.iso
                            .datetime({})
                            .describe('When the reminder was last modified.'),
                        })
                      )
                      .describe(
                        "A reminder as displayed in Soup.\n\nReminders are user-owned rather than shared, so unlike most Soup items they\ncarry no access metadata — the repository only ever returns the caller's own."
                      ),
                    tag: zod.enum(['reminder']),
                  })
                  .describe('Reminder item.'),
              ])
              .describe('A single item in the Soup feed.')
              .and(
                zod.object({
                  frecency_score: zod.number(),
                  is_favorited: zod
                    .boolean()
                    .describe(
                      'Whether the requesting user has favorited this entity.'
                    ),
                })
              )
              .describe(
                'API representation of a soup item with its frecency score.'
              )
          )
          .describe(
            'Items in this page, keyed by id. Ordering lives in `groups[].item_ids`.'
          ),
      })
      .describe(
        'Response for the initial grouped soup query.\n\nItems are returned as a pool keyed by id; each `ApiGroupMeta.item_ids`\ndescribes the ordered membership of one group.'
      )
      .and(
        zod.object({
          mode: zod.enum(['initial']),
        })
      )
      .describe('Initial grouped response containing multiple groups.'),
    zod
      .object({
        group: zod
          .object({
            display_order: zod
              .number()
              .nullish()
              .describe('Display order for sorting groups (lower = first)'),
            item_ids: zod
              .array(zod.uuid())
              .describe(
                'Ordered ids of items in this group for the current page.\nEach id keys into `GroupedSoupPage.items`.'
              ),
            key: zod
              .string()
              .describe('Group key - format depends on group_by field'),
            label: zod.string().describe('Human-readable label for the group'),
            next_cursor: zod
              .string()
              .nullish()
              .describe(
                'Cursor to load more items specifically from this group'
              ),
            total_count: zod
              .number()
              .min(postItemsSoupAstGroupedResponseGroupTotalCountMin)
              .describe('Total count of items in this group across all pages'),
          })
          .describe(
            'API representation of group metadata.\n\nItems belonging to this group are referenced by `item_ids`, each of which\nlooks up an entry in `GroupedSoupPage.items` (a normalized pool).'
          ),
        items: zod
          .record(
            zod.string(),
            zod
              .union([
                zod
                  .object({
                    data: zod
                      .object({
                        properties: zod
                          .array(
                            zod
                              .object({
                                definition: zod
                                  .object({
                                    created_at: zod.iso.datetime({}),
                                    data_type: zod
                                      .enum([
                                        'BOOLEAN',
                                        'DATE',
                                        'NUMBER',
                                        'STRING',
                                        'SELECT_NUMBER',
                                        'SELECT_STRING',
                                        'TAG',
                                        'ENTITY',
                                        'LINK',
                                      ])
                                      .describe(
                                        'Data type for property values, determining storage and validation.'
                                      ),
                                    display_name: zod.string(),
                                    id: zod.uuid(),
                                    is_metadata: zod
                                      .boolean()
                                      .describe(
                                        'Flag to indicate if this is a system-generated metadata property.\nNot stored in database - computed at service layer.'
                                      ),
                                    is_multi_select: zod.boolean(),
                                    is_system: zod
                                      .boolean()
                                      .describe(
                                        'Flag to indicate if this is a system property (stored in DB).'
                                      ),
                                    owner: zod
                                      .union([
                                        zod
                                          .object({
                                            scope: zod.enum(['user']),
                                            user_id: zod.string(),
                                          })
                                          .describe('User-scoped property.'),
                                        zod
                                          .object({
                                            scope: zod.enum(['team']),
                                            team_id: zod.uuid(),
                                          })
                                          .describe('Team-scoped property.'),
                                        zod
                                          .object({
                                            scope: zod.enum(['system']),
                                          })
                                          .describe(
                                            'System-owned property (no user or team owner).'
                                          ),
                                      ])
                                      .describe(
                                        'Defines who owns a property - user-scoped, team-scoped, or system.'
                                      ),
                                    specific_entity_type: zod
                                      .union([
                                        zod.null(),
                                        zod
                                          .enum([
                                            'CALENDAR_EVENT',
                                            'CALL_RECORD',
                                            'CHANNEL',
                                            'CHAT',
                                            'COMPANY',
                                            'DOCUMENT',
                                            'PROJECT',
                                            'TASK',
                                            'THREAD',
                                            'USER',
                                          ])
                                          .describe(
                                            'Type of entity that can be referenced by entity properties.'
                                          ),
                                      ])
                                      .optional(),
                                    updated_at: zod.iso.datetime({}),
                                  })
                                  .describe(
                                    'Property definition model (service representation).'
                                  ),
                                id: zod
                                  .uuid()
                                  .describe(
                                    'Globally unique id of the assignment attaching this property to an entity.'
                                  ),
                                value: zod
                                  .union([
                                    zod.null(),
                                    zod
                                      .union([
                                        zod
                                          .object({
                                            type: zod.enum(['Boolean']),
                                            value: zod
                                              .boolean()
                                              .describe(
                                                'Boolean value\nSerializes as: {\"type\": \"Boolean\", \"value\": true}'
                                              ),
                                          })
                                          .describe(
                                            'Boolean value\nSerializes as: {\"type\": \"Boolean\", \"value\": true}'
                                          ),
                                        zod
                                          .object({
                                            type: zod.enum(['Number']),
                                            value: zod
                                              .number()
                                              .describe(
                                                'Numeric value\nSerializes as: {\"type\": \"Number\", \"value\": 42.5}'
                                              ),
                                          })
                                          .describe(
                                            'Numeric value\nSerializes as: {\"type\": \"Number\", \"value\": 42.5}'
                                          ),
                                        zod
                                          .object({
                                            type: zod.enum(['String']),
                                            value: zod
                                              .string()
                                              .describe(
                                                'String value\nSerializes as: {\"type\": \"String\", \"value\": \"text\"}'
                                              ),
                                          })
                                          .describe(
                                            'String value\nSerializes as: {\"type\": \"String\", \"value\": \"text\"}'
                                          ),
                                        zod
                                          .object({
                                            type: zod.enum(['Date']),
                                            value: zod.iso
                                              .datetime({})
                                              .describe(
                                                'Date\/timestamp value\nSerializes as: {\"type\": \"Date\", \"value\": \"2025-01-01T00:00:00Z\"}'
                                              ),
                                          })
                                          .describe(
                                            'Date\/timestamp value\nSerializes as: {\"type\": \"Date\", \"value\": \"2025-01-01T00:00:00Z\"}'
                                          ),
                                        zod
                                          .object({
                                            type: zod.enum(['SelectOption']),
                                            value: zod
                                              .array(zod.uuid())
                                              .describe(
                                                'Select option(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"SelectOption\", \"value\": [\"uuid\"]} (length 0 or 1)\nMulti-select: {\"type\": \"SelectOption\", \"value\": [\"uuid1\", \"uuid2\", ...]} (length 0+)'
                                              ),
                                          })
                                          .describe(
                                            'Select option(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"SelectOption\", \"value\": [\"uuid\"]} (length 0 or 1)\nMulti-select: {\"type\": \"SelectOption\", \"value\": [\"uuid1\", \"uuid2\", ...]} (length 0+)'
                                          ),
                                        zod
                                          .object({
                                            type: zod.enum(['EntityReference']),
                                            value: zod
                                              .array(
                                                zod
                                                  .object({
                                                    entity_id: zod.string(),
                                                    entity_type: zod
                                                      .enum([
                                                        'CALENDAR_EVENT',
                                                        'CALL_RECORD',
                                                        'CHANNEL',
                                                        'CHAT',
                                                        'COMPANY',
                                                        'DOCUMENT',
                                                        'PROJECT',
                                                        'TASK',
                                                        'THREAD',
                                                        'USER',
                                                      ])
                                                      .describe(
                                                        'Type of entity that can be referenced by entity properties.'
                                                      ),
                                                    specific_message_id: zod
                                                      .uuid()
                                                      .nullish()
                                                      .describe(
                                                        'For CHANNEL, CHAT, THREAD entity types - optional specific message ID.\nThis allows referencing a specific message within a thread\/channel\/chat.'
                                                      ),
                                                  })
                                                  .describe(
                                                    'Entity reference for entity-type property values.'
                                                  )
                                              )
                                              .describe(
                                                'Entity reference(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"EntityReference\", \"value\": [{...}]} (length 0 or 1)\nMulti-select: {\"type\": \"EntityReference\", \"value\": [{...}, {...}, ...]} (length 0+)'
                                              ),
                                          })
                                          .describe(
                                            'Entity reference(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"EntityReference\", \"value\": [{...}]} (length 0 or 1)\nMulti-select: {\"type\": \"EntityReference\", \"value\": [{...}, {...}, ...]} (length 0+)'
                                          ),
                                        zod
                                          .object({
                                            type: zod.enum(['Link']),
                                            value: zod
                                              .array(zod.string())
                                              .describe(
                                                'Link value(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"Link\", \"value\": [\"https:\/\/example.com\"]} (length 0 or 1)\nMulti-select: {\"type\": \"Link\", \"value\": [\"https:\/\/example.com\", \"https:\/\/other.com\"]} (length 0+)'
                                              ),
                                          })
                                          .describe(
                                            'Link value(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"Link\", \"value\": [\"https:\/\/example.com\"]} (length 0 or 1)\nMulti-select: {\"type\": \"Link\", \"value\": [\"https:\/\/example.com\", \"https:\/\/other.com\"]} (length 0+)'
                                          ),
                                      ])
                                      .describe(
                                        'Property value (service representation).\n\nRepresents the actual value stored for an entity property.\nThis is serialized to\/from JSONB in the database.'
                                      ),
                                  ])
                                  .optional(),
                              })
                              .describe(
                                'A property attached to a Soup item.\n\nThis is a simplified representation that includes only the definition and value,\nomitting the entity property assignment metadata and options.'
                              )
                          )
                          .describe('Properties attached to the entity.'),
                      })
                      .describe(
                        'Property fields that can be flattened into property-bearing Soup items.'
                      )
                      .and(
                        zod.object({
                          branchedFromId: zod
                            .uuid()
                            .nullish()
                            .describe(
                              'The id of the document this document branched from'
                            ),
                          branchedFromVersionId: zod
                            .number()
                            .nullish()
                            .describe(
                              'The id of the version this document branched from\nThis could be either DocumentInstance or DocumentBom id depending on the file type'
                            ),
                          createdAt: zod.iso
                            .datetime({})
                            .describe('The time the document was created'),
                          deletedAt: zod.iso
                            .datetime({})
                            .nullish()
                            .describe('The time the document was deleted'),
                          documentFamilyId: zod
                            .number()
                            .nullish()
                            .describe(
                              'The id of the document family this document belongs to'
                            ),
                          documentVersionId: zod
                            .number()
                            .describe(
                              'The version of the document\nThis could be the document_instance_id or document_bom_id depending on the file type'
                            ),
                          fileType: zod
                            .string()
                            .nullish()
                            .describe(
                              'The file type of the document (e.g. pdf, docx)'
                            ),
                          id: zod.uuid().describe('The document id'),
                          name: zod
                            .string()
                            .describe('The name of the document'),
                          ownerId: zod
                            .string()
                            .describe('The owner of the document'),
                          projectId: zod
                            .uuid()
                            .nullish()
                            .describe(
                              'The id of the project that this document belongs to'
                            ),
                          sha: zod
                            .string()
                            .nullish()
                            .describe(
                              'If the document is a PDF, this is the SHA of the pdf\nIf the document is a DOCX, this will not be present'
                            ),
                          subType: zod
                            .union([
                              zod.null(),
                              zod
                                .union([
                                  zod
                                    .object({
                                      is_completed: zod
                                        .boolean()
                                        .describe(
                                          'Whether the task is completed.\nTrue if the Status property is set to \"Completed\".'
                                        ),
                                      type: zod.enum(['task']),
                                    })
                                    .describe(
                                      'A task document with its associated properties'
                                    ),
                                  zod
                                    .object({
                                      type: zod.enum(['snippet']),
                                    })
                                    .describe(
                                      'A snippet document — reusable markdown'
                                    ),
                                  zod
                                    .object({
                                      type: zod.enum(['skill']),
                                    })
                                    .describe(
                                      'A skill document — markdown instructions for AI'
                                    ),
                                ])
                                .describe(
                                  'Sub type of a document with associated properties encoded in each variant.\nThis ensures type-safety: task properties only exist when the document is a task.'
                                ),
                            ])
                            .optional(),
                          updatedAt: zod.iso
                            .datetime({})
                            .describe(
                              'The time the document instance \/ document BOM was updated'
                            ),
                          viewedAt: zod.iso
                            .datetime({})
                            .nullish()
                            .describe('The time the document was last viewed'),
                        })
                      )
                      .describe('A document as displayed in Soup.'),
                    tag: zod.enum(['document']),
                  })
                  .describe('Document item.'),
                zod
                  .object({
                    data: zod
                      .object({
                        properties: zod
                          .array(
                            zod
                              .object({
                                definition: zod
                                  .object({
                                    created_at: zod.iso.datetime({}),
                                    data_type: zod
                                      .enum([
                                        'BOOLEAN',
                                        'DATE',
                                        'NUMBER',
                                        'STRING',
                                        'SELECT_NUMBER',
                                        'SELECT_STRING',
                                        'TAG',
                                        'ENTITY',
                                        'LINK',
                                      ])
                                      .describe(
                                        'Data type for property values, determining storage and validation.'
                                      ),
                                    display_name: zod.string(),
                                    id: zod.uuid(),
                                    is_metadata: zod
                                      .boolean()
                                      .describe(
                                        'Flag to indicate if this is a system-generated metadata property.\nNot stored in database - computed at service layer.'
                                      ),
                                    is_multi_select: zod.boolean(),
                                    is_system: zod
                                      .boolean()
                                      .describe(
                                        'Flag to indicate if this is a system property (stored in DB).'
                                      ),
                                    owner: zod
                                      .union([
                                        zod
                                          .object({
                                            scope: zod.enum(['user']),
                                            user_id: zod.string(),
                                          })
                                          .describe('User-scoped property.'),
                                        zod
                                          .object({
                                            scope: zod.enum(['team']),
                                            team_id: zod.uuid(),
                                          })
                                          .describe('Team-scoped property.'),
                                        zod
                                          .object({
                                            scope: zod.enum(['system']),
                                          })
                                          .describe(
                                            'System-owned property (no user or team owner).'
                                          ),
                                      ])
                                      .describe(
                                        'Defines who owns a property - user-scoped, team-scoped, or system.'
                                      ),
                                    specific_entity_type: zod
                                      .union([
                                        zod.null(),
                                        zod
                                          .enum([
                                            'CALENDAR_EVENT',
                                            'CALL_RECORD',
                                            'CHANNEL',
                                            'CHAT',
                                            'COMPANY',
                                            'DOCUMENT',
                                            'PROJECT',
                                            'TASK',
                                            'THREAD',
                                            'USER',
                                          ])
                                          .describe(
                                            'Type of entity that can be referenced by entity properties.'
                                          ),
                                      ])
                                      .optional(),
                                    updated_at: zod.iso.datetime({}),
                                  })
                                  .describe(
                                    'Property definition model (service representation).'
                                  ),
                                id: zod
                                  .uuid()
                                  .describe(
                                    'Globally unique id of the assignment attaching this property to an entity.'
                                  ),
                                value: zod
                                  .union([
                                    zod.null(),
                                    zod
                                      .union([
                                        zod
                                          .object({
                                            type: zod.enum(['Boolean']),
                                            value: zod
                                              .boolean()
                                              .describe(
                                                'Boolean value\nSerializes as: {\"type\": \"Boolean\", \"value\": true}'
                                              ),
                                          })
                                          .describe(
                                            'Boolean value\nSerializes as: {\"type\": \"Boolean\", \"value\": true}'
                                          ),
                                        zod
                                          .object({
                                            type: zod.enum(['Number']),
                                            value: zod
                                              .number()
                                              .describe(
                                                'Numeric value\nSerializes as: {\"type\": \"Number\", \"value\": 42.5}'
                                              ),
                                          })
                                          .describe(
                                            'Numeric value\nSerializes as: {\"type\": \"Number\", \"value\": 42.5}'
                                          ),
                                        zod
                                          .object({
                                            type: zod.enum(['String']),
                                            value: zod
                                              .string()
                                              .describe(
                                                'String value\nSerializes as: {\"type\": \"String\", \"value\": \"text\"}'
                                              ),
                                          })
                                          .describe(
                                            'String value\nSerializes as: {\"type\": \"String\", \"value\": \"text\"}'
                                          ),
                                        zod
                                          .object({
                                            type: zod.enum(['Date']),
                                            value: zod.iso
                                              .datetime({})
                                              .describe(
                                                'Date\/timestamp value\nSerializes as: {\"type\": \"Date\", \"value\": \"2025-01-01T00:00:00Z\"}'
                                              ),
                                          })
                                          .describe(
                                            'Date\/timestamp value\nSerializes as: {\"type\": \"Date\", \"value\": \"2025-01-01T00:00:00Z\"}'
                                          ),
                                        zod
                                          .object({
                                            type: zod.enum(['SelectOption']),
                                            value: zod
                                              .array(zod.uuid())
                                              .describe(
                                                'Select option(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"SelectOption\", \"value\": [\"uuid\"]} (length 0 or 1)\nMulti-select: {\"type\": \"SelectOption\", \"value\": [\"uuid1\", \"uuid2\", ...]} (length 0+)'
                                              ),
                                          })
                                          .describe(
                                            'Select option(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"SelectOption\", \"value\": [\"uuid\"]} (length 0 or 1)\nMulti-select: {\"type\": \"SelectOption\", \"value\": [\"uuid1\", \"uuid2\", ...]} (length 0+)'
                                          ),
                                        zod
                                          .object({
                                            type: zod.enum(['EntityReference']),
                                            value: zod
                                              .array(
                                                zod
                                                  .object({
                                                    entity_id: zod.string(),
                                                    entity_type: zod
                                                      .enum([
                                                        'CALENDAR_EVENT',
                                                        'CALL_RECORD',
                                                        'CHANNEL',
                                                        'CHAT',
                                                        'COMPANY',
                                                        'DOCUMENT',
                                                        'PROJECT',
                                                        'TASK',
                                                        'THREAD',
                                                        'USER',
                                                      ])
                                                      .describe(
                                                        'Type of entity that can be referenced by entity properties.'
                                                      ),
                                                    specific_message_id: zod
                                                      .uuid()
                                                      .nullish()
                                                      .describe(
                                                        'For CHANNEL, CHAT, THREAD entity types - optional specific message ID.\nThis allows referencing a specific message within a thread\/channel\/chat.'
                                                      ),
                                                  })
                                                  .describe(
                                                    'Entity reference for entity-type property values.'
                                                  )
                                              )
                                              .describe(
                                                'Entity reference(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"EntityReference\", \"value\": [{...}]} (length 0 or 1)\nMulti-select: {\"type\": \"EntityReference\", \"value\": [{...}, {...}, ...]} (length 0+)'
                                              ),
                                          })
                                          .describe(
                                            'Entity reference(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"EntityReference\", \"value\": [{...}]} (length 0 or 1)\nMulti-select: {\"type\": \"EntityReference\", \"value\": [{...}, {...}, ...]} (length 0+)'
                                          ),
                                        zod
                                          .object({
                                            type: zod.enum(['Link']),
                                            value: zod
                                              .array(zod.string())
                                              .describe(
                                                'Link value(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"Link\", \"value\": [\"https:\/\/example.com\"]} (length 0 or 1)\nMulti-select: {\"type\": \"Link\", \"value\": [\"https:\/\/example.com\", \"https:\/\/other.com\"]} (length 0+)'
                                              ),
                                          })
                                          .describe(
                                            'Link value(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"Link\", \"value\": [\"https:\/\/example.com\"]} (length 0 or 1)\nMulti-select: {\"type\": \"Link\", \"value\": [\"https:\/\/example.com\", \"https:\/\/other.com\"]} (length 0+)'
                                          ),
                                      ])
                                      .describe(
                                        'Property value (service representation).\n\nRepresents the actual value stored for an entity property.\nThis is serialized to\/from JSONB in the database.'
                                      ),
                                  ])
                                  .optional(),
                              })
                              .describe(
                                'A property attached to a Soup item.\n\nThis is a simplified representation that includes only the definition and value,\nomitting the entity property assignment metadata and options.'
                              )
                          )
                          .describe('Properties attached to the entity.'),
                      })
                      .describe(
                        'Property fields that can be flattened into property-bearing Soup items.'
                      )
                      .and(
                        zod.object({
                          createdAt: zod.iso
                            .datetime({})
                            .describe('The time the chat was created'),
                          deletedAt: zod.iso
                            .datetime({})
                            .nullish()
                            .describe('The time the chat was deleted'),
                          id: zod.uuid().describe('The chat uuid'),
                          isPersistent: zod
                            .boolean()
                            .describe('Whether the chat is persistent or not'),
                          name: zod.string().describe('The name of the chat'),
                          ownerId: zod
                            .string()
                            .describe('Who the chat belongs to'),
                          projectId: zod
                            .uuid()
                            .nullish()
                            .describe('The project id of the chat'),
                          updatedAt: zod.iso
                            .datetime({})
                            .describe('The time the chat was last updated'),
                          viewedAt: zod.iso
                            .datetime({})
                            .nullish()
                            .describe('The time the chat was last viewed'),
                        })
                      )
                      .describe('A chat as displayed in Soup.'),
                    tag: zod.enum(['chat']),
                  })
                  .describe('Chat item.'),
                zod
                  .object({
                    data: zod
                      .object({
                        properties: zod
                          .array(
                            zod
                              .object({
                                definition: zod
                                  .object({
                                    created_at: zod.iso.datetime({}),
                                    data_type: zod
                                      .enum([
                                        'BOOLEAN',
                                        'DATE',
                                        'NUMBER',
                                        'STRING',
                                        'SELECT_NUMBER',
                                        'SELECT_STRING',
                                        'TAG',
                                        'ENTITY',
                                        'LINK',
                                      ])
                                      .describe(
                                        'Data type for property values, determining storage and validation.'
                                      ),
                                    display_name: zod.string(),
                                    id: zod.uuid(),
                                    is_metadata: zod
                                      .boolean()
                                      .describe(
                                        'Flag to indicate if this is a system-generated metadata property.\nNot stored in database - computed at service layer.'
                                      ),
                                    is_multi_select: zod.boolean(),
                                    is_system: zod
                                      .boolean()
                                      .describe(
                                        'Flag to indicate if this is a system property (stored in DB).'
                                      ),
                                    owner: zod
                                      .union([
                                        zod
                                          .object({
                                            scope: zod.enum(['user']),
                                            user_id: zod.string(),
                                          })
                                          .describe('User-scoped property.'),
                                        zod
                                          .object({
                                            scope: zod.enum(['team']),
                                            team_id: zod.uuid(),
                                          })
                                          .describe('Team-scoped property.'),
                                        zod
                                          .object({
                                            scope: zod.enum(['system']),
                                          })
                                          .describe(
                                            'System-owned property (no user or team owner).'
                                          ),
                                      ])
                                      .describe(
                                        'Defines who owns a property - user-scoped, team-scoped, or system.'
                                      ),
                                    specific_entity_type: zod
                                      .union([
                                        zod.null(),
                                        zod
                                          .enum([
                                            'CALENDAR_EVENT',
                                            'CALL_RECORD',
                                            'CHANNEL',
                                            'CHAT',
                                            'COMPANY',
                                            'DOCUMENT',
                                            'PROJECT',
                                            'TASK',
                                            'THREAD',
                                            'USER',
                                          ])
                                          .describe(
                                            'Type of entity that can be referenced by entity properties.'
                                          ),
                                      ])
                                      .optional(),
                                    updated_at: zod.iso.datetime({}),
                                  })
                                  .describe(
                                    'Property definition model (service representation).'
                                  ),
                                id: zod
                                  .uuid()
                                  .describe(
                                    'Globally unique id of the assignment attaching this property to an entity.'
                                  ),
                                value: zod
                                  .union([
                                    zod.null(),
                                    zod
                                      .union([
                                        zod
                                          .object({
                                            type: zod.enum(['Boolean']),
                                            value: zod
                                              .boolean()
                                              .describe(
                                                'Boolean value\nSerializes as: {\"type\": \"Boolean\", \"value\": true}'
                                              ),
                                          })
                                          .describe(
                                            'Boolean value\nSerializes as: {\"type\": \"Boolean\", \"value\": true}'
                                          ),
                                        zod
                                          .object({
                                            type: zod.enum(['Number']),
                                            value: zod
                                              .number()
                                              .describe(
                                                'Numeric value\nSerializes as: {\"type\": \"Number\", \"value\": 42.5}'
                                              ),
                                          })
                                          .describe(
                                            'Numeric value\nSerializes as: {\"type\": \"Number\", \"value\": 42.5}'
                                          ),
                                        zod
                                          .object({
                                            type: zod.enum(['String']),
                                            value: zod
                                              .string()
                                              .describe(
                                                'String value\nSerializes as: {\"type\": \"String\", \"value\": \"text\"}'
                                              ),
                                          })
                                          .describe(
                                            'String value\nSerializes as: {\"type\": \"String\", \"value\": \"text\"}'
                                          ),
                                        zod
                                          .object({
                                            type: zod.enum(['Date']),
                                            value: zod.iso
                                              .datetime({})
                                              .describe(
                                                'Date\/timestamp value\nSerializes as: {\"type\": \"Date\", \"value\": \"2025-01-01T00:00:00Z\"}'
                                              ),
                                          })
                                          .describe(
                                            'Date\/timestamp value\nSerializes as: {\"type\": \"Date\", \"value\": \"2025-01-01T00:00:00Z\"}'
                                          ),
                                        zod
                                          .object({
                                            type: zod.enum(['SelectOption']),
                                            value: zod
                                              .array(zod.uuid())
                                              .describe(
                                                'Select option(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"SelectOption\", \"value\": [\"uuid\"]} (length 0 or 1)\nMulti-select: {\"type\": \"SelectOption\", \"value\": [\"uuid1\", \"uuid2\", ...]} (length 0+)'
                                              ),
                                          })
                                          .describe(
                                            'Select option(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"SelectOption\", \"value\": [\"uuid\"]} (length 0 or 1)\nMulti-select: {\"type\": \"SelectOption\", \"value\": [\"uuid1\", \"uuid2\", ...]} (length 0+)'
                                          ),
                                        zod
                                          .object({
                                            type: zod.enum(['EntityReference']),
                                            value: zod
                                              .array(
                                                zod
                                                  .object({
                                                    entity_id: zod.string(),
                                                    entity_type: zod
                                                      .enum([
                                                        'CALENDAR_EVENT',
                                                        'CALL_RECORD',
                                                        'CHANNEL',
                                                        'CHAT',
                                                        'COMPANY',
                                                        'DOCUMENT',
                                                        'PROJECT',
                                                        'TASK',
                                                        'THREAD',
                                                        'USER',
                                                      ])
                                                      .describe(
                                                        'Type of entity that can be referenced by entity properties.'
                                                      ),
                                                    specific_message_id: zod
                                                      .uuid()
                                                      .nullish()
                                                      .describe(
                                                        'For CHANNEL, CHAT, THREAD entity types - optional specific message ID.\nThis allows referencing a specific message within a thread\/channel\/chat.'
                                                      ),
                                                  })
                                                  .describe(
                                                    'Entity reference for entity-type property values.'
                                                  )
                                              )
                                              .describe(
                                                'Entity reference(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"EntityReference\", \"value\": [{...}]} (length 0 or 1)\nMulti-select: {\"type\": \"EntityReference\", \"value\": [{...}, {...}, ...]} (length 0+)'
                                              ),
                                          })
                                          .describe(
                                            'Entity reference(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"EntityReference\", \"value\": [{...}]} (length 0 or 1)\nMulti-select: {\"type\": \"EntityReference\", \"value\": [{...}, {...}, ...]} (length 0+)'
                                          ),
                                        zod
                                          .object({
                                            type: zod.enum(['Link']),
                                            value: zod
                                              .array(zod.string())
                                              .describe(
                                                'Link value(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"Link\", \"value\": [\"https:\/\/example.com\"]} (length 0 or 1)\nMulti-select: {\"type\": \"Link\", \"value\": [\"https:\/\/example.com\", \"https:\/\/other.com\"]} (length 0+)'
                                              ),
                                          })
                                          .describe(
                                            'Link value(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"Link\", \"value\": [\"https:\/\/example.com\"]} (length 0 or 1)\nMulti-select: {\"type\": \"Link\", \"value\": [\"https:\/\/example.com\", \"https:\/\/other.com\"]} (length 0+)'
                                          ),
                                      ])
                                      .describe(
                                        'Property value (service representation).\n\nRepresents the actual value stored for an entity property.\nThis is serialized to\/from JSONB in the database.'
                                      ),
                                  ])
                                  .optional(),
                              })
                              .describe(
                                'A property attached to a Soup item.\n\nThis is a simplified representation that includes only the definition and value,\nomitting the entity property assignment metadata and options.'
                              )
                          )
                          .describe('Properties attached to the entity.'),
                      })
                      .describe(
                        'Property fields that can be flattened into property-bearing Soup items.'
                      )
                      .and(
                        zod.object({
                          createdAt: zod.iso
                            .datetime({})
                            .describe('The time the project was created'),
                          deletedAt: zod.iso
                            .datetime({})
                            .nullish()
                            .describe('The time the project was deleted'),
                          id: zod.uuid().describe('The id of the project'),
                          name: zod
                            .string()
                            .describe('The name of the project'),
                          ownerId: zod
                            .string()
                            .describe('The user id of who created the project'),
                          parentId: zod
                            .uuid()
                            .nullish()
                            .describe('The parent project id'),
                          updatedAt: zod.iso
                            .datetime({})
                            .describe('The time the project was updated'),
                          viewedAt: zod.iso
                            .datetime({})
                            .nullish()
                            .describe('The time the document was last viewed'),
                        })
                      )
                      .describe('A project as displayed in Soup.'),
                    tag: zod.enum(['project']),
                  })
                  .describe('Project item.'),
                zod
                  .object({
                    data: zod
                      .object({
                        createdAt: zod.iso
                          .datetime({})
                          .describe('Timestamp when the thread was created.'),
                        id: zod.uuid().describe('Thread id.'),
                        inboxVisible: zod
                          .boolean()
                          .describe(
                            'Whether the thread should appear in the inbox.'
                          ),
                        isDraft: zod
                          .boolean()
                          .describe('Whether the thread contains a draft.'),
                        isImportant: zod
                          .boolean()
                          .describe('Whether the thread is marked important.'),
                        isRead: zod
                          .boolean()
                          .describe('Whether the thread has been read.'),
                        name: zod
                          .string()
                          .nullish()
                          .describe('Thread display name or subject.'),
                        ownerId: zod.string().describe('Owner user id.'),
                        projectId: zod
                          .string()
                          .nullish()
                          .describe('Project id associated with the thread.'),
                        providerId: zod
                          .string()
                          .nullish()
                          .describe('Provider-specific thread id.'),
                        senderEmail: zod
                          .string()
                          .nullish()
                          .describe('Sender email address for the preview.'),
                        senderName: zod
                          .string()
                          .nullish()
                          .describe('Sender display name for the preview.'),
                        senderPhotoUrl: zod
                          .string()
                          .nullish()
                          .describe('Sender photo URL for the preview.'),
                        snippet: zod
                          .string()
                          .nullish()
                          .describe('Thread snippet.'),
                        sortTs: zod.iso
                          .datetime({})
                          .describe('Timestamp used for email thread sorting.'),
                        updatedAt: zod.iso
                          .datetime({})
                          .describe(
                            'Timestamp when the thread was last updated.'
                          ),
                        viewedAt: zod.iso
                          .datetime({})
                          .nullish()
                          .describe(
                            'Timestamp when the requesting user last viewed the thread.'
                          ),
                      })
                      .describe(
                        'Email thread preview data as displayed in Soup.'
                      )
                      .and(
                        zod
                          .object({
                            properties: zod
                              .array(
                                zod
                                  .object({
                                    definition: zod
                                      .object({
                                        created_at: zod.iso.datetime({}),
                                        data_type: zod
                                          .enum([
                                            'BOOLEAN',
                                            'DATE',
                                            'NUMBER',
                                            'STRING',
                                            'SELECT_NUMBER',
                                            'SELECT_STRING',
                                            'TAG',
                                            'ENTITY',
                                            'LINK',
                                          ])
                                          .describe(
                                            'Data type for property values, determining storage and validation.'
                                          ),
                                        display_name: zod.string(),
                                        id: zod.uuid(),
                                        is_metadata: zod
                                          .boolean()
                                          .describe(
                                            'Flag to indicate if this is a system-generated metadata property.\nNot stored in database - computed at service layer.'
                                          ),
                                        is_multi_select: zod.boolean(),
                                        is_system: zod
                                          .boolean()
                                          .describe(
                                            'Flag to indicate if this is a system property (stored in DB).'
                                          ),
                                        owner: zod
                                          .union([
                                            zod
                                              .object({
                                                scope: zod.enum(['user']),
                                                user_id: zod.string(),
                                              })
                                              .describe(
                                                'User-scoped property.'
                                              ),
                                            zod
                                              .object({
                                                scope: zod.enum(['team']),
                                                team_id: zod.uuid(),
                                              })
                                              .describe(
                                                'Team-scoped property.'
                                              ),
                                            zod
                                              .object({
                                                scope: zod.enum(['system']),
                                              })
                                              .describe(
                                                'System-owned property (no user or team owner).'
                                              ),
                                          ])
                                          .describe(
                                            'Defines who owns a property - user-scoped, team-scoped, or system.'
                                          ),
                                        specific_entity_type: zod
                                          .union([
                                            zod.null(),
                                            zod
                                              .enum([
                                                'CALENDAR_EVENT',
                                                'CALL_RECORD',
                                                'CHANNEL',
                                                'CHAT',
                                                'COMPANY',
                                                'DOCUMENT',
                                                'PROJECT',
                                                'TASK',
                                                'THREAD',
                                                'USER',
                                              ])
                                              .describe(
                                                'Type of entity that can be referenced by entity properties.'
                                              ),
                                          ])
                                          .optional(),
                                        updated_at: zod.iso.datetime({}),
                                      })
                                      .describe(
                                        'Property definition model (service representation).'
                                      ),
                                    id: zod
                                      .uuid()
                                      .describe(
                                        'Globally unique id of the assignment attaching this property to an entity.'
                                      ),
                                    value: zod
                                      .union([
                                        zod.null(),
                                        zod
                                          .union([
                                            zod
                                              .object({
                                                type: zod.enum(['Boolean']),
                                                value: zod
                                                  .boolean()
                                                  .describe(
                                                    'Boolean value\nSerializes as: {\"type\": \"Boolean\", \"value\": true}'
                                                  ),
                                              })
                                              .describe(
                                                'Boolean value\nSerializes as: {\"type\": \"Boolean\", \"value\": true}'
                                              ),
                                            zod
                                              .object({
                                                type: zod.enum(['Number']),
                                                value: zod
                                                  .number()
                                                  .describe(
                                                    'Numeric value\nSerializes as: {\"type\": \"Number\", \"value\": 42.5}'
                                                  ),
                                              })
                                              .describe(
                                                'Numeric value\nSerializes as: {\"type\": \"Number\", \"value\": 42.5}'
                                              ),
                                            zod
                                              .object({
                                                type: zod.enum(['String']),
                                                value: zod
                                                  .string()
                                                  .describe(
                                                    'String value\nSerializes as: {\"type\": \"String\", \"value\": \"text\"}'
                                                  ),
                                              })
                                              .describe(
                                                'String value\nSerializes as: {\"type\": \"String\", \"value\": \"text\"}'
                                              ),
                                            zod
                                              .object({
                                                type: zod.enum(['Date']),
                                                value: zod.iso
                                                  .datetime({})
                                                  .describe(
                                                    'Date\/timestamp value\nSerializes as: {\"type\": \"Date\", \"value\": \"2025-01-01T00:00:00Z\"}'
                                                  ),
                                              })
                                              .describe(
                                                'Date\/timestamp value\nSerializes as: {\"type\": \"Date\", \"value\": \"2025-01-01T00:00:00Z\"}'
                                              ),
                                            zod
                                              .object({
                                                type: zod.enum([
                                                  'SelectOption',
                                                ]),
                                                value: zod
                                                  .array(zod.uuid())
                                                  .describe(
                                                    'Select option(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"SelectOption\", \"value\": [\"uuid\"]} (length 0 or 1)\nMulti-select: {\"type\": \"SelectOption\", \"value\": [\"uuid1\", \"uuid2\", ...]} (length 0+)'
                                                  ),
                                              })
                                              .describe(
                                                'Select option(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"SelectOption\", \"value\": [\"uuid\"]} (length 0 or 1)\nMulti-select: {\"type\": \"SelectOption\", \"value\": [\"uuid1\", \"uuid2\", ...]} (length 0+)'
                                              ),
                                            zod
                                              .object({
                                                type: zod.enum([
                                                  'EntityReference',
                                                ]),
                                                value: zod
                                                  .array(
                                                    zod
                                                      .object({
                                                        entity_id: zod.string(),
                                                        entity_type: zod
                                                          .enum([
                                                            'CALENDAR_EVENT',
                                                            'CALL_RECORD',
                                                            'CHANNEL',
                                                            'CHAT',
                                                            'COMPANY',
                                                            'DOCUMENT',
                                                            'PROJECT',
                                                            'TASK',
                                                            'THREAD',
                                                            'USER',
                                                          ])
                                                          .describe(
                                                            'Type of entity that can be referenced by entity properties.'
                                                          ),
                                                        specific_message_id: zod
                                                          .uuid()
                                                          .nullish()
                                                          .describe(
                                                            'For CHANNEL, CHAT, THREAD entity types - optional specific message ID.\nThis allows referencing a specific message within a thread\/channel\/chat.'
                                                          ),
                                                      })
                                                      .describe(
                                                        'Entity reference for entity-type property values.'
                                                      )
                                                  )
                                                  .describe(
                                                    'Entity reference(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"EntityReference\", \"value\": [{...}]} (length 0 or 1)\nMulti-select: {\"type\": \"EntityReference\", \"value\": [{...}, {...}, ...]} (length 0+)'
                                                  ),
                                              })
                                              .describe(
                                                'Entity reference(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"EntityReference\", \"value\": [{...}]} (length 0 or 1)\nMulti-select: {\"type\": \"EntityReference\", \"value\": [{...}, {...}, ...]} (length 0+)'
                                              ),
                                            zod
                                              .object({
                                                type: zod.enum(['Link']),
                                                value: zod
                                                  .array(zod.string())
                                                  .describe(
                                                    'Link value(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"Link\", \"value\": [\"https:\/\/example.com\"]} (length 0 or 1)\nMulti-select: {\"type\": \"Link\", \"value\": [\"https:\/\/example.com\", \"https:\/\/other.com\"]} (length 0+)'
                                                  ),
                                              })
                                              .describe(
                                                'Link value(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"Link\", \"value\": [\"https:\/\/example.com\"]} (length 0 or 1)\nMulti-select: {\"type\": \"Link\", \"value\": [\"https:\/\/example.com\", \"https:\/\/other.com\"]} (length 0+)'
                                              ),
                                          ])
                                          .describe(
                                            'Property value (service representation).\n\nRepresents the actual value stored for an entity property.\nThis is serialized to\/from JSONB in the database.'
                                          ),
                                      ])
                                      .optional(),
                                  })
                                  .describe(
                                    'A property attached to a Soup item.\n\nThis is a simplified representation that includes only the definition and value,\nomitting the entity property assignment metadata and options.'
                                  )
                              )
                              .describe('Properties attached to the entity.'),
                          })
                          .describe(
                            'Property fields that can be flattened into property-bearing Soup items.'
                          )
                      )
                      .and(
                        zod.object({
                          attachments: zod
                            .array(
                              zod
                                .object({
                                  contentId: zod
                                    .string()
                                    .nullish()
                                    .describe(
                                      'Content id for inline attachments.'
                                    ),
                                  createdAt: zod.iso
                                    .datetime({})
                                    .describe(
                                      'Timestamp when the attachment was created.'
                                    ),
                                  filename: zod
                                    .string()
                                    .nullish()
                                    .describe('Attachment filename.'),
                                  id: zod.uuid().describe('Attachment id.'),
                                  messageId: zod
                                    .uuid()
                                    .describe(
                                      'Message id that owns this attachment.'
                                    ),
                                  mimeType: zod
                                    .string()
                                    .nullish()
                                    .describe('Attachment MIME type.'),
                                  providerAttachmentId: zod
                                    .string()
                                    .nullish()
                                    .describe(
                                      'Provider-specific attachment id.'
                                    ),
                                  sizeBytes: zod
                                    .number()
                                    .nullish()
                                    .describe('Attachment size in bytes.'),
                                })
                                .describe(
                                  'An email attachment as displayed in Soup.'
                                )
                            )
                            .describe('Attachments on the thread.'),
                          labels: zod
                            .array(
                              zod
                                .object({
                                  createdAt: zod.iso
                                    .datetime({})
                                    .describe(
                                      'Timestamp when the label was created.'
                                    ),
                                  id: zod.uuid().describe('Label id.'),
                                  labelListVisibility: zod
                                    .enum([
                                      'labelShow',
                                      'labelShowIfUnread',
                                      'labelHide',
                                    ])
                                    .describe(
                                      'Gmail-style label list visibility.'
                                    ),
                                  linkId: zod
                                    .uuid()
                                    .describe(
                                      'Connected account link id for the label.'
                                    ),
                                  messageListVisibility: zod
                                    .enum(['show', 'hide'])
                                    .describe(
                                      'Gmail-style message list visibility for a label.'
                                    ),
                                  name: zod
                                    .string()
                                    .describe('Label display name.'),
                                  providerLabelId: zod
                                    .string()
                                    .describe('Provider-specific label id.'),
                                  type: zod
                                    .enum(['system', 'user'])
                                    .describe(
                                      'Whether an email label is provider-created or user-created.'
                                    ),
                                })
                                .describe(
                                  'An email label as displayed in Soup.'
                                )
                            )
                            .describe('Labels attached to the thread.'),
                          participants: zod
                            .array(
                              zod
                                .object({
                                  emailAddress: zod
                                    .string()
                                    .nullish()
                                    .describe('Contact email address.'),
                                  id: zod.uuid().describe('Contact id.'),
                                  linkId: zod
                                    .uuid()
                                    .describe(
                                      'Connected account link id for the contact.'
                                    ),
                                  name: zod
                                    .string()
                                    .nullish()
                                    .describe('Contact display name.'),
                                  sfsPhotoUrl: zod
                                    .string()
                                    .nullish()
                                    .describe(
                                      'Contact photo URL from SFS, if available.'
                                    ),
                                })
                                .describe(
                                  'A contact participating in an email thread as displayed in Soup.'
                                )
                            )
                            .describe('Contacts participating in the thread.'),
                        })
                      )
                      .describe(
                        'Email thread preview enriched with related metadata for Soup.'
                      ),
                    tag: zod.enum(['emailThread']),
                  })
                  .describe('Email thread item.'),
                zod
                  .object({
                    data: zod
                      .object({
                        channel: zod
                          .object({
                            channel_type: zod
                              .enum([
                                'public',
                                'private',
                                'direct_message',
                                'team',
                              ])
                              .describe('Type of channel.'),
                            created_at: zod.iso
                              .datetime({})
                              .describe('Creation timestamp.'),
                            id: zod.uuid().describe('Channel id.'),
                            name: zod
                              .string()
                              .nullish()
                              .describe('Channel display name.'),
                            org_id: zod
                              .number()
                              .min(
                                postItemsSoupAstGroupedResponseItemsDataChannelOrgIdMinOne
                              )
                              .nullish()
                              .describe('Organization id.'),
                            owner_id: zod.string().describe('Channel owner.'),
                            team_id: zod.uuid().nullish().describe('Team id.'),
                            updated_at: zod.iso
                              .datetime({})
                              .describe('Update timestamp.'),
                          })
                          .describe('Channel metadata in soup payloads.'),
                        is_participant: zod
                          .boolean()
                          .optional()
                          .describe(
                            "Whether the requesting user is an active participant of the channel.\nFalse for team channels of the user's teams they have not joined."
                          ),
                        participants: zod
                          .array(
                            zod
                              .object({
                                channel_id: zod
                                  .uuid()
                                  .describe(
                                    'Channel id for the participant membership.'
                                  ),
                                joined_at: zod.iso
                                  .datetime({})
                                  .describe(
                                    'Timestamp when the participant joined the channel.'
                                  ),
                                left_at: zod.iso
                                  .datetime({})
                                  .nullish()
                                  .describe(
                                    'Timestamp when the participant left the channel, if any.'
                                  ),
                                role: zod
                                  .enum(['owner', 'admin', 'member'])
                                  .describe(
                                    'The role a user has within a channel.'
                                  ),
                                user_id: zod
                                  .string()
                                  .describe('Participant user id.'),
                              })
                              .describe("A user's membership in a channel.")
                          )
                          .describe('Participants in the channel.'),
                      })
                      .describe(
                        'Channel metadata together with its participants.'
                      )
                      .and(
                        zod
                          .object({
                            latest_message: zod
                              .union([
                                zod.null(),
                                zod
                                  .object({
                                    content: zod
                                      .string()
                                      .describe('Message content.'),
                                    created_at: zod.iso
                                      .datetime({})
                                      .describe('Creation timestamp.'),
                                    deleted_at: zod.iso
                                      .datetime({})
                                      .nullish()
                                      .describe('Deletion timestamp.'),
                                    mentions: zod
                                      .array(zod.string())
                                      .describe(
                                        'Message mentions formatted as `{ENTITY_TYPE}:{ENTITY_ID}`.'
                                      ),
                                    message_id: zod
                                      .uuid()
                                      .describe('Message id.'),
                                    sender_id: zod
                                      .string()
                                      .describe('Sender id.'),
                                    thread_id: zod
                                      .uuid()
                                      .nullish()
                                      .describe('Thread parent id.'),
                                    updated_at: zod.iso
                                      .datetime({})
                                      .describe('Update timestamp.'),
                                  })
                                  .describe(
                                    'Lightweight channel message for soup payloads.'
                                  ),
                              ])
                              .optional(),
                            latest_non_thread_message: zod
                              .union([
                                zod.null(),
                                zod
                                  .object({
                                    content: zod
                                      .string()
                                      .describe('Message content.'),
                                    created_at: zod.iso
                                      .datetime({})
                                      .describe('Creation timestamp.'),
                                    deleted_at: zod.iso
                                      .datetime({})
                                      .nullish()
                                      .describe('Deletion timestamp.'),
                                    mentions: zod
                                      .array(zod.string())
                                      .describe(
                                        'Message mentions formatted as `{ENTITY_TYPE}:{ENTITY_ID}`.'
                                      ),
                                    message_id: zod
                                      .uuid()
                                      .describe('Message id.'),
                                    sender_id: zod
                                      .string()
                                      .describe('Sender id.'),
                                    thread_id: zod
                                      .uuid()
                                      .nullish()
                                      .describe('Thread parent id.'),
                                    updated_at: zod.iso
                                      .datetime({})
                                      .describe('Update timestamp.'),
                                  })
                                  .describe(
                                    'Lightweight channel message for soup payloads.'
                                  ),
                              ])
                              .optional(),
                          })
                          .describe('Latest-message bundle for soup payloads.')
                      )
                      .and(
                        zod.object({
                          interacted_at: zod.iso
                            .datetime({})
                            .nullish()
                            .describe(
                              'Timestamp when the requesting user last interacted with this channel.'
                            ),
                          viewed_at: zod.iso
                            .datetime({})
                            .nullish()
                            .describe(
                              'Timestamp when the requesting user last viewed this channel.'
                            ),
                        })
                      )
                      .describe('A channel as displayed in Soup.'),
                    tag: zod.enum(['channel']),
                  })
                  .describe('Channel item.'),
                zod
                  .object({
                    data: zod
                      .object({
                        attachments: zod
                          .array(
                            zod
                              .object({
                                created_at: zod.iso
                                  .datetime({})
                                  .describe('Creation timestamp.'),
                                entity_id: zod.string().describe('Entity id.'),
                                entity_type: zod
                                  .string()
                                  .describe('Type of entity.'),
                                height: zod
                                  .number()
                                  .nullish()
                                  .describe('Height for images.'),
                                id: zod.uuid().describe('Attachment id.'),
                                width: zod
                                  .number()
                                  .nullish()
                                  .describe('Width for images.'),
                              })
                              .describe('An attachment on a message.')
                          )
                          .describe('Attachments on this message.'),
                        channel_id: zod.uuid().describe('Channel id.'),
                        content: zod.string().describe('Message content.'),
                        created_at: zod.iso
                          .datetime({})
                          .describe('Creation timestamp.'),
                        deleted_at: zod.iso
                          .datetime({})
                          .nullish()
                          .describe('Deletion timestamp.'),
                        edited_at: zod.iso
                          .datetime({})
                          .nullish()
                          .describe('Edit timestamp.'),
                        id: zod.uuid().describe('Message id.'),
                        reactions: zod
                          .array(
                            zod
                              .object({
                                emoji: zod.string().describe('Emoji string.'),
                                users: zod
                                  .array(zod.string())
                                  .describe(
                                    'User ids who added this reaction.'
                                  ),
                              })
                              .describe('A reaction with emoji and user list.')
                          )
                          .describe('Reactions on this message.'),
                        sender: zod
                          .object({
                            avatar_url: zod
                              .string()
                              .nullish()
                              .describe('Avatar URL for bot senders.'),
                            id: zod
                              .string()
                              .describe(
                                'Sender id without the storage namespace prefix.'
                              ),
                            name: zod
                              .string()
                              .nullish()
                              .describe('Display name for bot senders.'),
                            type: zod
                              .enum(['user', 'bot'])
                              .describe(
                                'Public sender type for soup channel messages.'
                              ),
                          })
                          .describe(
                            'Public sender identity for soup channel messages.'
                          ),
                        sender_id: zod.string().describe('Sender id.'),
                        thread: zod
                          .object({
                            latest_reply_at: zod.iso
                              .datetime({})
                              .nullish()
                              .describe('Timestamp of the latest reply.'),
                            preview: zod
                              .array(
                                zod
                                  .object({
                                    attachments: zod
                                      .array(
                                        zod
                                          .object({
                                            created_at: zod.iso
                                              .datetime({})
                                              .describe('Creation timestamp.'),
                                            entity_id: zod
                                              .string()
                                              .describe('Entity id.'),
                                            entity_type: zod
                                              .string()
                                              .describe('Type of entity.'),
                                            height: zod
                                              .number()
                                              .nullish()
                                              .describe('Height for images.'),
                                            id: zod
                                              .uuid()
                                              .describe('Attachment id.'),
                                            width: zod
                                              .number()
                                              .nullish()
                                              .describe('Width for images.'),
                                          })
                                          .describe(
                                            'An attachment on a message.'
                                          )
                                      )
                                      .describe('Attachments on this reply.'),
                                    content: zod
                                      .string()
                                      .describe('Reply content.'),
                                    created_at: zod.iso
                                      .datetime({})
                                      .describe('Creation timestamp.'),
                                    edited_at: zod.iso
                                      .datetime({})
                                      .nullish()
                                      .describe('Edit timestamp.'),
                                    id: zod.uuid().describe('Reply id.'),
                                    reactions: zod
                                      .array(
                                        zod
                                          .object({
                                            emoji: zod
                                              .string()
                                              .describe('Emoji string.'),
                                            users: zod
                                              .array(zod.string())
                                              .describe(
                                                'User ids who added this reaction.'
                                              ),
                                          })
                                          .describe(
                                            'A reaction with emoji and user list.'
                                          )
                                      )
                                      .describe('Reactions on this reply.'),
                                    sender: zod
                                      .object({
                                        avatar_url: zod
                                          .string()
                                          .nullish()
                                          .describe(
                                            'Avatar URL for bot senders.'
                                          ),
                                        id: zod
                                          .string()
                                          .describe(
                                            'Sender id without the storage namespace prefix.'
                                          ),
                                        name: zod
                                          .string()
                                          .nullish()
                                          .describe(
                                            'Display name for bot senders.'
                                          ),
                                        type: zod
                                          .enum(['user', 'bot'])
                                          .describe(
                                            'Public sender type for soup channel messages.'
                                          ),
                                      })
                                      .describe(
                                        'Public sender identity for soup channel messages.'
                                      ),
                                    sender_id: zod
                                      .string()
                                      .describe('Sender id.'),
                                    updated_at: zod.iso
                                      .datetime({})
                                      .describe('Update timestamp.'),
                                  })
                                  .describe('A thread reply shown in preview.')
                              )
                              .describe('Preview replies.'),
                            reply_count: zod
                              .number()
                              .describe('Total reply count.'),
                          })
                          .describe(
                            'Thread metadata and preview replies for soup channel messages.'
                          ),
                        updated_at: zod.iso
                          .datetime({})
                          .describe('Update timestamp.'),
                      })
                      .describe(
                        'A top-level channel message thread for soup payloads.\n\nThis mirrors the public channel-message API shape so soup consumers can\nrender a thread root the same way they render a channel timeline message.'
                      ),
                    tag: zod.enum(['channelThread']),
                  })
                  .describe('Channel thread item.'),
                zod
                  .object({
                    data: zod
                      .object({
                        properties: zod
                          .array(
                            zod
                              .object({
                                definition: zod
                                  .object({
                                    created_at: zod.iso.datetime({}),
                                    data_type: zod
                                      .enum([
                                        'BOOLEAN',
                                        'DATE',
                                        'NUMBER',
                                        'STRING',
                                        'SELECT_NUMBER',
                                        'SELECT_STRING',
                                        'TAG',
                                        'ENTITY',
                                        'LINK',
                                      ])
                                      .describe(
                                        'Data type for property values, determining storage and validation.'
                                      ),
                                    display_name: zod.string(),
                                    id: zod.uuid(),
                                    is_metadata: zod
                                      .boolean()
                                      .describe(
                                        'Flag to indicate if this is a system-generated metadata property.\nNot stored in database - computed at service layer.'
                                      ),
                                    is_multi_select: zod.boolean(),
                                    is_system: zod
                                      .boolean()
                                      .describe(
                                        'Flag to indicate if this is a system property (stored in DB).'
                                      ),
                                    owner: zod
                                      .union([
                                        zod
                                          .object({
                                            scope: zod.enum(['user']),
                                            user_id: zod.string(),
                                          })
                                          .describe('User-scoped property.'),
                                        zod
                                          .object({
                                            scope: zod.enum(['team']),
                                            team_id: zod.uuid(),
                                          })
                                          .describe('Team-scoped property.'),
                                        zod
                                          .object({
                                            scope: zod.enum(['system']),
                                          })
                                          .describe(
                                            'System-owned property (no user or team owner).'
                                          ),
                                      ])
                                      .describe(
                                        'Defines who owns a property - user-scoped, team-scoped, or system.'
                                      ),
                                    specific_entity_type: zod
                                      .union([
                                        zod.null(),
                                        zod
                                          .enum([
                                            'CALENDAR_EVENT',
                                            'CALL_RECORD',
                                            'CHANNEL',
                                            'CHAT',
                                            'COMPANY',
                                            'DOCUMENT',
                                            'PROJECT',
                                            'TASK',
                                            'THREAD',
                                            'USER',
                                          ])
                                          .describe(
                                            'Type of entity that can be referenced by entity properties.'
                                          ),
                                      ])
                                      .optional(),
                                    updated_at: zod.iso.datetime({}),
                                  })
                                  .describe(
                                    'Property definition model (service representation).'
                                  ),
                                id: zod
                                  .uuid()
                                  .describe(
                                    'Globally unique id of the assignment attaching this property to an entity.'
                                  ),
                                value: zod
                                  .union([
                                    zod.null(),
                                    zod
                                      .union([
                                        zod
                                          .object({
                                            type: zod.enum(['Boolean']),
                                            value: zod
                                              .boolean()
                                              .describe(
                                                'Boolean value\nSerializes as: {\"type\": \"Boolean\", \"value\": true}'
                                              ),
                                          })
                                          .describe(
                                            'Boolean value\nSerializes as: {\"type\": \"Boolean\", \"value\": true}'
                                          ),
                                        zod
                                          .object({
                                            type: zod.enum(['Number']),
                                            value: zod
                                              .number()
                                              .describe(
                                                'Numeric value\nSerializes as: {\"type\": \"Number\", \"value\": 42.5}'
                                              ),
                                          })
                                          .describe(
                                            'Numeric value\nSerializes as: {\"type\": \"Number\", \"value\": 42.5}'
                                          ),
                                        zod
                                          .object({
                                            type: zod.enum(['String']),
                                            value: zod
                                              .string()
                                              .describe(
                                                'String value\nSerializes as: {\"type\": \"String\", \"value\": \"text\"}'
                                              ),
                                          })
                                          .describe(
                                            'String value\nSerializes as: {\"type\": \"String\", \"value\": \"text\"}'
                                          ),
                                        zod
                                          .object({
                                            type: zod.enum(['Date']),
                                            value: zod.iso
                                              .datetime({})
                                              .describe(
                                                'Date\/timestamp value\nSerializes as: {\"type\": \"Date\", \"value\": \"2025-01-01T00:00:00Z\"}'
                                              ),
                                          })
                                          .describe(
                                            'Date\/timestamp value\nSerializes as: {\"type\": \"Date\", \"value\": \"2025-01-01T00:00:00Z\"}'
                                          ),
                                        zod
                                          .object({
                                            type: zod.enum(['SelectOption']),
                                            value: zod
                                              .array(zod.uuid())
                                              .describe(
                                                'Select option(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"SelectOption\", \"value\": [\"uuid\"]} (length 0 or 1)\nMulti-select: {\"type\": \"SelectOption\", \"value\": [\"uuid1\", \"uuid2\", ...]} (length 0+)'
                                              ),
                                          })
                                          .describe(
                                            'Select option(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"SelectOption\", \"value\": [\"uuid\"]} (length 0 or 1)\nMulti-select: {\"type\": \"SelectOption\", \"value\": [\"uuid1\", \"uuid2\", ...]} (length 0+)'
                                          ),
                                        zod
                                          .object({
                                            type: zod.enum(['EntityReference']),
                                            value: zod
                                              .array(
                                                zod
                                                  .object({
                                                    entity_id: zod.string(),
                                                    entity_type: zod
                                                      .enum([
                                                        'CALENDAR_EVENT',
                                                        'CALL_RECORD',
                                                        'CHANNEL',
                                                        'CHAT',
                                                        'COMPANY',
                                                        'DOCUMENT',
                                                        'PROJECT',
                                                        'TASK',
                                                        'THREAD',
                                                        'USER',
                                                      ])
                                                      .describe(
                                                        'Type of entity that can be referenced by entity properties.'
                                                      ),
                                                    specific_message_id: zod
                                                      .uuid()
                                                      .nullish()
                                                      .describe(
                                                        'For CHANNEL, CHAT, THREAD entity types - optional specific message ID.\nThis allows referencing a specific message within a thread\/channel\/chat.'
                                                      ),
                                                  })
                                                  .describe(
                                                    'Entity reference for entity-type property values.'
                                                  )
                                              )
                                              .describe(
                                                'Entity reference(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"EntityReference\", \"value\": [{...}]} (length 0 or 1)\nMulti-select: {\"type\": \"EntityReference\", \"value\": [{...}, {...}, ...]} (length 0+)'
                                              ),
                                          })
                                          .describe(
                                            'Entity reference(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"EntityReference\", \"value\": [{...}]} (length 0 or 1)\nMulti-select: {\"type\": \"EntityReference\", \"value\": [{...}, {...}, ...]} (length 0+)'
                                          ),
                                        zod
                                          .object({
                                            type: zod.enum(['Link']),
                                            value: zod
                                              .array(zod.string())
                                              .describe(
                                                'Link value(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"Link\", \"value\": [\"https:\/\/example.com\"]} (length 0 or 1)\nMulti-select: {\"type\": \"Link\", \"value\": [\"https:\/\/example.com\", \"https:\/\/other.com\"]} (length 0+)'
                                              ),
                                          })
                                          .describe(
                                            'Link value(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"Link\", \"value\": [\"https:\/\/example.com\"]} (length 0 or 1)\nMulti-select: {\"type\": \"Link\", \"value\": [\"https:\/\/example.com\", \"https:\/\/other.com\"]} (length 0+)'
                                          ),
                                      ])
                                      .describe(
                                        'Property value (service representation).\n\nRepresents the actual value stored for an entity property.\nThis is serialized to\/from JSONB in the database.'
                                      ),
                                  ])
                                  .optional(),
                              })
                              .describe(
                                'A property attached to a Soup item.\n\nThis is a simplified representation that includes only the definition and value,\nomitting the entity property assignment metadata and options.'
                              )
                          )
                          .describe('Properties attached to the entity.'),
                      })
                      .describe(
                        'Property fields that can be flattened into property-bearing Soup items.'
                      )
                      .and(
                        zod.object({
                          attended: zod
                            .boolean()
                            .describe(
                              'Whether the requesting user attended this call. Kept for compatibility\nand derived from `status == ATTENDED`.'
                            ),
                          callId: zod.uuid().describe('The call identifier.'),
                          channelId: zod
                            .uuid()
                            .describe('The channel this call belongs to.'),
                          channelName: zod
                            .string()
                            .nullish()
                            .describe('Resolved display name for the channel.'),
                          createdBy: zod
                            .string()
                            .describe('User who created the call.'),
                          customName: zod
                            .string()
                            .nullish()
                            .describe(
                              'User-supplied or AI-generated display name for the call.'
                            ),
                          durationMs: zod
                            .number()
                            .nullish()
                            .describe(
                              'Call duration in milliseconds (None if still active).'
                            ),
                          endedAt: zod.iso
                            .datetime({})
                            .nullish()
                            .describe(
                              'When the call ended (None if still active).'
                            ),
                          isActive: zod
                            .boolean()
                            .describe('Whether the call is currently active.'),
                          participants: zod
                            .array(
                              zod
                                .object({
                                  joinedAt: zod.iso
                                    .datetime({})
                                    .describe('When the user joined the call.'),
                                  leftAt: zod.iso
                                    .datetime({})
                                    .nullish()
                                    .describe(
                                      'When the user left (None if still in an active call).'
                                    ),
                                  userId: zod.string().describe('The user id.'),
                                })
                                .describe(
                                  'A participant in a call record, as displayed in Soup.'
                                )
                            )
                            .describe('Participants in the call.'),
                          startedAt: zod.iso
                            .datetime({})
                            .describe('When the call started.'),
                          status: zod
                            .enum(['ATTENDED', 'MISSED', 'UNATTENDED'])
                            .describe(
                              'Viewer-relative attendance status for a call record.\nSerializes as `ATTENDED`, `MISSED`, or `UNATTENDED`.'
                            ),
                          summary: zod
                            .string()
                            .nullish()
                            .describe(
                              'AI-generated summary of the call. Only set on archived\n`call_records` once summarization has run; active calls always\nreturn `None`.'
                            ),
                        })
                      )
                      .describe(
                        'A call record as displayed in Soup. Excludes room_name, egress_id,\nand transcript — fields that are irrelevant for the soup feed.'
                      ),
                    tag: zod.enum(['call']),
                  })
                  .describe('Call record item.'),
                zod
                  .object({
                    data: zod
                      .object({
                        conferenceProvider: zod
                          .string()
                          .nullish()
                          .describe(
                            'Which conferencing system backs `conference_url`.'
                          ),
                        conferenceUrl: zod
                          .string()
                          .nullish()
                          .describe('Direct conference join URL.'),
                        createdAt: zod.iso
                          .datetime({})
                          .describe('Entity creation timestamp.'),
                        description: zod
                          .string()
                          .nullish()
                          .describe('Optional description.'),
                        extra: zod
                          .object({
                            properties: zod
                              .array(
                                zod
                                  .object({
                                    definition: zod
                                      .object({
                                        created_at: zod.iso.datetime({}),
                                        data_type: zod
                                          .enum([
                                            'BOOLEAN',
                                            'DATE',
                                            'NUMBER',
                                            'STRING',
                                            'SELECT_NUMBER',
                                            'SELECT_STRING',
                                            'TAG',
                                            'ENTITY',
                                            'LINK',
                                          ])
                                          .describe(
                                            'Data type for property values, determining storage and validation.'
                                          ),
                                        display_name: zod.string(),
                                        id: zod.uuid(),
                                        is_metadata: zod
                                          .boolean()
                                          .describe(
                                            'Flag to indicate if this is a system-generated metadata property.\nNot stored in database - computed at service layer.'
                                          ),
                                        is_multi_select: zod.boolean(),
                                        is_system: zod
                                          .boolean()
                                          .describe(
                                            'Flag to indicate if this is a system property (stored in DB).'
                                          ),
                                        owner: zod
                                          .union([
                                            zod
                                              .object({
                                                scope: zod.enum(['user']),
                                                user_id: zod.string(),
                                              })
                                              .describe(
                                                'User-scoped property.'
                                              ),
                                            zod
                                              .object({
                                                scope: zod.enum(['team']),
                                                team_id: zod.uuid(),
                                              })
                                              .describe(
                                                'Team-scoped property.'
                                              ),
                                            zod
                                              .object({
                                                scope: zod.enum(['system']),
                                              })
                                              .describe(
                                                'System-owned property (no user or team owner).'
                                              ),
                                          ])
                                          .describe(
                                            'Defines who owns a property - user-scoped, team-scoped, or system.'
                                          ),
                                        specific_entity_type: zod
                                          .union([
                                            zod.null(),
                                            zod
                                              .enum([
                                                'CALENDAR_EVENT',
                                                'CALL_RECORD',
                                                'CHANNEL',
                                                'CHAT',
                                                'COMPANY',
                                                'DOCUMENT',
                                                'PROJECT',
                                                'TASK',
                                                'THREAD',
                                                'USER',
                                              ])
                                              .describe(
                                                'Type of entity that can be referenced by entity properties.'
                                              ),
                                          ])
                                          .optional(),
                                        updated_at: zod.iso.datetime({}),
                                      })
                                      .describe(
                                        'Property definition model (service representation).'
                                      ),
                                    id: zod
                                      .uuid()
                                      .describe(
                                        'Globally unique id of the assignment attaching this property to an entity.'
                                      ),
                                    value: zod
                                      .union([
                                        zod.null(),
                                        zod
                                          .union([
                                            zod
                                              .object({
                                                type: zod.enum(['Boolean']),
                                                value: zod
                                                  .boolean()
                                                  .describe(
                                                    'Boolean value\nSerializes as: {\"type\": \"Boolean\", \"value\": true}'
                                                  ),
                                              })
                                              .describe(
                                                'Boolean value\nSerializes as: {\"type\": \"Boolean\", \"value\": true}'
                                              ),
                                            zod
                                              .object({
                                                type: zod.enum(['Number']),
                                                value: zod
                                                  .number()
                                                  .describe(
                                                    'Numeric value\nSerializes as: {\"type\": \"Number\", \"value\": 42.5}'
                                                  ),
                                              })
                                              .describe(
                                                'Numeric value\nSerializes as: {\"type\": \"Number\", \"value\": 42.5}'
                                              ),
                                            zod
                                              .object({
                                                type: zod.enum(['String']),
                                                value: zod
                                                  .string()
                                                  .describe(
                                                    'String value\nSerializes as: {\"type\": \"String\", \"value\": \"text\"}'
                                                  ),
                                              })
                                              .describe(
                                                'String value\nSerializes as: {\"type\": \"String\", \"value\": \"text\"}'
                                              ),
                                            zod
                                              .object({
                                                type: zod.enum(['Date']),
                                                value: zod.iso
                                                  .datetime({})
                                                  .describe(
                                                    'Date\/timestamp value\nSerializes as: {\"type\": \"Date\", \"value\": \"2025-01-01T00:00:00Z\"}'
                                                  ),
                                              })
                                              .describe(
                                                'Date\/timestamp value\nSerializes as: {\"type\": \"Date\", \"value\": \"2025-01-01T00:00:00Z\"}'
                                              ),
                                            zod
                                              .object({
                                                type: zod.enum([
                                                  'SelectOption',
                                                ]),
                                                value: zod
                                                  .array(zod.uuid())
                                                  .describe(
                                                    'Select option(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"SelectOption\", \"value\": [\"uuid\"]} (length 0 or 1)\nMulti-select: {\"type\": \"SelectOption\", \"value\": [\"uuid1\", \"uuid2\", ...]} (length 0+)'
                                                  ),
                                              })
                                              .describe(
                                                'Select option(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"SelectOption\", \"value\": [\"uuid\"]} (length 0 or 1)\nMulti-select: {\"type\": \"SelectOption\", \"value\": [\"uuid1\", \"uuid2\", ...]} (length 0+)'
                                              ),
                                            zod
                                              .object({
                                                type: zod.enum([
                                                  'EntityReference',
                                                ]),
                                                value: zod
                                                  .array(
                                                    zod
                                                      .object({
                                                        entity_id: zod.string(),
                                                        entity_type: zod
                                                          .enum([
                                                            'CALENDAR_EVENT',
                                                            'CALL_RECORD',
                                                            'CHANNEL',
                                                            'CHAT',
                                                            'COMPANY',
                                                            'DOCUMENT',
                                                            'PROJECT',
                                                            'TASK',
                                                            'THREAD',
                                                            'USER',
                                                          ])
                                                          .describe(
                                                            'Type of entity that can be referenced by entity properties.'
                                                          ),
                                                        specific_message_id: zod
                                                          .uuid()
                                                          .nullish()
                                                          .describe(
                                                            'For CHANNEL, CHAT, THREAD entity types - optional specific message ID.\nThis allows referencing a specific message within a thread\/channel\/chat.'
                                                          ),
                                                      })
                                                      .describe(
                                                        'Entity reference for entity-type property values.'
                                                      )
                                                  )
                                                  .describe(
                                                    'Entity reference(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"EntityReference\", \"value\": [{...}]} (length 0 or 1)\nMulti-select: {\"type\": \"EntityReference\", \"value\": [{...}, {...}, ...]} (length 0+)'
                                                  ),
                                              })
                                              .describe(
                                                'Entity reference(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"EntityReference\", \"value\": [{...}]} (length 0 or 1)\nMulti-select: {\"type\": \"EntityReference\", \"value\": [{...}, {...}, ...]} (length 0+)'
                                              ),
                                            zod
                                              .object({
                                                type: zod.enum(['Link']),
                                                value: zod
                                                  .array(zod.string())
                                                  .describe(
                                                    'Link value(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"Link\", \"value\": [\"https:\/\/example.com\"]} (length 0 or 1)\nMulti-select: {\"type\": \"Link\", \"value\": [\"https:\/\/example.com\", \"https:\/\/other.com\"]} (length 0+)'
                                                  ),
                                              })
                                              .describe(
                                                'Link value(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"Link\", \"value\": [\"https:\/\/example.com\"]} (length 0 or 1)\nMulti-select: {\"type\": \"Link\", \"value\": [\"https:\/\/example.com\", \"https:\/\/other.com\"]} (length 0+)'
                                              ),
                                          ])
                                          .describe(
                                            'Property value (service representation).\n\nRepresents the actual value stored for an entity property.\nThis is serialized to\/from JSONB in the database.'
                                          ),
                                      ])
                                      .optional(),
                                  })
                                  .describe(
                                    'A property attached to a Soup item.\n\nThis is a simplified representation that includes only the definition and value,\nomitting the entity property assignment metadata and options.'
                                  )
                              )
                              .describe('Properties attached to the entity.'),
                          })
                          .describe(
                            'Property fields that can be flattened into property-bearing Soup items.'
                          ),
                        icalUid: zod
                          .string()
                          .describe(
                            'RFC 5545 UID used for source reconciliation.'
                          ),
                        id: zod.uuid().describe('Entity identifier.'),
                        isReadOnly: zod
                          .boolean()
                          .describe(
                            'Whether the selected canonical source is read-only.'
                          ),
                        location: zod
                          .string()
                          .nullish()
                          .describe('Optional location label.'),
                        organizerEmail: zod
                          .string()
                          .nullish()
                          .describe('Organizer email.'),
                        organizerName: zod
                          .string()
                          .nullish()
                          .describe('Organizer display name.'),
                        ownerId: zod.string().describe('Owning Macro user.'),
                        status: zod.string().describe('Canonical status.'),
                        time: zod
                          .union([
                            zod
                              .object({
                                endsAt: zod.iso
                                  .datetime({})
                                  .describe('Exclusive end.'),
                                kind: zod.enum(['timed']),
                                startsAt: zod.iso
                                  .datetime({})
                                  .describe('Inclusive start.'),
                                timeZone: zod
                                  .string()
                                  .nullish()
                                  .describe('Original IANA time zone.'),
                              })
                              .describe('Absolute timed event.'),
                            zod
                              .object({
                                endDate: zod.iso
                                  .date()
                                  .describe('Exclusive end date.'),
                                kind: zod.enum(['allDay']),
                                startDate: zod.iso
                                  .date()
                                  .describe('Inclusive start date.'),
                              })
                              .describe(
                                'All-day event with an exclusive end date.'
                              ),
                          ])
                          .describe(
                            'Timed or all-day calendar event span.\n\nFields are camelCased per variant rather than via `rename_all_fields`,\nwhich utoipa ignores — the generated OpenAPI schema would otherwise\nclaim snake_case fields the wire never carries.'
                          ),
                        title: zod.string().describe('Display title.'),
                        transparency: zod
                          .string()
                          .describe('Availability transparency.'),
                        updatedAt: zod.iso
                          .datetime({})
                          .describe('Entity update timestamp.'),
                        visibility: zod
                          .string()
                          .describe('Canonical visibility.'),
                      })
                      .describe('A canonical calendar event entity in Soup.'),
                    tag: zod.enum(['calendarEvent']),
                  })
                  .describe('Calendar event item.'),
                zod
                  .object({
                    data: zod
                      .object({
                        properties: zod
                          .array(
                            zod
                              .object({
                                definition: zod
                                  .object({
                                    created_at: zod.iso.datetime({}),
                                    data_type: zod
                                      .enum([
                                        'BOOLEAN',
                                        'DATE',
                                        'NUMBER',
                                        'STRING',
                                        'SELECT_NUMBER',
                                        'SELECT_STRING',
                                        'TAG',
                                        'ENTITY',
                                        'LINK',
                                      ])
                                      .describe(
                                        'Data type for property values, determining storage and validation.'
                                      ),
                                    display_name: zod.string(),
                                    id: zod.uuid(),
                                    is_metadata: zod
                                      .boolean()
                                      .describe(
                                        'Flag to indicate if this is a system-generated metadata property.\nNot stored in database - computed at service layer.'
                                      ),
                                    is_multi_select: zod.boolean(),
                                    is_system: zod
                                      .boolean()
                                      .describe(
                                        'Flag to indicate if this is a system property (stored in DB).'
                                      ),
                                    owner: zod
                                      .union([
                                        zod
                                          .object({
                                            scope: zod.enum(['user']),
                                            user_id: zod.string(),
                                          })
                                          .describe('User-scoped property.'),
                                        zod
                                          .object({
                                            scope: zod.enum(['team']),
                                            team_id: zod.uuid(),
                                          })
                                          .describe('Team-scoped property.'),
                                        zod
                                          .object({
                                            scope: zod.enum(['system']),
                                          })
                                          .describe(
                                            'System-owned property (no user or team owner).'
                                          ),
                                      ])
                                      .describe(
                                        'Defines who owns a property - user-scoped, team-scoped, or system.'
                                      ),
                                    specific_entity_type: zod
                                      .union([
                                        zod.null(),
                                        zod
                                          .enum([
                                            'CALENDAR_EVENT',
                                            'CALL_RECORD',
                                            'CHANNEL',
                                            'CHAT',
                                            'COMPANY',
                                            'DOCUMENT',
                                            'PROJECT',
                                            'TASK',
                                            'THREAD',
                                            'USER',
                                          ])
                                          .describe(
                                            'Type of entity that can be referenced by entity properties.'
                                          ),
                                      ])
                                      .optional(),
                                    updated_at: zod.iso.datetime({}),
                                  })
                                  .describe(
                                    'Property definition model (service representation).'
                                  ),
                                id: zod
                                  .uuid()
                                  .describe(
                                    'Globally unique id of the assignment attaching this property to an entity.'
                                  ),
                                value: zod
                                  .union([
                                    zod.null(),
                                    zod
                                      .union([
                                        zod
                                          .object({
                                            type: zod.enum(['Boolean']),
                                            value: zod
                                              .boolean()
                                              .describe(
                                                'Boolean value\nSerializes as: {\"type\": \"Boolean\", \"value\": true}'
                                              ),
                                          })
                                          .describe(
                                            'Boolean value\nSerializes as: {\"type\": \"Boolean\", \"value\": true}'
                                          ),
                                        zod
                                          .object({
                                            type: zod.enum(['Number']),
                                            value: zod
                                              .number()
                                              .describe(
                                                'Numeric value\nSerializes as: {\"type\": \"Number\", \"value\": 42.5}'
                                              ),
                                          })
                                          .describe(
                                            'Numeric value\nSerializes as: {\"type\": \"Number\", \"value\": 42.5}'
                                          ),
                                        zod
                                          .object({
                                            type: zod.enum(['String']),
                                            value: zod
                                              .string()
                                              .describe(
                                                'String value\nSerializes as: {\"type\": \"String\", \"value\": \"text\"}'
                                              ),
                                          })
                                          .describe(
                                            'String value\nSerializes as: {\"type\": \"String\", \"value\": \"text\"}'
                                          ),
                                        zod
                                          .object({
                                            type: zod.enum(['Date']),
                                            value: zod.iso
                                              .datetime({})
                                              .describe(
                                                'Date\/timestamp value\nSerializes as: {\"type\": \"Date\", \"value\": \"2025-01-01T00:00:00Z\"}'
                                              ),
                                          })
                                          .describe(
                                            'Date\/timestamp value\nSerializes as: {\"type\": \"Date\", \"value\": \"2025-01-01T00:00:00Z\"}'
                                          ),
                                        zod
                                          .object({
                                            type: zod.enum(['SelectOption']),
                                            value: zod
                                              .array(zod.uuid())
                                              .describe(
                                                'Select option(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"SelectOption\", \"value\": [\"uuid\"]} (length 0 or 1)\nMulti-select: {\"type\": \"SelectOption\", \"value\": [\"uuid1\", \"uuid2\", ...]} (length 0+)'
                                              ),
                                          })
                                          .describe(
                                            'Select option(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"SelectOption\", \"value\": [\"uuid\"]} (length 0 or 1)\nMulti-select: {\"type\": \"SelectOption\", \"value\": [\"uuid1\", \"uuid2\", ...]} (length 0+)'
                                          ),
                                        zod
                                          .object({
                                            type: zod.enum(['EntityReference']),
                                            value: zod
                                              .array(
                                                zod
                                                  .object({
                                                    entity_id: zod.string(),
                                                    entity_type: zod
                                                      .enum([
                                                        'CALENDAR_EVENT',
                                                        'CALL_RECORD',
                                                        'CHANNEL',
                                                        'CHAT',
                                                        'COMPANY',
                                                        'DOCUMENT',
                                                        'PROJECT',
                                                        'TASK',
                                                        'THREAD',
                                                        'USER',
                                                      ])
                                                      .describe(
                                                        'Type of entity that can be referenced by entity properties.'
                                                      ),
                                                    specific_message_id: zod
                                                      .uuid()
                                                      .nullish()
                                                      .describe(
                                                        'For CHANNEL, CHAT, THREAD entity types - optional specific message ID.\nThis allows referencing a specific message within a thread\/channel\/chat.'
                                                      ),
                                                  })
                                                  .describe(
                                                    'Entity reference for entity-type property values.'
                                                  )
                                              )
                                              .describe(
                                                'Entity reference(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"EntityReference\", \"value\": [{...}]} (length 0 or 1)\nMulti-select: {\"type\": \"EntityReference\", \"value\": [{...}, {...}, ...]} (length 0+)'
                                              ),
                                          })
                                          .describe(
                                            'Entity reference(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"EntityReference\", \"value\": [{...}]} (length 0 or 1)\nMulti-select: {\"type\": \"EntityReference\", \"value\": [{...}, {...}, ...]} (length 0+)'
                                          ),
                                        zod
                                          .object({
                                            type: zod.enum(['Link']),
                                            value: zod
                                              .array(zod.string())
                                              .describe(
                                                'Link value(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"Link\", \"value\": [\"https:\/\/example.com\"]} (length 0 or 1)\nMulti-select: {\"type\": \"Link\", \"value\": [\"https:\/\/example.com\", \"https:\/\/other.com\"]} (length 0+)'
                                              ),
                                          })
                                          .describe(
                                            'Link value(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"Link\", \"value\": [\"https:\/\/example.com\"]} (length 0 or 1)\nMulti-select: {\"type\": \"Link\", \"value\": [\"https:\/\/example.com\", \"https:\/\/other.com\"]} (length 0+)'
                                          ),
                                      ])
                                      .describe(
                                        'Property value (service representation).\n\nRepresents the actual value stored for an entity property.\nThis is serialized to\/from JSONB in the database.'
                                      ),
                                  ])
                                  .optional(),
                              })
                              .describe(
                                'A property attached to a Soup item.\n\nThis is a simplified representation that includes only the definition and value,\nomitting the entity property assignment metadata and options.'
                              )
                          )
                          .describe('Properties attached to the entity.'),
                      })
                      .describe(
                        'Property fields that can be flattened into property-bearing Soup items.'
                      )
                      .and(
                        zod.object({
                          createdAt: zod.iso
                            .datetime({})
                            .describe('When the company was created.'),
                          description: zod
                            .string()
                            .nullish()
                            .describe(
                              "Display description from the primary domain's directory entry."
                            ),
                          domains: zod
                            .array(
                              zod
                                .object({
                                  companyId: zod
                                    .uuid()
                                    .describe(
                                      'The id of the company the domain belongs to.'
                                    ),
                                  createdAt: zod.iso
                                    .datetime({})
                                    .describe(
                                      'When the domain record was created.'
                                    ),
                                  domain: zod
                                    .string()
                                    .describe(
                                      'The domain (lowercased, e.g. \"acme.com\").'
                                    ),
                                  id: zod
                                    .uuid()
                                    .describe('The id of the domain record.'),
                                })
                                .describe(
                                  "A CRM domain as displayed in Soup. Mirrors the crm crate's\n[`CrmDomain`] with a stable wire shape that the FE can rely on."
                                )
                            )
                            .describe(
                              'Domains associated with this company, ordered by creation time\nascending (primary first).'
                            ),
                          emailSync: zod
                            .boolean()
                            .describe(
                              'Whether email sync is enabled for this company.'
                            ),
                          hidden: zod
                            .boolean()
                            .describe(
                              'Whether the company is hidden from CRM listings. Soup filters\nthese out by default.'
                            ),
                          id: zod.uuid().describe('The id of the company.'),
                          name: zod
                            .string()
                            .nullish()
                            .describe(
                              "Display name from the primary domain's directory entry, or\n`None` when unresolved."
                            ),
                          teamId: zod
                            .uuid()
                            .describe(
                              'The id of the team that owns this company record.'
                            ),
                          updatedAt: zod.iso
                            .datetime({})
                            .describe('When the company was last updated.'),
                          viewedAt: zod.iso
                            .datetime({})
                            .nullish()
                            .describe(
                              'When the requesting user last viewed this company, or `None` if\nnever viewed. Mirrors the `viewed_at` other soup entities carry.'
                            ),
                        })
                      )
                      .describe(
                        'A CRM company as displayed in Soup. Carries the core company\nfields plus display metadata resolved from `crm_domain_directory`\nagainst the primary (earliest-created) domain.'
                      ),
                    tag: zod.enum(['crmCompany']),
                  })
                  .describe('CRM company item.'),
                zod
                  .object({
                    data: zod
                      .object({
                        createdAt: zod.iso
                          .datetime({})
                          .describe('Timestamp when the record was created.'),
                        foreignEntityId: zod
                          .string()
                          .describe(
                            'Identifier assigned by the external system.'
                          ),
                        foreignEntitySource: zod
                          .string()
                          .describe(
                            'Source system that owns the external identifier.'
                          ),
                        id: zod
                          .uuid()
                          .describe(
                            'Internal primary key for this foreign entity record.'
                          ),
                        metadata: zod
                          .object({})
                          .describe(
                            'Arbitrary metadata stored with the mapping.'
                          ),
                        storedForAuthEntity: zod
                          .string()
                          .describe(
                            'Internal auth entity namespace this foreign entity is stored for.'
                          ),
                        storedForId: zod
                          .string()
                          .describe(
                            'Internal entity identifier this foreign entity is stored for.'
                          ),
                        updatedAt: zod.iso
                          .datetime({})
                          .describe(
                            'Timestamp when the record was last updated.'
                          ),
                      })
                      .describe(
                        'A foreign entity record as displayed in Soup.'
                      ),
                    tag: zod.enum(['foreignEntity']),
                  })
                  .describe('Foreign entity item.'),
                zod
                  .object({
                    data: zod
                      .object({
                        properties: zod
                          .array(
                            zod
                              .object({
                                definition: zod
                                  .object({
                                    created_at: zod.iso.datetime({}),
                                    data_type: zod
                                      .enum([
                                        'BOOLEAN',
                                        'DATE',
                                        'NUMBER',
                                        'STRING',
                                        'SELECT_NUMBER',
                                        'SELECT_STRING',
                                        'TAG',
                                        'ENTITY',
                                        'LINK',
                                      ])
                                      .describe(
                                        'Data type for property values, determining storage and validation.'
                                      ),
                                    display_name: zod.string(),
                                    id: zod.uuid(),
                                    is_metadata: zod
                                      .boolean()
                                      .describe(
                                        'Flag to indicate if this is a system-generated metadata property.\nNot stored in database - computed at service layer.'
                                      ),
                                    is_multi_select: zod.boolean(),
                                    is_system: zod
                                      .boolean()
                                      .describe(
                                        'Flag to indicate if this is a system property (stored in DB).'
                                      ),
                                    owner: zod
                                      .union([
                                        zod
                                          .object({
                                            scope: zod.enum(['user']),
                                            user_id: zod.string(),
                                          })
                                          .describe('User-scoped property.'),
                                        zod
                                          .object({
                                            scope: zod.enum(['team']),
                                            team_id: zod.uuid(),
                                          })
                                          .describe('Team-scoped property.'),
                                        zod
                                          .object({
                                            scope: zod.enum(['system']),
                                          })
                                          .describe(
                                            'System-owned property (no user or team owner).'
                                          ),
                                      ])
                                      .describe(
                                        'Defines who owns a property - user-scoped, team-scoped, or system.'
                                      ),
                                    specific_entity_type: zod
                                      .union([
                                        zod.null(),
                                        zod
                                          .enum([
                                            'CALENDAR_EVENT',
                                            'CALL_RECORD',
                                            'CHANNEL',
                                            'CHAT',
                                            'COMPANY',
                                            'DOCUMENT',
                                            'PROJECT',
                                            'TASK',
                                            'THREAD',
                                            'USER',
                                          ])
                                          .describe(
                                            'Type of entity that can be referenced by entity properties.'
                                          ),
                                      ])
                                      .optional(),
                                    updated_at: zod.iso.datetime({}),
                                  })
                                  .describe(
                                    'Property definition model (service representation).'
                                  ),
                                id: zod
                                  .uuid()
                                  .describe(
                                    'Globally unique id of the assignment attaching this property to an entity.'
                                  ),
                                value: zod
                                  .union([
                                    zod.null(),
                                    zod
                                      .union([
                                        zod
                                          .object({
                                            type: zod.enum(['Boolean']),
                                            value: zod
                                              .boolean()
                                              .describe(
                                                'Boolean value\nSerializes as: {\"type\": \"Boolean\", \"value\": true}'
                                              ),
                                          })
                                          .describe(
                                            'Boolean value\nSerializes as: {\"type\": \"Boolean\", \"value\": true}'
                                          ),
                                        zod
                                          .object({
                                            type: zod.enum(['Number']),
                                            value: zod
                                              .number()
                                              .describe(
                                                'Numeric value\nSerializes as: {\"type\": \"Number\", \"value\": 42.5}'
                                              ),
                                          })
                                          .describe(
                                            'Numeric value\nSerializes as: {\"type\": \"Number\", \"value\": 42.5}'
                                          ),
                                        zod
                                          .object({
                                            type: zod.enum(['String']),
                                            value: zod
                                              .string()
                                              .describe(
                                                'String value\nSerializes as: {\"type\": \"String\", \"value\": \"text\"}'
                                              ),
                                          })
                                          .describe(
                                            'String value\nSerializes as: {\"type\": \"String\", \"value\": \"text\"}'
                                          ),
                                        zod
                                          .object({
                                            type: zod.enum(['Date']),
                                            value: zod.iso
                                              .datetime({})
                                              .describe(
                                                'Date\/timestamp value\nSerializes as: {\"type\": \"Date\", \"value\": \"2025-01-01T00:00:00Z\"}'
                                              ),
                                          })
                                          .describe(
                                            'Date\/timestamp value\nSerializes as: {\"type\": \"Date\", \"value\": \"2025-01-01T00:00:00Z\"}'
                                          ),
                                        zod
                                          .object({
                                            type: zod.enum(['SelectOption']),
                                            value: zod
                                              .array(zod.uuid())
                                              .describe(
                                                'Select option(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"SelectOption\", \"value\": [\"uuid\"]} (length 0 or 1)\nMulti-select: {\"type\": \"SelectOption\", \"value\": [\"uuid1\", \"uuid2\", ...]} (length 0+)'
                                              ),
                                          })
                                          .describe(
                                            'Select option(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"SelectOption\", \"value\": [\"uuid\"]} (length 0 or 1)\nMulti-select: {\"type\": \"SelectOption\", \"value\": [\"uuid1\", \"uuid2\", ...]} (length 0+)'
                                          ),
                                        zod
                                          .object({
                                            type: zod.enum(['EntityReference']),
                                            value: zod
                                              .array(
                                                zod
                                                  .object({
                                                    entity_id: zod.string(),
                                                    entity_type: zod
                                                      .enum([
                                                        'CALENDAR_EVENT',
                                                        'CALL_RECORD',
                                                        'CHANNEL',
                                                        'CHAT',
                                                        'COMPANY',
                                                        'DOCUMENT',
                                                        'PROJECT',
                                                        'TASK',
                                                        'THREAD',
                                                        'USER',
                                                      ])
                                                      .describe(
                                                        'Type of entity that can be referenced by entity properties.'
                                                      ),
                                                    specific_message_id: zod
                                                      .uuid()
                                                      .nullish()
                                                      .describe(
                                                        'For CHANNEL, CHAT, THREAD entity types - optional specific message ID.\nThis allows referencing a specific message within a thread\/channel\/chat.'
                                                      ),
                                                  })
                                                  .describe(
                                                    'Entity reference for entity-type property values.'
                                                  )
                                              )
                                              .describe(
                                                'Entity reference(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"EntityReference\", \"value\": [{...}]} (length 0 or 1)\nMulti-select: {\"type\": \"EntityReference\", \"value\": [{...}, {...}, ...]} (length 0+)'
                                              ),
                                          })
                                          .describe(
                                            'Entity reference(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"EntityReference\", \"value\": [{...}]} (length 0 or 1)\nMulti-select: {\"type\": \"EntityReference\", \"value\": [{...}, {...}, ...]} (length 0+)'
                                          ),
                                        zod
                                          .object({
                                            type: zod.enum(['Link']),
                                            value: zod
                                              .array(zod.string())
                                              .describe(
                                                'Link value(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"Link\", \"value\": [\"https:\/\/example.com\"]} (length 0 or 1)\nMulti-select: {\"type\": \"Link\", \"value\": [\"https:\/\/example.com\", \"https:\/\/other.com\"]} (length 0+)'
                                              ),
                                          })
                                          .describe(
                                            'Link value(s) - always an array (check is_multi_select to determine if single or multi)\nSingle-select: {\"type\": \"Link\", \"value\": [\"https:\/\/example.com\"]} (length 0 or 1)\nMulti-select: {\"type\": \"Link\", \"value\": [\"https:\/\/example.com\", \"https:\/\/other.com\"]} (length 0+)'
                                          ),
                                      ])
                                      .describe(
                                        'Property value (service representation).\n\nRepresents the actual value stored for an entity property.\nThis is serialized to\/from JSONB in the database.'
                                      ),
                                  ])
                                  .optional(),
                              })
                              .describe(
                                'A property attached to a Soup item.\n\nThis is a simplified representation that includes only the definition and value,\nomitting the entity property assignment metadata and options.'
                              )
                          )
                          .describe('Properties attached to the entity.'),
                      })
                      .describe(
                        'Property fields that can be flattened into property-bearing Soup items.'
                      )
                      .and(
                        zod.object({
                          completedAt: zod.iso
                            .datetime({})
                            .nullish()
                            .describe(
                              'Set once a one-shot reminder has fired.'
                            ),
                          createdAt: zod.iso
                            .datetime({})
                            .describe('When the reminder was created.'),
                          description: zod
                            .string()
                            .describe(
                              'What to remind the user about. Doubles as the display name.'
                            ),
                          enabled: zod
                            .boolean()
                            .describe(
                              'When false, the dispatcher skips this reminder.'
                            ),
                          id: zod.uuid().describe('The reminder id.'),
                          nextRunAt: zod.iso
                            .datetime({})
                            .describe(
                              'The next firing. This is what Soup sorts reminders on.'
                            ),
                          referencedEntity: zod
                            .union([
                              zod.null(),
                              zod
                                .object({
                                  entityType: zod
                                    .enum([
                                      'user',
                                      'chat',
                                      'channel',
                                      'channel_message',
                                      'document',
                                      'project',
                                      'email_thread',
                                      'calendar_event',
                                      'team',
                                      'call',
                                      'foreign_entity',
                                      'static_file',
                                      'crm_company',
                                      'crm_contact',
                                      'reminder',
                                      'skill',
                                    ])
                                    .describe('The type of an entity in Macro')
                                    .describe("The referenced entity's type."),
                                  fileType: zod
                                    .string()
                                    .nullish()
                                    .describe(
                                      'File type, when the reference is a document — `md`, `pdf`, and so on.'
                                    ),
                                  id: zod
                                    .string()
                                    .describe("The referenced entity's id."),
                                  subType: zod
                                    .string()
                                    .nullish()
                                    .describe(
                                      'Sub type, when the reference is a task or snippet document.'
                                    ),
                                })
                                .describe(
                                  "The entity a reminder is about, resolved server-side.\n\nA reminder has no block of its own — it opens, and is iconed as, whatever it\nreferences. Which block that is depends on the referenced document's file\ntype, and the client's icon path is synchronous, so this is resolved here\nrather than costing a fetch per row."
                                ),
                            ])
                            .optional(),
                          schedule: zod
                            .union([
                              zod
                                .object({
                                  remindAt: zod.iso
                                    .datetime({})
                                    .describe('The instant to fire at.'),
                                  type: zod.enum(['once']),
                                })
                                .describe('Fires once, at a fixed instant.'),
                              zod
                                .object({
                                  cron: zod
                                    .string()
                                    .describe(
                                      'Cron expression, normalized to the 6-field form.'
                                    ),
                                  timezone: zod
                                    .string()
                                    .describe(
                                      'The timezone the cron expression is evaluated in.'
                                    ),
                                  type: zod.enum(['recurring']),
                                })
                                .describe(
                                  'Fires repeatedly, on a cron schedule evaluated in `timezone`.'
                                ),
                            ])
                            .describe(
                              'How often a reminder fires, flattened for the wire.\n\nThe domain\'s [`ReminderSchedule`] is an internally-tagged enum carrying a\nvalidated cron type; Soup only needs enough to render \"once\" vs \"every\nweekday at 9am\", so the cron is exposed as a plain string.'
                            ),
                          updatedAt: zod.iso
                            .datetime({})
                            .describe('When the reminder was last modified.'),
                        })
                      )
                      .describe(
                        "A reminder as displayed in Soup.\n\nReminders are user-owned rather than shared, so unlike most Soup items they\ncarry no access metadata — the repository only ever returns the caller's own."
                      ),
                    tag: zod.enum(['reminder']),
                  })
                  .describe('Reminder item.'),
              ])
              .describe('A single item in the Soup feed.')
              .and(
                zod.object({
                  frecency_score: zod.number(),
                  is_favorited: zod
                    .boolean()
                    .describe(
                      'Whether the requesting user has favorited this entity.'
                    ),
                })
              )
              .describe(
                'API representation of a soup item with its frecency score.'
              )
          )
          .describe(
            'Items in this page, keyed by id. Ordering lives in `group.item_ids`.'
          ),
      })
      .describe('Response for fetching a page within one group.')
      .and(
        zod.object({
          mode: zod.enum(['group_page']),
        })
      )
      .describe('Follow-up response for one specific group.'),
  ])
  .describe('Response for grouped soup queries.');

/**
 * @summary Gets the users pinned items
 */
export const getPinsHandlerResponse = zod.object({
  data: zod
    .union([
      zod.null(),
      zod.object({
        recent: zod
          .array(
            zod.object({
              activity: zod.union([
                zod.object({
                  branchedFromId: zod
                    .string()
                    .nullish()
                    .describe(
                      'The id of the document this document branched from'
                    ),
                  branchedFromVersionId: zod
                    .number()
                    .nullish()
                    .describe(
                      'The id of the version this document branched from\nThis could be either DocumentInstance or DocumentBom id depending on\nthe file type'
                    ),
                  createdAt: zod.iso
                    .datetime({})
                    .nullish()
                    .describe('The time the document was created'),
                  deletedAt: zod.iso
                    .datetime({})
                    .nullish()
                    .describe('The time the document was deleted'),
                  documentFamilyId: zod
                    .number()
                    .nullish()
                    .describe(
                      'The id of the document family this document belongs to'
                    ),
                  documentVersionId: zod
                    .number()
                    .describe(
                      'The version of the document\nThis could be the document_instance_id or document_bom_id depending on\nthe file type'
                    ),
                  fileType: zod
                    .string()
                    .nullish()
                    .describe('The file type of the document (e.g. pdf, docx)'),
                  id: zod.string().describe('The document id'),
                  name: zod.string().describe('The name of the document'),
                  owner: zod.string().describe('The owner of the document'),
                  projectId: zod
                    .string()
                    .nullish()
                    .describe(
                      'The id of the project that this document belongs to'
                    ),
                  sha: zod
                    .string()
                    .nullish()
                    .describe(
                      'If the document is a PDF, this is the SHA of the pdf\nIf the document is a DOCX, this will not be present'
                    ),
                  subType: zod
                    .union([
                      zod.null(),
                      zod
                        .union([
                          zod
                            .object({
                              is_completed: zod
                                .boolean()
                                .describe(
                                  'Whether the task is completed.\nTrue if the Status property is set to \"Completed\".'
                                ),
                              type: zod.enum(['task']),
                            })
                            .describe(
                              'A task document with its associated properties'
                            ),
                          zod
                            .object({
                              type: zod.enum(['snippet']),
                            })
                            .describe('A snippet document — reusable markdown'),
                          zod
                            .object({
                              type: zod.enum(['skill']),
                            })
                            .describe(
                              'A skill document — markdown instructions for AI'
                            ),
                        ])
                        .describe(
                          'Sub type of a document with associated properties encoded in each variant.\nThis ensures type-safety: task properties only exist when the document is a task.'
                        ),
                    ])
                    .optional(),
                  updatedAt: zod.iso
                    .datetime({})
                    .nullish()
                    .describe(
                      'The time the document instance \/ document BOM was updated'
                    ),
                  type: zod.enum(['document']),
                }),
                zod.object({
                  createdAt: zod.iso
                    .datetime({})
                    .nullish()
                    .describe('The time the chat was created'),
                  deletedAt: zod.iso
                    .datetime({})
                    .nullish()
                    .describe('The time the chat was deleted'),
                  id: zod.string().describe('The chat uuid'),
                  isPersistent: zod.boolean(),
                  model: zod
                    .string()
                    .nullish()
                    .describe('The model used to generate the chat'),
                  name: zod.string().describe('The name of the chat'),
                  projectId: zod
                    .string()
                    .nullish()
                    .describe('The project id of the chat'),
                  tokenCount: zod.number().nullish(),
                  updatedAt: zod.iso
                    .datetime({})
                    .nullish()
                    .describe('The time the chat was last updated'),
                  userId: zod.string().describe('Who the chat belongs to'),
                  type: zod.enum(['chat']),
                }),
                zod.object({
                  createdAt: zod.iso
                    .datetime({})
                    .nullish()
                    .describe('The time the project was created'),
                  deletedAt: zod.iso.datetime({}).nullish(),
                  id: zod.string().describe('The id of the project'),
                  name: zod.string().describe('The name of the project'),
                  parentId: zod
                    .string()
                    .nullish()
                    .describe('The parent project id'),
                  updatedAt: zod.iso
                    .datetime({})
                    .nullish()
                    .describe('The time the project was updated'),
                  userId: zod
                    .string()
                    .describe('The user id of who created the project'),
                  type: zod.enum(['project']),
                }),
              ]),
              item: zod.union([
                zod.object({
                  branchedFromId: zod
                    .string()
                    .nullish()
                    .describe(
                      'The id of the document this document branched from'
                    ),
                  branchedFromVersionId: zod
                    .number()
                    .nullish()
                    .describe(
                      'The id of the version this document branched from\nThis could be either DocumentInstance or DocumentBom id depending on\nthe file type'
                    ),
                  createdAt: zod.iso
                    .datetime({})
                    .nullish()
                    .describe('The time the document was created'),
                  deletedAt: zod.iso
                    .datetime({})
                    .nullish()
                    .describe('The time the document was deleted'),
                  documentFamilyId: zod
                    .number()
                    .nullish()
                    .describe(
                      'The id of the document family this document belongs to'
                    ),
                  documentVersionId: zod
                    .number()
                    .describe(
                      'The version of the document\nThis could be the document_instance_id or document_bom_id depending on\nthe file type'
                    ),
                  fileType: zod
                    .string()
                    .nullish()
                    .describe('The file type of the document (e.g. pdf, docx)'),
                  id: zod.string().describe('The document id'),
                  name: zod.string().describe('The name of the document'),
                  owner: zod.string().describe('The owner of the document'),
                  projectId: zod
                    .string()
                    .nullish()
                    .describe(
                      'The id of the project that this document belongs to'
                    ),
                  sha: zod
                    .string()
                    .nullish()
                    .describe(
                      'If the document is a PDF, this is the SHA of the pdf\nIf the document is a DOCX, this will not be present'
                    ),
                  subType: zod
                    .union([
                      zod.null(),
                      zod
                        .union([
                          zod
                            .object({
                              is_completed: zod
                                .boolean()
                                .describe(
                                  'Whether the task is completed.\nTrue if the Status property is set to \"Completed\".'
                                ),
                              type: zod.enum(['task']),
                            })
                            .describe(
                              'A task document with its associated properties'
                            ),
                          zod
                            .object({
                              type: zod.enum(['snippet']),
                            })
                            .describe('A snippet document — reusable markdown'),
                          zod
                            .object({
                              type: zod.enum(['skill']),
                            })
                            .describe(
                              'A skill document — markdown instructions for AI'
                            ),
                        ])
                        .describe(
                          'Sub type of a document with associated properties encoded in each variant.\nThis ensures type-safety: task properties only exist when the document is a task.'
                        ),
                    ])
                    .optional(),
                  updatedAt: zod.iso
                    .datetime({})
                    .nullish()
                    .describe(
                      'The time the document instance \/ document BOM was updated'
                    ),
                  type: zod.enum(['document']),
                }),
                zod.object({
                  createdAt: zod.iso
                    .datetime({})
                    .nullish()
                    .describe('The time the chat was created'),
                  deletedAt: zod.iso
                    .datetime({})
                    .nullish()
                    .describe('The time the chat was deleted'),
                  id: zod.string().describe('The chat uuid'),
                  isPersistent: zod.boolean(),
                  model: zod
                    .string()
                    .nullish()
                    .describe('The model used to generate the chat'),
                  name: zod.string().describe('The name of the chat'),
                  projectId: zod
                    .string()
                    .nullish()
                    .describe('The project id of the chat'),
                  tokenCount: zod.number().nullish(),
                  updatedAt: zod.iso
                    .datetime({})
                    .nullish()
                    .describe('The time the chat was last updated'),
                  userId: zod.string().describe('Who the chat belongs to'),
                  type: zod.enum(['chat']),
                }),
                zod.object({
                  createdAt: zod.iso
                    .datetime({})
                    .nullish()
                    .describe('The time the project was created'),
                  deletedAt: zod.iso.datetime({}).nullish(),
                  id: zod.string().describe('The id of the project'),
                  name: zod.string().describe('The name of the project'),
                  parentId: zod
                    .string()
                    .nullish()
                    .describe('The parent project id'),
                  updatedAt: zod.iso
                    .datetime({})
                    .nullish()
                    .describe('The time the project was updated'),
                  userId: zod
                    .string()
                    .describe('The user id of who created the project'),
                  type: zod.enum(['project']),
                }),
              ]),
              pinIndex: zod.number().describe('The pin index'),
            })
          )
          .describe('The pins returned from the query'),
      }),
    ])
    .optional(),
  error: zod.boolean().describe('Indicates if an error occurred'),
});

/**
 * @summary Saves the updated order of the pins for the user
 */
export const reorderPinsHandlerBodyItem = zod.object({
  pinIndex: zod.number().describe('The index of the pin'),
  pinnedItemId: zod.string().describe('The id of the pinned item'),
  pinnedItemType: zod.string().describe('The type of the pin'),
});
export const reorderPinsHandlerBody = zod.array(reorderPinsHandlerBodyItem);

export const reorderPinsHandlerResponse = zod.object({
  data: zod.object({
    success: zod.boolean().describe('Indicates if the request was successful'),
  }),
  error: zod.boolean().describe('Indicates if an error occurred'),
});

/**
 * @summary Pins the item for the user
 */
export const addPinHandlerParams = zod.object({
  pinned_item_id: zod.string().describe('ID of the pinned item'),
});

export const addPinHandlerBody = zod.object({
  pinIndex: zod.number().describe('The index of the pin'),
  pinType: zod.string().describe('The type of the pin'),
});

export const addPinHandlerResponse = zod.object({
  data: zod.object({
    success: zod.boolean().describe('Indicates if the request was successful'),
  }),
  error: zod.boolean().describe('Indicates if an error occurred'),
});

/**
 * @summary Deletes the pin for the user
 */
export const removePinHandlerParams = zod.object({
  pinned_item_id: zod.string().describe('ID of the pinned item'),
});

export const removePinHandlerBody = zod.object({
  pinType: zod.string().describe('The type of the pin'),
});

export const removePinHandlerResponse = zod.object({
  data: zod.object({
    success: zod.boolean().describe('Indicates if the request was successful'),
  }),
  error: zod.boolean().describe('Indicates if an error occurred'),
});

/**
 * @summary List projects visible to the authenticated user.
 */
export const getProjectsHandlerResponse = zod.object({
  data: zod
    .array(
      zod.object({
        createdAt: zod.iso
          .datetime({})
          .nullish()
          .describe('The time the project was created'),
        deletedAt: zod.iso.datetime({}).nullish(),
        id: zod.string().describe('The id of the project'),
        name: zod.string().describe('The name of the project'),
        parentId: zod.string().nullish().describe('The parent project id'),
        updatedAt: zod.iso
          .datetime({})
          .nullish()
          .describe('The time the project was updated'),
        userId: zod.string().describe('The user id of who created the project'),
        type: zod.enum(['project']),
      })
    )
    .describe('Data to be returned'),
  error: zod.boolean().describe('Indicates if an error occurred'),
});

/**
 * @summary Create a project, optionally beneath an existing project.
 */
export const createProjectHandlerBody = zod.object({
  name: zod.string().describe('The name of the project.'),
  projectParentId: zod
    .uuid()
    .nullish()
    .describe('The project that the new project will belong to.'),
});

export const createProjectHandlerResponse = zod.object({
  data: zod.object({
    createdAt: zod.iso
      .datetime({})
      .nullish()
      .describe('The time the project was created'),
    deletedAt: zod.iso.datetime({}).nullish(),
    id: zod.string().describe('The id of the project'),
    name: zod.string().describe('The name of the project'),
    parentId: zod.string().nullish().describe('The parent project id'),
    updatedAt: zod.iso
      .datetime({})
      .nullish()
      .describe('The time the project was updated'),
    userId: zod.string().describe('The user id of who created the project'),
    type: zod.enum(['project']),
  }),
  error: zod.boolean().describe('Indicates if an error occurred'),
});

/**
 * @summary List pending root projects owned by the authenticated user.
 */
export const getPendingProjectsHandlerResponse = zod.object({
  data: zod
    .array(
      zod
        .object({
          createdAt: zod.iso
            .datetime({})
            .nullish()
            .describe('The time the project was created'),
          deletedAt: zod.iso.datetime({}).nullish(),
          id: zod.string().describe('The id of the project'),
          name: zod.string().describe('The name of the project'),
          parentId: zod.string().nullish().describe('The parent project id'),
          updatedAt: zod.iso
            .datetime({})
            .nullish()
            .describe('The time the project was updated'),
          userId: zod
            .string()
            .describe('The user id of who created the project'),
          type: zod.enum(['project']),
        })
        .and(
          zod.object({
            documentStatuses: zod.array(
              zod.object({
                documentId: zod.string(),
                status: zod
                  .enum(['pending', 'completed', 'failed', 'unknown'])
                  .describe('The upload status of the document'),
              })
            ),
          })
        )
    )
    .describe('Data to be returned'),
  error: zod.boolean().describe('Indicates if an error occurred'),
});

/**
 * @summary Get previews for a batch of project IDs.
 */
export const getBatchProjectPreviewBody = zod.object({
  projectIds: zod.array(zod.string()),
});

export const getBatchProjectPreviewResponse = zod.object({
  previews: zod.array(
    zod.union([
      zod
        .object({
          id: zod.string(),
          name: zod.string(),
          owner: zod.string(),
          path: zod.array(zod.string()),
          updatedAt: zod.iso.datetime({}).nullish(),
        })
        .and(
          zod.object({
            access: zod.enum(['access']),
          })
        ),
      zod
        .object({
          id: zod.string(),
        })
        .and(
          zod.object({
            access: zod.enum(['no_access']),
          })
        ),
      zod
        .object({
          id: zod.string(),
        })
        .and(
          zod.object({
            access: zod.enum(['does_not_exist']),
          })
        ),
    ])
  ),
});

/**
 * @summary Upload a folder tree and create its upload destinations.
 */
export const uploadFolderHandlerBody = zod.object({
  content: zod
    .array(
      zod.object({
        fileType: zod
          .union([
            zod.null(),
            zod
              .enum([
                'docx',
                'pdf',
                'md',
                'canvas',
                'coffee',
                'cson',
                'iced',
                'c',
                'i',
                'cpp',
                'cppm',
                'cc',
                'ccm',
                'cxx',
                'cxxm',
                'cplusplus',
                'cplusplusm',
                'hpp',
                'hh',
                'hxx',
                'hplusplus',
                'h',
                'ii',
                'ino',
                'inl',
                'ipp',
                'ixx',
                'tpp',
                'txx',
                'hppin',
                'hin',
                'cu',
                'cuh',
                'cs',
                'csx',
                'cake',
                'css',
                'dart',
                'diff',
                'patch',
                'rej',
                'dockerfile',
                'containerfile',
                'go',
                'handlebars',
                'hbs',
                'hjs',
                'hlsl',
                'hlsli',
                'fx',
                'fxh',
                'vsh',
                'psh',
                'cginc',
                'compute',
                'html',
                'htm',
                'shtml',
                'xhtml',
                'xht',
                'mdoc',
                'jsp',
                'asp',
                'aspx',
                'jshtm',
                'volt',
                'ejs',
                'rhtml',
                'ini',
                'conf',
                'properties',
                'cfg',
                'directory',
                'gitattributes',
                'gitconfig',
                'gitmodules',
                'editorconfig',
                'repo',
                'java',
                'jav',
                'jsx',
                'js',
                'es6',
                'mjs',
                'cjs',
                'pac',
                'json',
                'bowerrc',
                'jscsrc',
                'webmanifest',
                'jsmap',
                'cssmap',
                'tsmap',
                'har',
                'jslintrc',
                'jsonld',
                'geojson',
                'ipynb',
                'vuerc',
                'jsonc',
                'eslintrc',
                'eslintrcjson',
                'jsfmtrc',
                'jshintrc',
                'swcrc',
                'hintrc',
                'babelrc',
                'jsonl',
                'ndjson',
                'codesnippets',
                'jl',
                'jmd',
                'sty',
                'cls',
                'bbx',
                'cbx',
                'tex',
                'ltx',
                'ctx',
                'bib',
                'less',
                'log',
                'lua',
                'mak',
                'mk',
                'mkd',
                'mdwn',
                'mdown',
                'markdown',
                'markdn',
                'mdtxt',
                'mdtext',
                'workbook',
                'm',
                'mm',
                'pl',
                'pm',
                'pod',
                't',
                'psgi',
                'raku',
                'rakumod',
                'rakutest',
                'rakudoc',
                'nqp',
                'p6',
                'pl6',
                'pm6',
                'php',
                'php4',
                'php5',
                'phtml',
                'ctp',
                'ps1',
                'psm1',
                'psd1',
                'pssc',
                'psrc',
                'py',
                'rpy',
                'pyw',
                'cpy',
                'gyp',
                'gypi',
                'pyi',
                'ipy',
                'pyt',
                'r',
                'rhistory',
                'rprofile',
                'rt',
                'cshtml',
                'razor',
                'rb',
                'rbx',
                'rjs',
                'gemspec',
                'rake',
                'ru',
                'erb',
                'podspec',
                'rbi',
                'rs',
                'scss',
                'sass',
                'shader',
                'sh',
                'bash',
                'bashrc',
                'bashaliases',
                'bashprofile',
                'bashlogin',
                'ebuild',
                'eclass',
                'profile',
                'bashlogout',
                'xprofile',
                'xsession',
                'xsessionrc',
                'zsh',
                'zshrc',
                'zprofile',
                'zlogin',
                'zlogout',
                'zshenv',
                'zshtheme',
                'fish',
                'ksh',
                'csh',
                'cshrc',
                'tcshrc',
                'yashrc',
                'yashprofile',
                'sql',
                'dsql',
                'swift',
                'ts',
                'cts',
                'mts',
                'tsx',
                'tsbuildinfo',
                'xml',
                'xsd',
                'ascx',
                'atom',
                'axml',
                'axaml',
                'bpmn',
                'cpt',
                'csl',
                'csproj',
                'csprojuser',
                'dita',
                'ditamap',
                'dtd',
                'ent',
                'mod',
                'dtml',
                'fsproj',
                'fxml',
                'iml',
                'isml',
                'jmx',
                'launch',
                'menu',
                'mxml',
                'nuspec',
                'opml',
                'owl',
                'proj',
                'props',
                'pt',
                'publishsettings',
                'pubxml',
                'pubxmluser',
                'rbxlx',
                'rbxmx',
                'rdf',
                'rng',
                'rss',
                'shproj',
                'storyboard',
                'targets',
                'tld',
                'tmx',
                'vbproj',
                'vbprojuser',
                'vcxproj',
                'vcxprojfilters',
                'wsdl',
                'wxi',
                'wxl',
                'wxs',
                'xaml',
                'xbl',
                'xib',
                'xlf',
                'xliff',
                'xpdl',
                'xul',
                'xoml',
                'xsl',
                'xslt',
                'yaml',
                'yml',
                'eyaml',
                'eyml',
                'cff',
                'yamltmlanguage',
                'yamltmpreferences',
                'yamltmtheme',
                'winget',
                'txt',
                'csv',
                'tsv',
                'jpeg',
                'jpg',
                'png',
                'gif',
                'svg',
                'webp',
                'avif',
                'bmp',
                'ico',
                'tiff',
                'tif',
                'heic',
                'heif',
                'tar',
                'targz',
                'tgz',
                'gz',
                'bz2',
                'tarbz2',
                'tbz2',
                'z',
                'tarz',
                'lz',
                'tarlz',
                'xz',
                'tarxz',
                'txz',
                'lzma',
                'tarlzma',
                'rar',
                'sevenz',
                'zst',
                'tarzst',
                'tzst',
                'zip',
                'exe',
                'msi',
                'dll',
                'bat',
                'cmd',
                'com',
                'appimage',
                'app',
                'bin',
                'deb',
                'rpm',
                'apk',
                'dmg',
                'pkg',
                'crx',
                'xpi',
                'mp3',
                'wav',
                'ogg',
                'flac',
                'aac',
                'm4a',
                'wma',
                'mid',
                'midi',
                'mp4',
                'mkv',
                'webm',
                'avi',
                'mov',
                'wmv',
                'mpg',
                'mpeg',
                'm4v',
                'flv',
                'f4v',
                'threegp',
                'ttf',
                'otf',
                'woff',
                'woff2',
                'eot',
                'rtf',
                'odt',
                'ods',
                'odp',
                'odg',
                'odf',
                'epub',
                'mobi',
                'azw',
                'azw3',
                'djvu',
                'xls',
                'ppt',
                'pptx',
                'xlsx',
                'db',
                'sqlite',
                'sqlite3',
                'mdb',
                'accdb',
                'dbf',
                'plist',
                'toml',
                'env',
                'dot',
                'gv',
                'torrent',
                'ics',
                'vcf',
                'ai',
                'eps',
                'ps',
                'dxf',
                'dwg',
                'stl',
                'obj',
                'fbx',
                'blend',
                'dae',
                'threeds',
                'gltf',
                'glb',
                'vhd',
                'vhdx',
                'vmdk',
                'ova',
                'ovf',
                'iso',
                'img',
                'swf',
              ])
              .describe(
                'Generates a FileType enum and associated ContentType enum with their implementations.\n\nThis macro takes a list of tuples in the format:\n(Variant, \"extension\", \"mime_type\", CONTENT_TYPE_VARIANT)\n\nFor each tuple it generates:\n- A variant in the FileType enum\n- A variant in the ContentType enum\n- Implementations for:\n  - FileType::to_str() - Converts FileType to extension string\n  - FileType::from_str() - Converts extension string to FileType\n  - From<FileType> for ContentType - Maps FileType to ContentType\n  - ContentType::mime_type() - Gets MIME type for ContentType\n'
              ),
          ])
          .optional(),
        fullName: zod
          .string()
          .describe('The full OS name of the file for deduplication'),
        name: zod
          .string()
          .describe('The name of the file, without the extension'),
        relativePath: zod
          .string()
          .describe(
            'The relative path of the file.\n\nThis is the `webkitRelativePath` with the name of the file stripped at the end.'
          ),
        sha: zod.string().describe('The sha of the file.'),
      })
    )
    .describe('The content of the folder'),
  parentId: zod
    .string()
    .nullish()
    .describe('Optional parent project id to upload the folder into'),
  rootFolderName: zod
    .string()
    .describe(
      'The name of the folder you are uploading.\n\nThis is used to help us generate the folder map more easily.'
    ),
  uploadRequestId: zod.string().describe('The upload request id'),
});

export const uploadFolderHandlerResponse = zod.object({
  data: zod
    .object({
      destinationMap: zod.record(
        zod.string(),
        zod.union([
          zod
            .object({
              presignedUrl: zod
                .string()
                .describe('The presigned url used to upload the sha'),
              sha: zod.string().describe('The sha of the item'),
            })
            .and(
              zod.object({
                type: zod.enum(['external']),
              })
            ),
          zod
            .object({
              bucket: zod.string(),
              key: zod.string(),
            })
            .and(
              zod.object({
                type: zod.enum(['internal']),
              })
            ),
        ])
      ),
      fileSystem: zod.union([
        zod.object({
          document_id: zod.string(),
          item: zod.object({
            fileType: zod
              .union([
                zod.null(),
                zod
                  .enum([
                    'docx',
                    'pdf',
                    'md',
                    'canvas',
                    'coffee',
                    'cson',
                    'iced',
                    'c',
                    'i',
                    'cpp',
                    'cppm',
                    'cc',
                    'ccm',
                    'cxx',
                    'cxxm',
                    'cplusplus',
                    'cplusplusm',
                    'hpp',
                    'hh',
                    'hxx',
                    'hplusplus',
                    'h',
                    'ii',
                    'ino',
                    'inl',
                    'ipp',
                    'ixx',
                    'tpp',
                    'txx',
                    'hppin',
                    'hin',
                    'cu',
                    'cuh',
                    'cs',
                    'csx',
                    'cake',
                    'css',
                    'dart',
                    'diff',
                    'patch',
                    'rej',
                    'dockerfile',
                    'containerfile',
                    'go',
                    'handlebars',
                    'hbs',
                    'hjs',
                    'hlsl',
                    'hlsli',
                    'fx',
                    'fxh',
                    'vsh',
                    'psh',
                    'cginc',
                    'compute',
                    'html',
                    'htm',
                    'shtml',
                    'xhtml',
                    'xht',
                    'mdoc',
                    'jsp',
                    'asp',
                    'aspx',
                    'jshtm',
                    'volt',
                    'ejs',
                    'rhtml',
                    'ini',
                    'conf',
                    'properties',
                    'cfg',
                    'directory',
                    'gitattributes',
                    'gitconfig',
                    'gitmodules',
                    'editorconfig',
                    'repo',
                    'java',
                    'jav',
                    'jsx',
                    'js',
                    'es6',
                    'mjs',
                    'cjs',
                    'pac',
                    'json',
                    'bowerrc',
                    'jscsrc',
                    'webmanifest',
                    'jsmap',
                    'cssmap',
                    'tsmap',
                    'har',
                    'jslintrc',
                    'jsonld',
                    'geojson',
                    'ipynb',
                    'vuerc',
                    'jsonc',
                    'eslintrc',
                    'eslintrcjson',
                    'jsfmtrc',
                    'jshintrc',
                    'swcrc',
                    'hintrc',
                    'babelrc',
                    'jsonl',
                    'ndjson',
                    'codesnippets',
                    'jl',
                    'jmd',
                    'sty',
                    'cls',
                    'bbx',
                    'cbx',
                    'tex',
                    'ltx',
                    'ctx',
                    'bib',
                    'less',
                    'log',
                    'lua',
                    'mak',
                    'mk',
                    'mkd',
                    'mdwn',
                    'mdown',
                    'markdown',
                    'markdn',
                    'mdtxt',
                    'mdtext',
                    'workbook',
                    'm',
                    'mm',
                    'pl',
                    'pm',
                    'pod',
                    't',
                    'psgi',
                    'raku',
                    'rakumod',
                    'rakutest',
                    'rakudoc',
                    'nqp',
                    'p6',
                    'pl6',
                    'pm6',
                    'php',
                    'php4',
                    'php5',
                    'phtml',
                    'ctp',
                    'ps1',
                    'psm1',
                    'psd1',
                    'pssc',
                    'psrc',
                    'py',
                    'rpy',
                    'pyw',
                    'cpy',
                    'gyp',
                    'gypi',
                    'pyi',
                    'ipy',
                    'pyt',
                    'r',
                    'rhistory',
                    'rprofile',
                    'rt',
                    'cshtml',
                    'razor',
                    'rb',
                    'rbx',
                    'rjs',
                    'gemspec',
                    'rake',
                    'ru',
                    'erb',
                    'podspec',
                    'rbi',
                    'rs',
                    'scss',
                    'sass',
                    'shader',
                    'sh',
                    'bash',
                    'bashrc',
                    'bashaliases',
                    'bashprofile',
                    'bashlogin',
                    'ebuild',
                    'eclass',
                    'profile',
                    'bashlogout',
                    'xprofile',
                    'xsession',
                    'xsessionrc',
                    'zsh',
                    'zshrc',
                    'zprofile',
                    'zlogin',
                    'zlogout',
                    'zshenv',
                    'zshtheme',
                    'fish',
                    'ksh',
                    'csh',
                    'cshrc',
                    'tcshrc',
                    'yashrc',
                    'yashprofile',
                    'sql',
                    'dsql',
                    'swift',
                    'ts',
                    'cts',
                    'mts',
                    'tsx',
                    'tsbuildinfo',
                    'xml',
                    'xsd',
                    'ascx',
                    'atom',
                    'axml',
                    'axaml',
                    'bpmn',
                    'cpt',
                    'csl',
                    'csproj',
                    'csprojuser',
                    'dita',
                    'ditamap',
                    'dtd',
                    'ent',
                    'mod',
                    'dtml',
                    'fsproj',
                    'fxml',
                    'iml',
                    'isml',
                    'jmx',
                    'launch',
                    'menu',
                    'mxml',
                    'nuspec',
                    'opml',
                    'owl',
                    'proj',
                    'props',
                    'pt',
                    'publishsettings',
                    'pubxml',
                    'pubxmluser',
                    'rbxlx',
                    'rbxmx',
                    'rdf',
                    'rng',
                    'rss',
                    'shproj',
                    'storyboard',
                    'targets',
                    'tld',
                    'tmx',
                    'vbproj',
                    'vbprojuser',
                    'vcxproj',
                    'vcxprojfilters',
                    'wsdl',
                    'wxi',
                    'wxl',
                    'wxs',
                    'xaml',
                    'xbl',
                    'xib',
                    'xlf',
                    'xliff',
                    'xpdl',
                    'xul',
                    'xoml',
                    'xsl',
                    'xslt',
                    'yaml',
                    'yml',
                    'eyaml',
                    'eyml',
                    'cff',
                    'yamltmlanguage',
                    'yamltmpreferences',
                    'yamltmtheme',
                    'winget',
                    'txt',
                    'csv',
                    'tsv',
                    'jpeg',
                    'jpg',
                    'png',
                    'gif',
                    'svg',
                    'webp',
                    'avif',
                    'bmp',
                    'ico',
                    'tiff',
                    'tif',
                    'heic',
                    'heif',
                    'tar',
                    'targz',
                    'tgz',
                    'gz',
                    'bz2',
                    'tarbz2',
                    'tbz2',
                    'z',
                    'tarz',
                    'lz',
                    'tarlz',
                    'xz',
                    'tarxz',
                    'txz',
                    'lzma',
                    'tarlzma',
                    'rar',
                    'sevenz',
                    'zst',
                    'tarzst',
                    'tzst',
                    'zip',
                    'exe',
                    'msi',
                    'dll',
                    'bat',
                    'cmd',
                    'com',
                    'appimage',
                    'app',
                    'bin',
                    'deb',
                    'rpm',
                    'apk',
                    'dmg',
                    'pkg',
                    'crx',
                    'xpi',
                    'mp3',
                    'wav',
                    'ogg',
                    'flac',
                    'aac',
                    'm4a',
                    'wma',
                    'mid',
                    'midi',
                    'mp4',
                    'mkv',
                    'webm',
                    'avi',
                    'mov',
                    'wmv',
                    'mpg',
                    'mpeg',
                    'm4v',
                    'flv',
                    'f4v',
                    'threegp',
                    'ttf',
                    'otf',
                    'woff',
                    'woff2',
                    'eot',
                    'rtf',
                    'odt',
                    'ods',
                    'odp',
                    'odg',
                    'odf',
                    'epub',
                    'mobi',
                    'azw',
                    'azw3',
                    'djvu',
                    'xls',
                    'ppt',
                    'pptx',
                    'xlsx',
                    'db',
                    'sqlite',
                    'sqlite3',
                    'mdb',
                    'accdb',
                    'dbf',
                    'plist',
                    'toml',
                    'env',
                    'dot',
                    'gv',
                    'torrent',
                    'ics',
                    'vcf',
                    'ai',
                    'eps',
                    'ps',
                    'dxf',
                    'dwg',
                    'stl',
                    'obj',
                    'fbx',
                    'blend',
                    'dae',
                    'threeds',
                    'gltf',
                    'glb',
                    'vhd',
                    'vhdx',
                    'vmdk',
                    'ova',
                    'ovf',
                    'iso',
                    'img',
                    'swf',
                  ])
                  .describe(
                    'Generates a FileType enum and associated ContentType enum with their implementations.\n\nThis macro takes a list of tuples in the format:\n(Variant, \"extension\", \"mime_type\", CONTENT_TYPE_VARIANT)\n\nFor each tuple it generates:\n- A variant in the FileType enum\n- A variant in the ContentType enum\n- Implementations for:\n  - FileType::to_str() - Converts FileType to extension string\n  - FileType::from_str() - Converts extension string to FileType\n  - From<FileType> for ContentType - Maps FileType to ContentType\n  - ContentType::mime_type() - Gets MIME type for ContentType\n'
                  ),
              ])
              .optional(),
            fullName: zod
              .string()
              .describe('The full OS name of the file for deduplication'),
            name: zod
              .string()
              .describe('The name of the file, without the extension'),
            relativePath: zod
              .string()
              .describe(
                'The relative path of the file.\n\nThis is the `webkitRelativePath` with the name of the file stripped at the end.'
              ),
            sha: zod.string().describe('The sha of the file.'),
          }),
          type: zod.enum(['file']),
        }),
        zod.object({
          content: zod.record(zod.string(), zod.unknown()),
          project_id: zod.string(),
          type: zod.enum(['folder']),
        }),
      ]),
    })
    .describe('Data to be returned'),
  error: zod.boolean().describe('Indicates if an error occurred'),
});

/**
 * @summary Create a request for extracting an uploaded folder archive.
 */
export const uploadExtractFolderHandlerBody = zod.object({
  name: zod.string().nullish(),
  parentId: zod.string().nullish(),
  sha: zod.string(),
});

export const uploadExtractFolderHandlerResponse = zod.object({
  data: zod
    .object({
      presignedUrl: zod.string(),
      requestId: zod.string(),
    })
    .describe('Data to be returned'),
  error: zod.boolean().describe('Indicates if an error occurred'),
});

/**
 * @summary Get project metadata.
 */
export const getProjectHandlerParams = zod.object({
  id: zod.string().describe('ID of the project'),
});

export const getProjectHandlerResponse = zod.object({
  data: zod.object({
    projectMetadata: zod.object({
      createdAt: zod.iso
        .datetime({})
        .nullish()
        .describe('The time the project was created'),
      deletedAt: zod.iso.datetime({}).nullish(),
      id: zod.string().describe('The id of the project'),
      name: zod.string().describe('The name of the project'),
      parentId: zod.string().nullish().describe('The parent project id'),
      updatedAt: zod.iso
        .datetime({})
        .nullish()
        .describe('The time the project was updated'),
      userId: zod.string().describe('The user id of who created the project'),
      type: zod.enum(['project']),
    }),
    userAccessLevel: zod
      .enum(['view', 'comment', 'edit', 'owner'])
      .describe('Ordered from least to most access top -> bottom'),
  }),
  error: zod.boolean().describe('Indicates if an error occurred'),
});

/**
 * @summary Soft-delete a project and all of its children.
 */
export const deleteProjectHandlerParams = zod.object({
  id: zod.string().describe('ID of the project'),
});

export const deleteProjectHandlerResponse = zod.object({
  data: zod
    .object({
      chat_ids: zod.array(zod.string()).describe('Deleted chats.'),
      document_ids: zod.array(zod.string()).describe('Deleted documents.'),
      project_ids: zod
        .array(zod.string())
        .describe('Deleted projects, including the requested root.'),
    })
    .describe('Identifiers affected by a recursive project soft deletion.')
    .describe('Data to be returned'),
  error: zod.boolean().describe('Indicates if an error occurred'),
});

/**
 * @summary Get the caller's project access level.
 */
export const getProjectUserAccessLevelParams = zod.object({
  id: zod.string().describe('ID of the project'),
});

export const getProjectUserAccessLevelResponse = zod
  .enum(['view', 'comment', 'edit', 'owner'])
  .describe('Ordered from least to most access top -> bottom');

/**
 * @summary Get a project's immediate children.
 */
export const getProjectContentHandlerParams = zod.object({
  id: zod.string().describe('ID of the project'),
});

export const getProjectContentHandlerResponse = zod.object({
  data: zod
    .array(
      zod.object({
        item: zod.union([
          zod.object({
            branchedFromId: zod
              .string()
              .nullish()
              .describe('The id of the document this document branched from'),
            branchedFromVersionId: zod
              .number()
              .nullish()
              .describe(
                'The id of the version this document branched from\nThis could be either DocumentInstance or DocumentBom id depending on\nthe file type'
              ),
            createdAt: zod.iso
              .datetime({})
              .nullish()
              .describe('The time the document was created'),
            deletedAt: zod.iso
              .datetime({})
              .nullish()
              .describe('The time the document was deleted'),
            documentFamilyId: zod
              .number()
              .nullish()
              .describe(
                'The id of the document family this document belongs to'
              ),
            documentVersionId: zod
              .number()
              .describe(
                'The version of the document\nThis could be the document_instance_id or document_bom_id depending on\nthe file type'
              ),
            fileType: zod
              .string()
              .nullish()
              .describe('The file type of the document (e.g. pdf, docx)'),
            id: zod.string().describe('The document id'),
            name: zod.string().describe('The name of the document'),
            owner: zod.string().describe('The owner of the document'),
            projectId: zod
              .string()
              .nullish()
              .describe('The id of the project that this document belongs to'),
            sha: zod
              .string()
              .nullish()
              .describe(
                'If the document is a PDF, this is the SHA of the pdf\nIf the document is a DOCX, this will not be present'
              ),
            subType: zod
              .union([
                zod.null(),
                zod
                  .union([
                    zod
                      .object({
                        is_completed: zod
                          .boolean()
                          .describe(
                            'Whether the task is completed.\nTrue if the Status property is set to \"Completed\".'
                          ),
                        type: zod.enum(['task']),
                      })
                      .describe(
                        'A task document with its associated properties'
                      ),
                    zod
                      .object({
                        type: zod.enum(['snippet']),
                      })
                      .describe('A snippet document — reusable markdown'),
                    zod
                      .object({
                        type: zod.enum(['skill']),
                      })
                      .describe(
                        'A skill document — markdown instructions for AI'
                      ),
                  ])
                  .describe(
                    'Sub type of a document with associated properties encoded in each variant.\nThis ensures type-safety: task properties only exist when the document is a task.'
                  ),
              ])
              .optional(),
            updatedAt: zod.iso
              .datetime({})
              .nullish()
              .describe(
                'The time the document instance \/ document BOM was updated'
              ),
            type: zod.enum(['document']),
          }),
          zod.object({
            createdAt: zod.iso
              .datetime({})
              .nullish()
              .describe('The time the chat was created'),
            deletedAt: zod.iso
              .datetime({})
              .nullish()
              .describe('The time the chat was deleted'),
            id: zod.string().describe('The chat uuid'),
            isPersistent: zod.boolean(),
            model: zod
              .string()
              .nullish()
              .describe('The model used to generate the chat'),
            name: zod.string().describe('The name of the chat'),
            projectId: zod
              .string()
              .nullish()
              .describe('The project id of the chat'),
            tokenCount: zod.number().nullish(),
            updatedAt: zod.iso
              .datetime({})
              .nullish()
              .describe('The time the chat was last updated'),
            userId: zod.string().describe('Who the chat belongs to'),
            type: zod.enum(['chat']),
          }),
          zod.object({
            createdAt: zod.iso
              .datetime({})
              .nullish()
              .describe('The time the project was created'),
            deletedAt: zod.iso.datetime({}).nullish(),
            id: zod.string().describe('The id of the project'),
            name: zod.string().describe('The name of the project'),
            parentId: zod.string().nullish().describe('The parent project id'),
            updatedAt: zod.iso
              .datetime({})
              .nullish()
              .describe('The time the project was updated'),
            userId: zod
              .string()
              .describe('The user id of who created the project'),
            type: zod.enum(['project']),
          }),
        ]),
        userAccessLevel: zod
          .enum(['view', 'comment', 'edit', 'owner'])
          .describe('Ordered from least to most access top -> bottom'),
      })
    )
    .describe(
      'DSS Items inside of a given project with their user access level attached to each item'
    ),
  error: zod.boolean().describe('Indicates if an error occurred'),
});

/**
 * @summary Permanently delete a soft-deleted project and all of its children.
 */
export const permanentlyDeleteProjectParams = zod.object({
  id: zod.string().describe('ID of the project'),
});

export const permanentlyDeleteProjectResponse = zod.object({
  data: zod.object({
    success: zod.boolean().describe('Indicates if the request was successful'),
  }),
  error: zod.boolean().describe('Indicates if an error occurred'),
});

/**
 * @summary Get a project's share permissions.
 */
export const getProjectPermissionsV2Params = zod.object({
  id: zod.string().describe('ID of the project'),
});

export const getProjectPermissionsV2Response = zod.object({
  channelSharePermissions: zod
    .array(
      zod
        .object({
          access_level: zod
            .enum(['view', 'comment', 'edit', 'owner'])
            .describe('Ordered from least to most access top -> bottom'),
          channel_id: zod.string().describe('The channel id'),
        })
        .describe('The channel share permission')
    )
    .nullish()
    .describe('The channel share permissions for the item'),
  id: zod.string().describe('The share permission id'),
  linkShare: zod
    .union([
      zod.null(),
      zod
        .enum(['PUBLIC', 'TEAM'])
        .describe('Defines who can access an item through its share link.'),
    ])
    .optional(),
  linkShareAccessLevel: zod
    .union([
      zod.null(),
      zod
        .enum(['view', 'comment', 'edit', 'owner'])
        .describe('Ordered from least to most access top -> bottom'),
    ])
    .optional(),
  owner: zod.string().describe('The owner of the item'),
});

/**
 * @summary Restore a soft-deleted project and its children.
 */
export const revertDeleteProjectParams = zod.object({
  id: zod.string().describe('ID of the project'),
});

export const revertDeleteProjectResponse = zod.object({
  data: zod.object({
    success: zod.boolean().describe('Indicates if the request was successful'),
  }),
  error: zod.boolean().describe('Indicates if an error occurred'),
});

/**
 * @summary Gets the users recently deleted items.
 */
export const recentlyDeletedResponse = zod.object({
  data: zod
    .object({
      items: zod
        .array(
          zod.union([
            zod.object({
              branchedFromId: zod
                .string()
                .nullish()
                .describe('The id of the document this document branched from'),
              branchedFromVersionId: zod
                .number()
                .nullish()
                .describe(
                  'The id of the version this document branched from\nThis could be either DocumentInstance or DocumentBom id depending on\nthe file type'
                ),
              createdAt: zod.iso
                .datetime({})
                .nullish()
                .describe('The time the document was created'),
              deletedAt: zod.iso
                .datetime({})
                .nullish()
                .describe('The time the document was deleted'),
              documentFamilyId: zod
                .number()
                .nullish()
                .describe(
                  'The id of the document family this document belongs to'
                ),
              documentVersionId: zod
                .number()
                .describe(
                  'The version of the document\nThis could be the document_instance_id or document_bom_id depending on\nthe file type'
                ),
              fileType: zod
                .string()
                .nullish()
                .describe('The file type of the document (e.g. pdf, docx)'),
              id: zod.string().describe('The document id'),
              name: zod.string().describe('The name of the document'),
              owner: zod.string().describe('The owner of the document'),
              projectId: zod
                .string()
                .nullish()
                .describe(
                  'The id of the project that this document belongs to'
                ),
              sha: zod
                .string()
                .nullish()
                .describe(
                  'If the document is a PDF, this is the SHA of the pdf\nIf the document is a DOCX, this will not be present'
                ),
              subType: zod
                .union([
                  zod.null(),
                  zod
                    .union([
                      zod
                        .object({
                          is_completed: zod
                            .boolean()
                            .describe(
                              'Whether the task is completed.\nTrue if the Status property is set to \"Completed\".'
                            ),
                          type: zod.enum(['task']),
                        })
                        .describe(
                          'A task document with its associated properties'
                        ),
                      zod
                        .object({
                          type: zod.enum(['snippet']),
                        })
                        .describe('A snippet document — reusable markdown'),
                      zod
                        .object({
                          type: zod.enum(['skill']),
                        })
                        .describe(
                          'A skill document — markdown instructions for AI'
                        ),
                    ])
                    .describe(
                      'Sub type of a document with associated properties encoded in each variant.\nThis ensures type-safety: task properties only exist when the document is a task.'
                    ),
                ])
                .optional(),
              updatedAt: zod.iso
                .datetime({})
                .nullish()
                .describe(
                  'The time the document instance \/ document BOM was updated'
                ),
              type: zod.enum(['document']),
            }),
            zod.object({
              createdAt: zod.iso
                .datetime({})
                .nullish()
                .describe('The time the chat was created'),
              deletedAt: zod.iso
                .datetime({})
                .nullish()
                .describe('The time the chat was deleted'),
              id: zod.string().describe('The chat uuid'),
              isPersistent: zod.boolean(),
              model: zod
                .string()
                .nullish()
                .describe('The model used to generate the chat'),
              name: zod.string().describe('The name of the chat'),
              projectId: zod
                .string()
                .nullish()
                .describe('The project id of the chat'),
              tokenCount: zod.number().nullish(),
              updatedAt: zod.iso
                .datetime({})
                .nullish()
                .describe('The time the chat was last updated'),
              userId: zod.string().describe('Who the chat belongs to'),
              type: zod.enum(['chat']),
            }),
            zod.object({
              createdAt: zod.iso
                .datetime({})
                .nullish()
                .describe('The time the project was created'),
              deletedAt: zod.iso.datetime({}).nullish(),
              id: zod.string().describe('The id of the project'),
              name: zod.string().describe('The name of the project'),
              parentId: zod
                .string()
                .nullish()
                .describe('The parent project id'),
              updatedAt: zod.iso
                .datetime({})
                .nullish()
                .describe('The time the project was updated'),
              userId: zod
                .string()
                .describe('The user id of who created the project'),
              type: zod.enum(['project']),
            }),
          ])
        )
        .describe('The items returned from the call'),
    })
    .describe('Data to be returned'),
  error: zod.boolean().describe('Indicates if an error occurred'),
});

/**
 * @summary List the caller's reminders, soonest firing first.
 */
export const listRemindersQueryLimitMin = 0;

export const listRemindersQueryParams = zod.object({
  entityType: zod
    .enum([
      'user',
      'chat',
      'channel',
      'channel_message',
      'document',
      'project',
      'email_thread',
      'calendar_event',
      'team',
      'call',
      'foreign_entity',
      'static_file',
      'crm_company',
      'crm_contact',
      'reminder',
      'skill',
    ])
    .optional()
    .describe(
      'Restrict to reminders attached to this entity type. Requires `entityId`.'
    ),
  entityId: zod
    .string()
    .optional()
    .describe(
      'Restrict to reminders attached to this entity id. Requires `entityType`.'
    ),
  includeCompleted: zod
    .boolean()
    .optional()
    .describe('Include reminders that have already fired.'),
  limit: zod
    .number()
    .min(listRemindersQueryLimitMin)
    .optional()
    .describe(
      'Page size. Defaults to 100; larger values are capped at 500. A value\nthat is not a non-negative integer is rejected by the query extractor.'
    ),
  cursor: zod
    .string()
    .optional()
    .describe('`nextCursor` from a previous page.'),
});

export const listRemindersResponse = zod
  .object({
    nextCursor: zod
      .string()
      .nullish()
      .describe(
        'Pass back as `cursor` to fetch the next page. Absent on the last page —\nits absence is the only end-of-list signal, since a page can be short.'
      ),
    reminders: zod
      .array(
        zod
          .object({
            completedAt: zod.iso
              .datetime({})
              .nullish()
              .describe(
                'Set once the owner marks the reminder as dealt with. Firing does not\nset it — a delivered reminder is waiting on its owner, not finished.'
              ),
            createdAt: zod.iso
              .datetime({})
              .describe('When the reminder was created.'),
            description: zod
              .string()
              .describe('What to remind the user about.'),
            enabled: zod
              .boolean()
              .describe('When false, the dispatcher skips this reminder.'),
            entityId: zod
              .string()
              .nullish()
              .describe(
                'Id of the associated entity, when the reminder is attached to one.'
              ),
            entityType: zod
              .union([
                zod.null(),
                zod
                  .enum([
                    'user',
                    'chat',
                    'channel',
                    'channel_message',
                    'document',
                    'project',
                    'email_thread',
                    'calendar_event',
                    'team',
                    'call',
                    'foreign_entity',
                    'static_file',
                    'crm_company',
                    'crm_contact',
                    'reminder',
                    'skill',
                  ])
                  .describe('The type of an entity in Macro'),
              ])
              .optional()
              .describe(
                'Type of the associated entity, when the reminder is attached to one.'
              ),
            id: zod.uuid().describe('Reminder id.'),
            nextRunAt: zod.iso
              .datetime({})
              .describe('The next firing, derived from `schedule` on write.'),
            schedule: zod
              .union([
                zod
                  .object({
                    remindAt: zod.iso
                      .datetime({})
                      .describe('The instant to fire at.'),
                    type: zod.enum(['once']),
                  })
                  .describe('Fires once, at a fixed instant.'),
                zod
                  .object({
                    cron: zod
                      .string()
                      .describe(
                        'Cron expression, either the conventional 5-field\n`min hour dom mon dow` or the 6-\/7-field\n`sec min hour dom mon dow [year]`. A 5-field expression is stored\nnormalized to 6 fields with a zero seconds field, so `0 9 \* \* \*` and\n`0 0 9 \* \* \*` are the same schedule and both read back as the latter.'
                      ),
                    timezone: zod
                      .string()
                      .describe(
                        'The timezone the cron expression is evaluated in.'
                      ),
                    type: zod.enum(['recurring']),
                  })
                  .describe(
                    'Fires repeatedly, on a cron schedule evaluated in `timezone`.'
                  ),
              ])
              .describe('When a reminder fires.'),
            updatedAt: zod.iso
              .datetime({})
              .describe('When the reminder was last modified.'),
          })
          .describe(
            'A reminder belonging to a user.\n\n`user_id` is deliberately absent: a reminder is only ever read by its owner,\nso the field would be redundant on the wire.'
          )
      )
      .describe('The reminders.'),
  })
  .describe("The caller's reminders, soonest firing first.");

/**
 * @summary Create a reminder, optionally attached to an entity the caller can view.
 */
export const createReminderBody = zod
  .object({
    description: zod.string().describe('What to remind the caller about.'),
    entityId: zod
      .string()
      .nullish()
      .describe(
        'Id of the entity to attach the reminder to. Requires `entityType`.'
      ),
    entityType: zod
      .union([
        zod.null(),
        zod
          .enum([
            'user',
            'chat',
            'channel',
            'channel_message',
            'document',
            'project',
            'email_thread',
            'calendar_event',
            'team',
            'call',
            'foreign_entity',
            'static_file',
            'crm_company',
            'crm_contact',
            'reminder',
            'skill',
          ])
          .describe('The type of an entity in Macro'),
      ])
      .optional()
      .describe(
        'Type of the entity to attach the reminder to. Requires `entityId`.'
      ),
    schedule: zod
      .union([
        zod
          .object({
            remindAt: zod.iso.datetime({}).describe('The instant to fire at.'),
            type: zod.enum(['once']),
          })
          .describe('Fires once, at a fixed instant.'),
        zod
          .object({
            cron: zod
              .string()
              .describe(
                'Cron expression, either the conventional 5-field\n`min hour dom mon dow` or the 6-\/7-field\n`sec min hour dom mon dow [year]`. A 5-field expression is stored\nnormalized to 6 fields with a zero seconds field, so `0 9 \* \* \*` and\n`0 0 9 \* \* \*` are the same schedule and both read back as the latter.'
              ),
            timezone: zod
              .string()
              .describe('The timezone the cron expression is evaluated in.'),
            type: zod.enum(['recurring']),
          })
          .describe(
            'Fires repeatedly, on a cron schedule evaluated in `timezone`.'
          ),
      ])
      .describe('When a reminder fires.'),
  })
  .describe('Request body for creating a reminder.');

/**
 * @summary Fetch one of the caller's reminders.
 */
export const getReminderParams = zod.object({
  id: zod.uuid().describe('The reminder id.'),
});

export const getReminderResponse = zod
  .object({
    completedAt: zod.iso
      .datetime({})
      .nullish()
      .describe(
        'Set once the owner marks the reminder as dealt with. Firing does not\nset it — a delivered reminder is waiting on its owner, not finished.'
      ),
    createdAt: zod.iso.datetime({}).describe('When the reminder was created.'),
    description: zod.string().describe('What to remind the user about.'),
    enabled: zod
      .boolean()
      .describe('When false, the dispatcher skips this reminder.'),
    entityId: zod
      .string()
      .nullish()
      .describe(
        'Id of the associated entity, when the reminder is attached to one.'
      ),
    entityType: zod
      .union([
        zod.null(),
        zod
          .enum([
            'user',
            'chat',
            'channel',
            'channel_message',
            'document',
            'project',
            'email_thread',
            'calendar_event',
            'team',
            'call',
            'foreign_entity',
            'static_file',
            'crm_company',
            'crm_contact',
            'reminder',
            'skill',
          ])
          .describe('The type of an entity in Macro'),
      ])
      .optional()
      .describe(
        'Type of the associated entity, when the reminder is attached to one.'
      ),
    id: zod.uuid().describe('Reminder id.'),
    nextRunAt: zod.iso
      .datetime({})
      .describe('The next firing, derived from `schedule` on write.'),
    schedule: zod
      .union([
        zod
          .object({
            remindAt: zod.iso.datetime({}).describe('The instant to fire at.'),
            type: zod.enum(['once']),
          })
          .describe('Fires once, at a fixed instant.'),
        zod
          .object({
            cron: zod
              .string()
              .describe(
                'Cron expression, either the conventional 5-field\n`min hour dom mon dow` or the 6-\/7-field\n`sec min hour dom mon dow [year]`. A 5-field expression is stored\nnormalized to 6 fields with a zero seconds field, so `0 9 \* \* \*` and\n`0 0 9 \* \* \*` are the same schedule and both read back as the latter.'
              ),
            timezone: zod
              .string()
              .describe('The timezone the cron expression is evaluated in.'),
            type: zod.enum(['recurring']),
          })
          .describe(
            'Fires repeatedly, on a cron schedule evaluated in `timezone`.'
          ),
      ])
      .describe('When a reminder fires.'),
    updatedAt: zod.iso
      .datetime({})
      .describe('When the reminder was last modified.'),
  })
  .describe(
    'A reminder belonging to a user.\n\n`user_id` is deliberately absent: a reminder is only ever read by its owner,\nso the field would be redundant on the wire.'
  );

/**
 * @summary Delete one of the caller's reminders.
 */
export const deleteReminderParams = zod.object({
  id: zod.uuid().describe('The reminder id.'),
});

/**
 * @summary Modify one of the caller's reminders.
 */
export const updateReminderParams = zod.object({
  id: zod.uuid().describe('The reminder id.'),
});

export const updateReminderBody = zod
  .object({
    completed: zod
      .boolean()
      .optional()
      .describe(
        'Mark the reminder as dealt with, or live again. Distinct from\n`enabled`, which controls whether the dispatcher considers it.'
      ),
    description: zod.string().optional().describe('Replacement description.'),
    enabled: zod
      .boolean()
      .optional()
      .describe('Whether the reminder should fire at all.'),
    schedule: zod
      .union([
        zod
          .object({
            remindAt: zod.iso.datetime({}).describe('The instant to fire at.'),
            type: zod.enum(['once']),
          })
          .describe('Fires once, at a fixed instant.'),
        zod
          .object({
            cron: zod
              .string()
              .describe(
                'Cron expression, either the conventional 5-field\n`min hour dom mon dow` or the 6-\/7-field\n`sec min hour dom mon dow [year]`. A 5-field expression is stored\nnormalized to 6 fields with a zero seconds field, so `0 9 \* \* \*` and\n`0 0 9 \* \* \*` are the same schedule and both read back as the latter.'
              ),
            timezone: zod
              .string()
              .describe('The timezone the cron expression is evaluated in.'),
            type: zod.enum(['recurring']),
          })
          .describe(
            'Fires repeatedly, on a cron schedule evaluated in `timezone`.'
          ),
      ])
      .optional()
      .describe('When a reminder fires.'),
  })
  .describe(
    'Request body for modifying a reminder. Omitted fields are left unchanged;\nthe entity association is not modifiable.\n\nEvery field is optional but \*\*not\*\* nullable. `Option` here means \"absent\",\nand serde cannot tell an explicit `null` from an omitted key — so a body of\n`{\"enabled\": null}` would deserialize to an empty patch and be rejected as\nhaving no fields to update. `nullable = false` keeps the schema from\nadvertising a value the API has no meaning for; the deserializer still\ntolerates `null` rather than erroring on it.'
  );

export const updateReminderResponse = zod
  .object({
    completedAt: zod.iso
      .datetime({})
      .nullish()
      .describe(
        'Set once the owner marks the reminder as dealt with. Firing does not\nset it — a delivered reminder is waiting on its owner, not finished.'
      ),
    createdAt: zod.iso.datetime({}).describe('When the reminder was created.'),
    description: zod.string().describe('What to remind the user about.'),
    enabled: zod
      .boolean()
      .describe('When false, the dispatcher skips this reminder.'),
    entityId: zod
      .string()
      .nullish()
      .describe(
        'Id of the associated entity, when the reminder is attached to one.'
      ),
    entityType: zod
      .union([
        zod.null(),
        zod
          .enum([
            'user',
            'chat',
            'channel',
            'channel_message',
            'document',
            'project',
            'email_thread',
            'calendar_event',
            'team',
            'call',
            'foreign_entity',
            'static_file',
            'crm_company',
            'crm_contact',
            'reminder',
            'skill',
          ])
          .describe('The type of an entity in Macro'),
      ])
      .optional()
      .describe(
        'Type of the associated entity, when the reminder is attached to one.'
      ),
    id: zod.uuid().describe('Reminder id.'),
    nextRunAt: zod.iso
      .datetime({})
      .describe('The next firing, derived from `schedule` on write.'),
    schedule: zod
      .union([
        zod
          .object({
            remindAt: zod.iso.datetime({}).describe('The instant to fire at.'),
            type: zod.enum(['once']),
          })
          .describe('Fires once, at a fixed instant.'),
        zod
          .object({
            cron: zod
              .string()
              .describe(
                'Cron expression, either the conventional 5-field\n`min hour dom mon dow` or the 6-\/7-field\n`sec min hour dom mon dow [year]`. A 5-field expression is stored\nnormalized to 6 fields with a zero seconds field, so `0 9 \* \* \*` and\n`0 0 9 \* \* \*` are the same schedule and both read back as the latter.'
              ),
            timezone: zod
              .string()
              .describe('The timezone the cron expression is evaluated in.'),
            type: zod.enum(['recurring']),
          })
          .describe(
            'Fires repeatedly, on a cron schedule evaluated in `timezone`.'
          ),
      ])
      .describe('When a reminder fires.'),
    updatedAt: zod.iso
      .datetime({})
      .describe('When the reminder was last modified.'),
  })
  .describe(
    'A reminder belonging to a user.\n\n`user_id` is deliberately absent: a reminder is only ever read by its owner,\nso the field would be redundant on the wire.'
  );

export const getViewsHandlerResponse = zod.object({
  excludedDefaultViews: zod.array(
    zod
      .object({
        defaultViewId: zod.string(),
        id: zod.uuid(),
        userId: zod.string(),
      })
      .describe(
        "Frontend can define any set of its own default views for the user.\nThis is a list of views that are excluded from the default views list on the frontend.\n\nIt is important that the frontend can quickly iterate on default views, for that reason\nwe don't keep track of default views in the database, only those that are explicitly excluded."
      )
  ),
  views: zod.array(
    zod.object({
      config: zod
        .unknown()
        .describe(
          'It is an explicit choice that the structure of the view configuration\nis up to the frontend. The structure and composition of view configuration\nis still very much in flux.'
        ),
      createdAt: zod.iso.datetime({}),
      id: zod.uuid(),
      name: zod.string(),
      updatedAt: zod.iso.datetime({}),
      userId: zod.string(),
    })
  ),
});

export const createViewHandlerBody = zod.object({
  config: zod.unknown(),
  name: zod.string(),
});

export const createViewHandlerResponse = zod.object({
  config: zod
    .unknown()
    .describe(
      'It is an explicit choice that the structure of the view configuration\nis up to the frontend. The structure and composition of view configuration\nis still very much in flux.'
    ),
  createdAt: zod.iso.datetime({}),
  id: zod.uuid(),
  name: zod.string(),
  updatedAt: zod.iso.datetime({}),
  userId: zod.string(),
});

export const excludeDefaultViewHandlerBody = zod.object({
  defaultViewId: zod.string(),
});

export const deleteViewHandlerParams = zod.object({
  saved_view_id: zod.string().describe('The id of the saved view to delete'),
});

export const patchViewHandlerParams = zod.object({
  saved_view_id: zod.string().describe('The id of the saved view to patch'),
});

export const patchViewHandlerBody = zod.object({
  config: zod.unknown().optional(),
  name: zod.string().nullish(),
});

export const bulkWakeupSyncServiceDocumentsBody = zod.object({
  document_ids: zod.array(zod.string()),
});

/**
 * @summary Edits the share permissions of a thread.
 */
export const editThreadV2Params = zod.object({
  thread_id: zod.string().describe('thread ID'),
});

export const editThreadV2Body = zod.object({
  projectId: zod
    .string()
    .nullish()
    .describe('The new project that the thread will belong to.'),
  sharePermission: zod
    .union([
      zod.null(),
      zod.object({
        channelSharePermissions: zod
          .array(
            zod.object({
              accessLevel: zod
                .union([
                  zod.null(),
                  zod
                    .enum(['view', 'comment', 'edit', 'owner'])
                    .describe(
                      'Ordered from least to most access top -> bottom'
                    ),
                ])
                .optional(),
              channelId: zod.string().describe('The channel id'),
              operation: zod.enum(['add', 'remove', 'replace']),
            })
          )
          .nullish()
          .describe(
            'Any channel share permissions to be created\/updated\/removed'
          ),
        linkShare: zod
          .union([
            zod.null(),
            zod
              .enum(['PUBLIC', 'TEAM'])
              .describe(
                'Defines who can access an item through its share link.'
              ),
          ])
          .optional(),
        linkShareAccessLevel: zod
          .union([
            zod.null(),
            zod
              .enum(['view', 'comment', 'edit', 'owner'])
              .describe('Ordered from least to most access top -> bottom'),
          ])
          .optional(),
      }),
    ])
    .optional(),
});

export const editThreadV2Response = zod.object({
  data: zod.object({
    success: zod.boolean().describe('Indicates if the request was successful'),
  }),
  error: zod.boolean().describe('Indicates if an error occurred'),
});

/**
 * @summary Gets a UserPdfDocumentLocation entry
 */
export const getUserDocumentViewLocationParams = zod.object({
  document_id: zod.string().describe('Document ID'),
});

export const getUserDocumentViewLocationResponse = zod.object({
  location: zod.string().nullish(),
});

export const upsertUserDocumentViewLocationParams = zod.object({
  document_id: zod.string().describe('Document ID'),
});

export const upsertUserDocumentViewLocationBody = zod.object({
  location: zod.string(),
});

export const upsertUserDocumentViewLocationResponse = zod
  .object({})
  .describe(
    'Empty response is required due to custom fetch forcing `response.json()`'
  );

/**
 * @summary Deletes a document location for the user
 */
export const deleteUserDocumentViewLocationParams = zod.object({
  document_id: zod.string().describe('Document ID'),
});

export const deleteUserDocumentViewLocationResponse = zod
  .object({})
  .describe(
    'Empty response is required due to custom fetch forcing `response.json()`'
  );

/**
 * @summary Gets the current documents share permissions
 */
export const getDocumentPermissionsV2Params = zod.object({
  document_id: zod.string().describe('Document ID'),
});

export const getDocumentPermissionsV2Response = zod.object({
  documentPermissions: zod.object({
    channelSharePermissions: zod
      .array(
        zod
          .object({
            access_level: zod
              .enum(['view', 'comment', 'edit', 'owner'])
              .describe('Ordered from least to most access top -> bottom'),
            channel_id: zod.string().describe('The channel id'),
          })
          .describe('The channel share permission')
      )
      .nullish()
      .describe('The channel share permissions for the item'),
    id: zod.string().describe('The share permission id'),
    linkShare: zod
      .union([
        zod.null(),
        zod
          .enum(['PUBLIC', 'TEAM'])
          .describe('Defines who can access an item through its share link.'),
      ])
      .optional(),
    linkShareAccessLevel: zod
      .union([
        zod.null(),
        zod
          .enum(['view', 'comment', 'edit', 'owner'])
          .describe('Ordered from least to most access top -> bottom'),
      ])
      .optional(),
    owner: zod.string().describe('The owner of the item'),
  }),
});

/**
 * @summary Edit project metadata and sharing settings.
 */
export const editProjectV2Params = zod.object({
  id: zod.string().describe('ID of the project'),
});

export const editProjectV2Body = zod.object({
  name: zod.string().nullish().describe('The new name of the project.'),
  projectParentId: zod
    .string()
    .nullish()
    .describe('The new project that the new project will belong to.'),
  sharePermission: zod
    .union([
      zod.null(),
      zod.object({
        channelSharePermissions: zod
          .array(
            zod.object({
              accessLevel: zod
                .union([
                  zod.null(),
                  zod
                    .enum(['view', 'comment', 'edit', 'owner'])
                    .describe(
                      'Ordered from least to most access top -> bottom'
                    ),
                ])
                .optional(),
              channelId: zod.string().describe('The channel id'),
              operation: zod.enum(['add', 'remove', 'replace']),
            })
          )
          .nullish()
          .describe(
            'Any channel share permissions to be created\/updated\/removed'
          ),
        linkShare: zod
          .union([
            zod.null(),
            zod
              .enum(['PUBLIC', 'TEAM'])
              .describe(
                'Defines who can access an item through its share link.'
              ),
          ])
          .optional(),
        linkShareAccessLevel: zod
          .union([
            zod.null(),
            zod
              .enum(['view', 'comment', 'edit', 'owner'])
              .describe('Ordered from least to most access top -> bottom'),
          ])
          .optional(),
      }),
    ])
    .optional(),
});

export const editProjectV2Response = zod.object({
  data: zod.object({
    success: zod.boolean().describe('Indicates if the request was successful'),
  }),
  error: zod.boolean().describe('Indicates if an error occurred'),
});

/**
 * @summary List the caller's webhooks.
 */
export const listWebhooksResponse = zod
  .object({
    webhooks: zod
      .array(
        zod
          .object({
            created_at: zod.iso.datetime({}).describe('Creation timestamp.'),
            created_by_user_id: zod
              .string()
              .describe('User that created the webhook.'),
            deleted_at: zod.iso
              .datetime({})
              .nullish()
              .describe('Soft-delete timestamp.'),
            endpoint_url: zod
              .string()
              .describe(
                'Endpoint URL. HTTPS is required outside local environments.'
              ),
            filters: zod.array(
              zod
                .object({
                  events: zod
                    .array(zod.string())
                    .describe('Event names matched by this filter.'),
                  ids: zod
                    .array(zod.string())
                    .nullish()
                    .describe(
                      'Entity ids matched by this filter. When absent, the filter matches all entity ids.'
                    ),
                })
                .describe(
                  'Event and optional entity-id constraints used to match webhook deliveries.'
                )
            ),
            headers: zod.record(zod.string(), zod.string()),
            id: zod.string(),
            is_valid: zod
              .boolean()
              .describe(
                'Whether the current endpoint configuration has passed validation.'
              ),
            name: zod.string().describe('Display name.'),
            namespace: zod
              .string()
              .describe(
                "Caller-chosen namespace, unique among the owning workspace's webhooks.\nSet at creation time only; it cannot be changed afterwards."
              ),
            status: zod
              .enum(['active', 'paused', 'disabled'])
              .describe('Webhook lifecycle status.'),
            updated_at: zod.iso.datetime({}).describe('Update timestamp.'),
            workspace_id: zod.string().describe('Owning workspace id.'),
          })
          .describe('Webhook row returned by application APIs.')
      )
      .describe(
        "The caller's webhooks, newest first. Signing secrets are omitted."
      ),
  })
  .describe(
    'Webhooks visible to the caller across their personal and team workspaces.'
  );

/**
 * @summary Create a webhook.
 */
export const createWebhookBody = zod
  .object({
    endpoint_url: zod
      .string()
      .describe('Endpoint URL. HTTPS is required outside local environments.'),
    filters: zod.array(
      zod
        .object({
          events: zod
            .array(zod.string())
            .describe('Event names matched by this filter.'),
          ids: zod
            .array(zod.string())
            .nullish()
            .describe(
              'Entity ids matched by this filter. When absent, the filter matches all entity ids.'
            ),
        })
        .describe(
          'Event and optional entity-id constraints used to match webhook deliveries.'
        )
    ),
    headers: zod
      .union([zod.null(), zod.record(zod.string(), zod.string())])
      .optional(),
    name: zod.string().describe('Display name.'),
    namespace: zod
      .string()
      .describe(
        "Caller-chosen namespace, unique among the owning workspace's webhooks.\nSet at creation time only; it cannot be changed afterwards."
      ),
    scope: zod
      .enum(['user', 'team'])
      .describe('Scope that owns a newly-created webhook.'),
  })
  .describe('Request to create a webhook.');

/**
 * @summary Get a webhook.
 */
export const getWebhookParams = zod.object({
  webhook_id: zod.string().describe('Webhook id'),
});

export const getWebhookResponse = zod
  .object({
    created_at: zod.iso.datetime({}).describe('Creation timestamp.'),
    created_by_user_id: zod.string().describe('User that created the webhook.'),
    deleted_at: zod.iso
      .datetime({})
      .nullish()
      .describe('Soft-delete timestamp.'),
    endpoint_url: zod
      .string()
      .describe('Endpoint URL. HTTPS is required outside local environments.'),
    filters: zod.array(
      zod
        .object({
          events: zod
            .array(zod.string())
            .describe('Event names matched by this filter.'),
          ids: zod
            .array(zod.string())
            .nullish()
            .describe(
              'Entity ids matched by this filter. When absent, the filter matches all entity ids.'
            ),
        })
        .describe(
          'Event and optional entity-id constraints used to match webhook deliveries.'
        )
    ),
    headers: zod.record(zod.string(), zod.string()),
    id: zod.string(),
    is_valid: zod
      .boolean()
      .describe(
        'Whether the current endpoint configuration has passed validation.'
      ),
    name: zod.string().describe('Display name.'),
    namespace: zod
      .string()
      .describe(
        "Caller-chosen namespace, unique among the owning workspace's webhooks.\nSet at creation time only; it cannot be changed afterwards."
      ),
    status: zod
      .enum(['active', 'paused', 'disabled'])
      .describe('Webhook lifecycle status.'),
    updated_at: zod.iso.datetime({}).describe('Update timestamp.'),
    workspace_id: zod.string().describe('Owning workspace id.'),
  })
  .describe('Webhook row returned by application APIs.');

/**
 * @summary Delete a webhook.
 */
export const deleteWebhookParams = zod.object({
  webhook_id: zod.string().describe('Webhook id'),
});

/**
 * @summary Patch a webhook.
 */
export const patchWebhookParams = zod.object({
  webhook_id: zod.string().describe('Webhook id'),
});

export const patchWebhookBody = zod
  .object({
    endpoint_url: zod
      .string()
      .nullish()
      .describe('Endpoint URL. HTTPS is required outside local environments.'),
    filters: zod
      .union([
        zod.null(),
        zod.array(
          zod
            .object({
              events: zod
                .array(zod.string())
                .describe('Event names matched by this filter.'),
              ids: zod
                .array(zod.string())
                .nullish()
                .describe(
                  'Entity ids matched by this filter. When absent, the filter matches all entity ids.'
                ),
            })
            .describe(
              'Event and optional entity-id constraints used to match webhook deliveries.'
            )
        ),
      ])
      .optional(),
    headers: zod
      .union([zod.null(), zod.record(zod.string(), zod.string())])
      .optional(),
    name: zod.string().nullish().describe('Display name.'),
    status: zod
      .union([
        zod.null(),
        zod
          .enum(['active', 'paused', 'disabled'])
          .describe('Webhook lifecycle status.'),
      ])
      .optional(),
  })
  .describe(
    "Request to patch a webhook. The webhook's namespace is fixed at creation\ntime and is deliberately not patchable."
  );

export const patchWebhookResponse = zod
  .object({
    created_at: zod.iso.datetime({}).describe('Creation timestamp.'),
    created_by_user_id: zod.string().describe('User that created the webhook.'),
    deleted_at: zod.iso
      .datetime({})
      .nullish()
      .describe('Soft-delete timestamp.'),
    endpoint_url: zod
      .string()
      .describe('Endpoint URL. HTTPS is required outside local environments.'),
    filters: zod.array(
      zod
        .object({
          events: zod
            .array(zod.string())
            .describe('Event names matched by this filter.'),
          ids: zod
            .array(zod.string())
            .nullish()
            .describe(
              'Entity ids matched by this filter. When absent, the filter matches all entity ids.'
            ),
        })
        .describe(
          'Event and optional entity-id constraints used to match webhook deliveries.'
        )
    ),
    headers: zod.record(zod.string(), zod.string()),
    id: zod.string(),
    is_valid: zod
      .boolean()
      .describe(
        'Whether the current endpoint configuration has passed validation.'
      ),
    name: zod.string().describe('Display name.'),
    namespace: zod
      .string()
      .describe(
        "Caller-chosen namespace, unique among the owning workspace's webhooks.\nSet at creation time only; it cannot be changed afterwards."
      ),
    status: zod
      .enum(['active', 'paused', 'disabled'])
      .describe('Webhook lifecycle status.'),
    updated_at: zod.iso.datetime({}).describe('Update timestamp.'),
    workspace_id: zod.string().describe('Owning workspace id.'),
  })
  .describe('Webhook row returned by application APIs.');

/**
 * @summary Validate a webhook endpoint.
 */
export const validateWebhookParams = zod.object({
  webhook_id: zod.string().describe('Webhook id'),
});

export const validateWebhookResponseResponseStatusMin = 0;

export const validateWebhookResponse = zod
  .object({
    is_valid: zod
      .boolean()
      .describe(
        'Whether the endpoint accepted the signed validation delivery.'
      ),
    message: zod
      .string()
      .nullish()
      .describe('Sanitized message explaining validation failure.'),
    response_status: zod
      .number()
      .min(validateWebhookResponseResponseStatusMin)
      .nullish()
      .describe(
        'HTTP response status returned by the webhook endpoint, when available.'
      ),
    webhook_id: zod.string(),
  })
  .describe('Sanitized result of validating a webhook endpoint.');
